import React, { Component, Fragment } from 'react';
export { default as UAParser } from 'ua-parser-js';
import { DropboxAuth, Dropbox } from 'dropbox';

var UrlUtil = /*#__PURE__*/function () {
  function UrlUtil() {}

  UrlUtil.addParam = function addParam(url, name, value) {
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return "" + url + sep + encodeURIComponent(name) + "=" + encodeURIComponent(value);
  };

  UrlUtil.getParam = function getParam(url, name) {
    var reg = new RegExp('[?&]' + encodeURIComponent(name) + '=([^&#]*)');
    var val = reg.exec(url);
    return val ? decodeURIComponent(val[1]) : null;
  };

  UrlUtil.getBoolParam = function getBoolParam(url, name) {
    var val = this.getParam(url, name);
    return !!val && (val.toLowerCase() === 'true' || val === '1');
  };

  UrlUtil.getFileName = function getFileName(url) {
    try {
      url = decodeURIComponent(url);
    } catch (_unused) {
      console.error("Unable to decode URI (1): " + url);
    }

    var slash = url.lastIndexOf("/");

    if (slash >= 0 && url.length > slash + 1) {
      url = url.substring(slash + 1);
    }

    var ques = url.lastIndexOf("?");

    if (ques >= 0) {
      url = url.substring(0, ques);
    }

    try {
      url = decodeURIComponent(url);
    } catch (_unused2) {
      console.error("Unable to decode URI (2): " + url);
    }

    return url;
  };

  return UrlUtil;
}();

var localIp = "127.0.0.1";
var CONFIG = {
	localIp: localIp
};

var Config = /*#__PURE__*/function () {
  function Config() {
    this.isEmptyDefault = true;
  }

  var _proto = Config.prototype;

  _proto.getLocalIp = function getLocalIp() {
    return CONFIG.localIp;
  };

  _proto.getLocalPort = function getLocalPort() {
    return CONFIG.localPort;
  };

  _proto.getLocalUrl = function getLocalUrl() {
    return "http://" + this.getLocalIp() + ":" + this.getLocalPort();
  };

  _proto.getCorsProxy = function getCorsProxy() {
    return  null;
  };

  _proto.getCorsProxyDev = function getCorsProxyDev() {
    return  null;
  };

  _proto.isPublicServer = function isPublicServer() {
    return CONFIG.isPublicServer === true;
  };

  _proto.getDefaultFeedContentRoot = function getDefaultFeedContentRoot() {
    return  null;
  };

  _proto.getDefaultFeedImagesRoot = function getDefaultFeedImagesRoot() {
    return  null;
  };

  _proto.isEmptyDefaultFeed = function isEmptyDefaultFeed() {
    return this.isEmptyDefault;
  };

  _proto.setEmptyDefaultFeed = function setEmptyDefaultFeed(empty) {
    this.isEmptyDefault = empty;
  };

  return Config;
}();

var config = new Config();

var blobToStr = function blobToStr(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();

    reader.onerror = function () {
      reader.abort();
      reject(reader.error);
    };

    reader.onload = function () {
      resolve(reader.result);
    };

    reader.readAsBinaryString(blob);
  });
};

function u8ArrayToStr(u8Array) {
  var i,
      len = u8Array.length,
      b_str = "";

  for (i = 0; i < len; i++) {
    b_str += String.fromCharCode(u8Array[i]);
  }

  return b_str;
}

var isEmptyString = function isEmptyString(str) {
  return str === undefined || !str || str.length === 0;
};

var isValidString = function isValidString(str) {
  return str !== undefined && str && str.length > 0;
};

var limitString = function limitString(str, limit) {

  if (str <= limit) {
    return str;
  } else {
    return str.substring(0, limit) + "...";
  }
};

var strReplaceAll = function strReplaceAll(str, find, replace) {
  return str.split(find).join(replace);
};

var B64_PATTERN = new RegExp('^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$');
var Base64 = {
  _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  isBase64: function isBase64(input) {
    return input.match(B64_PATTERN);
  },
  encode: function encode(input) {
    var output = "";
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0;
    input = Base64._utf8_encode(input);

    while (i < input.length) {
      chr1 = input.charCodeAt(i++);
      chr2 = input.charCodeAt(i++);
      chr3 = input.charCodeAt(i++);
      enc1 = chr1 >> 2;
      enc2 = (chr1 & 3) << 4 | chr2 >> 4;
      enc3 = (chr2 & 15) << 2 | chr3 >> 6;
      enc4 = chr3 & 63;

      if (isNaN(chr2)) {
        enc3 = enc4 = 64;
      } else if (isNaN(chr3)) {
        enc4 = 64;
      }

      output = output + this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) + this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
    }

    return output;
  },
  decode: function decode(input) {
    var output = "";
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0;
    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    while (i < input.length) {
      enc1 = this._keyStr.indexOf(input.charAt(i++));
      enc2 = this._keyStr.indexOf(input.charAt(i++));
      enc3 = this._keyStr.indexOf(input.charAt(i++));
      enc4 = this._keyStr.indexOf(input.charAt(i++));
      chr1 = enc1 << 2 | enc2 >> 4;
      chr2 = (enc2 & 15) << 4 | enc3 >> 2;
      chr3 = (enc3 & 3) << 6 | enc4;
      output = output + String.fromCharCode(chr1);

      if (enc3 != 64) {
        output = output + String.fromCharCode(chr2);
      }

      if (enc4 != 64) {
        output = output + String.fromCharCode(chr3);
      }
    }

    output = Base64._utf8_decode(output);
    return output;
  },
  _utf8_encode: function _utf8_encode(string) {
    var utftext = "";
    string = string.replace(/\r\n/g, "\n");

    for (var n = 0; n < string.length; n++) {
      var c = string.charCodeAt(n);

      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }

    return utftext;
  },
  _utf8_decode: function _utf8_decode(utftext) {
    var string = "";
    var i = 0;
    var c, c1, c2, c3;
    c = c1 = c2 = 0;

    while (i < utftext.length) {
      c = utftext.charCodeAt(i);

      if (c < 128) {
        string += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        c2 = utftext.charCodeAt(i + 1);
        string += String.fromCharCode((c & 31) << 6 | c2 & 63);
        i += 2;
      } else {
        c2 = utftext.charCodeAt(i + 1);
        c3 = utftext.charCodeAt(i + 2);
        string += String.fromCharCode((c & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        i += 3;
      }
    }

    return string;
  }
};

function md5cycle(x, k) {
  var a = x[0],
      b = x[1],
      c = x[2],
      d = x[3];
  a = ff(a, b, c, d, k[0], 7, -680876936);
  d = ff(d, a, b, c, k[1], 12, -389564586);
  c = ff(c, d, a, b, k[2], 17, 606105819);
  b = ff(b, c, d, a, k[3], 22, -1044525330);
  a = ff(a, b, c, d, k[4], 7, -176418897);
  d = ff(d, a, b, c, k[5], 12, 1200080426);
  c = ff(c, d, a, b, k[6], 17, -1473231341);
  b = ff(b, c, d, a, k[7], 22, -45705983);
  a = ff(a, b, c, d, k[8], 7, 1770035416);
  d = ff(d, a, b, c, k[9], 12, -1958414417);
  c = ff(c, d, a, b, k[10], 17, -42063);
  b = ff(b, c, d, a, k[11], 22, -1990404162);
  a = ff(a, b, c, d, k[12], 7, 1804603682);
  d = ff(d, a, b, c, k[13], 12, -40341101);
  c = ff(c, d, a, b, k[14], 17, -1502002290);
  b = ff(b, c, d, a, k[15], 22, 1236535329);
  a = gg(a, b, c, d, k[1], 5, -165796510);
  d = gg(d, a, b, c, k[6], 9, -1069501632);
  c = gg(c, d, a, b, k[11], 14, 643717713);
  b = gg(b, c, d, a, k[0], 20, -373897302);
  a = gg(a, b, c, d, k[5], 5, -701558691);
  d = gg(d, a, b, c, k[10], 9, 38016083);
  c = gg(c, d, a, b, k[15], 14, -660478335);
  b = gg(b, c, d, a, k[4], 20, -405537848);
  a = gg(a, b, c, d, k[9], 5, 568446438);
  d = gg(d, a, b, c, k[14], 9, -1019803690);
  c = gg(c, d, a, b, k[3], 14, -187363961);
  b = gg(b, c, d, a, k[8], 20, 1163531501);
  a = gg(a, b, c, d, k[13], 5, -1444681467);
  d = gg(d, a, b, c, k[2], 9, -51403784);
  c = gg(c, d, a, b, k[7], 14, 1735328473);
  b = gg(b, c, d, a, k[12], 20, -1926607734);
  a = hh(a, b, c, d, k[5], 4, -378558);
  d = hh(d, a, b, c, k[8], 11, -2022574463);
  c = hh(c, d, a, b, k[11], 16, 1839030562);
  b = hh(b, c, d, a, k[14], 23, -35309556);
  a = hh(a, b, c, d, k[1], 4, -1530992060);
  d = hh(d, a, b, c, k[4], 11, 1272893353);
  c = hh(c, d, a, b, k[7], 16, -155497632);
  b = hh(b, c, d, a, k[10], 23, -1094730640);
  a = hh(a, b, c, d, k[13], 4, 681279174);
  d = hh(d, a, b, c, k[0], 11, -358537222);
  c = hh(c, d, a, b, k[3], 16, -722521979);
  b = hh(b, c, d, a, k[6], 23, 76029189);
  a = hh(a, b, c, d, k[9], 4, -640364487);
  d = hh(d, a, b, c, k[12], 11, -421815835);
  c = hh(c, d, a, b, k[15], 16, 530742520);
  b = hh(b, c, d, a, k[2], 23, -995338651);
  a = ii(a, b, c, d, k[0], 6, -198630844);
  d = ii(d, a, b, c, k[7], 10, 1126891415);
  c = ii(c, d, a, b, k[14], 15, -1416354905);
  b = ii(b, c, d, a, k[5], 21, -57434055);
  a = ii(a, b, c, d, k[12], 6, 1700485571);
  d = ii(d, a, b, c, k[3], 10, -1894986606);
  c = ii(c, d, a, b, k[10], 15, -1051523);
  b = ii(b, c, d, a, k[1], 21, -2054922799);
  a = ii(a, b, c, d, k[8], 6, 1873313359);
  d = ii(d, a, b, c, k[15], 10, -30611744);
  c = ii(c, d, a, b, k[6], 15, -1560198380);
  b = ii(b, c, d, a, k[13], 21, 1309151649);
  a = ii(a, b, c, d, k[4], 6, -145523070);
  d = ii(d, a, b, c, k[11], 10, -1120210379);
  c = ii(c, d, a, b, k[2], 15, 718787259);
  b = ii(b, c, d, a, k[9], 21, -343485551);
  x[0] = add32(a, x[0]);
  x[1] = add32(b, x[1]);
  x[2] = add32(c, x[2]);
  x[3] = add32(d, x[3]);
}

function cmn(q, a, b, x, s, t) {
  a = add32(add32(a, q), add32(x, t));
  return add32(a << s | a >>> 32 - s, b);
}

function ff(a, b, c, d, x, s, t) {
  return cmn(b & c | ~b & d, a, b, x, s, t);
}

function gg(a, b, c, d, x, s, t) {
  return cmn(b & d | c & ~d, a, b, x, s, t);
}

function hh(a, b, c, d, x, s, t) {
  return cmn(b ^ c ^ d, a, b, x, s, t);
}

function ii(a, b, c, d, x, s, t) {
  return cmn(c ^ (b | ~d), a, b, x, s, t);
}

function md51(s) {
  var n = s.length,
      state = [1732584193, -271733879, -1732584194, 271733878],
      i;

  for (i = 64; i <= s.length; i += 64) {
    md5cycle(state, md5blk(s.substring(i - 64, i)));
  }

  s = s.substring(i - 64);
  var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];

  for (i = 0; i < s.length; i++) {
    tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
  }

  tail[i >> 2] |= 0x80 << (i % 4 << 3);

  if (i > 55) {
    md5cycle(state, tail);

    for (i = 0; i < 16; i++) {
      tail[i] = 0;
    }
  }

  tail[14] = n * 8;
  md5cycle(state, tail);
  return state;
}

function md5blk(s) {
  var md5blks = [],
      i;

  for (i = 0; i < 64; i += 4) {
    md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
  }

  return md5blks;
}

var hex_chr = '0123456789abcdef'.split('');

function rhex(n) {
  var s = '',
      j = 0;

  for (; j < 4; j++) {
    s += hex_chr[n >> j * 8 + 4 & 0x0F] + hex_chr[n >> j * 8 & 0x0F];
  }

  return s;
}

function hex(x) {
  for (var i = 0; i < x.length; i++) {
    x[i] = rhex(x[i]);
  }

  return x.join('');
}

function md5(s) {
  return hex(md51(s));
}

function add32(a, b) {
  return a + b & 0xFFFFFFFF;
}

if (md5('hello') != '5d41402abc4b2a76b9719d911017c592') ;

// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = /*#__PURE__*/(function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

function _isSettledPact(thenable) {
	return thenable instanceof _Pact && thenable.s & 1;
}

// Asynchronously iterate through an object that has a length property, passing the index as the first argument to the callback (even as the length property changes)
function _forTo(array, body, check) {
	var i = -1, pact, reject;
	function _cycle(result) {
		try {
			while (++i < array.length && (!check || !check())) {
				result = body(i);
				if (result && result.then) {
					if (_isSettledPact(result)) {
						result = result.v;
					} else {
						result.then(_cycle, reject || (reject = _settle.bind(null, pact = new _Pact(), 2)));
						return;
					}
				}
			}
			if (pact) {
				_settle(pact, 1, result);
			} else {
				pact = result;
			}
		} catch (e) {
			_settle(pact || (pact = new _Pact()), 2, e);
		}
	}
	_cycle();
	return pact;
}

// Asynchronously iterate through an object's properties (including properties inherited from the prototype)
// Uses a snapshot of the object's properties
function _forIn(target, body, check) {
	var keys = [];
	for (var key in target) {
		keys.push(key);
	}
	return _forTo(keys, function(i) { return body(keys[i]); }, check);
}

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously implement a generic for loop
function _for(test, update, body) {
	var stage;
	for (;;) {
		var shouldContinue = test();
		if (_isSettledPact(shouldContinue)) {
			shouldContinue = shouldContinue.v;
		}
		if (!shouldContinue) {
			return result;
		}
		if (shouldContinue.then) {
			stage = 0;
			break;
		}
		var result = body();
		if (result && result.then) {
			if (_isSettledPact(result)) {
				result = result.s;
			} else {
				stage = 1;
				break;
			}
		}
		if (update) {
			var updateValue = update();
			if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
				stage = 2;
				break;
			}
		}
	}
	var pact = new _Pact();
	var reject = _settle.bind(null, pact, 2);
	(stage === 0 ? shouldContinue.then(_resumeAfterTest) : stage === 1 ? result.then(_resumeAfterBody) : updateValue.then(_resumeAfterUpdate)).then(void 0, reject);
	return pact;
	function _resumeAfterBody(value) {
		result = value;
		do {
			if (update) {
				updateValue = update();
				if (updateValue && updateValue.then && !_isSettledPact(updateValue)) {
					updateValue.then(_resumeAfterUpdate).then(void 0, reject);
					return;
				}
			}
			shouldContinue = test();
			if (!shouldContinue || (_isSettledPact(shouldContinue) && !shouldContinue.v)) {
				_settle(pact, 1, result);
				return;
			}
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
				return;
			}
			result = body();
			if (_isSettledPact(result)) {
				result = result.v;
			}
		} while (!result || !result.then);
		result.then(_resumeAfterBody).then(void 0, reject);
	}
	function _resumeAfterTest(shouldContinue) {
		if (shouldContinue) {
			result = body();
			if (result && result.then) {
				result.then(_resumeAfterBody).then(void 0, reject);
			} else {
				_resumeAfterBody(result);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
	function _resumeAfterUpdate() {
		if (shouldContinue = test()) {
			if (shouldContinue.then) {
				shouldContinue.then(_resumeAfterTest).then(void 0, reject);
			} else {
				_resumeAfterTest(shouldContinue);
			}
		} else {
			_settle(pact, 1, result);
		}
	}
}

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, result);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

var styles = {"message-container":"_K0-OE","message":"_3GlSf","snackbar":"_XdVEO","show":"_1_99M","errormsg":"_3FiSe","message--fadein":"_aG2tf","hide":"_dxHdm","message--fadeout":"_3DYJ8"};

var Message = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Message, _Component);

  function Message() {
    return _Component.call(this) || this;
  }

  var _proto = Message.prototype;

  _proto.componentDidMount = function componentDidMount() {};

  _proto.componentWillUnmount = function componentWillUnmount() {};

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement("div", {
      id: styles['message-container'],
      className: styles['message-container']
    }, /*#__PURE__*/React.createElement("div", {
      id: styles['snackbar'],
      className: styles['message'],
      onClick: function onClick() {
        return hideMessage();
      }
    }));
  };

  return Message;
}(Component);
var timeoutId = -1;
var anchorId = null;
function setMessageAnchorId(id) {
  anchorId = id;
}
function showMessage(message, addConsoleMessage) {
  if (addConsoleMessage === void 0) {
    addConsoleMessage = true;
  }

  var container = document.getElementById(styles['message-container']);
  var el = document.getElementById(styles['snackbar']);

  if (anchorId) {
    var parentEl = document.getElementById(anchorId);

    if (parentEl) {
      var rect = parentEl.getBoundingClientRect();
      container.style.position = 'absolute';
      container.style.top = (rect.top < 0 ? 0 : rect.top) + window.scrollY + "px";
      container.style.left = "50%";
    }
  }

  if (el) {
    el.innerHTML = (message ? (message + "").replaceAll("\n", "<br/>") : "Unknown error") + (addConsoleMessage ? "<br/><br/>See console log for details." : "");
    el.classList.add(styles['show']);
    el.classList.remove(styles['hide']);

    if (timeoutId > 0) {
      window.clearTimeout(timeoutId);
    }

    timeoutId = window.setTimeout(function () {
      return hideMessage();
    }, 5000);
  }
}
function hideMessage() {
  var el = document.getElementById(styles['snackbar']);

  if (el) {
    window.setTimeout(function () {
      el.classList.add(styles['hide']);
      el.classList.remove(styles['show']);
    }, 0);
  }
}

var error = function error(message) {
  console.error(message);
};

var info = function info(message) {
  console.info(message);
};

var LOG = {
  __proto__: null,
  error: error,
  info: info
};

var isXbox = function isXbox() {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes("xbox");
};

var isIos = function isIos() {
  var userAgent = navigator.userAgent.toLowerCase();
  return /ipad|iphone|ipod/.test(userAgent);
};

var isMacOs = function isMacOs() {
  var userAgent = navigator.userAgent.toLowerCase();
  return /mac os/.test(userAgent);
};

var isMobileSafari = function isMobileSafari() {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.includes('safari/') && userAgent.includes('mobile/') && userAgent.includes('version/');
};

var iosNavBarHackListener = function iosNavBarHackListener() {
  document.body.style.overflow = 'scroll';
  window.scrollTo(0, 0);
  setTimeout(function () {
    document.body.style.overflow = 'hidden';
    window.scrollTo(0, 1);
    setTimeout(function () {
      return window.scrollTo(0, 0);
    }, 50);
  }, 500);
};

var applyIosNavBarHack = function applyIosNavBarHack() {
  if (isMobileSafari()) {
    window.addEventListener('orientationchange', iosNavBarHackListener);
  }
};

var removeIosNavBarHack = function removeIosNavBarHack() {
  if (isMobileSafari()) {
    window.removeEventListener('orientationchange', iosNavBarHackListener);
  }
};

var xboxIntervalId = null;

var addXboxFullscreenCallback = function addXboxFullscreenCallback(cb) {
  document.addEventListener('keydown', function (e) {
    if (e.keyCode === 208) {
      setTimeout(function () {
        if (!document.hasFocus()) {
          if (!xboxIntervalId) {
            cb(true);
            xboxIntervalId = setInterval(function () {
              if (document.hasFocus()) {
                cb(false);
                clearInterval(xboxIntervalId);
                xboxIntervalId = null;
              }
            }, 100);
          }
        }
      }, 500);
    }
  });
};

var getXboxViewMessage = function getXboxViewMessage() {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'center'
    }
  }, "Due to an apparent bug in the Xbox Edge browser, focus is lost when the ", /*#__PURE__*/React.createElement("b", null, "View"), " button is pressed.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "To restore focus, open and close the ", /*#__PURE__*/React.createElement("b", null, "Guide menu"), " by pressing the controller's ", /*#__PURE__*/React.createElement("b", null, "Xbox"), " button twice.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), "Please use the alternate buttons for ", /*#__PURE__*/React.createElement("b", null, "Select"), ", ", /*#__PURE__*/React.createElement("b", null, "Start"), ", and ", /*#__PURE__*/React.createElement("b", null, "Show Pause Dialog"), " actions. ", /*#__PURE__*/React.createElement("br", null), "See the \"Xbox Series X|S Platform\" section in the webRcade documentation.", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: "https://docs.webrcade.com/platforms/xbox"
  }, "docs.webrcade.com/platforms/xbox"));
};

var isTouchSupported = function isTouchSupported() {
  return matchMedia('(hover: none)').matches;
};

var isParentSameOrigin = function isParentSameOrigin() {
  try {
    var href = window.parent.location.href;
    return href;
  } catch (e) {
    return false;
  }

  return false;
};

var isStoragePersisted = function isStoragePersisted() {
  try {
    var _navigator, _navigator$storage;

    return Promise.resolve((_navigator = navigator) === null || _navigator === void 0 ? void 0 : (_navigator$storage = _navigator.storage) === null || _navigator$storage === void 0 ? void 0 : _navigator$storage.persisted());
  } catch (e) {
    return Promise.reject(e);
  }
};

var storagePersist = function storagePersist() {
  (function () {
    try {
      var _temp3 = _catch(function () {
        return Promise.resolve(isStoragePersisted()).then(function (_isStoragePersisted) {
          var _temp = function () {
            if (!_isStoragePersisted) {
              var _navigator2, _navigator2$storage;

              info("Storage is not persisted long term.");
              var _info2 = info;
              return Promise.resolve((_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : (_navigator2$storage = _navigator2.storage) === null || _navigator2$storage === void 0 ? void 0 : _navigator2$storage.persist()).then(function (_navigator$storage$pe2) {
                _info2.call(LOG, "Result of requesting long term storage: " + _navigator$storage$pe2);
              });
            } else {
              info("Storage is persisted long term.");
            }
          }();

          if (_temp && _temp.then) return _temp.then(function () {});
        });
      }, function (e) {
        error("Error requesting long term storage", e);
      });

      return _temp3 && _temp3.then ? _temp3.then(function () {}) : void 0;
    } catch (e) {
      Promise.reject(e);
    }
  })();
};

var fullScreen = function fullScreen(elem) {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
  } else if (elem.webkitRequestFullscreen) {
    elem.webkitRequestFullscreen();
  } else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
  }
};

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

var cloneObject = function cloneObject(obj) {
  return JSON.parse(JSON.stringify(obj));
};

var preloadImages = function preloadImages(images) {
  images.forEach(function (image) {
    var img = new Image();
    img.src = image;
  });
};

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

function isApp() {
  return window.location.href.toLowerCase().indexOf('/app/') != -1 || window.self !== window.top;
}

function resolvePath(path) {
  return isDev() ? config.getLocalUrl() + "/" + path : isApp() ? "../../" + path : path;
}

function normalizeFileName(name) {
  name = strReplaceAll(name, '?', '_');
  name = strReplaceAll(name, '*', '_');
  name = strReplaceAll(name, '/', '_');
  name = strReplaceAll(name, ':', '_');
  return name;
}

function removeEmptyArrayItems(arr) {
  var ret = [];

  for (var i = 0; i < arr.length; i++) {
    var item = arr[i].trim();

    if (item.length > 0) {
      ret.push(item);
    }
  }

  return ret;
}

var RP_DEBUG = "debug";
var debug = typeof window !== "undefined" ? UrlUtil.getBoolParam(window.location.search, RP_DEBUG) : null;

function isDebug() {
  return debug;
}

var AppProps = /*#__PURE__*/function () {
  function AppProps() {}

  AppProps.encode = function encode(props) {
    return Base64.encode(encodeURIComponent(JSON.stringify(props)));
  };

  AppProps.decode = function decode(encodedProps) {
    return JSON.parse(decodeURIComponent(Base64.decode(encodedProps)));
  };

  return AppProps;
}();
AppProps.RP_CONTEXT = "ctx";
AppProps.RP_DEBUG = RP_DEBUG;
AppProps.RP_PROPS = "props";
AppProps.RP_ROM = "rom";
AppProps.RP_TYPE = "type";
AppProps.RP_EDITOR_TEST = "editTest";
AppProps.RV_CONTEXT_EDITOR = "editor";
AppProps.RV_CONTEXT_STANDALONE = "standalone";
AppProps.RV_EDITOR_TEST_ENABLED = "1";

var DB_PREFIX = "https://www.dropbox.com/";
var DB_REMAP_PREFIX = "https://dl.dropboxusercontent.com/";
var GDRIVE_PREFIX = "https://drive.google.com/file/d/";
var GDRIVE_REMAP_PREFIX = "https://drive.google.com/uc?export=download&id=";
var IMG_PREFIX = "http://webrcade.aerofever.com.ar/default-feed/images/";
var IMG_REMAP_PREFIX = "https://webrcade.github.io/webrcade-default-feed/images/";
var CONTENT_PREFIX = "https://raw.githubusercontent.com/webrcade/webrcade/master/public/default-feed/content/";
var CONTENT_REMAP_PREFIX = "https://raw.githubusercontent.com/webrcade/webrcade-default-feed/main/content/";

var remapDropbox = function remapDropbox(urlLower, url) {
  if (urlLower.substring(0, DB_PREFIX.length) === DB_PREFIX) {
    if (urlLower.includes("&rlkey=") || urlLower.includes("?rlkey=")) {
      url = url.replace("dl=0", "dl=1");
      url = url.replace(DB_PREFIX, "https://dl.dropbox.com/");
      info("Remapped dropbox url: '" + url + "'");
      return url;
    } else {
      url = DB_REMAP_PREFIX + url.substring(DB_PREFIX.length);
      url = url.split('?')[0];

      if (isDebug()) {
        info("Remapped dropbox url: '" + url + "'");
      }

      return url;
    }
  }

  return null;
};

var remapGdrive = function remapGdrive(urlLower, url) {
  if (urlLower.substring(0, GDRIVE_PREFIX.length) === GDRIVE_PREFIX) {
    url = GDRIVE_REMAP_PREFIX + url.substring(GDRIVE_PREFIX.length);
    url = url.split('/view')[0];
    url += "&confirm=t";

    if (isDebug()) {
      info("Remapped Gdrive url: '" + url + "'");
    }

    return url;
  }

  return null;
};

var remapOldDefaultImage = function remapOldDefaultImage(urlLower, url) {
  if (urlLower.substring(0, IMG_PREFIX.length) === IMG_PREFIX) {
    url = IMG_REMAP_PREFIX + url.substring(IMG_PREFIX.length);

    if (isDebug()) {
      info("Remapped old image url: '" + url + "'");
    }

    return url;
  }

  return null;
};

var remapOldContentUrl = function remapOldContentUrl(urlLower, url) {
  if (urlLower.substring(0, CONTENT_PREFIX.length) === CONTENT_PREFIX) {
    url = CONTENT_REMAP_PREFIX + url.substring(CONTENT_PREFIX.length);

    if (isDebug()) {
      info("Remapped old content url: '" + url + "'");
    }

    return url;
  }

  return null;
};

var remapUrl = function remapUrl(url) {
  if (!url) return url;
  var urlLower = url.toLowerCase();
  var newUrl = remapOldDefaultImage(urlLower, url);
  if (newUrl) return newUrl;
  newUrl = remapOldContentUrl(urlLower, url);
  if (newUrl) return newUrl;
  newUrl = remapDropbox(urlLower, url);
  if (newUrl) return newUrl;
  newUrl = remapGdrive(urlLower, url);
  if (newUrl) return newUrl;
  return url;
};

var PROXY_DISABLED = "proxy-disabled";
var DIRECT = "direct";
var HTTP_PROXY = "http-proxy";
var HTTPS_PROXY = "https-proxy";
var DROPBOX_HTML_ERROR = "Dropbox is returning HTML content.";
var GDRIVE_HTML_ERROR = "Google Drive is returning HTML content.";
function getContentDispositionFilename(headers) {
  var disposition = headers['content-disposition'];

  if (disposition) {
    var matches = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/gim.exec(disposition);

    if (matches.length > 1) {
      var match = matches[1];
      match = match.trim();

      if (match.length > 0) {
        if (match[0] === '"' || match[0] === '\'') {
          match = match.substring(1);
        }

        if (match.length > 0) {
          if (match[match.length - 1] === '"' || match[match.length - 1] === '\'') {
            match = match.substring(0, match.length - 1);
          }
        }

        console.log(match);
        return match;
      }
    }
  }

  return null;
}
var FetchAppData = /*#__PURE__*/function () {
  function FetchAppData(url) {
    this.P = config.getCorsProxy() ? (config.isPublicServer() ? "" : window.location.host) + config.getCorsProxy() : null;
    this.url = remapUrl(url);
    this.retries = 1;
    this.proxyDisabled = false;
    this.successMethod = null;
    this.method = null;
    this.updatedUrl = null;
    this.dropboxHtmlIssue = false;
    this.htmlRetries = 10;
  }

  var _proto = FetchAppData.prototype;

  _proto.getSuccessMethod = function getSuccessMethod() {
    return this.successMethod;
  };

  _proto.setMethod = function setMethod(method) {
    this.method = method;
  };

  _proto.getHeaders = function getHeaders(res) {
    var headers = res.headers;
    var headerObj = {};

    if (headers) {
      var keys = headers.keys();
      var header = keys.next();

      while (header.value) {
        headerObj[header.value] = headers.get(header.value);
        header = keys.next();
      }
    }

    return headerObj;
  };

  _proto.setRetries = function setRetries(retries) {
    this.retries = retries;
    return this;
  };

  _proto.setProxyDisabled = function setProxyDisabled(disabled) {
    this.proxyDisabled = disabled;
    return this;
  };

  _proto.isProxyDisabled = function isProxyDisabled() {
    return this.proxyDisabled || !this.P || this.P.length === 0;
  };

  _proto.getFilename = function getFilename(res) {
    var headers = this.getHeaders(res);

    if (headers) {
      return getContentDispositionFilename(headers);
    }

    return null;
  };

  _proto.fetch = function (_fetch) {
    function fetch(_x) {
      return _fetch.apply(this, arguments);
    }

    fetch.toString = function () {
      return _fetch.toString();
    };

    return fetch;
  }(function (props) {
    try {
      var _temp5 = function _temp5(_result4) {
        if (_exit2) return _result4;
        throw error$1;
      };

      var _exit2 = false;

      var _this2 = this;

      var P = _this2.P;
      var retries = _this2.retries,
          proxyDisabled = _this2.proxyDisabled;
      var url = _this2.url;
      var s = url.toLowerCase().startsWith("https");

      var h = function h(s) {
        return s ? "https://" : "http://";
      };

      if (isDev() && config.getCorsProxyDev()) {
        P = config.getCorsProxyDev();
      }

      var getText = function getText(r) {
        try {
          return Promise.resolve(r.text()).then(function (text) {
            return r.status === 404 ? "404 (Not found)" : r.status + ": " + limitString(text, 80);
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      var checkDropboxHtml = function checkDropboxHtml(res) {
        try {
          var isDropbox = url.indexOf("dropbox") !== -1;
          var isGDrive = url.indexOf("drive.google.com") !== -1;
          return Promise.resolve(function () {
            if (isDropbox || isGDrive) {
              var headers = _this2.getHeaders(res);

              var ctype = headers["content-type"];
              var disposition = headers["content-disposition"];
              return function () {
                if (ctype && disposition === undefined && ctype.indexOf("text/html") !== -1) {
                  return function () {
                    if (isGDrive) {
                      return Promise.resolve(res.text()).then(function (body) {
                        var search = "name=\"uuid\" value=\"";
                        var idIndex = body.indexOf(search);
                        var uuid = null;

                        if (idIndex !== -1) {
                          uuid = body.substring(search.length + idIndex);
                          var qidx = uuid.indexOf("\"");

                          if (qidx !== -1) {
                            uuid = uuid.substring(0, qidx);
                          }

                          var idx = url.indexOf("?");

                          if (idx !== -1) {
                            _this2.updatedUrl = "https://drive.usercontent.google.com/download" + url.substring(idx) + "&uuid=" + uuid;
                            throw GDRIVE_HTML_ERROR;
                          }
                        }
                      });
                    } else {
                      _this2.dropboxHtmlIssue = true;
                      throw DROPBOX_HTML_ERROR;
                    }
                  }();
                }
              }();
            }
          }());
        } catch (e) {
          return Promise.reject(e);
        }
      };

      var doFetch = function doFetch(url) {
        try {
          return Promise.resolve(fetch(url, props)).then(function (res) {
            if (res.ok) {
              return res;
            } else {
              return Promise.resolve(getText(res)).then(function (_getText) {
                throw new Error(_getText);
              });
            }
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      var directFetch = function directFetch(url) {
        return Promise.resolve(doFetch(url)).then(function (_doFetch) {
          res = _doFetch;
          return Promise.resolve(checkDropboxHtml(res)).then(function () {
            if (!res) throw new Error("result is undefined");
            _this2.successMethod = DIRECT;
            return res;
          });
        });
      };

      var httpProxyFetch = function httpProxyFetch(url) {
        try {
          var _temp9 = function _temp9(_result8) {
            if (_exit4) return _result8;
            throw Error(PROXY_DISABLED);
          };

          var _exit4 = false;

          var _temp10 = function () {
            if (!_this2.isProxyDisabled()) {
              return Promise.resolve(doFetch("" + h(s) + P + encodeURIComponent(encodeURI(url)))).then(function (_doFetch2) {
                res = _doFetch2;
                return Promise.resolve(checkDropboxHtml(res)).then(function () {
                  if (!res) throw new Error("result is undefined");
                  _this2.successMethod = HTTP_PROXY;
                  _exit4 = true;
                  return res;
                });
              });
            }
          }();

          return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(_temp9) : _temp9(_temp10));
        } catch (e) {
          return Promise.reject(e);
        }
      };

      var httpsProxyFetch = function httpsProxyFetch(url) {
        try {
          var _temp13 = function _temp13(_result9) {
            if (_exit6) return _result9;
            throw Error(PROXY_DISABLED);
          };

          var _exit6 = false;

          var _temp14 = function () {
            if (!_this2.isProxyDisabled()) {
              return Promise.resolve(doFetch("" + h(!s) + P + encodeURIComponent(encodeURI(url)))).then(function (_doFetch3) {
                res = _doFetch3;
                return Promise.resolve(checkDropboxHtml(res)).then(function () {
                  if (!res) throw new Error("result is undefined");
                  _this2.successMethod = HTTPS_PROXY;
                  _exit6 = true;
                  return res;
                });
              });
            }
          }();

          return Promise.resolve(_temp14 && _temp14.then ? _temp14.then(_temp13) : _temp13(_temp14));
        } catch (e) {
          return Promise.reject(e);
        }
      };

      var methods = [];

      if (_this2.method === DIRECT) {
        methods.push(directFetch);
      } else if (_this2.method === HTTP_PROXY) {
        methods.push(httpProxyFetch);
      } else if (_this2.method === HTTPS_PROXY) {
        methods.push(httpsProxyFetch);
      }

      if (_this2.method !== DIRECT) {
        methods.push(directFetch);
      }

      if (_this2.method !== HTTP_PROXY) {
        methods.push(httpProxyFetch);
      }

      if (_this2.method !== HTTPS_PROXY) {
        methods.push(httpsProxyFetch);
      }

      var res = null;
      var error$1 = null;
      var _x2 = 0;

      var _temp6 = _for(function () {
        return !_exit2 && _x2 <= retries;
      }, function () {
        return _x2++;
      }, function () {
        function _temp2(_result) {
          if (_exit2) return _result;

          if (_this2.dropboxHtmlIssue) {
            _this2.dropboxHtmlIssue = false;
            info("Dropbox HTML content issue.");

            if (_this2.htmlRetries-- > 0) {
              info("Retrying Dropbox HTML error...: " + (_this2.htmlRetries + 1));
              _x2 = 0;
            }
          }

          if (_this2.updatedUrl && _this2.updatedUrl !== url) {
            url = _this2.updatedUrl;
            info("Updated URL: " + url);

            if (_this2.htmlRetries-- > 0) {
              info("Retrying HTML error...: " + (_this2.htmlRetries + 1));
              _x2 = 0;
            }
          }
        }

        if (_x2 > 0) {
          info("Retry: " + _x2);
        }

        var _temp = _catch(function () {
          return Promise.resolve(methods[0](url)).then(function (_await$methods$) {
            _exit2 = true;
            return _await$methods$;
          });
        }, function (e) {
          if (e.message !== PROXY_DISABLED) {
            error(e);
            error$1 = e;
          }

          return _catch(function () {
            return Promise.resolve(methods[1](url)).then(function (_await$methods$2) {
              _exit2 = true;
              return _await$methods$2;
            });
          }, function (e) {
            if (e.message !== PROXY_DISABLED) {
              error(e);
              error$1 = e;
            }

            return _catch(function () {
              return Promise.resolve(methods[2](url)).then(function (_await$methods$3) {
                _exit2 = true;
                return _await$methods$3;
              });
            }, function (e) {
              if (e.message !== PROXY_DISABLED) {
                error(e);
                error$1 = e;
              }
            });
          });
        });

        return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
    } catch (e) {
      return Promise.reject(e);
    }
  });

  return FetchAppData;
}();

var BaseSettings = /*#__PURE__*/function () {
  function BaseSettings(storage) {
    this.storage = storage;
  }

  var _proto = BaseSettings.prototype;

  _proto.loadBool = function loadBool(name, def) {
    if (def === void 0) {
      def = false;
    }

    try {
      var _this2 = this;

      return Promise.resolve(_this2.storage.get(name)).then(function (b) {
        return b === null ? def : b === "true";
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveBool = function saveBool(name, b) {
    try {
      var _this4 = this;

      return Promise.resolve(_this4.storage.put(name, b.toString())).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadValue = function loadValue(name, def) {
    if (def === void 0) {
      def = null;
    }

    try {
      var _this6 = this;

      return Promise.resolve(_this6.storage.get(name)).then(function (val) {
        return val === null ? def : val;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveValue = function saveValue(name, val) {
    try {
      var _this8 = this;

      var _temp2 = function () {
        if (val === null) {
          return Promise.resolve(_this8.storage.remove(name)).then(function () {});
        } else {
          return Promise.resolve(_this8.storage.put(name, val)).then(function () {});
        }
      }();

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.load = function load() {
    return Promise.resolve();
  };

  _proto.save = function save() {
    return Promise.resolve();
  };

  return BaseSettings;
}();

var Storage = /*#__PURE__*/function () {
  function Storage() {
    this.DB_NAME = "webrcade";
    this.DB_STORE = "STORAGE";
    this.UINT8_ARRAY_MARKER = "_u8a_:";
    this.OBJECT_MARKER = "_obj_:";
    this.initialized = false;
    this.localStorageAvailable = false;
    this.idxDb = null;
  }

  var _proto = Storage.prototype;

  _proto.init = function init() {
    try {
      var _this2 = this;

      if (_this2.initialized) return Promise.resolve();
      _this2.initialized = true;
      _this2.localStorageAvailable = _this2.checkLocalStorageAvailable();

      var _temp2 = _catch(function () {
        return Promise.resolve(_this2.openIndexedDb()).then(function (_this$openIndexedDb) {
          _this2.idxDb = _this$openIndexedDb;
        });
      }, function (ex) {
        error("IndexDB error: " + ex);
      });

      return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.checkLocalStorageAvailable = function checkLocalStorageAvailable() {
    var TEST = '__test__';

    try {
      localStorage.setItem(TEST, TEST);
      localStorage.removeItem(TEST);
      info("Local storage is available.");
      return true;
    } catch (e) {
      info("Local storage is not available.");
    }

    return false;
  };

  _proto.openIndexedDb = function openIndexedDb() {
    try {
      var _this4 = this;

      var DB_NAME = _this4.DB_NAME,
          DB_STORE = _this4.DB_STORE;

      if (!window.indexedDB) {
        window.indexedDB = window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
      }

      if (!window.IDBTransaction) {
        window.IDBTransaction = window.webkitIDBTransaction || window.msIDBTransaction;
      }

      if (!window.IDBKeyRange) {
        window.IDBKeyRange = window.webkitIDBKeyRange || window.msIDBKeyRange;
      }

      if (!window.indexedDB) {
        throw new Error("indexedDB is unavailable.");
      }

      return Promise.resolve(new Promise(function (resolve, reject) {
        var request = window.indexedDB.open(DB_NAME, 1);

        request.onerror = function (e) {
          info('Indexed DB error.');
          reject(e);
        };

        request.onsuccess = function (e) {
          info('Indexed DB success.');
          resolve(request.result);
        };

        request.onupgradeneeded = function (e) {
          try {
            info('Indexed DB upgrade.');
            var db = e.target.result;
            db.createObjectStore(DB_STORE);
          } catch (ex) {
            reject(ex);
          }
        };
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.put = function put(name, value) {
    try {
      var _this6 = this;

      return Promise.resolve(_this6.init()).then(function () {
        var idxDb = _this6.idxDb,
            localStorageAvailable = _this6.localStorageAvailable,
            DB_STORE = _this6.DB_STORE,
            OBJECT_MARKER = _this6.OBJECT_MARKER,
            UINT8_ARRAY_MARKER = _this6.UINT8_ARRAY_MARKER;

        if (idxDb) {
          return new Promise(function (resolve, reject) {
            var txn = idxDb.transaction([DB_STORE], "readwrite");

            txn.oncomplete = function (e) {
              resolve(true);
            };

            txn.onerror = function (e) {
              reject(e);
            };

            txn.objectStore(DB_STORE).put(value, name);
          });
        } else if (localStorageAvailable) {
          if (value instanceof Uint8Array) {
            var binary = "";
            var len = value.byteLength;

            for (var j = 0; j < len; j++) {
              binary += String.fromCharCode(value[j]);
            }

            value = UINT8_ARRAY_MARKER + btoa(binary);
          } else if (typeof value === 'object') {
            value = OBJECT_MARKER + JSON.stringify(value);
          }

          localStorage.setItem(name, value);
          return true;
        }

        info("Unable to perform put, storage not available.");
        return false;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.get = function get(name) {
    try {
      var _this8 = this;

      return Promise.resolve(_this8.init()).then(function () {
        var idxDb = _this8.idxDb,
            localStorageAvailable = _this8.localStorageAvailable,
            DB_STORE = _this8.DB_STORE,
            OBJECT_MARKER = _this8.OBJECT_MARKER,
            UINT8_ARRAY_MARKER = _this8.UINT8_ARRAY_MARKER;

        if (idxDb) {
          return new Promise(function (resolve, reject) {
            var txn = idxDb.transaction([DB_STORE], "readonly");

            txn.onerror = function (e) {
              reject(e);
            };

            var request = txn.objectStore(DB_STORE).get(name);

            request.onsuccess = function (e) {
              resolve(request.result ? request.result : null);
            };
          });
        } else if (localStorageAvailable) {
          var value = localStorage.getItem(name);

          if (typeof value === 'string') {
            if (value.startsWith(UINT8_ARRAY_MARKER)) {
              var binary = atob(value.substring(UINT8_ARRAY_MARKER.length));
              var len = binary.length;
              var bytes = new Uint8Array(len);

              for (var j = 0; j < len; j++) {
                bytes[j] = binary.charCodeAt(j);
              }

              value = bytes;
            } else if (value.startsWith(OBJECT_MARKER)) {
              value = JSON.parse(value.substring(OBJECT_MARKER.length));
            }
          }

          return value;
        }

        info("Unable to perform get, storage not available.");
        return null;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.remove = function remove(name) {
    try {
      var _this10 = this;

      return Promise.resolve(_this10.init()).then(function () {
        var idxDb = _this10.idxDb,
            localStorageAvailable = _this10.localStorageAvailable,
            DB_STORE = _this10.DB_STORE,
            OBJECT_MARKER = _this10.OBJECT_MARKER,
            UINT8_ARRAY_MARKER = _this10.UINT8_ARRAY_MARKER;

        if (idxDb) {
          return new Promise(function (resolve, reject) {
            var txn = idxDb.transaction([DB_STORE], "readwrite");

            txn.onerror = function (e) {
              reject(e);
            };

            var request = txn.objectStore(DB_STORE)["delete"](name);

            request.onsuccess = function (e) {
              resolve(true);
            };
          });
        } else if (localStorageAvailable) {
          localStorage.removeItem(name);
          return true;
        }

        info("Unable to perform remove, storage not available.");
        return false;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return Storage;
}();

var storage = new Storage();

var testMagic = function testMagic(bytes) {
  if (bytes.length < 0x100 + 15) return false;
  var str = "";

  for (var i = 0x100; i < 0x100 + 15; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  if (str.startsWith("SEGA MEGA DRIVE") || str.startsWith("SEGA GENESIS") || str.startsWith("SEGA 32X") || str.startsWith("SEGA") || str.startsWith(" SEGA")) {
    return true;
  }

  return false;
};

var testMagic$1 = function testMagic(bytes) {
  if (bytes.length < 0x10) return false;
  var str = "";

  for (var i = 0x1; i < 0x10; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  return str.startsWith("ATARI7800");
};

var getMd5 = function getMd5(blob) {
  try {
    return Promise.resolve(new Response(blob).arrayBuffer()).then(function (abuffer) {
      var _exit = false;

      var _temp = function () {
        if (testMagic$1(new Uint8Array(abuffer)) && blob.size > 0x80) {
          blob = blob.slice(0x80);
          return Promise.resolve(blobToStr(blob)).then(function (_blobToStr) {
            var _md = md5(_blobToStr);

            _exit = true;
            return _md;
          });
        }
      }();

      return _temp && _temp.then ? _temp.then(function (_result) {
        return _exit ? _result : null;
      }) : _exit ? _temp : null;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var testMagic$2 = function testMagic(bytes) {
  if (bytes.length < 4) return false;
  var str = "";

  for (var i = 0; i < 4; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  return str.startsWith("LYNX");
};

var getMd5$1 = function getMd5(blob) {
  try {
    return Promise.resolve(new Response(blob).arrayBuffer()).then(function (abuffer) {
      var _exit = false;

      var _temp = function () {
        if (testMagic$2(new Uint8Array(abuffer)) && blob.size > 0x40) {
          blob = blob.slice(0x40);
          return Promise.resolve(blobToStr(blob)).then(function (_blobToStr) {
            var _md = md5(_blobToStr);

            _exit = true;
            return _md;
          });
        }
      }();

      return _temp && _temp.then ? _temp.then(function (_result) {
        return _exit ? _result : null;
      }) : _exit ? _temp : null;
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var testInesMagic = function testInesMagic(bytes) {
  if (bytes.length < 4) return false;
  var str = "";

  for (var i = 0; i < 4; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  var ret = false;

  if (str.startsWith("NES\x1a")) {
    ret = true;
  }

  return ret;
};

var testUnifMagic = function testUnifMagic(bytes) {
  if (bytes.length < 4) return false;
  var str = "";

  for (var i = 0; i < 4; i++) {
    str += String.fromCharCode(bytes[i]);
  }

  var ret = false;

  if (str.startsWith("UNIF")) {
    ret = true;
  }

  return ret;
};

var roundUpPow2 = function roundUpPow2(v) {
  v--;
  v |= v >> 1;
  v |= v >> 2;
  v |= v >> 4;
  v |= v >> 8;
  v |= v >> 16;
  v++;
  v += v == 0;
  return v;
};

var getMd5$2 = function getMd5(blob) {
  try {
    var offset = 16;

    if (blob.size < offset) {
      return Promise.resolve(null);
    }

    return Promise.resolve(new Response(blob).arrayBuffer()).then(function (abuffer) {
      var bufArray = new Uint8Array(abuffer);

      if (!testInesMagic(bufArray)) {
        return null;
      }

      var romSize = roundUpPow2(bufArray[4]);
      var vromSize = roundUpPow2(bufArray[5]);
      var romType = bufArray[6];

      if (romType & 4) {
        info('offset for trainer.');
        offset += 512;
      }

      var length = romSize * 0x4000 + vromSize * 0x2000;
      blob = blob.slice(offset, length + offset);
      return Promise.resolve(blobToStr(blob)).then(md5);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var testMagic$3 = function testMagic(bytes) {
  return testInesMagic(bytes) || testUnifMagic(bytes);
};

var testMagic$4 = function testMagic(bytes) {
  if (bytes.length < 2) return false;

  if (bytes[0] == 0x55 && bytes[1] == 0xAA || bytes[0] == 0xAA && bytes[1] == 0x55) {
    return true;
  }

  if (bytes.length >= 0x4000) {
    var byte0 = bytes.length - 0x4000;
    var byte1 = bytes.length - 0x4000 + 1;
    return bytes[byte0] == 0x55 && bytes[byte1] == 0xAA || bytes[byte0] == 0xAA && bytes[byte1] == 0x55;
  }

  return false;
};

var _excluded = ["key"];
var localIp$1 = config.getLocalIp();
var locGenesis = isDev() ? "http://" + localIp$1 + ":3010" : 'app/genesis/';
var locSms = locGenesis;
var locRetroGenesis = isDev() ? "http://" + localIp$1 + ":3101" : 'app/retro-genesis/';
var locRetroPceFast = isDev() ? "http://" + localIp$1 + ":3202" : 'app/retro-pce-fast/';
var locRetroStella = isDev() ? "http://" + localIp$1 + ":3312" : 'app/retro-stella/';
var locRetroStellaLatest = isDev() ? "http://" + localIp$1 + ":3314" : 'app/retro-stella-latest/';
var locRetroCommodore8Bit = isDev() ? "http://" + localIp$1 + ":3315" : 'app/retro-commodore-8bit/';
var locPsx = isDev() ? "http://" + localIp$1 + ":3099" : 'app/psx/';
var loc7800 = isDev() ? "http://" + localIp$1 + ":3020" : 'app/7800/';
var locNes = isDev() ? "http://" + localIp$1 + ":3030" : 'app/nes/';
var locDoom = isDev() ? "http://" + localIp$1 + ":3040" : 'app/doom/';
var loc2600 = isDev() ? "http://" + localIp$1 + ":3050" : 'app/2600/';
var locSnes = isDev() ? "http://" + localIp$1 + ":3060" : 'app/snes/';
var locN64 = isDev() ? "http://" + localIp$1 + ":3065" : 'app/n64/';
var locGba = isDev() ? "http://" + localIp$1 + ":3070" : 'app/gba/';
var locNeo = isDev() ? "http://" + localIp$1 + ":3077" : 'app/neo/';
var locMednafen = isDev() ? "http://" + localIp$1 + ":3075" : 'app/mednafen/';
var locColeco = isDev() ? "http://" + localIp$1 + ":3303" : 'app/colem/';
var loc5200 = isDev() ? "http://" + localIp$1 + ":3304" : 'app/5200/';
var locPcfx = isDev() ? "http://" + localIp$1 + ":3305" : 'app/pcfx/';
var locRetro5200 = isDev() ? "http://" + localIp$1 + ":3306" : 'app/retro-a5200/';
var locRetroNeocd = isDev() ? "http://" + localIp$1 + ":3307" : 'app/retro-neocd/';
var locQuake = isDev() ? "http://" + localIp$1 + ":3308" : 'app/quake/';
var locRetro3dO = isDev() ? "http://" + localIp$1 + ":3311" : 'app/3do/';
var locScummVm = isDev() ? "http://" + localIp$1 + ":3313" : 'app/scummvm/';
var locStandalone = isDev() ? "http://" + localIp$1 + ":3080" : 'app/standalone/';

var checkRom = function checkRom(app) {
  if (app.props === undefined || isEmptyString(app.props.rom)) {
    throw new Error("Missing 'rom' property");
  }
};

var checkArchive = function checkArchive(app) {
  if (app.props === undefined || isEmptyString(app.props.archive)) {
    throw new Error("Missing 'archive' property");
  }
};

var checkDiscs = function checkDiscs(app) {
  if (app.props === undefined || app.props.discs === undefined || app.props.discs.length === 0) {
    throw new Error("Missing 'discs' property");
  }
};

var checkMedia = function checkMedia(app) {
  if (app.props === undefined || (app.props.media === undefined || app.props.media.length === 0) && (app.props.saveDisks === undefined || app.props.saveDisks <= 0)) {
    throw new Error("Missing 'media' property");
  }
};

var APP_TYPE_KEYS = {
  AT5200: "a5200",
  BEETLE_PSX: "beetle-psx",
  BEETLE_PCFX: "beetle-pcfx",
  COLEM: "colem",
  COMMODORE_C64: "commodore-c64",
  FBNEO_ARCADE: "fbneo-arcade",
  FBNEO_CAPCOM: "fbneo-capcom",
  FBNEO_KONAMI: "fbneo-konami",
  FBNEO_NEOGEO: "fbneo-neogeo",
  FCEUX: "fceux",
  GENPLUSGX_GG: "genplusgx-gg",
  GENPLUSGX_MD: "genplusgx-md",
  GENPLUSGX_SG: "genplusgx-sg",
  GENPLUSGX_SMS: "genplusgx-sms",
  JAVATARI: "javatari",
  JS7800: "js7800",
  MEDNAFEN_LNX: "mednafen-lnx",
  MEDNAFEN_NGC: "mednafen-ngc",
  MEDNAFEN_NGP: "mednafen-ngp",
  MEDNAFEN_PCE: "mednafen-pce",
  MEDNAFEN_SGX: "mednafen-sgx",
  MEDNAFEN_VB: "mednafen-vb",
  MEDNAFEN_WSC: "mednafen-wsc",
  MEDNAFEN_WS: "mednafen-ws",
  PCFX: "pcfx",
  PRBOOM: "prboom",
  PSX: "psx",
  RETRO_COMMODORE_C64: "retro-commodore-c64",
  RETRO_GENPLUSGX_SEGACD: "retro-genplusgx-segacd",
  RETRO_PCE_FAST: "retro-pce-fast",
  RETRO_NEOCD: "retro-neocd",
  RETRO_OPERA: "retro-opera",
  RETRO_PARALLEL_N64: "retro-parallel-n64",
  RETRO_STELLA: "retro-stella",
  RETRO_STELLA_LATEST: "retro-stella-latest",
  SCUMMVM: "scummvm",
  SNES9X: "snes9x",
  TYRQUAKE: "tyrquake",
  VBA_M_GBA: "vba-m-gba",
  VBA_M_GB: "vba-m-gb",
  VBA_M_GBC: "vba-m-gbc",
  A2600: "2600",
  A7800: "7800",
  ARCADE: "arcade",
  ARCADE_KONAMI: "arcade-konami",
  ARCADE_CAPCOM: "arcade-capcom",
  COLECO: "coleco",
  DOOM: "doom",
  GBA: "gba",
  GB: "gb",
  GBC: "gbc",
  GENESIS: "genesis",
  GG: "gg",
  LNX: "lnx",
  NEOGEO: "neogeo",
  NEOGEOCD: "neogeocd",
  NES: "nes",
  NGC: "ngc",
  NGP: "ngp",
  PCE: "pce",
  PCECD: "pcecd",
  QUAKE: "quake",
  SCUMM: "scumm",
  SEGACD: "segacd",
  SG1000: 'sg1000',
  SGX: 'sgx',
  SMS: "sms",
  SNES: "snes",
  THREEDO: "3do",
  VB: "vb",
  WSC: "wsc",
  WS: "ws"
};
var PCE_DEFAULTS = {
  rom: "",
  pad6button: false,
  zoomLevel: 0
};
var WS_DEFAULTS = {
  rom: "",
  rotated: false,
  language: 0,
  zoomLevel: 0
};
var NGP_DEFAULTS = {
  rom: "",
  language: 0,
  zoomLevel: 0
};
var ARCADE_DEFAULTS = {
  rom: "",
  additionalRoms: [],
  volAdjust: 0,
  samples: "",
  playerOrder: "0:1:2:3",
  zoomLevel: 0
};
var types = [{
  key: APP_TYPE_KEYS.FBNEO_NEOGEO,
  alias: APP_TYPE_KEYS.NEOGEO,
  name: 'SNK Neo Geo',
  shortName: 'SNK Neo Geo',
  coreName: 'Final Burn Neo',
  location: locNeo,
  background: 'images/app/neogeo-background.png',
  thumbnail: 'images/app/neogeo-thumb.png',
  validate: checkRom,
  extensions: [],
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.neogeo_bios;

    if (bios) {
      outProps.neogeo_bios = bios;
    }
  },
  defaults: {
    rom: "",
    additionalRoms: [],
    volAdjust: 0,
    bios: 0,
    forceAesMode: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.FBNEO_ARCADE,
  alias: APP_TYPE_KEYS.ARCADE,
  name: 'Arcade',
  shortName: 'Arcade',
  coreName: 'Final Burn Neo',
  location: locNeo,
  background: 'images/app/arcade-background.png',
  thumbnail: 'images/app/arcade-thumb.png',
  validate: checkRom,
  extensions: [],
  defaults: ARCADE_DEFAULTS
}, {
  key: APP_TYPE_KEYS.FBNEO_KONAMI,
  alias: APP_TYPE_KEYS.ARCADE_KONAMI,
  name: 'Arcade: Konami',
  shortName: 'Arcade: Konami',
  coreName: 'Final Burn Neo',
  location: locNeo,
  background: 'images/app/konami-background.png',
  thumbnail: 'images/app/konami-thumb.png',
  validate: checkRom,
  extensions: [],
  defaults: ARCADE_DEFAULTS
}, {
  key: APP_TYPE_KEYS.FBNEO_CAPCOM,
  alias: APP_TYPE_KEYS.ARCADE_CAPCOM,
  name: 'Arcade: Capcom',
  shortName: 'Arcade: Capcom',
  coreName: 'Final Burn Neo',
  location: locNeo,
  background: 'images/app/capcom-background.png',
  thumbnail: 'images/app/capcom-thumb.png',
  validate: checkRom,
  extensions: [],
  defaults: ARCADE_DEFAULTS
}, {
  key: APP_TYPE_KEYS.SNES9X,
  alias: APP_TYPE_KEYS.SNES,
  name: 'Super Nintendo',
  shortName: 'Nintendo SNES',
  coreName: 'SNES9X',
  location: locSnes,
  thumbnail: "images/app/snes-thumb.png",
  background: "images/app/snes-background.png",
  validate: checkRom,
  extensions: ['smc', 'sfc', 'swc'],
  defaults: {
    rom: "",
    zoomLevel: 0,
    pal: false,
    port2: 0
  }
}, {
  key: APP_TYPE_KEYS.JAVATARI,
  alias: APP_TYPE_KEYS.A2600,
  name: 'Atari 2600',
  coreName: 'Javatari',
  location: loc2600,
  thumbnail: "images/app/2600-thumb.png",
  background: "images/app/2600-background.png",
  validate: checkRom,
  extensions: ['a26'],
  defaults: {
    rom: "",
    swap: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.RETRO_STELLA,
  alias: APP_TYPE_KEYS.A2600,
  name: 'Atari 2600',
  coreName: 'Libretro Stella 2014',
  location: locRetroStella,
  thumbnail: "images/app/2600-thumb.png",
  background: "images/app/2600-background.png",
  validate: checkRom,
  extensions: ['a26'],
  defaults: {
    rom: "",
    swap: false,
    zoomLevel: 0,
    port0: 0,
    port1: 0,
    paddleSensitivity: 0,
    paddleCenter: 0,
    paddleVertical: false,
    paddleInverted: false
  }
}, {
  key: APP_TYPE_KEYS.RETRO_COMMODORE_C64,
  alias: APP_TYPE_KEYS.COMMODORE_C64,
  name: 'Commodore 64',
  coreName: 'Libretro Commodore 64',
  location: locRetroCommodore8Bit,
  thumbnail: "images/app/c64-thumb.png",
  background: "images/app/c64-background.png",
  validate: checkMedia,
  extensions: ['d64', 'd81', 'g64', 't64', 'tap', 'crt', 'prg', 'nib', 'nbz'],
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.commodore8bit_bios;

    if (bios) {
      outProps.commodore8bit_bios = bios;
    }
  },
  defaults: {
    uid: "",
    media: [],
    swap: false,
    zoomLevel: 0,
    jiffydos: 0,
    region: 0,
    saveDisks: 1,
    disableAutoload: false,
    disableTrueDriveEmulation: false,
    ramExpansion: 0,
    mappings: {}
  }
}, {
  key: APP_TYPE_KEYS.RETRO_STELLA_LATEST,
  alias: APP_TYPE_KEYS.A2600,
  name: 'Atari 2600',
  coreName: 'Libretro Stella',
  location: locRetroStellaLatest,
  thumbnail: "images/app/2600-thumb.png",
  background: "images/app/2600-background.png",
  validate: checkRom,
  extensions: ['a26'],
  defaults: {
    rom: "",
    swap: false,
    zoomLevel: 0,
    port0: 0,
    port1: 0,
    paddleSensitivity: 0,
    paddleCenter: 0,
    paddleVertical: false,
    paddleInverted: false
  }
}, {
  key: APP_TYPE_KEYS.JS7800,
  alias: APP_TYPE_KEYS.A7800,
  name: 'Atari 7800',
  coreName: 'JS7800',
  location: loc7800,
  background: 'images/app/7800-background.png',
  thumbnail: 'images/app/7800-thumb.png',
  validate: checkRom,
  extensions: ['a78'],
  testMagic: testMagic$1,
  getMd5: getMd5,
  defaults: {
    rom: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.GENPLUSGX_MD,
  alias: APP_TYPE_KEYS.GENESIS,
  name: 'Sega Genesis',
  coreName: 'Genesis Plus GX',
  location: locGenesis,
  background: 'images/app/genesis-background.png',
  thumbnail: 'images/app/genesis-thumb.png',
  validate: checkRom,
  extensions: ['smd', 'md', 'gen'],
  testMagic: testMagic,
  defaults: {
    rom: "",
    pal: false,
    pad3button: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.FCEUX,
  alias: APP_TYPE_KEYS.NES,
  name: 'Nintendo Entertainment System',
  shortName: 'Nintendo NES',
  coreName: 'FCEUX',
  location: locNes,
  background: 'images/app/nes-background.png',
  thumbnail: 'images/app/nes-thumb.png',
  validate: checkRom,
  extensions: ['nes'],
  testMagic: testMagic$3,
  getMd5: getMd5$2,
  defaults: {
    rom: "",
    pal: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.COLEM,
  alias: APP_TYPE_KEYS.COLECO,
  name: 'ColecoVision',
  shortName: 'ColecoVision',
  coreName: 'Colem',
  location: locColeco,
  background: 'images/app/colecovision-background.png',
  thumbnail: 'images/app/colecovision-thumb.png',
  validate: checkRom,
  extensions: ['col'],
  testMagic: testMagic$4,
  testMagicLast: true,
  addProps: function addProps(feedProps, outProps) {
    var rom = feedProps.coleco_rom;

    if (rom) {
      outProps.coleco_rom = rom;
    }
  },
  defaults: {
    rom: "",
    zoomLevel: 0,
    descriptions: {},
    mappings: {},
    controlsMode: 0
  }
}, {
  key: APP_TYPE_KEYS.GENPLUSGX_SMS,
  alias: APP_TYPE_KEYS.SMS,
  name: 'Sega Master System',
  coreName: 'Genesis Plus GX',
  location: locSms,
  background: 'images/app/mastersystem-background.png',
  thumbnail: 'images/app/mastersystem-thumb.png',
  validate: checkRom,
  extensions: ['sms'],
  defaults: {
    rom: "",
    hwType: 0,
    pal: false,
    ym2413: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.GENPLUSGX_SG,
  alias: APP_TYPE_KEYS.SG1000,
  name: 'Sega SG-1000',
  coreName: 'Genesis Plus GX',
  location: locSms,
  background: 'images/app/sg1000-background.png',
  thumbnail: 'images/app/sg1000-thumb.png',
  validate: checkRom,
  extensions: ['sg'],
  defaults: {
    rom: "",
    pal: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.GENPLUSGX_GG,
  alias: APP_TYPE_KEYS.GG,
  name: 'Sega Game Gear',
  coreName: 'Genesis Plus GX',
  location: locSms,
  background: 'images/app/gamegear-background.png',
  thumbnail: 'images/app/gamegear-thumb.png',
  validate: checkRom,
  extensions: ['gg'],
  defaults: {
    rom: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.VBA_M_GBA,
  alias: APP_TYPE_KEYS.GBA,
  name: 'Nintendo Game Boy Advance',
  shortName: 'Nintendo GBA',
  coreName: 'VBA-M',
  location: locGba,
  background: 'images/app/gba-background.png',
  thumbnail: 'images/app/gba-thumb.png',
  validate: checkRom,
  extensions: ['gba'],
  defaults: {
    rom: "",
    rotation: 0,
    rtc: false,
    mirroring: false,
    saveType: 0,
    flashSize: 65536,
    disableLookup: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.VBA_M_GB,
  alias: APP_TYPE_KEYS.GB,
  name: 'Nintendo Game Boy',
  shortName: 'Nintendo Game Boy',
  coreName: 'VBA-M',
  location: locGba,
  background: 'images/app/gb-background.png',
  thumbnail: 'images/app/gb-thumb.png',
  validate: checkRom,
  extensions: ['gb'],
  defaults: {
    rom: "",
    hwType: 0,
    colors: 0,
    palette: 0,
    border: 0,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.VBA_M_GBC,
  alias: APP_TYPE_KEYS.GBC,
  name: 'Nintendo Game Boy Color',
  shortName: 'Nintendo Game Boy Color',
  coreName: 'VBA-M',
  location: locGba,
  background: 'images/app/gbc-background.png',
  thumbnail: 'images/app/gbc-thumb.png',
  validate: checkRom,
  extensions: ['gbc'],
  defaults: {
    rom: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_PCE,
  alias: APP_TYPE_KEYS.PCE,
  name: 'NEC PC Engine',
  shortName: 'NEC PC Engine',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/pce-background.png',
  thumbnail: 'images/app/pce-thumb.png',
  validate: checkRom,
  extensions: ['pce'],
  defaults: _extends({}, PCE_DEFAULTS, {
    mapRunSelect: false
  })
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_SGX,
  alias: APP_TYPE_KEYS.SGX,
  name: 'NEC SuperGrafx',
  shortName: 'NEC SuperGrafx',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/sgx-background.png',
  thumbnail: 'images/app/sgx-thumb.png',
  validate: checkRom,
  extensions: ['sgx'],
  defaults: PCE_DEFAULTS
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_VB,
  alias: APP_TYPE_KEYS.VB,
  name: 'Nintendo Virtual Boy',
  shortName: 'Nintendo Virtual Boy',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/vb-background.png',
  thumbnail: 'images/app/vb-thumb.png',
  validate: checkRom,
  extensions: ['vb'],
  defaults: {
    rom: "",
    pad6button: false,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_NGC,
  alias: APP_TYPE_KEYS.NGC,
  name: 'SNK Neo Geo Pocket Color',
  shortName: 'SNK Neo Geo Pocket Color',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/ngc-background.png',
  thumbnail: 'images/app/ngc-thumb.png',
  validate: checkRom,
  extensions: ['ngc'],
  defaults: NGP_DEFAULTS
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_NGP,
  alias: APP_TYPE_KEYS.NGP,
  name: 'SNK Neo Geo Pocket',
  shortName: 'SNK Neo Geo Pocket',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/ngp-background.png',
  thumbnail: 'images/app/ngp-thumb.png',
  validate: checkRom,
  extensions: ['ngp'],
  defaults: NGP_DEFAULTS
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_WSC,
  alias: APP_TYPE_KEYS.WSC,
  name: 'Bandai WonderSwan Color',
  shortName: 'Bandai WonderSwan Color',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/wsc-background.png',
  thumbnail: 'images/app/wsc-thumb.png',
  validate: checkRom,
  extensions: ['wsc'],
  defaults: WS_DEFAULTS
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_WS,
  alias: APP_TYPE_KEYS.WS,
  name: 'Bandai WonderSwan',
  shortName: 'Bandai WonderSwan',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/ws-background.png',
  thumbnail: 'images/app/ws-thumb.png',
  validate: checkRom,
  extensions: ['ws'],
  defaults: WS_DEFAULTS
}, {
  key: APP_TYPE_KEYS.MEDNAFEN_LNX,
  alias: APP_TYPE_KEYS.LNX,
  name: 'Atari Lynx',
  shortName: 'Atari Lynx',
  coreName: 'Mednafen',
  location: locMednafen,
  background: 'images/app/lynx-background.png',
  thumbnail: 'images/app/lynx-thumb.png',
  validate: checkRom,
  extensions: ['lnx'],
  testMagic: testMagic$2,
  getMd5: getMd5$1,
  addProps: function addProps(feedProps, outProps) {
    var boot = feedProps.lnx_boot;

    if (boot) {
      outProps.lnx_boot = boot;
    }
  },
  defaults: {
    rom: "",
    rotation: 0,
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.BEETLE_PSX,
  alias: APP_TYPE_KEYS.PSX,
  name: 'Sony PlayStation',
  shortName: 'Sony PlayStation',
  coreName: 'Beetle PSX',
  location: locPsx,
  background: 'images/app/playstation-background.png',
  thumbnail: 'images/app/playstation-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.psx_bios;

    if (bios) {
      outProps.psx_bios = bios;
    }
  },
  defaults: {
    discs: [],
    sbi: [],
    multitap: false,
    analog: false,
    uid: "",
    zoomLevel: 0,
    skipBios: false,
    disableMemCard1: false
  }
}, {
  key: APP_TYPE_KEYS.RETRO_GENPLUSGX_SEGACD,
  alias: APP_TYPE_KEYS.SEGACD,
  name: 'Sega CD',
  shortName: 'Sega CD',
  coreName: 'Libretro Genesis Plus GX',
  location: locRetroGenesis,
  background: 'images/app/segacd-background.png',
  thumbnail: 'images/app/segacd-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.segacd_bios;

    if (bios) {
      outProps.segacd_bios = bios;
    }
  },
  defaults: {
    discs: [],
    uid: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.RETRO_PCE_FAST,
  alias: APP_TYPE_KEYS.PCECD,
  name: 'NEC PC Engine CD',
  shortName: 'NEC PC Engine CD',
  coreName: 'Libretro PCE Fast',
  location: locRetroPceFast,
  background: 'images/app/pcecd-background.png',
  thumbnail: 'images/app/pcecd-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.pcecd_bios;

    if (bios) {
      outProps.pcecd_bios = bios;
    }
  },
  defaults: {
    discs: [],
    uid: "",
    zoomLevel: 0,
    pad6button: false,
    mapRunSelect: false,
    customBios: ""
  }
}, {
  key: APP_TYPE_KEYS.RETRO_NEOCD,
  alias: APP_TYPE_KEYS.NEOGEOCD,
  name: 'SNK Neo Geo CD',
  shortName: 'SNK Neo Geo CD',
  coreName: 'Libretro NeoCD',
  location: locRetroNeocd,
  background: 'images/app/neogeocd-background.png',
  thumbnail: 'images/app/neogeocd-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.neogeocd_bios;

    if (bios) {
      outProps.neogeocd_bios = bios;
    }
  },
  defaults: {
    discs: [],
    uid: "",
    zoomLevel: 0,
    region: 0,
    cdSpeedHack: true,
    skipCdLoading: true
  }
}, {
  key: APP_TYPE_KEYS.RETRO_OPERA,
  alias: APP_TYPE_KEYS.THREEDO,
  name: '3DO',
  shortName: '3DO',
  coreName: 'Libretro Opera',
  location: locRetro3dO,
  background: 'images/app/3do-background.png',
  thumbnail: 'images/app/3do-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.threedo_bios;
    var fonts = feedProps.threedo_fonts;

    if (bios) {
      outProps.threedo_bios = bios;
    }

    if (fonts) {
      outProps.threedo_fonts = fonts;
    }
  },
  defaults: {
    discs: [],
    uid: "",
    zoomLevel: 0,
    hack: 0
  }
}, {
  key: APP_TYPE_KEYS.BEETLE_PCFX,
  alias: APP_TYPE_KEYS.PCFX,
  name: 'NEC PC-FX',
  shortName: 'NEC PC-FX',
  coreName: 'Beetle PC-FX',
  location: locPcfx,
  background: 'images/app/pcfx-background.png',
  thumbnail: 'images/app/pcfx-thumb.png',
  validate: checkDiscs,
  extensions: [],
  slowExit: true,
  addProps: function addProps(feedProps, outProps) {
    var bios = feedProps.pcfx_bios;

    if (bios) {
      outProps.pcfx_bios = bios;
    }
  },
  defaults: {
    discs: [],
    uid: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.TYRQUAKE,
  alias: APP_TYPE_KEYS.QUAKE,
  name: 'Quake',
  coreName: 'TyrQuake',
  slowExit: true,
  location: locQuake,
  background: 'images/app/quake-background.png',
  thumbnail: 'images/app/quake-thumb.png',
  validate: checkArchive,
  extensions: [],
  defaults: {
    archive: "",
    wadType: 0,
    wadPath: "",
    uid: "",
    zoomLevel: 0
  }
}, {
  key: APP_TYPE_KEYS.SCUMMVM,
  alias: APP_TYPE_KEYS.SCUMM,
  name: 'ScummVM',
  coreName: 'ScummVM',
  slowExit: true,
  location: locScummVm,
  background: 'images/app/scummvm-background.png',
  thumbnail: 'images/app/scummvm-thumb.png',
  validate: checkArchive,
  extensions: [],
  defaults: {
    archive: "",
    uid: "",
    zoomLevel: 0
  }
}];

var addAlias = function addAlias(types, alias, typeKey) {
  var _types$filter$ = types.filter(function (t) {
    return t.key === typeKey;
  })[0],
      props = _objectWithoutPropertiesLoose(_types$filter$, _excluded);

  types.push(_extends({
    key: alias,
    absoluteKey: typeKey
  }, props));
};

if (config.isPublicServer()) {
  types.push({
    key: APP_TYPE_KEYS.PRBOOM,
    alias: APP_TYPE_KEYS.DOOM,
    name: 'Doom Classic',
    coreName: 'PrBoom',
    location: locDoom,
    background: 'images/app/doom-background.png',
    thumbnail: 'images/app/doom-thumb.png',
    isDelayedExit: true,
    validate: function validate(app) {
      if (app.props === undefined || isEmptyString(app.props.game)) {
        throw new Error("Missing 'game' property");
      }
    },
    defaults: {
      game: ""
    }
  });
  addAlias(types, APP_TYPE_KEYS.DOOM, APP_TYPE_KEYS.PRBOOM);
}

addAlias(types, APP_TYPE_KEYS.A2600, APP_TYPE_KEYS.RETRO_STELLA_LATEST);
addAlias(types, APP_TYPE_KEYS.A7800, APP_TYPE_KEYS.JS7800);
addAlias(types, APP_TYPE_KEYS.ARCADE, APP_TYPE_KEYS.FBNEO_ARCADE);
addAlias(types, APP_TYPE_KEYS.ARCADE_CAPCOM, APP_TYPE_KEYS.FBNEO_CAPCOM);
addAlias(types, APP_TYPE_KEYS.ARCADE_KONAMI, APP_TYPE_KEYS.FBNEO_KONAMI);
addAlias(types, APP_TYPE_KEYS.COLECO, APP_TYPE_KEYS.COLEM);
addAlias(types, APP_TYPE_KEYS.COMMODORE_C64, APP_TYPE_KEYS.RETRO_COMMODORE_C64);
addAlias(types, APP_TYPE_KEYS.GBA, APP_TYPE_KEYS.VBA_M_GBA);
addAlias(types, APP_TYPE_KEYS.GB, APP_TYPE_KEYS.VBA_M_GB);
addAlias(types, APP_TYPE_KEYS.GBC, APP_TYPE_KEYS.VBA_M_GBC);
addAlias(types, APP_TYPE_KEYS.GENESIS, APP_TYPE_KEYS.GENPLUSGX_MD);
addAlias(types, APP_TYPE_KEYS.GG, APP_TYPE_KEYS.GENPLUSGX_GG);
addAlias(types, APP_TYPE_KEYS.LNX, APP_TYPE_KEYS.MEDNAFEN_LNX);
addAlias(types, APP_TYPE_KEYS.NEOGEO, APP_TYPE_KEYS.FBNEO_NEOGEO);
addAlias(types, APP_TYPE_KEYS.NEOGEOCD, APP_TYPE_KEYS.RETRO_NEOCD);
addAlias(types, APP_TYPE_KEYS.NES, APP_TYPE_KEYS.FCEUX);
addAlias(types, APP_TYPE_KEYS.NGC, APP_TYPE_KEYS.MEDNAFEN_NGC);
addAlias(types, APP_TYPE_KEYS.NGP, APP_TYPE_KEYS.MEDNAFEN_NGP);
addAlias(types, APP_TYPE_KEYS.PCE, APP_TYPE_KEYS.MEDNAFEN_PCE);
addAlias(types, APP_TYPE_KEYS.PCECD, APP_TYPE_KEYS.RETRO_PCE_FAST);
addAlias(types, APP_TYPE_KEYS.PCFX, APP_TYPE_KEYS.BEETLE_PCFX);
addAlias(types, APP_TYPE_KEYS.PSX, APP_TYPE_KEYS.BEETLE_PSX);
addAlias(types, APP_TYPE_KEYS.QUAKE, APP_TYPE_KEYS.TYRQUAKE);
addAlias(types, APP_TYPE_KEYS.SCUMM, APP_TYPE_KEYS.SCUMMVM);
addAlias(types, APP_TYPE_KEYS.SEGACD, APP_TYPE_KEYS.RETRO_GENPLUSGX_SEGACD);
addAlias(types, APP_TYPE_KEYS.SG1000, APP_TYPE_KEYS.GENPLUSGX_SG);
addAlias(types, APP_TYPE_KEYS.SGX, APP_TYPE_KEYS.MEDNAFEN_SGX);
addAlias(types, APP_TYPE_KEYS.SMS, APP_TYPE_KEYS.GENPLUSGX_SMS);
addAlias(types, APP_TYPE_KEYS.SNES, APP_TYPE_KEYS.SNES9X);
addAlias(types, APP_TYPE_KEYS.THREEDO, APP_TYPE_KEYS.RETRO_OPERA);
addAlias(types, APP_TYPE_KEYS.VB, APP_TYPE_KEYS.MEDNAFEN_VB);
addAlias(types, APP_TYPE_KEYS.WSC, APP_TYPE_KEYS.MEDNAFEN_WSC);
addAlias(types, APP_TYPE_KEYS.WS, APP_TYPE_KEYS.MEDNAFEN_WS);
var APP_TYPES = types;

var enableExperimentalApps = function enableExperimentalApps(b) {
  var clone = [].concat(APP_TYPES);
  APP_TYPES.length = 0;

  for (var i = 0; i < clone.length; i++) {
    var t = clone[i];

    if ((!APP_TYPE_KEYS.PARALLEL_N64 || t.key !== APP_TYPE_KEYS.PARALLEL_N64) && (!APP_TYPE_KEYS.N64 || t.key !== APP_TYPE_KEYS.N64)) {
      APP_TYPES.push(t);
    }
  }

  delete APP_TYPE_KEYS.PARALLEL_N64;
  delete APP_TYPE_KEYS.N64;

  if (b) {
    APP_TYPE_KEYS.PARALLEL_N64 = "parallel-n64";
    APP_TYPE_KEYS.N64 = "n64";
    APP_TYPES.push({
      key: APP_TYPE_KEYS.PARALLEL_N64,
      alias: APP_TYPE_KEYS.N64,
      name: 'Nintendo 64',
      coreName: 'paraLLEl N64',
      location: locN64,
      background: 'images/app/n64-background.png',
      thumbnail: 'images/app/n64-thumb.png',
      validate: checkRom,
      extensions: ['n64', 'v64', 'z64'],
      isDelayedExit: true,
      addParams: function addParams(url) {
        url = UrlUtil.addParam(url, "n64", "1");
        var N64_SKIP_RP = "n64.skip";
        var n64skip = UrlUtil.getParam(window.location.search, N64_SKIP_RP);

        if (n64skip) {
          url = UrlUtil.addParam(url, N64_SKIP_RP, n64skip);
        }

        var N64_VBO_RP = "n64.vbo";
        var n64vbo = UrlUtil.getParam(window.location.search, N64_VBO_RP);

        if (n64vbo) {
          url = UrlUtil.addParam(url, N64_VBO_RP, n64vbo);
        }

        return url;
      },
      defaults: {
        rom: "",
        zoomLevel: 0
      }
    });
    addAlias(APP_TYPES, APP_TYPE_KEYS.N64, APP_TYPE_KEYS.PARALLEL_N64);
  }

  for (var _i = 0; _i < clone.length; _i++) {
    var _t = clone[_i];

    if ((!APP_TYPE_KEYS.RETRO_A5200 || _t.key !== APP_TYPE_KEYS.RETRO_A5200) && (!APP_TYPE_KEYS.A5200 || _t.key !== APP_TYPE_KEYS.A5200)) {
      APP_TYPES.push(_t);
    }
  }

  delete APP_TYPE_KEYS.RETRO_A5200;
  delete APP_TYPE_KEYS.A5200;

  if (b) {
    APP_TYPE_KEYS.RETRO_A5200 = "retro-5200";
    APP_TYPE_KEYS.A5200 = "5200";
    APP_TYPES.push({
      key: APP_TYPE_KEYS.RETRO_A5200,
      alias: APP_TYPE_KEYS.A5200,
      name: 'Atari 5200',
      coreName: 'Libretro A5200',
      location: locRetro5200,
      background: 'images/app/5200-background.png',
      thumbnail: 'images/app/5200-thumb.png',
      validate: checkRom,
      extensions: ['a52'],
      addProps: function addProps(feedProps, outProps) {
        var rom = feedProps.atari5200_rom;

        if (rom) {
          outProps.atari5200_rom = rom;
        }
      },
      defaults: {
        rom: "",
        zoomLevel: 0,
        swap: false,
        analog: false,
        twinStick: false,
        descriptions: {},
        mappings: {}
      }
    });
    addAlias(types, APP_TYPE_KEYS.A5200, APP_TYPE_KEYS.RETRO_A5200);
  }
};

var getStandaloneLocation = function getStandaloneLocation() {
  return locStandalone;
};

var add_circle_outline_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDdjLS41NSAwLTEgLjQ1LTEgMXYzSDhjLS41NSAwLTEgLjQ1LTEgMXMuNDUgMSAxIDFoM3YzYzAgLjU1LjQ1IDEgMSAxczEtLjQ1IDEtMXYtM2gzYy41NSAwIDEtLjQ1IDEtMXMtLjQ1LTEtMS0xaC0zVjhjMC0uNTUtLjQ1LTEtMS0xem0wLTVDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPg==';
var add_circle_outline_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDdjLS41NSAwLTEgLjQ1LTEgMXYzSDhjLS41NSAwLTEgLjQ1LTEgMXMuNDUgMSAxIDFoM3YzYzAgLjU1LjQ1IDEgMSAxczEtLjQ1IDEtMXYtM2gzYy41NSAwIDEtLjQ1IDEtMXMtLjQ1LTEtMS0xaC0zVjhjMC0uNTUtLjQ1LTEtMS0xem0wLTVDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4eiIvPjwvc3ZnPg==';
var album_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDJDNi40OCAyIDIgNi40OCAyIDEyczQuNDggMTAgMTAgMTAgMTAtNC40OCAxMC0xMFMxNy41MiAyIDEyIDJ6bTAgMThjLTQuNDEgMC04LTMuNTktOC04czMuNTktOCA4LTggOCAzLjU5IDggOC0zLjU5IDgtOCA4em0wLTEyLjVjLTIuNDkgMC00LjUgMi4wMS00LjUgNC41czIuMDEgNC41IDQuNSA0LjUgNC41LTIuMDEgNC41LTQuNS0yLjAxLTQuNS00LjUtNC41em0wIDUuNWMtLjU1IDAtMS0uNDUtMS0xcy40NS0xIDEtMSAxIC40NSAxIDEtLjQ1IDEtMSAxeiIvPjwvc3ZnPg==';
var arrow_back_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNGRkZGRkYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Im0zMTMtNDQwIDE5NiAxOTZxMTIgMTIgMTEuNSAyOFQ1MDgtMTg4cS0xMiAxMS0yOCAxMS41VDQ1Mi0xODhMMTg4LTQ1MnEtNi02LTguNS0xM3QtMi41LTE1cTAtOCAyLjUtMTV0OC41LTEzbDI2NC0yNjRxMTEtMTEgMjcuNS0xMXQyOC41IDExcTEyIDEyIDEyIDI4LjVUNTA4LTcxNUwzMTMtNTIwaDQ0N3ExNyAwIDI4LjUgMTEuNVQ4MDAtNDgwcTAgMTctMTEuNSAyOC41VDc2MC00NDBIMzEzWiIvPjwvc3ZnPgo=';
var arrow_back_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5IDExSDcuODNsNC44OC00Ljg4Yy4zOS0uMzkuMzktMS4wMyAwLTEuNDItLjM5LS4zOS0xLjAyLS4zOS0xLjQxIDBsLTYuNTkgNi41OWMtLjM5LjM5LS4zOSAxLjAyIDAgMS40MWw2LjU5IDYuNTljLjM5LjM5IDEuMDIuMzkgMS40MSAwIC4zOS0uMzkuMzktMS4wMiAwLTEuNDFMNy44MyAxM0gxOWMuNTUgMCAxLS40NSAxLTFzLS40NS0xLTEtMXoiLz48L3N2Zz4=';
var arrow_downward_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNGRkZGRkYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik00NDAtMzEzdi00NDdxMC0xNyAxMS41LTI4LjVUNDgwLTgwMHExNyAwIDI4LjUgMTEuNVQ1MjAtNzYwdjQ0N2wxOTYtMTk2cTEyLTEyIDI4LTExLjV0MjggMTIuNXExMSAxMiAxMS41IDI4VDc3Mi00NTJMNTA4LTE4OHEtNiA2LTEzIDguNXQtMTUgMi41cS04IDAtMTUtMi41dC0xMy04LjVMMTg4LTQ1MnEtMTEtMTEtMTEtMjcuNXQxMS0yOC41cTEyLTEyIDI4LjUtMTJ0MjguNSAxMmwxOTUgMTk1WiIvPjwvc3ZnPgo=';
var chevron_left_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE0LjcxIDYuNzFjLS4zOS0uMzktMS4wMi0uMzktMS40MSAwTDguNzEgMTEuM2MtLjM5LjM5LS4zOSAxLjAyIDAgMS40MWw0LjU5IDQuNTljLjM5LjM5IDEuMDIuMzkgMS40MSAwIC4zOS0uMzkuMzktMS4wMiAwLTEuNDFMMTAuODMgMTJsMy44OC0zLjg4Yy4zOS0uMzkuMzgtMS4wMyAwLTEuNDF6Ii8+PC9zdmc+';
var chevron_right_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xMCA2TDguNTkgNy40MSAxMy4xNyAxMmwtNC41OCA0LjU5TDEwIDE4bDYtNnoiLz48L3N2Zz4=';
var arrow_upward_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNGRkZGRkYiPjxwYXRoIGQ9Ik00NDAtNjQ3IDI0NC00NTFxLTEyIDEyLTI4IDExLjVUMTg4LTQ1MnEtMTEtMTItMTEuNS0yOHQxMS41LTI4bDI2NC0yNjRxNi02IDEzLTguNXQxNS0yLjVxOCAwIDE1IDIuNXQxMyA4LjVsMjY0IDI2NHExMSAxMSAxMSAyNy41VDc3Mi00NTJxLTEyIDEyLTI4LjUgMTJUNzE1LTQ1Mkw1MjAtNjQ3djQ0N3EwIDE3LTExLjUgMjguNVQ0ODAtMTYwcS0xNyAwLTI4LjUtMTEuNVQ0NDAtMjAwdi00NDdaIi8+PC9zdmc+Cg==';
var arrow_forward_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNGRkZGRkYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik02NDctNDQwSDIwMHEtMTcgMC0yOC41LTExLjVUMTYwLTQ4MHEwLTE3IDExLjUtMjguNVQyMDAtNTIwaDQ0N0w0NTEtNzE2cS0xMi0xMi0xMS41LTI4dDEyLjUtMjhxMTItMTEgMjgtMTEuNXQyOCAxMS41bDI2NCAyNjRxNiA2IDguNSAxM3QyLjUgMTVxMCA4LTIuNSAxNXQtOC41IDEzTDUwOC0xODhxLTExIDExLTI3LjUgMTFUNDUyLTE4OHEtMTItMTItMTItMjguNXQxMi0yOC41bDE5NS0xOTVaIi8+PC9zdmc+Cg==';
var cloud_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDZjMi42MiAwIDQuODggMS44NiA1LjM5IDQuNDNsLjMgMS41IDEuNTMuMTFjMS41Ni4xIDIuNzggMS40MSAyLjc4IDIuOTYgMCAxLjY1LTEuMzUgMy0zIDNINmMtMi4yMSAwLTQtMS43OS00LTQgMC0yLjA1IDEuNTMtMy43NiAzLjU2LTMuOTdsMS4wNy0uMTEuNS0uOTVDOC4wOCA3LjE0IDkuOTQgNiAxMiA2bTAtMkM5LjExIDQgNi42IDUuNjQgNS4zNSA4LjA0IDIuMzQgOC4zNiAwIDEwLjkxIDAgMTRjMCAzLjMxIDIuNjkgNiA2IDZoMTNjMi43NiAwIDUtMi4yNCA1LTUgMC0yLjY0LTIuMDUtNC43OC00LjY1LTQuOTZDMTguNjcgNi41OSAxNS42NCA0IDEyIDR6Ii8+PC9zdmc+';
var cloud_download_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5LjM1IDEwLjA0QzE4LjY3IDYuNTkgMTUuNjQgNCAxMiA0IDkuMTEgNCA2LjYgNS42NCA1LjM1IDguMDQgMi4zNCA4LjM2IDAgMTAuOTEgMCAxNGMwIDMuMzEgMi42OSA2IDYgNmgxM2MyLjc2IDAgNS0yLjI0IDUtNSAwLTIuNjQtMi4wNS00Ljc4LTQuNjUtNC45NnpNMTcgMTNsLTQuNjUgNC42NWMtLjIuMi0uNTEuMi0uNzEgMEw3IDEzaDNWOWg0djRoM3oiLz48L3N2Zz4=';
var cloud_download_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5LjM1IDEwLjA0QzE4LjY3IDYuNTkgMTUuNjQgNCAxMiA0IDkuMTEgNCA2LjYgNS42NCA1LjM1IDguMDQgMi4zNCA4LjM2IDAgMTAuOTEgMCAxNGMwIDMuMzEgMi42OSA2IDYgNmgxM2MyLjc2IDAgNS0yLjI0IDUtNSAwLTIuNjQtMi4wNS00Ljc4LTQuNjUtNC45NnpNMTcgMTNsLTQuNjUgNC42NWMtLjIuMi0uNTEuMi0uNzEgMEw3IDEzaDNWOWg0djRoM3oiLz48L3N2Zz4=';
var cloud_upload_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xOS4zNSAxMC4wNEMxOC42NyA2LjU5IDE1LjY0IDQgMTIgNCA5LjExIDQgNi42IDUuNjQgNS4zNSA4LjA0IDIuMzQgOC4zNiAwIDEwLjkxIDAgMTRjMCAzLjMxIDIuNjkgNiA2IDZoMTNjMi43NiAwIDUtMi4yNCA1LTUgMC0yLjY0LTIuMDUtNC43OC00LjY1LTQuOTZ6TTE0IDEzdjRoLTR2LTRIN2w1LTUgNSA1aC0zeiIvPjwvc3ZnPg==';
var cloud_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTEyIDZjMi42MiAwIDQuODggMS44NiA1LjM5IDQuNDNsLjMgMS41IDEuNTMuMTFjMS41Ni4xIDIuNzggMS40MSAyLjc4IDIuOTYgMCAxLjY1LTEuMzUgMy0zIDNINmMtMi4yMSAwLTQtMS43OS00LTQgMC0yLjA1IDEuNTMtMy43NiAzLjU2LTMuOTdsMS4wNy0uMTEuNS0uOTVDOC4wOCA3LjE0IDkuOTQgNiAxMiA2bTAtMkM5LjExIDQgNi42IDUuNjQgNS4zNSA4LjA0IDIuMzQgOC4zNiAwIDEwLjkxIDAgMTRjMCAzLjMxIDIuNjkgNiA2IDZoMTNjMi43NiAwIDUtMi4yNCA1LTUgMC0yLjY0LTIuMDUtNC43OC00LjY1LTQuOTZDMTguNjcgNi41OSAxNS42NCA0IDEyIDR6Ii8+PC9zdmc+';
var cloud_upload_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xOS4zNSAxMC4wNEMxOC42NyA2LjU5IDE1LjY0IDQgMTIgNCA5LjExIDQgNi42IDUuNjQgNS4zNSA4LjA0IDIuMzQgOC4zNiAwIDEwLjkxIDAgMTRjMCAzLjMxIDIuNjkgNiA2IDZoMTNjMi43NiAwIDUtMi4yNCA1LTUgMC0yLjY0LTIuMDUtNC43OC00LjY1LTQuOTZ6TTE0IDEzdjRoLTR2LTRIN2w1LTUgNSA1aC0zeiIvPjwvc3ZnPg==';
var delete_forever_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiMwMDAwMDAiPjxnPjxwYXRoIGQ9Ik0wLDBoMjR2MjRIMFYweiIgZmlsbD0ibm9uZSIvPjwvZz48Zz48cGF0aCBkPSJNNiwxOWMwLDEuMSwwLjksMiwyLDJoOGMxLjEsMCwyLTAuOSwyLTJWN0g2VjE5eiBNOS4xNywxMi41OWMtMC4zOS0wLjM5LTAuMzktMS4wMiwwLTEuNDFjMC4zOS0wLjM5LDEuMDItMC4zOSwxLjQxLDAgTDEyLDEyLjU5bDEuNDEtMS40MWMwLjM5LTAuMzksMS4wMi0wLjM5LDEuNDEsMHMwLjM5LDEuMDIsMCwxLjQxTDEzLjQxLDE0bDEuNDEsMS40MWMwLjM5LDAuMzksMC4zOSwxLjAyLDAsMS40MSBzLTEuMDIsMC4zOS0xLjQxLDBMMTIsMTUuNDFsLTEuNDEsMS40MWMtMC4zOSwwLjM5LTEuMDIsMC4zOS0xLjQxLDBjLTAuMzktMC4zOS0wLjM5LTEuMDIsMC0xLjQxTDEwLjU5LDE0TDkuMTcsMTIuNTl6IE0xOCw0aC0yLjUgbC0wLjcxLTAuNzFDMTQuNjEsMy4xMSwxNC4zNSwzLDE0LjA5LDNIOS45MWMtMC4yNiwwLTAuNTIsMC4xMS0wLjcsMC4yOUw4LjUsNEg2QzUuNDUsNCw1LDQuNDUsNSw1czAuNDUsMSwxLDFoMTIgYzAuNTUsMCwxLTAuNDUsMS0xUzE4LjU1LDQsMTgsNHoiLz48L2c+PC9zdmc+';
var description_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTggMTZoOHYySDh6bTAtNGg4djJIOHptNi0xMEg2Yy0xLjEgMC0yIC45LTIgMnYxNmMwIDEuMS44OSAyIDEuOTkgMkgxOGMxLjEgMCAyLS45IDItMlY4bC02LTZ6bTQgMThINlY0aDd2NWg1djExeiIvPjwvc3ZnPg==';
var description_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTggMTZoOHYySDh6bTAtNGg4djJIOHptNi0xMEg2Yy0xLjEgMC0yIC45LTIgMnYxNmMwIDEuMS44OSAyIDEuOTkgMkgxOGMxLjEgMCAyLS45IDItMlY4bC02LTZ6bTQgMThINlY0aDd2NWg1djExeiIvPjwvc3ZnPg==';
var delete_forever_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiNGRkZGRkYiPjxnPjxwYXRoIGQ9Ik0wLDBoMjR2MjRIMFYweiIgZmlsbD0ibm9uZSIvPjwvZz48Zz48cGF0aCBkPSJNNiwxOWMwLDEuMSwwLjksMiwyLDJoOGMxLjEsMCwyLTAuOSwyLTJWN0g2VjE5eiBNOS4xNywxMi41OWMtMC4zOS0wLjM5LTAuMzktMS4wMiwwLTEuNDFjMC4zOS0wLjM5LDEuMDItMC4zOSwxLjQxLDAgTDEyLDEyLjU5bDEuNDEtMS40MWMwLjM5LTAuMzksMS4wMi0wLjM5LDEuNDEsMHMwLjM5LDEuMDIsMCwxLjQxTDEzLjQxLDE0bDEuNDEsMS40MWMwLjM5LDAuMzksMC4zOSwxLjAyLDAsMS40MSBzLTEuMDIsMC4zOS0xLjQxLDBMMTIsMTUuNDFsLTEuNDEsMS40MWMtMC4zOSwwLjM5LTEuMDIsMC4zOS0xLjQxLDBjLTAuMzktMC4zOS0wLjM5LTEuMDIsMC0xLjQxTDEwLjU5LDE0TDkuMTcsMTIuNTl6IE0xOCw0aC0yLjUgbC0wLjcxLTAuNzFDMTQuNjEsMy4xMSwxNC4zNSwzLDE0LjA5LDNIOS45MWMtMC4yNiwwLTAuNTIsMC4xMS0wLjcsMC4yOUw4LjUsNEg2QzUuNDUsNCw1LDQuNDUsNSw1czAuNDUsMSwxLDFoMTIgYzAuNTUsMCwxLTAuNDUsMS0xUzE4LjU1LDQsMTgsNHoiLz48L2c+PC9zdmc+';
var gamepad_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDI0IDI0IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0cHgiIGZpbGw9IiNGRkZGRkYiPjxnPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjxyZWN0IGZpbGw9Im5vbmUiIGhlaWdodD0iMjQiIHdpZHRoPSIyNCIvPjwvZz48Zz48Zz48cGF0aCBkPSJNMjEuNTgsMTYuMDlsLTEuMDktNy42NkMyMC4yMSw2LjQ2LDE4LjUyLDUsMTYuNTMsNUg3LjQ3QzUuNDgsNSwzLjc5LDYuNDYsMy41MSw4LjQzbC0xLjA5LDcuNjYgQzIuMiwxNy42MywzLjM5LDE5LDQuOTQsMTloMGMwLjY4LDAsMS4zMi0wLjI3LDEuOC0wLjc1TDksMTZoNmwyLjI1LDIuMjVjMC40OCwwLjQ4LDEuMTMsMC43NSwxLjgsMC43NWgwIEMyMC42MSwxOSwyMS44LDE3LjYzLDIxLjU4LDE2LjA5eiBNMTEsMTFIOXYySDh2LTJINnYtMWgyVjhoMXYyaDJWMTF6IE0xNSwxMGMtMC41NSwwLTEtMC40NS0xLTFjMC0wLjU1LDAuNDUtMSwxLTFzMSwwLjQ1LDEsMSBDMTYsOS41NSwxNS41NSwxMCwxNSwxMHogTTE3LDEzYy0wLjU1LDAtMS0wLjQ1LTEtMWMwLTAuNTUsMC40NS0xLDEtMXMxLDAuNDUsMSwxQzE4LDEyLjU1LDE3LjU1LDEzLDE3LDEzeiIvPjwvZz48L2c+PC9zdmc+';
var keyboard_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xNjAtMjAwcS0zMyAwLTU2LjUtMjMuNVQ4MC0yODB2LTQwMHEwLTMzIDIzLjUtNTYuNVQxNjAtNzYwaDY0MHEzMyAwIDU2LjUgMjMuNVQ4ODAtNjgwdjQwMHEwIDMzLTIzLjUgNTYuNVQ4MDAtMjAwSDE2MFptMC04MGg2NDB2LTQwMEgxNjB2NDAwWm0yMDAtNDBoMjQwcTE3IDAgMjguNS0xMS41VDY0MC0zNjBxMC0xNy0xMS41LTI4LjVUNjAwLTQwMEgzNjBxLTE3IDAtMjguNSAxMS41VDMyMC0zNjBxMCAxNyAxMS41IDI4LjVUMzYwLTMyMFptLTIwMCA0MHYtNDAwIDQwMFptNDAtMTYwaDgwdi04MGgtODB2ODBabTEyMCAwaDgwdi04MGgtODB2ODBabTEyMCAwaDgwdi04MGgtODB2ODBabTEyMCAwaDgwdi04MGgtODB2ODBabTEyMCAwaDgwdi04MGgtODB2ODBaTTIwMC01NjBoODB2LTgwaC04MHY4MFptMTIwIDBoODB2LTgwaC04MHY4MFptMTIwIDBoODB2LTgwaC04MHY4MFptMTIwIDBoODB2LTgwaC04MHY4MFptMTIwIDBoODB2LTgwaC04MHY4MFoiLz48L3N2Zz4=';
var link_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE3IDdoLTR2Mmg0YzEuNjUgMCAzIDEuMzUgMyAzcy0xLjM1IDMtMyAzaC00djJoNGMyLjc2IDAgNS0yLjI0IDUtNXMtMi4yNC01LTUtNXptLTYgOEg3Yy0xLjY1IDAtMy0xLjM1LTMtM3MxLjM1LTMgMy0zaDRWN0g3Yy0yLjc2IDAtNSAyLjI0LTUgNXMyLjI0IDUgNSA1aDR2LTJ6bS0zLTRoOHYySDh6Ii8+PC9zdmc+';
var link_off_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE0LjM5IDExTDE2IDEyLjYxVjExek0xNyA3aC00djEuOWg0YzEuNzEgMCAzLjEgMS4zOSAzLjEgMy4xIDAgMS4yNy0uNzcgMi4zNy0xLjg3IDIuODRsMS40IDEuNEMyMS4wNSAxNS4zNiAyMiAxMy43OSAyMiAxMmMwLTIuNzYtMi4yNC01LTUtNXpNMiA0LjI3bDMuMTEgMy4xMUMzLjI5IDguMTIgMiA5LjkxIDIgMTJjMCAyLjc2IDIuMjQgNSA1IDVoNHYtMS45SDdjLTEuNzEgMC0zLjEtMS4zOS0zLjEtMy4xIDAtMS41OSAxLjIxLTIuOSAyLjc2LTMuMDdMOC43MyAxMUg4djJoMi43M0wxMyAxNS4yN1YxN2gxLjczbDQuMDEgNC4wMSAxLjQxLTEuNDFMMy40MSAyLjg2IDIgNC4yN3oiLz48L3N2Zz4=';
var link_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE3IDdoLTR2Mmg0YzEuNjUgMCAzIDEuMzUgMyAzcy0xLjM1IDMtMyAzaC00djJoNGMyLjc2IDAgNS0yLjI0IDUtNXMtMi4yNC01LTUtNXptLTYgOEg3Yy0xLjY1IDAtMy0xLjM1LTMtM3MxLjM1LTMgMy0zaDRWN0g3Yy0yLjc2IDAtNSAyLjI0LTUgNXMyLjI0IDUgNSA1aDR2LTJ6bS0zLTRoOHYySDh6Ii8+PC9zdmc+';
var link_off_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE0LjM5IDExTDE2IDEyLjYxVjExek0xNyA3aC00djEuOWg0YzEuNzEgMCAzLjEgMS4zOSAzLjEgMy4xIDAgMS4yNy0uNzcgMi4zNy0xLjg3IDIuODRsMS40IDEuNEMyMS4wNSAxNS4zNiAyMiAxMy43OSAyMiAxMmMwLTIuNzYtMi4yNC01LTUtNXpNMiA0LjI3bDMuMTEgMy4xMUMzLjI5IDguMTIgMiA5LjkxIDIgMTJjMCAyLjc2IDIuMjQgNSA1IDVoNHYtMS45SDdjLTEuNzEgMC0zLjEtMS4zOS0zLjEtMy4xIDAtMS41OSAxLjIxLTIuOSAyLjc2LTMuMDdMOC43MyAxMUg4djJoMi43M0wxMyAxNS4yN1YxN2gxLjczbDQuMDEgNC4wMSAxLjQxLTEuNDFMMy40MSAyLjg2IDIgNC4yN3oiLz48L3N2Zz4=';
var lists_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiICBmaWxsPSIjRkZGRkZGIj48cGF0aCBkPSJNNDAwLTE2MHEtMzMgMC01Ni41LTIzLjVUMzIwLTI0MHEwLTMzIDIzLjUtNTYuNVQ0MDAtMzIwaDQwMHEzMyAwIDU2LjUgMjMuNVQ4ODAtMjQwcTAgMzMtMjMuNSA1Ni41VDgwMC0xNjBINDAwWm0wLTI0MHEtMzMgMC01Ni41LTIzLjVUMzIwLTQ4MHEwLTMzIDIzLjUtNTYuNVQ0MDAtNTYwaDQwMHEzMyAwIDU2LjUgMjMuNVQ4ODAtNDgwcTAgMzMtMjMuNSA1Ni41VDgwMC00MDBINDAwWm0wLTI0MHEtMzMgMC01Ni41LTIzLjVUMzIwLTcyMHEwLTMzIDIzLjUtNTYuNVQ0MDAtODAwaDQwMHEzMyAwIDU2LjUgMjMuNVQ4ODAtNzIwcTAgMzMtMjMuNSA1Ni41VDgwMC02NDBINDAwWm0tMjQwIDBxLTMzIDAtNTYuNS0yMy41VDgwLTcyMHEwLTMzIDIzLjUtNTYuNVQxNjAtODAwcTMzIDAgNTYuNSAyMy41VDI0MC03MjBxMCAzMy0yMy41IDU2LjVUMTYwLTY0MFptMCAyNDBxLTMzIDAtNTYuNS0yMy41VDgwLTQ4MHEwLTMzIDIzLjUtNTYuNVQxNjAtNTYwcTMzIDAgNTYuNSAyMy41VDI0MC00ODBxMCAzMy0yMy41IDU2LjVUMTYwLTQwMFptMCAyNDBxLTMzIDAtNTYuNS0yMy41VDgwLTI0MHEwLTMzIDIzLjUtNTYuNVQxNjAtMzIwcTMzIDAgNTYuNSAyMy41VDI0MC0yNDBxMCAzMy0yMy41IDU2LjVUMTYwLTE2MFoiLz48L3N2Zz4K';
var mouse_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik00ODAtODBxLTExNiAwLTE5OC04MnQtODItMTk4di0yNDBxMC0xMTYgODItMTk4dDE5OC04MnExMTYgMCAxOTggODJ0ODIgMTk4djI0MHEwIDExNi04MiAxOThUNDgwLTgwWm00MC01MjBoMTYwcTAtNzItNDUuNS0xMjdUNTIwLTc5NnYxOTZabS0yNDAgMGgxNjB2LTE5NnEtNjkgMTQtMTE0LjUgNjlUMjgwLTYwMFptMjAwIDQ0MHE4MyAwIDE0MS41LTU4LjVUNjgwLTM2MHYtMTYwSDI4MHYxNjBxMCA4MyA1OC41IDE0MS41VDQ4MC0xNjBabTAtMzYwWm00MC04MFptLTgwIDBabTQwIDgwWiIvPjwvc3ZnPg==';
var loader = 'data:image/svg+xml;base64, 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';
var pause_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik02MDAtMjAwcS0zMyAwLTU2LjUtMjMuNVQ1MjAtMjgwdi00MDBxMC0zMyAyMy41LTU2LjVUNjAwLTc2MGg4MHEzMyAwIDU2LjUgMjMuNVQ3NjAtNjgwdjQwMHEwIDMzLTIzLjUgNTYuNVQ2ODAtMjAwaC04MFptLTMyMCAwcS0zMyAwLTU2LjUtMjMuNVQyMDAtMjgwdi00MDBxMC0zMyAyMy41LTU2LjVUMjgwLTc2MGg4MHEzMyAwIDU2LjUgMjMuNVQ0NDAtNjgwdjQwMHEwIDMzLTIzLjUgNTYuNVQzNjAtMjAwaC04MFptMzIwLTgwaDgwdi00MDBoLTgwdjQwMFptLTMyMCAwaDgwdi00MDBoLTgwdjQwMFptMC00MDB2NDAwLTQwMFptMzIwIDB2NDAwLTQwMFoiLz48L3N2Zz4K';
var play_arrow_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTggNi44MnYxMC4zNmMwIC43OS44NyAxLjI3IDEuNTQuODRsOC4xNC01LjE4Yy42Mi0uMzkuNjItMS4yOSAwLTEuNjlMOS41NCA1Ljk4QzguODcgNS41NSA4IDYuMDMgOCA2LjgyeiIvPjwvc3ZnPg==';
var play_arrow_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTggNi44MnYxMC4zNmMwIC43OS44NyAxLjI3IDEuNTQuODRsOC4xNC01LjE4Yy42Mi0uMzkuNjItMS4yOSAwLTEuNjlMOS41NCA1Ljk4QzguODcgNS41NSA4IDYuMDMgOCA2LjgyeiIvPjwvc3ZnPg==';
var settings_applications_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTYuMjEgMTMuOTdsMS4yIDIuMDdjLjA4LjEzLjIzLjE4LjM3LjEzbDEuNDktLjZjLjMxLjI0LjY0LjQ0IDEuMDEuNTlsLjIyIDEuNTljLjAzLjE0LjE1LjI1LjMuMjVoMi40Yy4xNSAwIC4yNy0uMTEuMy0uMjZsLjIyLTEuNTljLjM2LS4xNS43LS4zNSAxLjAxLS41OWwxLjQ5LjZjLjE0LjA1LjI5IDAgLjM3LS4xM2wxLjItMi4wN2MuMDgtLjEzLjA0LS4yOS0uMDctLjM5bC0xLjI3LS45OWMuMDMtLjE5LjA0LS4zOS4wNC0uNTggMC0uMi0uMDItLjM5LS4wNC0uNTlsMS4yNy0uOTljLjExLS4wOS4xNS0uMjYuMDctLjM5bC0xLjItMi4wN2MtLjA4LS4xMy0uMjMtLjE4LS4zNy0uMTNsLTEuNDkuNmMtLjMxLS4yNC0uNjQtLjQ0LTEuMDEtLjU5bC0uMjItMS41OWMtLjAzLS4xNC0uMTUtLjI1LS4zLS4yNWgtMi40Yy0uMTUgMC0uMjcuMTEtLjMuMjZsLS4yMiAxLjU5Yy0uMzYuMTUtLjcxLjM0LTEuMDEuNThsLTEuNDktLjZjLS4xNC0uMDUtLjI5IDAtLjM3LjEzbC0xLjIgMi4wN2MtLjA4LjEzLS4wNC4yOS4wNy4zOWwxLjI3Ljk5Yy0uMDMuMi0uMDUuMzktLjA1LjU5IDAgLjIuMDIuMzkuMDQuNTlsLTEuMjcuOTljLS4xMS4xLS4xNC4yNi0uMDYuMzl6TTEyIDEwLjI5Yy45NCAwIDEuNzEuNzcgMS43MSAxLjcxcy0uNzcgMS43MS0xLjcxIDEuNzEtMS43MS0uNzctMS43MS0xLjcxLjc3LTEuNzEgMS43MS0xLjcxek0xOSAzSDVjLTEuMTEgMC0yIC45LTIgMnYxNGMwIDEuMS44OSAyIDIgMmgxNGMxLjExIDAgMi0uOSAyLTJWNWMwLTEuMS0uODktMi0yLTJ6bTAgMTZINVY1aDE0djE0eiIvPjwvc3ZnPg==';
var settings_red_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5LjQzIDEyLjk4Yy4wNC0uMzIuMDctLjY0LjA3LS45OCAwLS4zNC0uMDMtLjY2LS4wNy0uOThsMi4xMS0xLjY1Yy4xOS0uMTUuMjQtLjQyLjEyLS42NGwtMi0zLjQ2Yy0uMDktLjE2LS4yNi0uMjUtLjQ0LS4yNS0uMDYgMC0uMTIuMDEtLjE3LjAzbC0yLjQ5IDFjLS41Mi0uNC0xLjA4LS43My0xLjY5LS45OGwtLjM4LTIuNjVDMTQuNDYgMi4xOCAxNC4yNSAyIDE0IDJoLTRjLS4yNSAwLS40Ni4xOC0uNDkuNDJsLS4zOCAyLjY1Yy0uNjEuMjUtMS4xNy41OS0xLjY5Ljk4bC0yLjQ5LTFjLS4wNi0uMDItLjEyLS4wMy0uMTgtLjAzLS4xNyAwLS4zNC4wOS0uNDMuMjVsLTIgMy40NmMtLjEzLjIyLS4wNy40OS4xMi42NGwyLjExIDEuNjVjLS4wNC4zMi0uMDcuNjUtLjA3Ljk4IDAgLjMzLjAzLjY2LjA3Ljk4bC0yLjExIDEuNjVjLS4xOS4xNS0uMjQuNDItLjEyLjY0bDIgMy40NmMuMDkuMTYuMjYuMjUuNDQuMjUuMDYgMCAuMTItLjAxLjE3LS4wM2wyLjQ5LTFjLjUyLjQgMS4wOC43MyAxLjY5Ljk4bC4zOCAyLjY1Yy4wMy4yNC4yNC40Mi40OS40Mmg0Yy4yNSAwIC40Ni0uMTguNDktLjQybC4zOC0yLjY1Yy42MS0uMjUgMS4xNy0uNTkgMS42OS0uOThsMi40OSAxYy4wNi4wMi4xMi4wMy4xOC4wMy4xNyAwIC4zNC0uMDkuNDMtLjI1bDItMy40NmMuMTItLjIyLjA3LS40OS0uMTItLjY0bC0yLjExLTEuNjV6bS0xLjk4LTEuNzFjLjA0LjMxLjA1LjUyLjA1LjczIDAgLjIxLS4wMi40My0uMDUuNzNsLS4xNCAxLjEzLjg5LjcgMS4wOC44NC0uNyAxLjIxLTEuMjctLjUxLTEuMDQtLjQyLS45LjY4Yy0uNDMuMzItLjg0LjU2LTEuMjUuNzNsLTEuMDYuNDMtLjE2IDEuMTMtLjIgMS4zNWgtMS40bC0uMTktMS4zNS0uMTYtMS4xMy0xLjA2LS40M2MtLjQzLS4xOC0uODMtLjQxLTEuMjMtLjcxbC0uOTEtLjctMS4wNi40My0xLjI3LjUxLS43LTEuMjEgMS4wOC0uODQuODktLjctLjE0LTEuMTNjLS4wMy0uMzEtLjA1LS41NC0uMDUtLjc0cy4wMi0uNDMuMDUtLjczbC4xNC0xLjEzLS44OS0uNy0xLjA4LS44NC43LTEuMjEgMS4yNy41MSAxLjA0LjQyLjktLjY4Yy40My0uMzIuODQtLjU2IDEuMjUtLjczbDEuMDYtLjQzLjE2LTEuMTMuMi0xLjM1aDEuMzlsLjE5IDEuMzUuMTYgMS4xMyAxLjA2LjQzYy40My4xOC44My40MSAxLjIzLjcxbC45MS43IDEuMDYtLjQzIDEuMjctLjUxLjcgMS4yMS0xLjA3Ljg1LS44OS43LjE0IDEuMTN6TTEyIDhjLTIuMjEgMC00IDEuNzktNCA0czEuNzkgNCA0IDQgNC0xLjc5IDQtNC0xLjc5LTQtNC00em0wIDZjLTEuMSAwLTItLjktMi0ycy45LTIgMi0yIDIgLjkgMiAyLS45IDItMiAyeiIvPjwvc3ZnPg==';
var save_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPjxwYXRoIGQ9Ik0xNyAzSDVjLTEuMTEgMC0yIC45LTIgMnYxNGMwIDEuMS44OSAyIDIgMmgxNGMxLjEgMCAyLS45IDItMlY3bC00LTR6bS01IDE2Yy0xLjY2IDAtMy0xLjM0LTMtM3MxLjM0LTMgMy0zIDMgMS4zNCAzIDMtMS4zNCAzLTMgM3ptMy0xMEg1VjVoMTB2NHoiLz48L3N2Zz4=';
var settings_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTE5LjQzIDEyLjk4Yy4wNC0uMzIuMDctLjY0LjA3LS45OCAwLS4zNC0uMDMtLjY2LS4wNy0uOThsMi4xMS0xLjY1Yy4xOS0uMTUuMjQtLjQyLjEyLS42NGwtMi0zLjQ2Yy0uMDktLjE2LS4yNi0uMjUtLjQ0LS4yNS0uMDYgMC0uMTIuMDEtLjE3LjAzbC0yLjQ5IDFjLS41Mi0uNC0xLjA4LS43My0xLjY5LS45OGwtLjM4LTIuNjVDMTQuNDYgMi4xOCAxNC4yNSAyIDE0IDJoLTRjLS4yNSAwLS40Ni4xOC0uNDkuNDJsLS4zOCAyLjY1Yy0uNjEuMjUtMS4xNy41OS0xLjY5Ljk4bC0yLjQ5LTFjLS4wNi0uMDItLjEyLS4wMy0uMTgtLjAzLS4xNyAwLS4zNC4wOS0uNDMuMjVsLTIgMy40NmMtLjEzLjIyLS4wNy40OS4xMi42NGwyLjExIDEuNjVjLS4wNC4zMi0uMDcuNjUtLjA3Ljk4IDAgLjMzLjAzLjY2LjA3Ljk4bC0yLjExIDEuNjVjLS4xOS4xNS0uMjQuNDItLjEyLjY0bDIgMy40NmMuMDkuMTYuMjYuMjUuNDQuMjUuMDYgMCAuMTItLjAxLjE3LS4wM2wyLjQ5LTFjLjUyLjQgMS4wOC43MyAxLjY5Ljk4bC4zOCAyLjY1Yy4wMy4yNC4yNC40Mi40OS40Mmg0Yy4yNSAwIC40Ni0uMTguNDktLjQybC4zOC0yLjY1Yy42MS0uMjUgMS4xNy0uNTkgMS42OS0uOThsMi40OSAxYy4wNi4wMi4xMi4wMy4xOC4wMy4xNyAwIC4zNC0uMDkuNDMtLjI1bDItMy40NmMuMTItLjIyLjA3LS40OS0uMTItLjY0bC0yLjExLTEuNjV6bS0xLjk4LTEuNzFjLjA0LjMxLjA1LjUyLjA1LjczIDAgLjIxLS4wMi40My0uMDUuNzNsLS4xNCAxLjEzLjg5LjcgMS4wOC44NC0uNyAxLjIxLTEuMjctLjUxLTEuMDQtLjQyLS45LjY4Yy0uNDMuMzItLjg0LjU2LTEuMjUuNzNsLTEuMDYuNDMtLjE2IDEuMTMtLjIgMS4zNWgtMS40bC0uMTktMS4zNS0uMTYtMS4xMy0xLjA2LS40M2MtLjQzLS4xOC0uODMtLjQxLTEuMjMtLjcxbC0uOTEtLjctMS4wNi40My0xLjI3LjUxLS43LTEuMjEgMS4wOC0uODQuODktLjctLjE0LTEuMTNjLS4wMy0uMzEtLjA1LS41NC0uMDUtLjc0cy4wMi0uNDMuMDUtLjczbC4xNC0xLjEzLS44OS0uNy0xLjA4LS44NC43LTEuMjEgMS4yNy41MSAxLjA0LjQyLjktLjY4Yy40My0uMzIuODQtLjU2IDEuMjUtLjczbDEuMDYtLjQzLjE2LTEuMTMuMi0xLjM1aDEuMzlsLjE5IDEuMzUuMTYgMS4xMyAxLjA2LjQzYy40My4xOC44My40MSAxLjIzLjcxbC45MS43IDEuMDYtLjQzIDEuMjctLjUxLjcgMS4yMS0xLjA3Ljg1LS44OS43LjE0IDEuMTN6TTEyIDhjLTIuMjEgMC00IDEuNzktNCA0czEuNzkgNCA0IDQgNC0xLjc5IDQtNC0xLjc5LTQtNC00em0wIDZjLTEuMSAwLTItLjktMi0ycy45LTIgMi0yIDIgLjkgMiAyLS45IDItMiAyeiIvPjwvc3ZnPg==';
var swap_vert_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9IiNGRkZGRkYiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Ik0zNjAtNDQwcS0xNyAwLTI4LjUtMTEuNVQzMjAtNDgwdi0yNDdsLTc1IDc1cS0xMSAxMS0yNy41IDExVDE4OS02NTJxLTEyLTEyLTEyLTI4LjV0MTItMjguNWwxNDMtMTQzcTYtNiAxMy04LjV0MTUtMi41cTggMCAxNSAyLjV0MTMgOC41bDE0NCAxNDRxMTIgMTIgMTEuNSAyOFQ1MzEtNjUycS0xMiAxMS0yOCAxMS41VDQ3NS02NTJsLTc1LTc1djI0N3EwIDE3LTExLjUgMjguNVQzNjAtNDQwWk02MDAtOTdxLTggMC0xNS0yLjV0LTEzLTguNUw0MjgtMjUycS0xMi0xMi0xMS41LTI4dDEyLjUtMjhxMTItMTEgMjgtMTEuNXQyOCAxMS41bDc1IDc1di0yNDdxMC0xNyAxMS41LTI4LjVUNjAwLTUyMHExNyAwIDI4LjUgMTEuNVQ2NDAtNDgwdjI0N2w3NS03NXExMS0xMSAyNy41LTExdDI4LjUgMTFxMTIgMTIgMTIgMjguNVQ3NzEtMjUxTDYyOC0xMDhxLTYgNi0xMyA4LjVUNjAwLTk3WiIvPjwvc3ZnPgo=';
var swipe_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik00ODAtODYwcS04OCAwLTE2OSAzMXQtMTQ3IDg5aDg2cTEzIDAgMjEuNSA4LjVUMjgwLTcxMHEwIDEzLTguNSAyMS41VDI1MC02ODBIMTIwcS0xNyAwLTI4LjUtMTEuNVQ4MC03MjB2LTEzMHEwLTEzIDguNS0yMS41VDExMC04ODBxMTMgMCAyMS41IDguNVQxNDAtODUwdjUxcTcyLTU5IDE1OS05MHQxODEtMzFxOTQgMCAxODEgMzF0MTU5IDkwdi01MXEwLTEzIDguNS0yMS41VDg1MC04ODBxMTMgMCAyMS41IDguNVQ4ODAtODUwdjEzMHEwIDE3LTExLjUgMjguNVQ4NDAtNjgwSDcxMHEtMTMgMC0yMS41LTguNVQ2ODAtNzEwcTAtMTMgOC41LTIxLjVUNzEwLTc0MGg4NnEtNjYtNTgtMTQ3LTg5dC0xNjktMzFabS03IDc4MHEtMjQgMC00Ni05dC0zOS0yNkwyMTItMjkycS0xMS0xMS0xMS41LTI3LjVUMjExLTM0OGwzLTNxMTYtMTYgMzcuNS0yMS41dDQyLjUuNWw2NiAxOXYtMzI3cTAtMTcgMTEuNS0yOC41VDQwMC03MjBxMTcgMCAyOC41IDExLjVUNDQwLTY4MHYzODBxMCAyMC0xNiAzMnQtMzUgN2wtNDYtMTMgMTAyIDEwMnE1IDUgMTIuNSA4LjVUNDczLTE2MGgxNjdxMzMgMCA1Ni41LTIzLjVUNzIwLTI0MHYtMTYwcTAtMTcgMTEuNS0yOC41VDc2MC00NDBxMTcgMCAyOC41IDExLjVUODAwLTQwMHYxNjBxMCA2Ni00NyAxMTNUNjQwLTgwSDQ3M1ptNDctNDgwcTE3IDAgMjguNSAxMS41VDU2MC01MjB2MTIwcTAgMTctMTEuNSAyOC41VDUyMC0zNjBxLTE3IDAtMjguNS0xMS41VDQ4MC00MDB2LTEyMHEwLTE3IDExLjUtMjguNVQ1MjAtNTYwWm0xMjAgNDBxMTcgMCAyOC41IDExLjVUNjgwLTQ4MHY4MHEwIDE3LTExLjUgMjguNVQ2NDAtMzYwcS0xNyAwLTI4LjUtMTEuNVQ2MDAtNDAwdi04MHEwLTE3IDExLjUtMjguNVQ2NDAtNTIwWm0tNjkgMjQwWiIvPjwvc3ZnPg==';
var tune_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTMgMThjMCAuNTUuNDUgMSAxIDFoNXYtMkg0Yy0uNTUgMC0xIC40NS0xIDF6TTMgNmMwIC41NS40NSAxIDEgMWg5VjVINGMtLjU1IDAtMSAuNDUtMSAxem0xMCAxNHYtMWg3Yy41NSAwIDEtLjQ1IDEtMXMtLjQ1LTEtMS0xaC03di0xYzAtLjU1LS40NS0xLTEtMXMtMSAuNDUtMSAxdjRjMCAuNTUuNDUgMSAxIDFzMS0uNDUgMS0xek03IDEwdjFINGMtLjU1IDAtMSAuNDUtMSAxcy40NSAxIDEgMWgzdjFjMCAuNTUuNDUgMSAxIDFzMS0uNDUgMS0xdi00YzAtLjU1LS40NS0xLTEtMXMtMSAuNDUtMSAxem0xNCAyYzAtLjU1LS40NS0xLTEtMWgtOXYyaDljLjU1IDAgMS0uNDUgMS0xem0tNS0zYy41NSAwIDEtLjQ1IDEtMVY3aDNjLjU1IDAgMS0uNDUgMS0xcy0uNDUtMS0xLTFoLTNWNGMwLS41NS0uNDUtMS0xLTFzLTEgLjQ1LTEgMXY0YzAgLjU1LjQ1IDEgMSAxeiIvPjwvc3ZnPg==';
var tv_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iI0ZGRkZGRiI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIxIDNIM2MtMS4xIDAtMiAuOS0yIDJ2MTJjMCAxLjEuOSAyIDIgMmg1djJoOHYtMmg1YzEuMSAwIDEuOTktLjkgMS45OS0yTDIzIDVjMC0xLjEtLjktMi0yLTJ6bTAgMTRIM1Y1aDE4djEyeiIvPjwvc3ZnPg==';
var videogame_asset_off_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNGRkZGRkYiPjxwYXRoIGQ9Ik0zNjYtNDgwWm0tODYgNDBoLTQwcS0xNyAwLTI4LjUtMTEuNVQyMDAtNDgwcTAtMTcgMTEuNS0yOC41VDI0MC01MjBoNDB2LTQwcTAtMTcgMTEuNS0yOC41VDMyMC02MDBxMTcgMCAyOC41IDExLjVUMzYwLTU2MHY0MGg0MHExNyAwIDI4LjUgMTEuNVQ0NDAtNDgwcTAgMTctMTEuNSAyOC41VDQwMC00NDBoLTQwdjQwcTAgMTctMTEuNSAyOC41VDMyMC0zNjBxLTE3IDAtMjguNS0xMS41VDI4MC00MDB2LTQwWk0xNjAtMjQwcS0zMyAwLTU2LjUtMjMuNVQ4MC0zMjB2LTMyMHEwLTM0IDI0LTU3LjV0NTgtMjMuNWg3N2w4MSA4MUgxNjB2MzIwaDM2Nkw4My03NjNxLTEyLTEyLTEyLTI4LjVUODMtODIwcTEyLTEyIDI4LjUtMTJ0MjguNSAxMmw2ODAgNjgwcTEyIDEyIDEyIDI4dC0xMiAyOHEtMTIgMTItMjguNSAxMlQ3NjMtODRMNjA2LTI0MEgxNjBabTU0MC0yNDBxLTI1IDAtNDIuNS0xNy41VDY0MC01NDBxMC0yNSAxNy41LTQyLjVUNzAwLTYwMHEyNSAwIDQyLjUgMTcuNVQ3NjAtNTQwcTAgMjUtMTcuNSA0Mi41VDcwMC00ODBabTEwMC0yNDBxMzMgMCA1Ni41IDIzLjVUODgwLTY0MHYzMjBxMCAxNy0xMS41IDI4LjVUODQwLTI4MHEtMTcgMC0yOC41LTExLjVUODAwLTMyMHYtMzIwSDQ0MHEtMTcgMC0yOC41LTExLjVUNDAwLTY4MHEwLTE3IDExLjUtMjguNVQ0NDAtNzIwaDM2MFpNNjE3LTQ1N1oiLz48L3N2Zz4=';
var videogame_asset_white_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiIGZpbGw9IiNGRkZGRkYiPjxwYXRoIGQ9Ik0xNjAtMjQwcS0zMyAwLTU2LjUtMjMuNVQ4MC0zMjB2LTMyMHEwLTMzIDIzLjUtNTYuNVQxNjAtNzIwaDY0MHEzMyAwIDU2LjUgMjMuNVQ4ODAtNjQwdjMyMHEwIDMzLTIzLjUgNTYuNVQ4MDAtMjQwSDE2MFptMC04MGg2NDB2LTMyMEgxNjB2MzIwWm0xMjAtMTIwdjQwcTAgMTcgMTEuNSAyOC41VDMyMC0zNjBxMTcgMCAyOC41LTExLjVUMzYwLTQwMHYtNDBoNDBxMTcgMCAyOC41LTExLjVUNDQwLTQ4MHEwLTE3LTExLjUtMjguNVQ0MDAtNTIwaC00MHYtNDBxMC0xNy0xMS41LTI4LjVUMzIwLTYwMHEtMTcgMC0yOC41IDExLjVUMjgwLTU2MHY0MGgtNDBxLTE3IDAtMjguNSAxMS41VDIwMC00ODBxMCAxNyAxMS41IDI4LjVUMjQwLTQ0MGg0MFptMzAwIDgwcTI1IDAgNDIuNS0xNy41VDY0MC00MjBxMC0yNS0xNy41LTQyLjVUNTgwLTQ4MHEtMjUgMC00Mi41IDE3LjVUNTIwLTQyMHEwIDI1IDE3LjUgNDIuNVQ1ODAtMzYwWm0xMjAtMTIwcTI1IDAgNDIuNS0xNy41VDc2MC01NDBxMC0yNS0xNy41LTQyLjVUNzAwLTYwMHEtMjUgMC00Mi41IDE3LjVUNjQwLTU0MHEwIDI1IDE3LjUgNDIuNVQ3MDAtNDgwWk0xNjAtMzIwdi0zMjAgMzIwWiIvPjwvc3ZnPg==';
var volume_off_black_24dp = 'data:image/svg+xml;base64, PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTQuMzQgMi45M0wyLjkzIDQuMzQgNy4yOSA4LjcgNyA5SDN2Nmg0bDUgNXYtNi41OWw0LjE4IDQuMThjLS42NS40OS0xLjM4Ljg4LTIuMTggMS4xMXYyLjA2YzEuMzQtLjMgMi41Ny0uOTIgMy42MS0xLjc1bDIuMDUgMi4wNSAxLjQxLTEuNDFMNC4zNCAyLjkzek0xMCAxNS4xN0w3LjgzIDEzSDV2LTJoMi44M2wuODgtLjg4TDEwIDExLjQxdjMuNzZ6TTE5IDEyYzAgLjgyLS4xNSAxLjYxLS40MSAyLjM0bDEuNTMgMS41M2MuNTYtMS4xNy44OC0yLjQ4Ljg4LTMuODcgMC00LjI4LTIuOTktNy44Ni03LTguNzd2Mi4wNmMyLjg5Ljg2IDUgMy41NCA1IDYuNzF6bS03LThsLTEuODggMS44OEwxMiA3Ljc2em00LjUgOGMwLTEuNzctMS4wMi0zLjI5LTIuNS00LjAzdjEuNzlsMi40OCAyLjQ4Yy4wMS0uMDguMDItLjE2LjAyLS4yNHoiLz48L3N2Zz4=';
var webrcade_logo_dark = 'data:image/svg+xml;base64, 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';
var webrcade_logo_large = 'data:image/svg+xml;base64, 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';

var resolvePath$1 = function resolvePath$1(path) {
  return resolvePath(path);
};

var AlbumWhiteImage = album_white_24dp;
var ArrowBackWhiteImage = arrow_back_white_24dp;
var ChevronLeftWhiteImage = chevron_left_white_24dp;
var ChevronRightWhiteImage = chevron_right_white_24dp;
var CloudBlackImage = cloud_black_24dp;
var CloudWhiteImage = cloud_white_24dp;
var CloudDownloadBlackImage = cloud_download_black_24dp;
var CloudDownloadWhiteImage = cloud_download_white_24dp;
var CloudUploadBlackImage = cloud_upload_black_24dp;
var CloudUploadWhiteImage = cloud_upload_white_24dp;
var DeleteForeverBlackImage = delete_forever_black_24dp;
var DeleteForeverWhiteImage = delete_forever_white_24dp;
var DescriptionBlackImage = description_black_24dp;
var DescriptionWhiteImage = description_white_24dp;
var GamepadWhiteImage = gamepad_white_24dp;
var KeyboardWhiteImage = keyboard_white_24dp;
var AddCircleBlackImage = add_circle_outline_black_24dp;
var AddCircleWhiteImage = add_circle_outline_white_24dp;
var PlayArrowBlackImage = play_arrow_black_24dp;
var LoaderImage = loader;
var LinkBlackImage = link_black_24dp;
var LinkWhiteImage = link_white_24dp;
var LinkOffBlackImage = link_off_black_24dp;
var LinkOffWhiteImage = link_off_white_24dp;
var ListsWhiteImage = lists_white_24dp;
var PauseWhiteImage = pause_white_24dp;
var PlayArrowWhiteImage = play_arrow_white_24dp;
var TuneWhiteImage = tune_white_24dp;
var VolumeOffBlackImage = volume_off_black_24dp;
var WebrcadeLogoDarkImage = webrcade_logo_dark;
var WebrcadeLogoLargeImage = webrcade_logo_large;
var SaveWhiteImage = save_white_24dp;
var SettingsRedImage = settings_red_24dp;
var SettingsWhiteImage = settings_white_24dp;
var SettingsAppWhiteImage = settings_applications_white_24dp;
var TelevisionWhiteImage = tv_white_24dp;
var MouseWhiteImage = mouse_white_24dp;
var SwipeWhiteImage = swipe_white_24dp;
var ArrowUpwardImage = arrow_upward_24dp;
var ArrowDownwardImage = arrow_downward_24dp;
var ArrowBackImage = arrow_back_24dp;
var ArrowForwardImage = arrow_forward_24dp;
var SwapVertImage = swap_vert_24dp;
var VideoGameAssetWhiteImage = videogame_asset_white_24dp;
var VideoGameAssetOffWhiteImage = videogame_asset_off_white_24dp;
var CategoryThumbImage = resolvePath$1("images/folder.png");
var CategoryBackgroundImage = resolvePath$1("images/folder-background.png");
var FeedThumbImage = resolvePath$1("images/feed.png");
var FeedBackgroundImage = resolvePath$1("images/feed-background.png");
var XboxOneDpad = resolvePath$1("images/common/controller/Xbox One/XboxOne_Dpad.png");
var XboxOneAButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_A.png");
var XboxOneBButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_B.png");
var XboxOneXButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_X.png");
var XboxOneYButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_Y.png");
var XboxOneLeftStick = resolvePath$1("images/common/controller/Xbox One/XboxOne_Left_Stick.png");
var XboxOneRightStick = resolvePath$1("images/common/controller/Xbox One/XboxOne_Right_Stick.png");
var XboxOneMenuButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_Menu.png");
var XboxOneWindowsButton = resolvePath$1("images/common/controller/Xbox One/XboxOne_Windows.png");
var XboxOneRightBumper = resolvePath$1("images/common/controller/Xbox One/XboxOne_RB.png");
var XboxOneLeftBumper = resolvePath$1("images/common/controller/Xbox One/XboxOne_LB.png");
var XboxOneRightTrigger = resolvePath$1("images/common/controller/Xbox One/XboxOne_RT.png");
var XboxOneLeftTrigger = resolvePath$1("images/common/controller/Xbox One/XboxOne_LT.png");
var ArrowLeftKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Arrow_Left_Key_Dark.png");
var ArrowRightKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Arrow_Right_Key_Dark.png");
var ArrowUpKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Arrow_Up_Key_Dark.png");
var ArrowDownKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Arrow_Down_Key_Dark.png");
var EscapeKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Esc_Key_Dark.png");
var EnterKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Enter_Key_Dark.png");
var ShiftKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Shift_Key_Dark.png");
var ControlKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Ctrl_Key_Dark.png");
var SpaceKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Space_Key_Dark.png");
var AKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/A_Key_Dark.png");
var CKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/C_Key_Dark.png");
var DKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/D_Key_Dark.png");
var IKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/I_Key_Dark.png");
var JKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/J_Key_Dark.png");
var KKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/K_Key_Dark.png");
var LKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/L_Key_Dark.png");
var SKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/S_Key_Dark.png");
var VKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/V_Key_Dark.png");
var XKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/X_Key_Dark.png");
var ZKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Z_Key_Dark.png");
var QKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Q_Key_Dark.png");
var WKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/W_Key_Dark.png");
var TKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/T_Key_Dark.png");
var RKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/R_Key_Dark.png");
var EKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/E_Key_Dark.png");
var PeriodKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Period_Key_Dark.png");
var ZeroKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/0_Key_Dark.png");
var OneKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/1_Key_Dark.png");
var TwoKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/2_Key_Dark.png");
var ThreeKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/3_Key_Dark.png");
var FourKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/4_Key_Dark.png");
var FiveKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/5_Key_Dark.png");
var SixKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/6_Key_Dark.png");
var SevenKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/7_Key_Dark.png");
var EightKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/8_Key_Dark.png");
var NineKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/9_Key_Dark.png");
var MinusKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Minus_Key_Dark.png");
var EqualsKey = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/Equals_Key_Dark.png");
var F5Key = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/F5_Key_Dark.png");
var F7Key = resolvePath$1("images/common/controller/Keyboard & Mouse/Dark/F7_Key_Dark.png");
var Atari2600Background = resolvePath$1("images/app/2600-background.png");
var Atari7800Background = resolvePath$1("images/app/7800-background.png");
var ThreedoBackground = resolvePath$1("images/app/3do-background.png");
var NesBackground = resolvePath$1("images/app/nes-background.png");
var SnesBackground = resolvePath$1("images/app/snes-background.png");
var GbaBackground = resolvePath$1("images/app/gba-background.png");
var GbBackground = resolvePath$1("images/app/gb-background.png");
var GbcBackground = resolvePath$1("images/app/gbc-background.png");
var GenesisBackground = resolvePath$1("images/app/genesis-background.png");
var GameGearBackground = resolvePath$1("images/app/gamegear-background.png");
var MasterSystemBackground = resolvePath$1("images/app/mastersystem-background.png");
var Sg1000Background = resolvePath$1("images/app/sg1000-background.png");
var PceBackground = resolvePath$1("images/app/pce-background.png");
var SgxBackground = resolvePath$1("images/app/sgx-background.png");
var NgpBackground = resolvePath$1("images/app/ngp-background.png");
var NgcBackground = resolvePath$1("images/app/ngc-background.png");
var LynxBackground = resolvePath$1("images/app/lynx-background.png");
var WscBackground = resolvePath$1("images/app/wsc-background.png");
var WsBackground = resolvePath$1("images/app/ws-background.png");
var VbBackground = resolvePath$1("images/app/vb-background.png");
var PceCdBackground = resolvePath$1("images/app/pcecd-background.png");
var SegaCdBackground = resolvePath$1("images/app/segacd-background.png");
var PsxBackground = resolvePath$1("images/app/playstation-background.png");
var CapcomBackground = resolvePath$1("images/app/capcom-background.png");
var KonamiBackground = resolvePath$1("images/app/konami-background.png");
var NeoGeoBackground = resolvePath$1("images/app/neogeo-background.png");
var NeoGeoCdBackground = resolvePath$1("images/app/neogeocd-background.png");
var ArcadeBackground = resolvePath$1("images/app/arcade-background.png");
var N64Background = resolvePath$1("images/app/n64-background.png");
var A5200Background = resolvePath$1("images/app/5200-background.png");
var ColecoVisionBackground = resolvePath$1("images/app/colecovision-background.png");
var ColecoController = resolvePath$1("images/app/coleco/controller.png");
var A5200Controller = resolvePath$1("images/app/a5200/controller.png");
var ScummVmBackground = resolvePath$1("images/app/scummvm-background.png");
var Commodore64Background = resolvePath$1("images/app/c64-background.png");

var AppRegistry = /*#__PURE__*/function () {
  function AppRegistry() {
    this.APP_TYPES = {};
    this.updateAppTypes();
  }

  var _proto = AppRegistry.prototype;

  _proto.enableExpApps = function enableExpApps(b) {
    enableExperimentalApps(b);
    this.updateAppTypes();
  };

  _proto.updateAppTypes = function updateAppTypes() {
    var _this = this;

    this.APP_TYPES = {};
    APP_TYPES.forEach(function (appType) {
      _this.APP_TYPES[appType.key] = appType;
      appType.type = appType.absoluteKey === undefined ? appType.key : appType.absoluteKey;
    });
  };

  _proto.validate = function validate(app) {
    var APP_TYPES = this.APP_TYPES;

    if (isEmptyString(app.title)) {
      throw new Error("Missing 'title' property");
    }

    if (isEmptyString(app.type)) {
      throw new Error("Missing 'type' property");
    }

    if (APP_TYPES[app.type] === undefined) {
      throw new Error("'type' is invalid.");
    }

    APP_TYPES[app.type].validate(app);
  };

  _proto.getDefaultBackground = function getDefaultBackground(app) {
    var APP_TYPES = this.APP_TYPES;
    return APP_TYPES[app.type].background;
  };

  _proto.getDefaultThumbnail = function getDefaultThumbnail(app) {
    var APP_TYPES = this.APP_TYPES;
    return APP_TYPES[app.type].thumbnail;
  };

  _proto.getBackground = function getBackground(app) {
    return isValidString(app.background) ? app.background : this.getDefaultBackground(app);
  };

  _proto.getThumbnail = function getThumbnail(app) {
    return isValidString(app.thumbnail) ? app.thumbnail : this.getDefaultThumbnail(app);
  };

  _proto.getDescription = function getDescription(app) {
    var APP_TYPES = this.APP_TYPES;
    return isValidString(app.description) ? app.description : APP_TYPES[app.type].description;
  };

  _proto.getName = function getName(app) {
    var APP_TYPES = this.APP_TYPES;
    return APP_TYPES[app.type].name;
  };

  _proto.isDelayedExit = function isDelayedExit(app) {
    return true;
  };

  _proto.isSlowExit = function isSlowExit(app) {
    var APP_TYPES = this.APP_TYPES;
    var appType = APP_TYPES[app.type];
    return appType.slowExit !== undefined && appType.slowExit === true;
  };

  _proto.getAlias = function getAlias(typeName) {
    var APP_TYPES = this.APP_TYPES;
    var appType = APP_TYPES[typeName];
    return appType.alias;
  };

  _proto.getLocation = function getLocation(app, context, feedProps, otherProps) {
    var RP_CONTEXT = AppProps.RP_CONTEXT,
        RP_DEBUG = AppProps.RP_DEBUG,
        RP_PROPS = AppProps.RP_PROPS;
    var props = app.props;
    var APP_TYPES = this.APP_TYPES;
    var appType = APP_TYPES[app.type];
    var outProps = {
      type: appType.type,
      title: this.getLongTitle(app),
      app: this.getName(app)
    };

    if (otherProps) {
      outProps = _extends({}, outProps, otherProps);
    }

    if (props !== undefined) {
      Object.assign(outProps, props);
    }

    if (appType.addProps && feedProps) {
      appType.addProps(feedProps, outProps);
    }

    var loc = UrlUtil.addParam(appType.location, RP_PROPS, AppProps.encode(outProps));
    var debug = UrlUtil.getBoolParam(window.location.search, RP_DEBUG);

    if (debug) {
      loc = UrlUtil.addParam(loc, RP_DEBUG, 'true');
    }

    if (context) {
      loc = UrlUtil.addParam(loc, RP_CONTEXT, context);
    }

    if (appType.addParams) {
      loc = appType.addParams(loc);
    }

    return loc;
  };

  _proto.getTitle = function getTitle(app) {
    return app.title;
  };

  _proto.getLongTitle = function getLongTitle(app) {
    return isValidString(app.longTitle) ? app.longTitle : this.getTitle(app);
  };

  _proto.getNameForType = function getNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    var t = APP_TYPES[type];
    return t.absoluteKey ? this.getGeneralNameForType(type) : this.getCoreNameForType(type);
  };

  _proto.getShortNameForType = function getShortNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    var t = APP_TYPES[type];
    return t.absoluteKey ? this.getGeneralShortNameForType(type) : this.getShortCoreNameForType(type);
  };

  _proto.getGeneralNameForType = function getGeneralNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    return APP_TYPES[type].name;
  };

  _proto.getGeneralShortNameForType = function getGeneralShortNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    var t = APP_TYPES[type];
    return t.shortName ? t.shortName : t.name;
  };

  _proto.getCoreNameForType = function getCoreNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    var t = APP_TYPES[type];
    return this.getNameForType(type) + " (" + t.coreName + ")";
  };

  _proto.getShortCoreNameForType = function getShortCoreNameForType(type) {
    var APP_TYPES = this.APP_TYPES;
    var t = APP_TYPES[type];
    return this.getGeneralShortNameForType(type) + " (" + t.coreName + ")";
  };

  _proto.getThumbnailForType = function getThumbnailForType(type, imgSrc) {
    return isValidString(imgSrc) ? imgSrc : this.getDefaultThumbnailForType(type);
  };

  _proto.getDefaultThumbnailForType = function getDefaultThumbnailForType(type) {
    var APP_TYPES = this.APP_TYPES;
    return resolvePath$1(APP_TYPES[type].thumbnail);
  };

  _proto.getBackgroundForType = function getBackgroundForType(type, imgSrc) {
    return isValidString(imgSrc) ? imgSrc : this.getDefaultBackgroundForType(type);
  };

  _proto.getDefaultBackgroundForType = function getDefaultBackgroundForType(type) {
    var APP_TYPES = this.APP_TYPES;
    return resolvePath$1(APP_TYPES[type].background);
  };

  _proto.getDefaultsForType = function getDefaultsForType(type) {
    var APP_TYPES = this.APP_TYPES;
    return APP_TYPES[type].defaults;
  };

  _proto.getAppTypes = function getAppTypes() {
    return this.APP_TYPES;
  };

  _proto.getTypeForExtension = function getTypeForExtension(ext) {
    var APP_TYPES = this.APP_TYPES;
    ext = ext.toLowerCase();
    var retType = null;

    for (var name in APP_TYPES) {
      var type = APP_TYPES[name];

      if (type.extensions) {
        for (var j = 0; j < type.extensions.length; j++) {
          if (ext === type.extensions[j] && (retType === null || type.absoluteKey)) {
            retType = type;
          }
        }
      }
    }

    return retType;
  };

  _proto.getAllExtensions = function getAllExtensions(dotted, nonUnique) {
    if (dotted === void 0) {
      dotted = true;
    }

    if (nonUnique === void 0) {
      nonUnique = false;
    }

    var extensions = [];

    if (nonUnique) {
      extensions.push((dotted ? "." : "") + "bin");
    }

    var APP_TYPES = this.APP_TYPES;

    for (var name in APP_TYPES) {
      var type = APP_TYPES[name];

      if (type.extensions && !type.absoluteKey) {
        for (var j = 0; j < type.extensions.length; j++) {
          extensions.push((dotted ? "." : "") + type.extensions[j]);
        }
      }
    }

    return extensions;
  };

  _proto.getExtensions = function getExtensions(name, dotted, nonUnique) {
    if (dotted === void 0) {
      dotted = true;
    }

    if (nonUnique === void 0) {
      nonUnique = false;
    }

    var extensions = [];

    if (nonUnique) {
      extensions.push((dotted ? "." : "") + "bin");
    }

    var APP_TYPES = this.APP_TYPES;
    var type = APP_TYPES[name];

    if (type.absoluteKey) {
      type = APP_TYPES[type.absoluteKey];
    }

    if (type.extensions) {
      for (var j = 0; j < type.extensions.length; j++) {
        extensions.push((dotted ? "." : "") + type.extensions[j]);
      }
    }

    return extensions;
  };

  _proto.testMagic = function testMagic(bytes) {
    var APP_TYPES = this.APP_TYPES;
    var testLast = [];

    for (var name in APP_TYPES) {
      var type = APP_TYPES[name];

      if (type.absoluteKey && type.testMagic) {
        if (type.testMagicLast !== undefined && type.testMagicLast == true) {
          testLast.push(type);
        } else {
          if (type.testMagic(bytes)) {
            return type;
          }
        }
      }
    }

    for (var i = 0; i < testLast.length; i++) {
      var _type = testLast[i];

      if (_type.testMagic(bytes)) {
        return _type;
      }
    }

    return null;
  };

  _proto.getMd5 = function getMd5(blob, type) {
    if (type === void 0) {
      type = null;
    }

    try {
      var _temp5 = function _temp5() {
        function _temp2(_blobToStr) {
          return _temp ? _blobToStr : md5(_blobToStr);
        }

        var _temp = result != null;

        return _temp ? _temp2(result) : Promise.resolve(blobToStr(blob)).then(_temp2);
      };

      var _this3 = this;

      var _APP_TYPES = _this3.APP_TYPES;
      var result = null;

      if (type && typeof type === 'string') {
        type = _APP_TYPES[type];
      }

      var _temp6 = function () {
        if (type && type.getMd5) {
          return Promise.resolve(type.getMd5(blob)).then(function (_type$getMd) {
            result = _type$getMd;
          });
        }
      }();

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(_temp5) : _temp5(_temp6));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return AppRegistry;
}();

AppRegistry.instance = AppRegistry.instance || new AppRegistry();

var SCREEN_SIZES = {
  SS_DEFAULT: "default",
  SS_NATIVE: "native",
  SS_16_9: "16:9",
  SS_FILL: "fill"
};
var Settings = /*#__PURE__*/function (_BaseSettings) {
  _inheritsLoose(Settings, _BaseSettings);

  function Settings(storage) {
    var _this;

    _this = _BaseSettings.call(this, storage) || this;
    _this.PREFIX = "wrcSettings.";
    _this.EXP_APPS_PROP = _this.PREFIX + "expApps";
    _this.VSYNC_PROP = _this.PREFIX + "vsync";
    _this.BILINEAR_FILTER_PROP = _this.PREFIX + "bilinearFilter";
    _this.SCREEN_SIZE_PROP = _this.PREFIX + "screenSize";
    _this.CLOUD_STORAGE_PROP = _this.PREFIX + "cloudStorage";
    _this.HIDE_TITLE_BAR_PROP = _this.PREFIX + "hideTitleBar";
    _this.DB_TOKEN = _this.PREFIX + "dbToken";
    _this.DISABLE_GAME_SAVES_AFTER_STATE = _this.PREFIX + "disableGameSavesAfterState";
    _this.expApps = false;
    _this.vsync = true;
    _this.bilinearFilter = false;
    _this.cloudStorage = false;
    _this.hideTitleBar = false;
    _this.disableGameSavesAfterState = false;
    _this.dbToken = null;
    _this.screenSize = SCREEN_SIZES.SS_NATIVE;
    return _this;
  }

  var _proto = Settings.prototype;

  _proto.load = function load() {
    try {
      var _this3 = this;

      info("Loading settings.");
      return Promise.resolve(_this3.loadBool(_this3.EXP_APPS_PROP, _this3.expApps)).then(function (_this2$loadBool) {
        _this3.expApps = _this2$loadBool;
        return Promise.resolve(_this3.loadBool(_this3.VSYNC_PROP, _this3.vsync)).then(function (_this2$loadBool2) {
          _this3.vsync = _this2$loadBool2;
          return Promise.resolve(_this3.loadBool(_this3.CLOUD_STORAGE_PROP, _this3.cloudStorage)).then(function (_this2$loadBool3) {
            _this3.cloudStorage = _this2$loadBool3;
            return Promise.resolve(_this3.loadBool(_this3.BILINEAR_FILTER_PROP, _this3.bilinearFilter)).then(function (_this2$loadBool4) {
              _this3.bilinearFilter = _this2$loadBool4;
              return Promise.resolve(_this3.loadBool(_this3.HIDE_TITLE_BAR_PROP, _this3.hideTitleBar)).then(function (_this2$loadBool5) {
                _this3.hideTitleBar = _this2$loadBool5;
                return Promise.resolve(_this3.loadValue(_this3.DB_TOKEN, _this3.dbToken)).then(function (_this2$loadValue) {
                  _this3.dbToken = _this2$loadValue;
                  return Promise.resolve(_this3.loadValue(_this3.SCREEN_SIZE_PROP, _this3.screenSize)).then(function (_this2$loadValue2) {
                    _this3.screenSize = _this2$loadValue2;
                    return Promise.resolve(_this3.loadValue(_this3.DISABLE_GAME_SAVES_AFTER_STATE, _this3.disableGameSavesAfterState)).then(function (_this2$loadValue3) {
                      _this3.disableGameSavesAfterState = _this2$loadValue3;
                      AppRegistry.instance.enableExpApps(_this3.expApps);
                    });
                  });
                });
              });
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.save = function save() {
    try {
      var _this5 = this;

      info("Saving settings.");
      return Promise.resolve(_this5.saveBool(_this5.EXP_APPS_PROP, _this5.expApps)).then(function () {
        return Promise.resolve(_this5.saveBool(_this5.VSYNC_PROP, _this5.vsync)).then(function () {
          return Promise.resolve(_this5.saveBool(_this5.CLOUD_STORAGE_PROP, _this5.cloudStorage)).then(function () {
            return Promise.resolve(_this5.saveBool(_this5.BILINEAR_FILTER_PROP, _this5.bilinearFilter)).then(function () {
              return Promise.resolve(_this5.saveBool(_this5.HIDE_TITLE_BAR_PROP, _this5.hideTitleBar)).then(function () {
                return Promise.resolve(_this5.saveValue(_this5.DB_TOKEN, _this5.dbToken)).then(function () {
                  return Promise.resolve(_this5.saveValue(_this5.SCREEN_SIZE_PROP, _this5.screenSize)).then(function () {
                    return Promise.resolve(_this5.saveValue(_this5.DISABLE_GAME_SAVES_AFTER_STATE, _this5.disableGameSavesAfterState)).then(function () {
                      AppRegistry.instance.enableExpApps(_this5.expApps);
                    });
                  });
                });
              });
            });
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.isExpAppsEnabled = function isExpAppsEnabled() {
    return this.expApps;
  };

  _proto.setExpAppsEnabled = function setExpAppsEnabled(b) {
    this.expApps = b;
  };

  _proto.getDbToken = function getDbToken() {
    return this.dbToken;
  };

  _proto.setDbToken = function setDbToken(t) {
    this.dbToken = t;
  };

  _proto.isCloudStorageEnabled = function isCloudStorageEnabled() {
    return this.cloudStorage;
  };

  _proto.setCloudStorageEnabled = function setCloudStorageEnabled(b) {
    this.cloudStorage = b;
  };

  _proto.isVsyncEnabled = function isVsyncEnabled() {
    return this.vsync;
  };

  _proto.setVsyncEnabled = function setVsyncEnabled(b) {
    this.vsync = b;
  };

  _proto.isBilinearFilterEnabled = function isBilinearFilterEnabled() {
    return this.bilinearFilter;
  };

  _proto.setBilinearFilterEnabled = function setBilinearFilterEnabled(b) {
    this.bilinearFilter = b;
  };

  _proto.getHideTitleBar = function getHideTitleBar() {
    return this.hideTitleBar;
  };

  _proto.setHideTitleBar = function setHideTitleBar(b) {
    this.hideTitleBar = b;
  };

  _proto.getScreenSize = function getScreenSize() {
    return this.screenSize;
  };

  _proto.setScreenSize = function setScreenSize(s) {
    this.screenSize = s;
  };

  _proto.isGameSavesDisabledAfterState = function isGameSavesDisabledAfterState() {
    return this.disableGameSavesAfterState;
  };

  _proto.setGameSavesDisabledAfterState = function setGameSavesDisabledAfterState(b) {
    this.disableGameSavesAfterState = b;
  };

  return Settings;
}(BaseSettings);
var settings = new Settings(storage);

var hideInactiveMouse = function hideInactiveMouse(element, timeout) {
  if (timeout === void 0) {
    timeout = 2500;
  }

  var timeoutId = null;

  var fTimeout = function fTimeout() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = null;
    element.style.cursor = 'none';
  };

  var f = function f() {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    timeoutId = setTimeout(fTimeout, timeout);
    element.style.cursor = 'auto';
  };

  element.addEventListener('mousemove', f);
  element.addEventListener('mousedown', f);
  element.addEventListener('mouseup', f);
  element.addEventListener('wheel', f);
  element.style.cursor = 'auto';
  timeoutId = setTimeout(fTimeout, timeout);
};

var CIDS = {
  UP: 0,
  DOWN: 1,
  LEFT: 2,
  RIGHT: 3,
  A: 4,
  B: 5,
  X: 6,
  Y: 7,
  LBUMP: 8,
  RBUMP: 9,
  LTRIG: 10,
  RTRIG: 11,
  SELECT: 12,
  START: 13,
  LANALOG: 14,
  RANALOG: 15,
  ESCAPE: 16
};
var KCODES = {
  ARROW_UP: 'ArrowUp',
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  A: 'KeyA',
  C: 'KeyC',
  D: 'KeyD',
  E: 'KeyE',
  I: 'KeyI',
  J: 'KeyJ',
  K: 'KeyK',
  L: 'KeyL',
  Q: 'KeyQ',
  R: 'KeyR',
  S: 'KeyS',
  T: 'KeyT',
  V: 'KeyV',
  W: 'KeyW',
  X: 'KeyX',
  Z: 'KeyZ',
  DIGIT_0: 'Digit0',
  DIGIT_1: 'Digit1',
  DIGIT_2: 'Digit2',
  DIGIT_3: 'Digit3',
  DIGIT_4: 'Digit4',
  DIGIT_5: 'Digit5',
  DIGIT_6: 'Digit6',
  DIGIT_7: 'Digit7',
  DIGIT_8: 'Digit8',
  DIGIT_9: 'Digit9',
  EQUAL: 'Equal',
  MINUS: 'Minus',
  SHIFT_RIGHT: 'ShiftRight',
  SHIFT_LEFT: 'ShiftLeft',
  SPACE_BAR: 'Space',
  CONTROL_LEFT: 'ControlLeft',
  CONTROL_RIGHT: 'ControlRight',
  ENTER: 'Enter',
  ESCAPE: 'Escape'
};
var PadMapping = /*#__PURE__*/function () {
  function PadMapping(idToButtonNum, axisMappings) {

    this.idToButtonNum = idToButtonNum;
    this.buttonNumToId = {};

    for (var _i = 0, _Object$entries = Object.entries(idToButtonNum); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _Object$entries[_i],
          id = _Object$entries$_i[0],
          num = _Object$entries$_i[1];
      this.buttonNumToId[num] = id;
    }
  }

  var _proto = PadMapping.prototype;

  _proto.getButtonNum = function getButtonNum(cid) {
    var bid = this.idToButtonNum[cid];
    return bid === undefined ? -1 : bid;
  };

  _proto.getAxisIndex = function getAxisIndex(stick, isX) {
    return -1;
  };

  _proto.getHotKeyIds = function getHotKeyIds() {
    return null;
  };

  _proto.getAxisValue = function getAxisValue(pad, stick, isX) {
    if (pad && pad.axes) {
      var idx = this.getAxisIndex(stick, isX);

      if (idx >= 0 && idx < pad.axes.length) {
        return pad.axes[idx];
      }
    }

    return 0;
  };

  return PadMapping;
}();
var StandardPadMapping = /*#__PURE__*/function (_PadMapping) {
  _inheritsLoose(StandardPadMapping, _PadMapping);

  function StandardPadMapping() {
    var _PadMapping$call;

    return _PadMapping.call(this, (_PadMapping$call = {}, _PadMapping$call[CIDS.UP] = 12, _PadMapping$call[CIDS.DOWN] = 13, _PadMapping$call[CIDS.LEFT] = 14, _PadMapping$call[CIDS.RIGHT] = 15, _PadMapping$call[CIDS.A] = 0, _PadMapping$call[CIDS.B] = 1, _PadMapping$call[CIDS.X] = 2, _PadMapping$call[CIDS.Y] = 3, _PadMapping$call[CIDS.LBUMP] = 4, _PadMapping$call[CIDS.RBUMP] = 5, _PadMapping$call[CIDS.LTRIG] = 6, _PadMapping$call[CIDS.RTRIG] = 7, _PadMapping$call[CIDS.SELECT] = 8, _PadMapping$call[CIDS.START] = 9, _PadMapping$call[CIDS.LANALOG] = 10, _PadMapping$call[CIDS.RANALOG] = 11, _PadMapping$call)) || this;
  }

  var _proto2 = StandardPadMapping.prototype;

  _proto2.getAxisIndex = function getAxisIndex(stick, isX) {
    if (stick === 0) return isX ? 0 : 1;else if (stick === 1) {
      return isX ? 2 : 3;
    } else {
      return -1;
    }
  };

  return StandardPadMapping;
}(PadMapping);
var KeyCodeToControlMapping = /*#__PURE__*/function () {
  function KeyCodeToControlMapping(keyCodeToControlId) {
    if (keyCodeToControlId === void 0) {
      keyCodeToControlId = {};
    }

    this.keyCodeToControlId = keyCodeToControlId;
    this.controlIdState = {};

    for (var _i2 = 0, _Object$entries2 = Object.entries(keyCodeToControlId); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _Object$entries2[_i2],
          id = _Object$entries2$_i[1];
      this.controlIdState[id] = false;
      this.leftLast = false;
      this.upLast = false;
      this.upHeld = false;
      this.downHeld = false;
      this.rightHeld = false;
      this.leftHeld = false;
      this.escape = false;
    }
  }

  var _proto3 = KeyCodeToControlMapping.prototype;

  _proto3.getKeyCodeToControlId = function getKeyCodeToControlId() {
    return this.keyCodeToControlId;
  };

  _proto3.handleKeyEvent = function handleKeyEvent(e, down) {
    if (isEscapeKeySequence(e)) {
      e.preventDefault();
      this.escape = true;
      return;
    }

    this.escape = false;
    var cid = this.keyCodeToControlId[e.code];

    if (cid !== undefined) {
      e.preventDefault();
      this.controlIdState[cid] = down;

      switch (cid) {
        case CIDS.UP:
          this.upHeld = down;
          if (down) this.upLast = true;
          break;

        case CIDS.DOWN:
          this.downHeld = down;
          if (down) this.upLast = false;
          break;

        case CIDS.RIGHT:
          this.rightHeld = down;
          if (down) this.leftLast = false;
          break;

        case CIDS.LEFT:
          this.leftHeld = down;
          if (down) this.leftLast = true;
          break;
      }
    }
  };

  _proto3.isControlDown = function isControlDown(cid) {
    if (this.escape && cid === CIDS.ESCAPE) {
      return true;
    }

    var down = this.controlIdState[cid];

    if (down !== undefined && down) {
      switch (cid) {
        case CIDS.UP:
          down = !(this.downHeld && !this.upLast);
          break;

        case CIDS.DOWN:
          down = !(this.upHeld && this.upLast);
          break;

        case CIDS.RIGHT:
          down = !(this.leftHeld && this.leftLast);
          break;

        case CIDS.LEFT:
          down = !(this.rightHeld && !this.leftLast);
          break;
      }
    } else {
      down = false;
    }

    return down;
  };

  return KeyCodeToControlMapping;
}();
var DefaultKeyCodeToControlMapping = /*#__PURE__*/function (_KeyCodeToControlMapp) {
  _inheritsLoose(DefaultKeyCodeToControlMapping, _KeyCodeToControlMapp);

  function DefaultKeyCodeToControlMapping() {
    var _KeyCodeToControlMapp2;

    return _KeyCodeToControlMapp.call(this, (_KeyCodeToControlMapp2 = {}, _KeyCodeToControlMapp2[KCODES.ARROW_UP] = CIDS.UP, _KeyCodeToControlMapp2[KCODES.ARROW_DOWN] = CIDS.DOWN, _KeyCodeToControlMapp2[KCODES.ARROW_RIGHT] = CIDS.RIGHT, _KeyCodeToControlMapp2[KCODES.ARROW_LEFT] = CIDS.LEFT, _KeyCodeToControlMapp2[KCODES.Z] = CIDS.A, _KeyCodeToControlMapp2[KCODES.A] = CIDS.X, _KeyCodeToControlMapp2[KCODES.X] = CIDS.B, _KeyCodeToControlMapp2[KCODES.S] = CIDS.Y, _KeyCodeToControlMapp2[KCODES.Q] = CIDS.LBUMP, _KeyCodeToControlMapp2[KCODES.W] = CIDS.RBUMP, _KeyCodeToControlMapp2[KCODES.SHIFT_RIGHT] = CIDS.SELECT, _KeyCodeToControlMapp2[KCODES.ENTER] = CIDS.START, _KeyCodeToControlMapp2[KCODES.ESCAPE] = CIDS.ESCAPE, _KeyCodeToControlMapp2)) || this;
  }

  return DefaultKeyCodeToControlMapping;
}(KeyCodeToControlMapping);
var Controller = /*#__PURE__*/function () {
  function Controller(keyCodeToControlMapping) {
    if (keyCodeToControlMapping === void 0) {
      keyCodeToControlMapping = new KeyCodeToControlMapping();
    }

    this.keyCodeToControlMapping = keyCodeToControlMapping;
    this.padMapping = new StandardPadMapping();
    this.pad = null;
    this.isXbox = isXbox();
  }

  var _proto4 = Controller.prototype;

  _proto4.getKeyCodeToControllerMapping = function getKeyCodeToControllerMapping() {
    return this.keyCodeToControlMapping;
  };

  _proto4.setPad = function setPad(pad) {
    this.pad = pad;
  };

  _proto4.handleKeyEvent = function handleKeyEvent(e, down) {
    this.keyCodeToControlMapping.handleKeyEvent(e, down);
  };

  _proto4.isPadButtonDown = function isPadButtonDown(cid, analogToDigital) {
    if (analogToDigital === void 0) {
      analogToDigital = true;
    }

    var padMapping = this.padMapping;
    var pad = this.pad;
    var bid = padMapping.getButtonNum(cid);
    var bdown = false;

    if (bid >= 0 && pad && pad.buttons.length > bid) {
      bdown = pad.buttons[bid].pressed;
    }

    if (!bdown && analogToDigital) {
      switch (cid) {
        case CIDS.LEFT:
          bdown = this.isAxisLeft(0);
          break;

        case CIDS.RIGHT:
          bdown = this.isAxisRight(0);
          break;

        case CIDS.UP:
          bdown = this.isAxisUp(0);
          break;

        case CIDS.DOWN:
          bdown = this.isAxisDown(0);
          break;
      }
    }

    return bdown;
  };

  _proto4.getAxisValue = function getAxisValue(stick, isX) {
    var padMapping = this.padMapping;
    return padMapping.getAxisValue(this.pad, stick, isX);
  };

  _proto4.isAxisLeft = function isAxisLeft(stick) {
    var padMapping = this.padMapping;
    return padMapping.getAxisValue(this.pad, stick, true) < -0.5;
  };

  _proto4.isAxisRight = function isAxisRight(stick) {
    var padMapping = this.padMapping;
    return padMapping.getAxisValue(this.pad, stick, true) > 0.5;
  };

  _proto4.isAxisUp = function isAxisUp(stick) {
    var padMapping = this.padMapping;
    return padMapping.getAxisValue(this.pad, stick, false) < -0.5;
  };

  _proto4.isAxisDown = function isAxisDown(stick) {
    var padMapping = this.padMapping;
    return padMapping.getAxisValue(this.pad, stick, false) > 0.5;
  };

  _proto4.isControlDown = function isControlDown(cid, analogToDigital) {
    if (analogToDigital === void 0) {
      analogToDigital = true;
    }

    var isXbox = this.isXbox;

    if (this.keyCodeToControlMapping.isControlDown(cid)) {
      return true;
    }

    if (cid === CIDS.ESCAPE || cid === CIDS.START || cid == CIDS.SELECT) {
      if (cid === CIDS.ESCAPE) {
        return this.isPadButtonDown(CIDS.LTRIG) && (this.isPadButtonDown(CIDS.RANALOG) || this.isPadButtonDown(CIDS.LANALOG)) || !isXbox && (this.isPadButtonDown(CIDS.LTRIG) && (this.isPadButtonDown(CIDS.START) || this.isPadButtonDown(CIDS.SELECT)) || this.isPadButtonDown(CIDS.SELECT) && this.isPadButtonDown(CIDS.X));
      } else if (cid == CIDS.START) {
        return this.isPadButtonDown(CIDS.RTRIG) && this.isPadButtonDown(CIDS.RANALOG) || !isXbox && this.isPadButtonDown(CIDS.START);
      } else if (cid == CIDS.SELECT) {
        return this.isPadButtonDown(CIDS.RTRIG) && this.isPadButtonDown(CIDS.LANALOG) || !isXbox && this.isPadButtonDown(CIDS.SELECT);
      }

      return false;
    }

    return this.isPadButtonDown(cid, analogToDigital);
  };

  return Controller;
}();
var Controllers = /*#__PURE__*/function () {
  function Controllers(controllerArray) {
    var _this = this;

    this.keyDownListener = function (e) {
      _this.handleKeyEvent(e, true);
    };

    this.keyUpListener = function (e) {
      _this.handleKeyEvent(e, false);
    };

    this.controllers = controllerArray;
    this.enabled = false;
    this.keyboardDisabled = false;
    this.setEnabled(true);
  }

  var _proto5 = Controllers.prototype;

  _proto5.getController = function getController(index) {
    return this.controllers[index];
  };

  _proto5.setKeyboardDisabled = function setKeyboardDisabled(v) {
    this.keyboardDisabled = v;
  };

  _proto5.addFakeKeyEvent = function addFakeKeyEvent(code, down) {
    this.handleKeyEvent({
      code: code,
      preventDefault: function preventDefault() {}
    }, down);
  };

  _proto5.setEnabled = function setEnabled(enable) {
    var docElement = document.documentElement;

    if (enable && !this.enabled) {
      this.enabled = true;
      docElement.addEventListener("keydown", this.keyDownListener);
      docElement.addEventListener("keyup", this.keyUpListener);
    } else if (!enable && this.enabled) {
      this.enabled = false;
      docElement.removeEventListener("keydown", this.keyDownListener);
      docElement.removeEventListener("keyup", this.keyUpListener);
    }
  };

  _proto5.handleKeyEvent = function handleKeyEvent(e, down) {
    if (this.keyboardDisabled) return;

    for (var i = 0; i < this.controllers.length; i++) {
      this.controllers[i].handleKeyEvent(e, down);
    }
  };

  _proto5.waitUntilControlReleased = function waitUntilControlReleased(controllerIdx, cid) {
    var _this2 = this;

    var INTERVAL = 50;
    return new Promise(function (resolve, reject) {
      var f = function f() {
        _this2.poll();

        if (!_this2.isControlDown(controllerIdx, cid)) {
          resolve();
        } else {
          setTimeout(f, INTERVAL);
        }
      };

      setTimeout(f, INTERVAL);
    });
  };

  _proto5.poll = function poll() {
    var clen = this.controllers.length;
    var gamepads = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads() : [];
    var padIdx = 0;

    for (var idx = 0; padIdx < clen && idx < gamepads.length; idx++) {
      var pad = gamepads[idx];

      if (pad) {
        this.controllers[padIdx].setPad(pad);
        padIdx++;
      }
    }

    for (; padIdx < clen; padIdx++) {
      this.controllers[padIdx].setPad(null);
    }
  };

  _proto5.isControlDown = function isControlDown(controllerIdx, cid, analogToDigital) {
    if (analogToDigital === void 0) {
      analogToDigital = true;
    }

    return this.controllers[controllerIdx].isControlDown(cid, analogToDigital);
  };

  _proto5.isAxisDown = function isAxisDown(controllerIdx, stick) {
    return this.controllers[controllerIdx].isAxisDown(stick);
  };

  _proto5.isAxisUp = function isAxisUp(controllerIdx, stick) {
    return this.controllers[controllerIdx].isAxisUp(stick);
  };

  _proto5.isAxisLeft = function isAxisLeft(controllerIdx, stick) {
    return this.controllers[controllerIdx].isAxisLeft(stick);
  };

  _proto5.isAxisRight = function isAxisRight(controllerIdx, stick) {
    return this.controllers[controllerIdx].isAxisRight(stick);
  };

  _proto5.getAxisValue = function getAxisValue(controllerIdx, stick, isX) {
    return this.controllers[controllerIdx].getAxisValue(stick, isX);
  };

  return Controllers;
}();
function isEscapeKeySequence(e) {
  return e.getModifierState && (e.getModifierState("Control") || e.getModifierState("Alt")) && (e.code === KCODES.ENTER || e.code === KCODES.SHIFT_LEFT || e.code === KCODES.SHIFT_RIGHT);
}

var registerAudioResume = function registerAudioResume(obj, cb, interval) {
  var audioCtx = obj;
  var isProcessor = false;

  if (obj.audioCtx) {
    audioCtx = obj.audioCtx;
    isProcessor = true;
  }

  var docElement = document.documentElement;
  var audioSucceeded = false;

  var resumeFunc = function resumeFunc() {
    if (isProcessor && obj.paused) {
      return;
    }

    console.log('### resume func.');

    var fSuccess = function fSuccess() {
      if (audioSucceeded) return;
      audioSucceeded = true;
      console.log('### success.');
      if (cb) cb(true);
      docElement.removeEventListener("keydown", resumeFunc);
      docElement.removeEventListener("click", resumeFunc);
      docElement.removeEventListener("drop", resumeFunc);
      docElement.removeEventListener("dragdrop", resumeFunc);
      docElement.removeEventListener("touchend", resumeFunc);
    };

    if (audioCtx.state !== 'running') {
      audioCtx.resume().then(function () {
        if (audioCtx.state === 'running') {
          fSuccess();
        } else {
          if (interval !== undefined) {
            setTimeout(resumeFunc, interval);
          }
        }
      });
    } else {
      fSuccess();
    }
  };

  if (interval !== undefined) {
    setTimeout(resumeFunc, interval);
  }

  docElement.addEventListener("keydown", resumeFunc);
  docElement.addEventListener("click", resumeFunc);
  docElement.addEventListener("drop", resumeFunc);
  docElement.addEventListener("dragdrop", resumeFunc);
  docElement.addEventListener("touchend", resumeFunc);
};

var ScriptAudioProcessor = /*#__PURE__*/function () {
  function ScriptAudioProcessor(channelCount, frequency, bufferSize, scriptBufferSize) {
    if (channelCount === void 0) {
      channelCount = 2;
    }

    if (frequency === void 0) {
      frequency = 48000;
    }

    if (bufferSize === void 0) {
      bufferSize = 16384;
    }

    if (scriptBufferSize === void 0) {
      scriptBufferSize = 2048;
    }

    this.frequency = frequency;
    this.bufferSize = bufferSize;
    this.scriptBufferSize = scriptBufferSize;
    this.channelCount = channelCount;
    this.paused = true;
    this.audioCtx = null;
    this.audioNode = null;
    this.mixhead = 0;
    this.mixtail = 0;
    this.callback = null;
    this.debug = false;
    this.adjustVol = 0;
    this.tmpBuffers = new Array(channelCount);
    this.mixbuffer = new Array(channelCount);

    for (var i = 0; i < channelCount; i++) {
      this.mixbuffer[i] = new Array(bufferSize);
    }
  }

  var _proto = ScriptAudioProcessor.prototype;

  _proto.adjustVolume = function adjustVolume(adjust) {
    if (adjust === 0) {
      return;
    }

    if (adjust > 99) {
      adjust = 99;
    }

    if (adjust < -99) {
      adjust = -99;
    }

    if (adjust < 0) {
      this.adjustVol = (100 + adjust) / 99;
    } else {
      this.adjustVol = 1 + adjust / 5;
    }

    info("## adjustVolume: " + this.adjustVol);
  };

  _proto.setDebug = function setDebug(debug) {
    this.debug = debug;
    return this;
  };

  _proto.isPlaying = function isPlaying() {
    var audioCtx = this.audioCtx;
    return audioCtx && audioCtx.state === 'running';
  };

  _proto.setCallback = function setCallback(cb) {
    this.callback = cb;
  };

  _proto.getFrequency = function getFrequency() {
    return this.frequency;
  };

  _proto.pause = function pause(p) {
    if (p == this.paused) return;

    if (this.audioCtx) {
      if (!p) {
        this.audioCtx.resume();
      } else {
        this.audioCtx.suspend();
      }
    }

    this.paused = p;
  };

  _proto.start = function start(forceResume) {
    var _this = this;

    if (forceResume === void 0) {
      forceResume = false;
    }

    if (!this.audioCtx && (window.AudioContext || window.webkitAudioContext)) {
      this.audioCtx = window.AudioContext ? new window.AudioContext({
        sampleRate: this.frequency
      }) : new window.webkitAudioContext();

      if (this.audioCtx.sampleRate) {
        this.frequency = this.audioCtx.sampleRate;
      }

      this.audioNode = this.audioCtx.createScriptProcessor(this.scriptBufferSize, 0, this.channelCount);

      this.audioNode.onaudioprocess = function (e) {
        for (var i = 0; i < _this.channelCount; i++) {
          _this.tmpBuffers[i] = e.outputBuffer.getChannelData(i);
        }

        var done = 0;
        var len = _this.tmpBuffers[0].length;

        while (_this.mixtail != _this.mixhead && done < len) {
          for (var _i = 0; _i < _this.channelCount; _i++) {
            _this.tmpBuffers[_i][done] = _this.mixbuffer[_i][_this.mixtail];
          }

          done++;
          _this.mixtail++;

          if (_this.mixtail == _this.bufferSize) {
            _this.mixtail = 0;
          }
        }

        if (_this.debug) {
          if (_this.mixtail === _this.mixhead && done < len) {
            info("Not enough samples available: " + (len - done));
          }
        }

        while (done < len) {
          for (var _i2 = 0; _i2 < _this.channelCount; _i2++) {
            _this.tmpBuffers[_i2] = 0;
          }

          done++;
        }
      };

      this.audioNode.connect(this.audioCtx.destination);
      this.paused = false;
      setTimeout(function () {
        if (!_this.isPlaying() || forceResume) {
          registerAudioResume(_this, _this.callback);
          if (_this.callback) _this.callback(false);
        }
      }, 100);
    }
  };

  _proto.storeSound = function storeSound(channels, length) {
    for (var i = 0; i < length; i++) {
      for (var j = 0; j < channels.length; j++) {
        this.mixbuffer[j][this.mixhead] = channels[j][i];
      }

      this.mixhead++;
      if (this.mixhead == this.bufferSize) this.mixhead = 0;
    }
  };

  _proto.storeSoundCombinedInput = function storeSoundCombinedInput(channels, channelCount, length, offset, divisor) {
    if (offset === void 0) {
      offset = 0;
    }

    if (divisor === void 0) {
      divisor = 1;
    }

    var adjust = this.adjustVol == 0 ? 1 : this.adjustVol;

    for (var i = 0; i < length;) {
      for (var j = 0; j < channelCount; j++) {
        var val = channels[offset + i++] / divisor * adjust;
        this.mixbuffer[j][this.mixhead] = val;
      }

      this.mixhead++;
      if (this.mixhead == this.bufferSize) this.mixhead = 0;

      if (this.debug) {
        if (this.mixtail === this.mixhead + 1) {
          info('head hit tail!');
        }
      }
    }
  };

  return ScriptAudioProcessor;
}();

var TouchEndListener = function TouchEndListener(cb) {
  window.document.addEventListener('touchend', function (e) {
    return cb(e);
  });
};

var VisibilityChangeMonitor = function VisibilityChangeMonitor(cb) {
  var _this = this;

  this.cb = cb;
  this.hidden = null;
  this.visibilityChange = null;

  var handleVisibilityChange = function handleVisibilityChange() {
    _this.cb(document[_this.hidden]);
  };

  if (typeof document.hidden !== "undefined") {
    this.hidden = "hidden";
    this.visibilityChange = "visibilitychange";
  } else if (typeof document.msHidden !== "undefined") {
    this.hidden = "msHidden";
    this.visibilityChange = "msvisibilitychange";
  } else if (typeof document.webkitHidden !== "undefined") {
    this.hidden = "webkitHidden";
    this.visibilityChange = "webkitvisibilitychange";
  }

  document.addEventListener(this.visibilityChange, handleVisibilityChange, false);
};

var TEXT_VALUES = {
  ADD: "Add",
  ADD_UC: "ADD",
  ADVANCED_SETTINGS: "Advanced Settings",
  ANALOG: "Analog",
  BILINEAR_FILTER: "Bilinear filter",
  CANCEL: "Cancel",
  CATEGORIES: "Categories",
  CLICK_TO_UNMUTE: "Click Screen to Unmute",
  CLOUD_CHECKING: "Checking cloud storage...",
  CLOUD_DELETING: "Deleting from cloud...",
  CLOUD_LOAD: "Loading from cloud...",
  CLOUD_LOAD_ERROR: "An error occurred attempting to load from the cloud.",
  CLOUD_LOAD_STATE_ERROR: "An error occurred attempting to load the save state from the cloud.",
  CLOUD_SAVE: "Saving to cloud...",
  CLOUD_SAVE_ERROR: "An error occurred attempting to save to the cloud.",
  CLOUD_SAVE_STATE_ERROR: "An error occurred attempting to save state to the cloud.",
  CLOUD_SAVES_DISABLED: "An error occurred connecting to the cloud.\nCloud saves have been disabled.",
  CLOUD_STORAGE: "Cloud Storage",
  CONFIRM_DELETE_FEED: "Are you sure you want to delete the selected feed?",
  CONNECT: "Connect",
  DELETE: "Delete",
  DELETE_UC: "DELETE",
  DISPLAY_SETTINGS: "Display Settings",
  DROPBOX: "Dropbox",
  DROPBOX_SERVER_UNAUTHORIZED: "This webЯcade server is not authorized to access Dropbox.",
  ENABLED: "Enabled",
  ERROR_DELETING_FEED: "An error has occurred attempting to delete the selected feed.",
  ERROR_LOADING_GAME: "An error occurred attempting to load the selected game.",
  ERROR_LOADING_FEED: "An error occurred attempting to load the selected feed.",
  ERROR_RETRIEVING_GAME: "An error has occurred attempting to retrieve the selected game.",
  ERROR_UNKNOWN: "An unknown error has occurred.",
  EXPERIMENTAL_APPS: "Experimental apps",
  FEEDS: "Feeds",
  FILE_UC: "FILE",
  GAMEPAD_CONTROLS: "Gamepad Controls",
  GAMEPAD_CONTROLS_DETAIL: "Gamepad Controls (%s)",
  GENERAL_SETTINGS: "General Settings",
  HIDE_TITLE_BAR: "Hide title bar",
  KEYBOARD_CONTROLS: "Keyboard Controls",
  KEYBOARD_CONTROLS_DETAIL: "Keyboard Controls (%s)",
  LINK: "Link",
  LINKED: "Linked",
  LOAD: "Load",
  LOAD_UC: "LOAD",
  LOADING: "Loading",
  LOADING_DOTS: "Loading...",
  LOADING_FEED: "Loading feed...",
  LOCAL_PARENS: "(Local)",
  NO: "No",
  OK: "OK",
  PLAY: "Play",
  PLAY_UC: "PLAY",
  RELOAD_EXP_APPS: "Changing the experimental apps setting requires webЯcade to be reloaded.",
  RESUME: "Resume",
  RETURN_TO_BROWSE: "Return to Browse",
  RETURN_TO_EDITOR: "Return to Editor",
  ROTATED: "Rotated",
  SAVE: "Save",
  SAVE_DOES_NOT_EXIST: "Save does not exist.",
  SAVE_STATES: "Save States",
  SAVE_TIME: "Save Time",
  SC_AUTO: "(auto)",
  SC_ON: "On",
  SC_OFF: "Off",
  SCREEN_SIZE: "Screen size",
  SEE_CONSOLE_LOG: "See console log for details.",
  SELECT_DISC: "Disc %s",
  SELECT_UC: "SELECT",
  SETTINGS: "Settings",
  SHOW_CATEGORIES: "Show Categories",
  SHOW_FEEDS: "Show Feeds",
  SIX_BUTTON: "6-button",
  SOMETHING_WENT_WRONG: "Whoops, something went wrong...",
  SPECIFY_LOCATION_OF_FEED: "Specify the location of the feed to add (URL)",
  SS_DEFAULT: "(default)",
  SS_NATIVE: "Native",
  SS_16_9: "16:9",
  SS_FILL: "Fill",
  STATUS: "Status",
  TAP_TO_UNMUTE: "Tap Screen to Unmute",
  TWO_BUTTON: "2-button",
  UNLINK: "Unlink",
  UNLINKED: "Unlinked",
  URL: "URL",
  VERTICAL_SYNC: "Vertical sync",
  VIEW_CONTROLS: "View Controls",
  YES: "Yes"
};
var TEXT_IDS = {
  ADD: "ADD",
  ADD_UC: "ADD_UC",
  ADVANCED_SETTINGS: "ADVANCED_SETTINGS",
  ANALOG: "ANALOG",
  BILINEAR_FILTER: "BILINEAR_FILTER",
  CANCEL: "CANCEL",
  CATEGORIES: "CATEGORIES",
  CLICK_TO_UNMUTE: "CLICK_TO_UNMUTE",
  CLOUD_CHECKING: "CLOUD_CHECKING",
  CLOUD_DELETING: "CLOUD_DELETING",
  CLOUD_LOAD: "CLOUD_LOAD",
  CLOUD_LOAD_ERROR: "CLOUD_LOAD_ERROR",
  CLOUD_LOAD_STATE_ERROR: "CLOUD_LOAD_STATE_ERROR",
  CLOUD_SAVE: "CLOUD_SAVE",
  CLOUD_SAVE_ERROR: "CLOUD_SAVE_ERROR",
  CLOUD_SAVE_STATE_ERROR: "CLOUD_SAVE_STATE_ERROR",
  CLOUD_SAVES_DISABLED: "CLOUD_SAVES_DISABLED",
  CLOUD_STORAGE: "CLOUD_STORAGE",
  CONFIRM_DELETE_FEED: "CONFIRM_DELETE_FEED",
  CONNECT: "CONNECT",
  DELETE: "DELETE",
  DELETE_UC: "DELETE_UC",
  DISPLAY_SETTINGS: "DISPLAY_SETTINGS",
  DROPBOX: "DROPBOX",
  DROPBOX_SERVER_UNAUTHORIZED: "DROPBOX_SERVER_UNAUTHORIZED",
  ENABLED: "ENABLED",
  ERROR_DELETING_FEED: "ERROR_DELETING_FEED",
  ERROR_LOADING_GAME: "ERROR_LOADING_GAME",
  ERROR_LOADING_FEED: "ERROR_LOADING_FEED",
  ERROR_RETRIEVING_GAME: "ERROR_RETRIEVING_GAME",
  ERROR_UNKNOWN: "ERROR_UNKNOWN",
  EXPERIMENTAL_APPS: "EXPERIMENTAL_APPS",
  FEEDS: "FEEDS",
  FILE_UC: "FILE_UC",
  GAMEPAD_CONTROLS: "GAMEPAD_CONTROLS",
  GAMEPAD_CONTROLS_DETAIL: "GAMEPAD_CONTROLS_DETAIL",
  GENERAL_SETTINGS: "GENERAL_SETTINGS",
  HIDE_TITLE_BAR: "HIDE_TITLE_BAR",
  KEYBOARD_CONTROLS: "KEYBOARD_CONTROLS",
  KEYBOARD_CONTROLS_DETAIL: "KEYBOARD_CONTROLS_DETAIL",
  LINK: "LINK",
  LINKED: "LINKED",
  LOAD: "LOAD",
  LOAD_UC: "LOAD_UC",
  LOADING: "LOADING",
  LOADING_DOTS: "LOADING_DOTS",
  LOADING_FEED: "LOADING_FEED",
  LOCAL_PARENS: "LOCAL_PARENS",
  NO: "NO",
  OK: "OK",
  PLAY: "PLAY",
  PLAY_UC: "PLAY_UC",
  RELOAD_EXP_APPS: "RELOAD_EXP_APPS",
  RESUME: "RESUME",
  RETURN_TO_BROWSE: "RETURN_TO_BROWSE",
  RETURN_TO_EDITOR: "RETURN_TO_EDITOR",
  ROTATED: "ROTATED",
  SAVE: "SAVE",
  SAVE_DOES_NOT_EXIST: "SAVE_DOES_NOT_EXIST",
  SAVE_STATES: "SAVE_STATES",
  SAVE_TIME: "SAVE_TIME",
  SC_AUTO: "SC_AUTO",
  SC_ON: "SC_ON",
  SC_OFF: "SC_OFF",
  SCREEN_SIZE: "SCREEN_SIZE",
  SEE_CONSOLE_LOG: "SEE_CONSOLE_LOG",
  SELECT_DISC: "SELECT_DISC",
  SELECT_UC: "SELECT_UC",
  SETTINGS: "SETTINGS",
  SHOW_CATEGORIES: "SHOW_CATEGORIES",
  SHOW_FEEDS: "SHOW_FEEDS",
  SIX_BUTTON: "SIX_BUTTON",
  SOMETHING_WENT_WRONG: "SOMETHING_WENT_WRONG",
  SPECIFY_LOCATION_OF_FEED: "SPECIFY_LOCATION_OF_FEED",
  SS_DEFAULT: "SS_DEFAULT",
  SS_NATIVE: "SS_NATIVE",
  SS_16_9: "SS_16_9",
  SS_FILL: "SS_FILL",
  STATUS: "STATUS",
  TAP_TO_UNMUTE: "TAP_TO_UNMUTE",
  TWO_BUTTON: "TWO_BUTTON",
  UNLINK: "UNLINK",
  UNLINKED: "UNLINKED",
  URL: "URL",
  VERTICAL_SYNC: "VERTICAL_SYNC",
  VIEW_CONTROLS: "VIEW_CONTROLS",
  YES: "YES"
};

var Resources = /*#__PURE__*/function () {
  function Resources() {}

  Resources.getText = function getText() {
    var id = arguments[0];
    var message = TEXT_VALUES[id];

    if (message === undefined) {
      error("Unable to find resource for key: '" + id + "'");
    }

    for (var i = 1; i < arguments.length; i++) {
      message = message.replace(/%s/, arguments[i]);
    }

    return message;
  };

  Resources.check = function check() {
    for (var key in TEXT_IDS) {
      if (TEXT_VALUES[key] === undefined) {
        error("Unable to find resource for key: '" + key + "'");
      }
    }
  };

  return Resources;
}();

var WrcDropbox = /*#__PURE__*/function () {
  function WrcDropbox() {
    this.dbx = null;
  }

  var _proto = WrcDropbox.prototype;

  _proto.clearSession = function clearSession() {
    Object.keys(sessionStorage).forEach(function (key) {
      if (key.startsWith(WrcDropbox.PREFIX)) {
        sessionStorage.removeItem(key);
      }
    });
  };

  _proto.getRedirectUri = function getRedirectUri() {
    var redirectUri = null;
    var uriLen = 0;
    var currentUri = window.location.href.split('?')[0].toLowerCase();

    for (var i = 0; i < WrcDropbox.REDIRECT_URIS.length; i++) {
      var redir = WrcDropbox.REDIRECT_URIS[i];
      var uri = redir.uri;
      var redirUri = redir.redirectUri;

      if (currentUri.startsWith(uri)) {
        var len = uri.length;

        if (!redirectUri || len > uriLen) {
          redirectUri = redirUri;
          uriLen = len;
        }
      }
    }

    return redirectUri;
  };

  _proto.getDropbox = function getDropbox() {
    try {
      var _temp3 = function _temp3() {
        return _this2.dbx;
      };

      var _this2 = this;

      if (!_this2.dbx) {
        var token = settings.getDbToken();

        if (token) {
          var dbxAuth = new DropboxAuth({
            clientId: WrcDropbox.CLIENT_ID
          });
          dbxAuth.setRefreshToken(token);
          _this2.dbx = new Dropbox({
            auth: dbxAuth
          });
        } else {
          throw "Dropbox token is not available.";
        }
      }

      var _temp4 = function () {
        if (_this2.dbx) {
          return Promise.resolve(_this2.dbx.auth.checkAndRefreshAccessToken()).then(function () {});
        }
      }();

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.checkFileExists = function checkFileExists(path) {
    try {
      var _this4 = this;

      var exists = false;

      var _temp6 = _catch(function () {
        return Promise.resolve(_this4.getDropbox()).then(function (dbx) {
          return Promise.resolve(dbx.filesGetMetadata({
            path: path
          })).then(function () {
            exists = true;
          });
        });
      }, function (e) {
        error(e);
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
        return exists;
      }) : exists);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.deleteFile = function deleteFile(path) {
    try {
      var _this6 = this;

      var ret = false;

      var _temp8 = _catch(function () {
        return Promise.resolve(_this6.getDropbox()).then(function (dbx) {
          return Promise.resolve(dbx.filesDeleteV2({
            path: path
          })).then(function () {
            ret = true;
          });
        });
      }, function (e) {
        error(e);
      });

      return Promise.resolve(_temp8 && _temp8.then ? _temp8.then(function () {
        return ret;
      }) : ret);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.listFolder = function listFolder(path) {
    try {
      var _this8 = this;

      return Promise.resolve(_this8.getDropbox()).then(function (dbx) {
        return Promise.resolve(dbx.filesListFolder({
          path: path,
          limit: 2000,
          include_non_downloadable_files: false
        }));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.createSharedLink = function createSharedLink(path) {
    try {
      var _this10 = this;

      return Promise.resolve(_this10.getDropbox()).then(function (dbx) {
        return Promise.resolve(dbx.sharingCreateSharedLinkWithSettings({
          path: path
        }));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.downloadFile = function downloadFile(path) {
    try {
      var _this12 = this;

      return Promise.resolve(_this12.getDropbox()).then(function (dbx) {
        return Promise.resolve(dbx.filesDownload({
          path: path
        })).then(function (result) {
          return result.result.fileBlob;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.uploadFile = function uploadFile(blob, path) {
    try {
      var _this14 = this;

      var UPLOAD_FILE_SIZE_LIMIT = 150 * 1024 * 1024;
      return Promise.resolve(_this14.getDropbox()).then(function (dbx) {
        var _exit = false;
        var file = new File([blob], path);

        if (file.size < UPLOAD_FILE_SIZE_LIMIT) {
          return Promise.resolve(dbx.filesUpload({
            path: file.name,
            contents: file,
            mode: 'overwrite'
          })).then(function () {
            return true;
          });
        } else {
          var maxBlob = 8 * 1000 * 1000;
          var offset = 0;
          var sessionId = null;
          var idx = 0;

          var _temp12 = _for(function () {
            return !_exit && offset < file.size;
          }, void 0, function () {
            function _temp10(_result) {
              if (_exit) return _result;
              offset += chunkSize;
              idx++;
            }

            var chunkSize = Math.min(maxBlob, file.size - offset);
            var blob = file.slice(offset, offset + chunkSize);

            var _temp9 = function () {
              if (offset === 0) {
                return Promise.resolve(dbx.filesUploadSessionStart({
                  close: false,
                  contents: blob
                })).then(function (response) {
                  sessionId = response.result.session_id;
                });
              } else return function () {
                if (offset + chunkSize === file.size) {
                  var cursor = {
                    session_id: sessionId,
                    offset: file.size - blob.size
                  };
                  var commit = {
                    path: file.name,
                    mode: 'overwrite',
                    autorename: true,
                    mute: false
                  };
                  return Promise.resolve(dbx.filesUploadSessionFinish({
                    cursor: cursor,
                    commit: commit,
                    contents: blob
                  })).then(function () {
                    _exit = true;
                    return true;
                  });
                } else {
                  var _cursor = {
                    session_id: sessionId,
                    offset: idx * maxBlob
                  };
                  return Promise.resolve(dbx.filesUploadSessionAppendV2({
                    cursor: _cursor,
                    close: false,
                    contents: blob
                  })).then(function () {});
                }
              }();
            }();

            return _temp9 && _temp9.then ? _temp9.then(_temp10) : _temp10(_temp9);
          });

          return _temp12 && _temp12.then ? _temp12.then(function (_result3) {
            return _exit ? _result3 : false;
          }) : _exit ? _temp12 : false;
        }
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.testWrite = function testWrite() {
    try {
      var _exit3 = false;

      var _this16 = this;

      var path = "/_test_/" + uuidv4();
      var val = 123;

      var _temp15 = _catch(function () {
        var bytes = new Uint8Array(1);
        bytes[0] = val;
        return Promise.resolve(_this16.uploadFile(new Blob([bytes]), path)).then(function () {
          return Promise.resolve(_this16.downloadFile(path)).then(function (blob) {
            return Promise.resolve(blob.arrayBuffer()).then(function (arrayBuffer) {
              _this16.deleteFile(path);

              var _temp13 = new Uint8Array(arrayBuffer)[0] === val;

              _exit3 = true;
              return _temp13;
            });
          });
        });
      }, function (e) {
        error(e);
      });

      return Promise.resolve(_temp15 && _temp15.then ? _temp15.then(function (_result4) {
        return _exit3 ? _result4 : false;
      }) : _exit3 ? _temp15 : false);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.checkLinkResult = function checkLinkResult() {
    try {
      var _this18 = this;

      return Promise.resolve(_finallyRethrows(function () {
        var errorDesc = sessionStorage.getItem(WrcDropbox.ERROR_DESC_PROP);

        if (errorDesc) {
          throw errorDesc;
        }

        var verifier = window.sessionStorage.getItem(WrcDropbox.CODE_VERIFIER_PROP);
        var code = window.sessionStorage.getItem(WrcDropbox.CODE_PROP);

        var redirectUri = _this18.getRedirectUri();

        var _temp16 = function () {
          if (verifier && code && redirectUri) {
            var dbxAuth = new DropboxAuth({
              clientId: WrcDropbox.CLIENT_ID
            });
            dbxAuth.setCodeVerifier(verifier);
            return Promise.resolve(dbxAuth.getAccessTokenFromCode(redirectUri, code)).then(function (response) {
              var refreshToken = response.result.refresh_token;
              settings.setDbToken(refreshToken);
              return Promise.resolve(settings.save()).then(function () {});
            });
          }
        }();

        if (_temp16 && _temp16.then) return _temp16.then(function () {});
      }, function (_wasThrown, _result5) {
        _this18.clearSession();

        if (_wasThrown) throw _result5;
        return _result5;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.link = function link(returnUri) {
    try {
      var _this20 = this;

      _this20.clearSession();

      var dbxAuth = new DropboxAuth({
        clientId: WrcDropbox.CLIENT_ID
      });

      var redirectUri = _this20.getRedirectUri();

      if (!redirectUri) {
        throw Resources.getText(TEXT_IDS.DROPBOX_SERVER_UNAUTHORIZED);
      }

      return Promise.resolve(dbxAuth.getAuthenticationUrl(redirectUri, undefined, 'code', 'offline', undefined, undefined, true)).then(function (authUrl) {
        window.sessionStorage.setItem(WrcDropbox.CODE_VERIFIER_PROP, dbxAuth.codeVerifier);

        if (returnUri) {
          window.sessionStorage.setItem(WrcDropbox.RETURN_URI, returnUri);
        }

        window.location.href = authUrl;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return WrcDropbox;
}();

WrcDropbox.CLIENT_ID = "xvz6ybh9wta2u30";
WrcDropbox.PREFIX = "dropbox.";
WrcDropbox.CODE_VERIFIER_PROP = WrcDropbox.PREFIX + "verifier";
WrcDropbox.ERROR_DESC_PROP = WrcDropbox.PREFIX + "errorDesc";
WrcDropbox.CODE_PROP = WrcDropbox.PREFIX + "code";
WrcDropbox.RETURN_URI = WrcDropbox.PREFIX + "returnUri";
WrcDropbox.REDIRECT_URIS = [{
  uri: "http://localhost:3000",
  redirectUri: "http://localhost:3000/dropbox/"
}, {
  uri: "http://localhost:3200",
  redirectUri: "http://localhost:3200/dropbox/"
}, {
  uri: "http://localhost:8000",
  redirectUri: "http://localhost:8000/dropbox/"
}, {
  uri: "http://localhost:8000/app/editor",
  redirectUri: "http://localhost:8000/app/editor/dropbox/"
}, {
  uri: "http://localhost:8000/app/standalone",
  redirectUri: "http://localhost:8000/app/standalone/dropbox/"
}, {
  uri: "https://play.webrcade.com",
  redirectUri: "http://webrcade.aerofever.com.ar/dropbox/"
}, {
  uri: "http://webrcade.aerofever.com.ar/app/editor",
  redirectUri: "http://webrcade.aerofever.com.ar/app/editor/dropbox/"
}, {
  uri: "http://webrcade.aerofever.com.ar/app/standalone",
  redirectUri: "http://webrcade.aerofever.com.ar/app/standalone/dropbox/"
}, {
  uri: "https://play-staging.webrcade.com",
  redirectUri: "https://play-staging.webrcade.com/dropbox/"
}, {
  uri: "https://play-staging.webrcade.com/app/editor",
  redirectUri: "https://play-staging.webrcade.com/app/editor/dropbox/"
}, {
  uri: "https://play-staging.webrcade.com/app/standalone",
  redirectUri: "https://play-staging.webrcade.com/app/standalone/dropbox/"
}, {
  uri: "http://webrcade.aerofever.com.ar/app/standalone",
  redirectUri: "http://webrcade.aerofever.com.ar/app/standalone/dropbox/"
}, {
  uri: "https://webrcade.github.io/webrcade-mirror",
  redirectUri: "https://webrcade.github.io/webrcade-mirror/dropbox/"
}, {
  uri: "https://webrcade.github.io/webrcade-mirror/app/editor",
  redirectUri: "https://webrcade.github.io/webrcade-mirror/app/editor/dropbox/"
}, {
  uri: "https://webrcade.github.io/webrcade-mirror/app/standalone",
  redirectUri: "https://webrcade.github.io/webrcade-mirror/app/standalone/dropbox/"
}];
var dropbox = new WrcDropbox();

var zipExport = {};

(function (obj) {

  var ERR_BAD_FORMAT = "File format is not recognized.";
  var ERR_CRC = "CRC failed.";
  var ERR_ENCRYPTED = "File contains encrypted entry.";
  var ERR_ZIP64 = "File is using Zip64 (4gb+ file size).";
  var ERR_READ = "Error while reading zip file.";
  var ERR_WRITE = "Error while writing zip file.";
  var ERR_WRITE_DATA = "Error while writing file data.";
  var ERR_READ_DATA = "Error while reading file data.";
  var ERR_DUPLICATED_NAME = "File already exists.";
  var CHUNK_SIZE = 512 * 1024;
  var TEXT_PLAIN = "text/plain";
  var appendABViewSupported;

  try {
    appendABViewSupported = new Blob([new DataView(new ArrayBuffer(0))]).size === 0;
  } catch (e) {}

  function Crc32() {
    this.crc = -1;
  }

  Crc32.prototype.append = function append(data) {
    var crc = this.crc | 0,
        table = this.table;

    for (var offset = 0, len = data.length | 0; offset < len; offset++) {
      crc = crc >>> 8 ^ table[(crc ^ data[offset]) & 0xFF];
    }

    this.crc = crc;
  };

  Crc32.prototype.get = function get() {
    return ~this.crc;
  };

  Crc32.prototype.table = function () {
    var i,
        j,
        t,
        table = [];

    for (i = 0; i < 256; i++) {
      t = i;

      for (j = 0; j < 8; j++) {
        if (t & 1) t = t >>> 1 ^ 0xEDB88320;else t = t >>> 1;
      }

      table[i] = t;
    }

    return table;
  }();

  function NOOP() {}

  NOOP.prototype.append = function append(bytes, onprogress) {
    return bytes;
  };

  NOOP.prototype.flush = function flush() {};

  function blobSlice(blob, index, length) {
    if (index < 0 || length < 0 || index + length > blob.size) throw new RangeError('offset:' + index + ', length:' + length + ', size:' + blob.size);
    if (blob.slice) return blob.slice(index, index + length);else if (blob.webkitSlice) return blob.webkitSlice(index, index + length);else if (blob.mozSlice) return blob.mozSlice(index, index + length);else if (blob.msSlice) return blob.msSlice(index, index + length);
  }

  function getDataHelper(byteLength, bytes) {
    var dataBuffer, dataArray;
    dataBuffer = new ArrayBuffer(byteLength);
    dataArray = new Uint8Array(dataBuffer);
    if (bytes) dataArray.set(bytes, 0);
    return {
      buffer: dataBuffer,
      array: dataArray,
      view: new DataView(dataBuffer)
    };
  }

  function Reader() {}

  function TextReader(text) {
    var that = this,
        blobReader;

    function init(callback, onerror) {
      var blob = new Blob([text], {
        type: TEXT_PLAIN
      });
      blobReader = new BlobReader(blob);
      blobReader.init(function () {
        that.size = blobReader.size;
        callback();
      }, onerror);
    }

    function readUint8Array(index, length, callback, onerror) {
      blobReader.readUint8Array(index, length, callback, onerror);
    }

    that.size = 0;
    that.init = init;
    that.readUint8Array = readUint8Array;
  }

  TextReader.prototype = new Reader();
  TextReader.prototype.constructor = TextReader;

  function Data64URIReader(dataURI) {
    var that = this,
        dataStart;

    function init(callback) {
      var dataEnd = dataURI.length;

      while (dataURI.charAt(dataEnd - 1) == "=") {
        dataEnd--;
      }

      dataStart = dataURI.indexOf(",") + 1;
      that.size = Math.floor((dataEnd - dataStart) * 0.75);
      callback();
    }

    function readUint8Array(index, length, callback) {
      var i,
          data = getDataHelper(length);
      var start = Math.floor(index / 3) * 4;
      var end = Math.ceil((index + length) / 3) * 4;
      var bytes = obj.atob(dataURI.substring(start + dataStart, end + dataStart));
      var delta = index - Math.floor(start / 4) * 3;

      for (i = delta; i < delta + length; i++) {
        data.array[i - delta] = bytes.charCodeAt(i);
      }

      callback(data.array);
    }

    that.size = 0;
    that.init = init;
    that.readUint8Array = readUint8Array;
  }

  Data64URIReader.prototype = new Reader();
  Data64URIReader.prototype.constructor = Data64URIReader;

  function BlobReader(blob) {
    var that = this;

    function init(callback) {
      that.size = blob.size;
      callback();
    }

    function readUint8Array(index, length, callback, onerror) {
      var reader = new FileReader();

      reader.onload = function (e) {
        callback(new Uint8Array(e.target.result));
      };

      reader.onerror = onerror;

      try {
        reader.readAsArrayBuffer(blobSlice(blob, index, length));
      } catch (e) {
        onerror(e);
      }
    }

    that.size = 0;
    that.init = init;
    that.readUint8Array = readUint8Array;
  }

  BlobReader.prototype = new Reader();
  BlobReader.prototype.constructor = BlobReader;

  function Writer() {}

  Writer.prototype.getData = function (callback) {
    callback(this.data);
  };

  function TextWriter(encoding) {
    var that = this,
        blob;

    function init(callback) {
      blob = new Blob([], {
        type: TEXT_PLAIN
      });
      callback();
    }

    function writeUint8Array(array, callback) {
      blob = new Blob([blob, appendABViewSupported ? array : array.buffer], {
        type: TEXT_PLAIN
      });
      callback();
    }

    function getData(callback, onerror) {
      var reader = new FileReader();

      reader.onload = function (e) {
        callback(e.target.result);
      };

      reader.onerror = onerror;
      reader.readAsText(blob, encoding);
    }

    that.init = init;
    that.writeUint8Array = writeUint8Array;
    that.getData = getData;
  }

  TextWriter.prototype = new Writer();
  TextWriter.prototype.constructor = TextWriter;

  function Data64URIWriter(contentType) {
    var that = this,
        data = "",
        pending = "";

    function init(callback) {
      data += "data:" + (contentType || "") + ";base64,";
      callback();
    }

    function writeUint8Array(array, callback) {
      var i,
          delta = pending.length,
          dataString = pending;
      pending = "";

      for (i = 0; i < Math.floor((delta + array.length) / 3) * 3 - delta; i++) {
        dataString += String.fromCharCode(array[i]);
      }

      for (; i < array.length; i++) {
        pending += String.fromCharCode(array[i]);
      }

      if (dataString.length > 2) data += obj.btoa(dataString);else pending = dataString;
      callback();
    }

    function getData(callback) {
      callback(data + obj.btoa(pending));
    }

    that.init = init;
    that.writeUint8Array = writeUint8Array;
    that.getData = getData;
  }

  Data64URIWriter.prototype = new Writer();
  Data64URIWriter.prototype.constructor = Data64URIWriter;

  function BlobWriter(contentType) {
    var blob,
        that = this;

    function init(callback) {
      blob = new Blob([], {
        type: contentType
      });
      callback();
    }

    function writeUint8Array(array, callback) {
      blob = new Blob([blob, appendABViewSupported ? array : array.buffer], {
        type: contentType
      });
      callback();
    }

    function getData(callback) {
      callback(blob);
    }

    that.init = init;
    that.writeUint8Array = writeUint8Array;
    that.getData = getData;
  }

  BlobWriter.prototype = new Writer();
  BlobWriter.prototype.constructor = BlobWriter;

  function launchWorkerProcess(worker, initialMessage, reader, writer, offset, size, onprogress, onend, onreaderror, onwriteerror) {
    var chunkIndex = 0,
        index,
        outputSize,
        sn = initialMessage.sn,
        crc;

    function onflush() {
      worker.removeEventListener('message', onmessage, false);
      onend(outputSize, crc);
    }

    function onmessage(event) {
      var message = event.data,
          data = message.data,
          err = message.error;

      if (err) {
        err.toString = function () {
          return 'Error: ' + this.message;
        };

        onreaderror(err);
        return;
      }

      if (message.sn !== sn) return;
      if (typeof message.codecTime === 'number') worker.codecTime += message.codecTime;
      if (typeof message.crcTime === 'number') worker.crcTime += message.crcTime;

      switch (message.type) {
        case 'append':
          if (data) {
            outputSize += data.length;
            writer.writeUint8Array(data, function () {
              step();
            }, onwriteerror);
          } else step();

          break;

        case 'flush':
          crc = message.crc;

          if (data) {
            outputSize += data.length;
            writer.writeUint8Array(data, function () {
              onflush();
            }, onwriteerror);
          } else onflush();

          break;

        case 'progress':
          if (onprogress) onprogress(index + message.loaded, size);
          break;

        case 'importScripts':
        case 'newTask':
        case 'echo':
          break;

        default:
          console.warn('zip.js:launchWorkerProcess: unknown message: ', message);
      }
    }

    function step() {
      index = chunkIndex * CHUNK_SIZE;

      if (index <= size) {
        reader.readUint8Array(offset + index, Math.min(CHUNK_SIZE, size - index), function (array) {
          if (onprogress) onprogress(index, size);
          var msg = index === 0 ? initialMessage : {
            sn: sn
          };
          msg.type = 'append';
          msg.data = array;

          try {
            worker.postMessage(msg, [array.buffer]);
          } catch (ex) {
            worker.postMessage(msg);
          }

          chunkIndex++;
        }, onreaderror);
      } else {
        worker.postMessage({
          sn: sn,
          type: 'flush'
        });
      }
    }

    outputSize = 0;
    worker.addEventListener('message', onmessage, false);
    step();
  }

  function launchProcess(process, reader, writer, offset, size, crcType, onprogress, onend, onreaderror, onwriteerror) {
    var chunkIndex = 0,
        index,
        outputSize = 0,
        crcInput = crcType === 'input',
        crcOutput = crcType === 'output',
        crc = new Crc32();

    function step() {
      var outputData;
      index = chunkIndex * CHUNK_SIZE;
      if (index < size) reader.readUint8Array(offset + index, Math.min(CHUNK_SIZE, size - index), function (inputData) {
        var outputData;

        try {
          outputData = process.append(inputData, function (loaded) {
            if (onprogress) onprogress(index + loaded, size);
          });
        } catch (e) {
          onreaderror(e);
          return;
        }

        if (outputData) {
          outputSize += outputData.length;
          writer.writeUint8Array(outputData, function () {
            chunkIndex++;
            setTimeout(step, 1);
          }, onwriteerror);
          if (crcOutput) crc.append(outputData);
        } else {
          chunkIndex++;
          setTimeout(step, 1);
        }

        if (crcInput) crc.append(inputData);
        if (onprogress) onprogress(index, size);
      }, onreaderror);else {
        try {
          outputData = process.flush();
        } catch (e) {
          onreaderror(e);
          return;
        }

        if (outputData) {
          if (crcOutput) crc.append(outputData);
          outputSize += outputData.length;
          writer.writeUint8Array(outputData, function () {
            onend(outputSize, crc.get());
          }, onwriteerror);
        } else onend(outputSize, crc.get());
      }
    }

    step();
  }

  function inflate(worker, sn, reader, writer, offset, size, computeCrc32, onend, onprogress, onreaderror, onwriteerror) {
    var crcType = computeCrc32 ? 'output' : 'none';

    if (obj.zip.useWebWorkers) {
      var initialMessage = {
        sn: sn,
        codecClass: 'Inflater',
        crcType: crcType
      };
      launchWorkerProcess(worker, initialMessage, reader, writer, offset, size, onprogress, onend, onreaderror, onwriteerror);
    } else launchProcess(new obj.zip.Inflater(), reader, writer, offset, size, crcType, onprogress, onend, onreaderror, onwriteerror);
  }

  function deflate(worker, sn, reader, writer, level, onend, onprogress, onreaderror, onwriteerror) {
    var crcType = 'input';

    if (obj.zip.useWebWorkers) {
      var initialMessage = {
        sn: sn,
        options: {
          level: level
        },
        codecClass: 'Deflater',
        crcType: crcType
      };
      launchWorkerProcess(worker, initialMessage, reader, writer, 0, reader.size, onprogress, onend, onreaderror, onwriteerror);
    } else launchProcess(new obj.zip.Deflater(), reader, writer, 0, reader.size, crcType, onprogress, onend, onreaderror, onwriteerror);
  }

  function copy(worker, sn, reader, writer, offset, size, computeCrc32, onend, onprogress, onreaderror, onwriteerror) {
    var crcType = 'input';

    if (obj.zip.useWebWorkers && computeCrc32) {
      var initialMessage = {
        sn: sn,
        codecClass: 'NOOP',
        crcType: crcType
      };
      launchWorkerProcess(worker, initialMessage, reader, writer, offset, size, onprogress, onend, onreaderror, onwriteerror);
    } else launchProcess(new NOOP(), reader, writer, offset, size, crcType, onprogress, onend, onreaderror, onwriteerror);
  }

  function decodeASCII(str) {
    var i,
        out = "",
        charCode,
        extendedASCII = ["\xC7", "\xFC", "\xE9", "\xE2", "\xE4", "\xE0", "\xE5", "\xE7", "\xEA", "\xEB", "\xE8", "\xEF", "\xEE", "\xEC", "\xC4", "\xC5", "\xC9", "\xE6", "\xC6", "\xF4", "\xF6", "\xF2", "\xFB", "\xF9", "\xFF", "\xD6", "\xDC", "\xF8", "\xA3", "\xD8", "\xD7", "\u0192", "\xE1", "\xED", "\xF3", "\xFA", "\xF1", "\xD1", "\xAA", "\xBA", "\xBF", "\xAE", "\xAC", "\xBD", "\xBC", "\xA1", "\xAB", "\xBB", '_', '_', '_', "\xA6", "\xA6", "\xC1", "\xC2", "\xC0", "\xA9", "\xA6", "\xA6", '+', '+', "\xA2", "\xA5", '+', '+', '-', '-', '+', '-', '+', "\xE3", "\xC3", '+', '+', '-', '-', "\xA6", '-', '+', "\xA4", "\xF0", "\xD0", "\xCA", "\xCB", "\xC8", 'i', "\xCD", "\xCE", "\xCF", '+', '+', '_', '_', "\xA6", "\xCC", '_', "\xD3", "\xDF", "\xD4", "\xD2", "\xF5", "\xD5", "\xB5", "\xFE", "\xDE", "\xDA", "\xDB", "\xD9", "\xFD", "\xDD", "\xAF", "\xB4", "\xAD", "\xB1", '_', "\xBE", "\xB6", "\xA7", "\xF7", "\xB8", "\xB0", "\xA8", "\xB7", "\xB9", "\xB3", "\xB2", '_', ' '];

    for (i = 0; i < str.length; i++) {
      charCode = str.charCodeAt(i) & 0xFF;
      if (charCode > 127) out += extendedASCII[charCode - 128];else out += String.fromCharCode(charCode);
    }

    return out;
  }

  function decodeUTF8(string) {
    return decodeURIComponent(escape(string));
  }

  function getString(bytes) {
    var i,
        str = "";

    for (i = 0; i < bytes.length; i++) {
      str += String.fromCharCode(bytes[i]);
    }

    return str;
  }

  function getDate(timeRaw) {
    var date = (timeRaw & 0xffff0000) >> 16,
        time = timeRaw & 0x0000ffff;

    try {
      return new Date(1980 + ((date & 0xFE00) >> 9), ((date & 0x01E0) >> 5) - 1, date & 0x001F, (time & 0xF800) >> 11, (time & 0x07E0) >> 5, (time & 0x001F) * 2, 0);
    } catch (e) {}
  }

  function readCommonHeader(entry, data, index, centralDirectory, onerror) {
    entry.version = data.view.getUint16(index, true);
    entry.bitFlag = data.view.getUint16(index + 2, true);
    entry.compressionMethod = data.view.getUint16(index + 4, true);
    entry.lastModDateRaw = data.view.getUint32(index + 6, true);
    entry.lastModDate = getDate(entry.lastModDateRaw);

    if ((entry.bitFlag & 0x01) === 0x01) {
      onerror(ERR_ENCRYPTED);
      return;
    }

    if (centralDirectory || (entry.bitFlag & 0x0008) != 0x0008) {
      entry.crc32 = data.view.getUint32(index + 10, true);
      entry.compressedSize = data.view.getUint32(index + 14, true);
      entry.uncompressedSize = data.view.getUint32(index + 18, true);
    }

    if (entry.compressedSize === 0xFFFFFFFF || entry.uncompressedSize === 0xFFFFFFFF) {
      onerror(ERR_ZIP64);
      return;
    }

    entry.filenameLength = data.view.getUint16(index + 22, true);
    entry.extraFieldLength = data.view.getUint16(index + 24, true);
  }

  function createZipReader(reader, callback, onerror) {
    var inflateSN = 0;

    function Entry() {}

    Entry.prototype.getData = function (writer, onend, onprogress, checkCrc32) {
      var that = this;

      function testCrc32(crc32) {
        var dataCrc32 = getDataHelper(4);
        dataCrc32.view.setUint32(0, crc32);
        return that.crc32 == dataCrc32.view.getUint32(0);
      }

      function getWriterData(uncompressedSize, crc32) {
        if (checkCrc32 && !testCrc32(crc32)) onerror(ERR_CRC);else writer.getData(function (data) {
          onend(data);
        });
      }

      function onreaderror(err) {
        onerror(err || ERR_READ_DATA);
      }

      function onwriteerror(err) {
        onerror(err || ERR_WRITE_DATA);
      }

      reader.readUint8Array(that.offset, 30, function (bytes) {
        var data = getDataHelper(bytes.length, bytes),
            dataOffset;

        if (data.view.getUint32(0) != 0x504b0304) {
          onerror(ERR_BAD_FORMAT);
          return;
        }

        readCommonHeader(that, data, 4, false, onerror);
        dataOffset = that.offset + 30 + that.filenameLength + that.extraFieldLength;
        writer.init(function () {
          if (that.compressionMethod === 0) copy(that._worker, inflateSN++, reader, writer, dataOffset, that.compressedSize, checkCrc32, getWriterData, onprogress, onreaderror, onwriteerror);else inflate(that._worker, inflateSN++, reader, writer, dataOffset, that.compressedSize, checkCrc32, getWriterData, onprogress, onreaderror, onwriteerror);
        }, onwriteerror);
      }, onreaderror);
    };

    function seekEOCDR(eocdrCallback) {
      var EOCDR_MIN = 22;

      if (reader.size < EOCDR_MIN) {
        onerror(ERR_BAD_FORMAT);
        return;
      }

      var ZIP_COMMENT_MAX = 256 * 256,
          EOCDR_MAX = EOCDR_MIN + ZIP_COMMENT_MAX;
      doSeek(EOCDR_MIN, function () {
        doSeek(Math.min(EOCDR_MAX, reader.size), function () {
          onerror(ERR_BAD_FORMAT);
        });
      });

      function doSeek(length, eocdrNotFoundCallback) {
        reader.readUint8Array(reader.size - length, length, function (bytes) {
          for (var i = bytes.length - EOCDR_MIN; i >= 0; i--) {
            if (bytes[i] === 0x50 && bytes[i + 1] === 0x4b && bytes[i + 2] === 0x05 && bytes[i + 3] === 0x06) {
              eocdrCallback(new DataView(bytes.buffer, i, EOCDR_MIN));
              return;
            }
          }

          eocdrNotFoundCallback();
        }, function () {
          onerror(ERR_READ);
        });
      }
    }

    var zipReader = {
      getEntries: function getEntries(callback) {
        var worker = this._worker;
        seekEOCDR(function (dataView) {
          var datalength, fileslength;
          datalength = dataView.getUint32(16, true);
          fileslength = dataView.getUint16(8, true);

          if (datalength < 0 || datalength >= reader.size) {
            onerror(ERR_BAD_FORMAT);
            return;
          }

          reader.readUint8Array(datalength, reader.size - datalength, function (bytes) {
            var i,
                index = 0,
                entries = [],
                entry,
                filename,
                comment,
                data = getDataHelper(bytes.length, bytes);

            for (i = 0; i < fileslength; i++) {
              entry = new Entry();
              entry._worker = worker;

              if (data.view.getUint32(index) != 0x504b0102) {
                onerror(ERR_BAD_FORMAT);
                return;
              }

              readCommonHeader(entry, data, index + 6, true, onerror);
              entry.commentLength = data.view.getUint16(index + 32, true);
              entry.directory = (data.view.getUint8(index + 38) & 0x10) == 0x10;
              entry.offset = data.view.getUint32(index + 42, true);
              filename = getString(data.array.subarray(index + 46, index + 46 + entry.filenameLength));
              entry.filename = (entry.bitFlag & 0x0800) === 0x0800 ? decodeUTF8(filename) : decodeASCII(filename);
              if (!entry.directory && entry.filename.charAt(entry.filename.length - 1) == "/") entry.directory = true;
              comment = getString(data.array.subarray(index + 46 + entry.filenameLength + entry.extraFieldLength, index + 46 + entry.filenameLength + entry.extraFieldLength + entry.commentLength));
              entry.comment = (entry.bitFlag & 0x0800) === 0x0800 ? decodeUTF8(comment) : decodeASCII(comment);
              entries.push(entry);
              index += 46 + entry.filenameLength + entry.extraFieldLength + entry.commentLength;
            }

            callback(entries);
          }, function () {
            onerror(ERR_READ);
          });
        });
      },
      close: function close(callback) {
        if (this._worker) {
          this._worker.terminate();

          this._worker = null;
        }

        if (callback) callback();
      },
      _worker: null
    };
    if (!obj.zip.useWebWorkers) callback(zipReader);else {
      createWorker('inflater', function (worker) {
        zipReader._worker = worker;
        callback(zipReader);
      }, function (err) {
        onerror(err);
      });
    }
  }

  function encodeUTF8(string) {
    return unescape(encodeURIComponent(string));
  }

  function getBytes(str) {
    var i,
        array = [];

    for (i = 0; i < str.length; i++) {
      array.push(str.charCodeAt(i));
    }

    return array;
  }

  function createZipWriter(writer, callback, onerror, dontDeflate) {
    var files = {},
        filenames = [],
        datalength = 0;
    var deflateSN = 0;

    function onwriteerror(err) {
      onerror(err || ERR_WRITE);
    }

    function onreaderror(err) {
      onerror(err || ERR_READ_DATA);
    }

    var zipWriter = {
      add: function add(name, reader, onend, onprogress, options) {
        var header, filename, date;
        var worker = this._worker;

        function writeHeader(callback) {
          var data;
          date = options.lastModDate || new Date();
          header = getDataHelper(26);
          files[name] = {
            headerArray: header.array,
            directory: options.directory,
            filename: filename,
            offset: datalength,
            comment: getBytes(encodeUTF8(options.comment || ""))
          };
          header.view.setUint32(0, 0x14000808);
          if (options.version) header.view.setUint8(0, options.version);
          if (!dontDeflate && options.level !== 0 && !options.directory) header.view.setUint16(4, 0x0800);
          header.view.setUint16(6, (date.getHours() << 6 | date.getMinutes()) << 5 | date.getSeconds() / 2, true);
          header.view.setUint16(8, (date.getFullYear() - 1980 << 4 | date.getMonth() + 1) << 5 | date.getDate(), true);
          header.view.setUint16(22, filename.length, true);
          data = getDataHelper(30 + filename.length);
          data.view.setUint32(0, 0x504b0304);
          data.array.set(header.array, 4);
          data.array.set(filename, 30);
          datalength += data.array.length;
          writer.writeUint8Array(data.array, callback, onwriteerror);
        }

        function writeFooter(compressedLength, crc32) {
          var footer = getDataHelper(16);
          datalength += compressedLength || 0;
          footer.view.setUint32(0, 0x504b0708);

          if (typeof crc32 != "undefined") {
            header.view.setUint32(10, crc32, true);
            footer.view.setUint32(4, crc32, true);
          }

          if (reader) {
            footer.view.setUint32(8, compressedLength, true);
            header.view.setUint32(14, compressedLength, true);
            footer.view.setUint32(12, reader.size, true);
            header.view.setUint32(18, reader.size, true);
          }

          writer.writeUint8Array(footer.array, function () {
            datalength += 16;
            onend();
          }, onwriteerror);
        }

        function writeFile() {
          options = options || {};
          name = name.trim();
          if (options.directory && name.charAt(name.length - 1) != "/") name += "/";

          if (files.hasOwnProperty(name)) {
            onerror(ERR_DUPLICATED_NAME);
            return;
          }

          filename = getBytes(encodeUTF8(name));
          filenames.push(name);
          writeHeader(function () {
            if (reader) {
              if (dontDeflate || options.level === 0) copy(worker, deflateSN++, reader, writer, 0, reader.size, true, writeFooter, onprogress, onreaderror, onwriteerror);else deflate(worker, deflateSN++, reader, writer, options.level, writeFooter, onprogress, onreaderror, onwriteerror);
            } else writeFooter();
          });
        }

        if (reader) reader.init(writeFile, onreaderror);else writeFile();
      },
      close: function close(callback) {
        if (this._worker) {
          this._worker.terminate();

          this._worker = null;
        }

        var data,
            length = 0,
            index = 0,
            indexFilename,
            file;

        for (indexFilename = 0; indexFilename < filenames.length; indexFilename++) {
          file = files[filenames[indexFilename]];
          length += 46 + file.filename.length + file.comment.length;
        }

        data = getDataHelper(length + 22);

        for (indexFilename = 0; indexFilename < filenames.length; indexFilename++) {
          file = files[filenames[indexFilename]];
          data.view.setUint32(index, 0x504b0102);
          data.view.setUint16(index + 4, 0x1400);
          data.array.set(file.headerArray, index + 6);
          data.view.setUint16(index + 32, file.comment.length, true);
          if (file.directory) data.view.setUint8(index + 38, 0x10);
          data.view.setUint32(index + 42, file.offset, true);
          data.array.set(file.filename, index + 46);
          data.array.set(file.comment, index + 46 + file.filename.length);
          index += 46 + file.filename.length + file.comment.length;
        }

        data.view.setUint32(index, 0x504b0506);
        data.view.setUint16(index + 8, filenames.length, true);
        data.view.setUint16(index + 10, filenames.length, true);
        data.view.setUint32(index + 12, length, true);
        data.view.setUint32(index + 16, datalength, true);
        writer.writeUint8Array(data.array, function () {
          writer.getData(callback);
        }, onwriteerror);
      },
      _worker: null
    };
    if (!obj.zip.useWebWorkers) callback(zipWriter);else {
      createWorker('deflater', function (worker) {
        zipWriter._worker = worker;
        callback(zipWriter);
      }, function (err) {
        onerror(err);
      });
    }
  }

  function resolveURLs(urls) {
    var a = document.createElement('a');
    return urls.map(function (url) {
      a.href = url;
      return a.href;
    });
  }

  var DEFAULT_WORKER_SCRIPTS = {
    deflater: ['z-worker.js', 'deflate.js'],
    inflater: ['z-worker.js', 'inflate.js']
  };

  function createWorker(type, callback, onerror) {
    if (obj.zip.workerScripts !== null && obj.zip.workerScriptsPath !== null) {
      onerror(new Error('Either zip.workerScripts or zip.workerScriptsPath may be set, not both.'));
      return;
    }

    var scripts;

    if (obj.zip.workerScripts) {
      scripts = obj.zip.workerScripts[type];

      if (!Array.isArray(scripts)) {
        onerror(new Error('zip.workerScripts.' + type + ' is not an array!'));
        return;
      }

      scripts = resolveURLs(scripts);
    } else {
      scripts = DEFAULT_WORKER_SCRIPTS[type].slice(0);
      scripts[0] = (obj.zip.workerScriptsPath || '') + scripts[0];
    }

    var worker = new Worker(scripts[0]);
    worker.codecTime = worker.crcTime = 0;
    worker.postMessage({
      type: 'importScripts',
      scripts: scripts.slice(1)
    });
    worker.addEventListener('message', onmessage);

    function onmessage(ev) {
      var msg = ev.data;

      if (msg.error) {
        worker.terminate();
        onerror(msg.error);
        return;
      }

      if (msg.type === 'importScripts') {
        worker.removeEventListener('message', onmessage);
        worker.removeEventListener('error', errorHandler);
        callback(worker);
      }
    }

    worker.addEventListener('error', errorHandler);

    function errorHandler(err) {
      worker.terminate();
      onerror(err);
    }
  }

  function onerror_default(error) {
    console.error(error);
  }

  obj.zip = {
    Reader: Reader,
    Writer: Writer,
    BlobReader: BlobReader,
    Data64URIReader: Data64URIReader,
    TextReader: TextReader,
    BlobWriter: BlobWriter,
    Data64URIWriter: Data64URIWriter,
    TextWriter: TextWriter,
    createReader: function createReader(reader, callback, onerror) {
      onerror = onerror || onerror_default;
      reader.init(function () {
        createZipReader(reader, callback, onerror);
      }, onerror);
    },
    createWriter: function createWriter(writer, callback, onerror, dontDeflate) {
      onerror = onerror || onerror_default;
      dontDeflate = !!dontDeflate;
      writer.init(function () {
        createZipWriter(writer, callback, onerror, dontDeflate);
      }, onerror);
    },
    useWebWorkers: true,
    workerScriptsPath: null,
    workerScripts: null
  };
})(zipExport);

(function (global) {

  var MAX_BITS = 15;
  var Z_OK = 0;
  var Z_STREAM_END = 1;
  var Z_NEED_DICT = 2;
  var Z_STREAM_ERROR = -2;
  var Z_DATA_ERROR = -3;
  var Z_MEM_ERROR = -4;
  var Z_BUF_ERROR = -5;
  var inflate_mask = [0x00000000, 0x00000001, 0x00000003, 0x00000007, 0x0000000f, 0x0000001f, 0x0000003f, 0x0000007f, 0x000000ff, 0x000001ff, 0x000003ff, 0x000007ff, 0x00000fff, 0x00001fff, 0x00003fff, 0x00007fff, 0x0000ffff];
  var MANY = 1440;
  var Z_NO_FLUSH = 0;
  var Z_FINISH = 4;
  var fixed_bl = 9;
  var fixed_bd = 5;
  var fixed_tl = [96, 7, 256, 0, 8, 80, 0, 8, 16, 84, 8, 115, 82, 7, 31, 0, 8, 112, 0, 8, 48, 0, 9, 192, 80, 7, 10, 0, 8, 96, 0, 8, 32, 0, 9, 160, 0, 8, 0, 0, 8, 128, 0, 8, 64, 0, 9, 224, 80, 7, 6, 0, 8, 88, 0, 8, 24, 0, 9, 144, 83, 7, 59, 0, 8, 120, 0, 8, 56, 0, 9, 208, 81, 7, 17, 0, 8, 104, 0, 8, 40, 0, 9, 176, 0, 8, 8, 0, 8, 136, 0, 8, 72, 0, 9, 240, 80, 7, 4, 0, 8, 84, 0, 8, 20, 85, 8, 227, 83, 7, 43, 0, 8, 116, 0, 8, 52, 0, 9, 200, 81, 7, 13, 0, 8, 100, 0, 8, 36, 0, 9, 168, 0, 8, 4, 0, 8, 132, 0, 8, 68, 0, 9, 232, 80, 7, 8, 0, 8, 92, 0, 8, 28, 0, 9, 152, 84, 7, 83, 0, 8, 124, 0, 8, 60, 0, 9, 216, 82, 7, 23, 0, 8, 108, 0, 8, 44, 0, 9, 184, 0, 8, 12, 0, 8, 140, 0, 8, 76, 0, 9, 248, 80, 7, 3, 0, 8, 82, 0, 8, 18, 85, 8, 163, 83, 7, 35, 0, 8, 114, 0, 8, 50, 0, 9, 196, 81, 7, 11, 0, 8, 98, 0, 8, 34, 0, 9, 164, 0, 8, 2, 0, 8, 130, 0, 8, 66, 0, 9, 228, 80, 7, 7, 0, 8, 90, 0, 8, 26, 0, 9, 148, 84, 7, 67, 0, 8, 122, 0, 8, 58, 0, 9, 212, 82, 7, 19, 0, 8, 106, 0, 8, 42, 0, 9, 180, 0, 8, 10, 0, 8, 138, 0, 8, 74, 0, 9, 244, 80, 7, 5, 0, 8, 86, 0, 8, 22, 192, 8, 0, 83, 7, 51, 0, 8, 118, 0, 8, 54, 0, 9, 204, 81, 7, 15, 0, 8, 102, 0, 8, 38, 0, 9, 172, 0, 8, 6, 0, 8, 134, 0, 8, 70, 0, 9, 236, 80, 7, 9, 0, 8, 94, 0, 8, 30, 0, 9, 156, 84, 7, 99, 0, 8, 126, 0, 8, 62, 0, 9, 220, 82, 7, 27, 0, 8, 110, 0, 8, 46, 0, 9, 188, 0, 8, 14, 0, 8, 142, 0, 8, 78, 0, 9, 252, 96, 7, 256, 0, 8, 81, 0, 8, 17, 85, 8, 131, 82, 7, 31, 0, 8, 113, 0, 8, 49, 0, 9, 194, 80, 7, 10, 0, 8, 97, 0, 8, 33, 0, 9, 162, 0, 8, 1, 0, 8, 129, 0, 8, 65, 0, 9, 226, 80, 7, 6, 0, 8, 89, 0, 8, 25, 0, 9, 146, 83, 7, 59, 0, 8, 121, 0, 8, 57, 0, 9, 210, 81, 7, 17, 0, 8, 105, 0, 8, 41, 0, 9, 178, 0, 8, 9, 0, 8, 137, 0, 8, 73, 0, 9, 242, 80, 7, 4, 0, 8, 85, 0, 8, 21, 80, 8, 258, 83, 7, 43, 0, 8, 117, 0, 8, 53, 0, 9, 202, 81, 7, 13, 0, 8, 101, 0, 8, 37, 0, 9, 170, 0, 8, 5, 0, 8, 133, 0, 8, 69, 0, 9, 234, 80, 7, 8, 0, 8, 93, 0, 8, 29, 0, 9, 154, 84, 7, 83, 0, 8, 125, 0, 8, 61, 0, 9, 218, 82, 7, 23, 0, 8, 109, 0, 8, 45, 0, 9, 186, 0, 8, 13, 0, 8, 141, 0, 8, 77, 0, 9, 250, 80, 7, 3, 0, 8, 83, 0, 8, 19, 85, 8, 195, 83, 7, 35, 0, 8, 115, 0, 8, 51, 0, 9, 198, 81, 7, 11, 0, 8, 99, 0, 8, 35, 0, 9, 166, 0, 8, 3, 0, 8, 131, 0, 8, 67, 0, 9, 230, 80, 7, 7, 0, 8, 91, 0, 8, 27, 0, 9, 150, 84, 7, 67, 0, 8, 123, 0, 8, 59, 0, 9, 214, 82, 7, 19, 0, 8, 107, 0, 8, 43, 0, 9, 182, 0, 8, 11, 0, 8, 139, 0, 8, 75, 0, 9, 246, 80, 7, 5, 0, 8, 87, 0, 8, 23, 192, 8, 0, 83, 7, 51, 0, 8, 119, 0, 8, 55, 0, 9, 206, 81, 7, 15, 0, 8, 103, 0, 8, 39, 0, 9, 174, 0, 8, 7, 0, 8, 135, 0, 8, 71, 0, 9, 238, 80, 7, 9, 0, 8, 95, 0, 8, 31, 0, 9, 158, 84, 7, 99, 0, 8, 127, 0, 8, 63, 0, 9, 222, 82, 7, 27, 0, 8, 111, 0, 8, 47, 0, 9, 190, 0, 8, 15, 0, 8, 143, 0, 8, 79, 0, 9, 254, 96, 7, 256, 0, 8, 80, 0, 8, 16, 84, 8, 115, 82, 7, 31, 0, 8, 112, 0, 8, 48, 0, 9, 193, 80, 7, 10, 0, 8, 96, 0, 8, 32, 0, 9, 161, 0, 8, 0, 0, 8, 128, 0, 8, 64, 0, 9, 225, 80, 7, 6, 0, 8, 88, 0, 8, 24, 0, 9, 145, 83, 7, 59, 0, 8, 120, 0, 8, 56, 0, 9, 209, 81, 7, 17, 0, 8, 104, 0, 8, 40, 0, 9, 177, 0, 8, 8, 0, 8, 136, 0, 8, 72, 0, 9, 241, 80, 7, 4, 0, 8, 84, 0, 8, 20, 85, 8, 227, 83, 7, 43, 0, 8, 116, 0, 8, 52, 0, 9, 201, 81, 7, 13, 0, 8, 100, 0, 8, 36, 0, 9, 169, 0, 8, 4, 0, 8, 132, 0, 8, 68, 0, 9, 233, 80, 7, 8, 0, 8, 92, 0, 8, 28, 0, 9, 153, 84, 7, 83, 0, 8, 124, 0, 8, 60, 0, 9, 217, 82, 7, 23, 0, 8, 108, 0, 8, 44, 0, 9, 185, 0, 8, 12, 0, 8, 140, 0, 8, 76, 0, 9, 249, 80, 7, 3, 0, 8, 82, 0, 8, 18, 85, 8, 163, 83, 7, 35, 0, 8, 114, 0, 8, 50, 0, 9, 197, 81, 7, 11, 0, 8, 98, 0, 8, 34, 0, 9, 165, 0, 8, 2, 0, 8, 130, 0, 8, 66, 0, 9, 229, 80, 7, 7, 0, 8, 90, 0, 8, 26, 0, 9, 149, 84, 7, 67, 0, 8, 122, 0, 8, 58, 0, 9, 213, 82, 7, 19, 0, 8, 106, 0, 8, 42, 0, 9, 181, 0, 8, 10, 0, 8, 138, 0, 8, 74, 0, 9, 245, 80, 7, 5, 0, 8, 86, 0, 8, 22, 192, 8, 0, 83, 7, 51, 0, 8, 118, 0, 8, 54, 0, 9, 205, 81, 7, 15, 0, 8, 102, 0, 8, 38, 0, 9, 173, 0, 8, 6, 0, 8, 134, 0, 8, 70, 0, 9, 237, 80, 7, 9, 0, 8, 94, 0, 8, 30, 0, 9, 157, 84, 7, 99, 0, 8, 126, 0, 8, 62, 0, 9, 221, 82, 7, 27, 0, 8, 110, 0, 8, 46, 0, 9, 189, 0, 8, 14, 0, 8, 142, 0, 8, 78, 0, 9, 253, 96, 7, 256, 0, 8, 81, 0, 8, 17, 85, 8, 131, 82, 7, 31, 0, 8, 113, 0, 8, 49, 0, 9, 195, 80, 7, 10, 0, 8, 97, 0, 8, 33, 0, 9, 163, 0, 8, 1, 0, 8, 129, 0, 8, 65, 0, 9, 227, 80, 7, 6, 0, 8, 89, 0, 8, 25, 0, 9, 147, 83, 7, 59, 0, 8, 121, 0, 8, 57, 0, 9, 211, 81, 7, 17, 0, 8, 105, 0, 8, 41, 0, 9, 179, 0, 8, 9, 0, 8, 137, 0, 8, 73, 0, 9, 243, 80, 7, 4, 0, 8, 85, 0, 8, 21, 80, 8, 258, 83, 7, 43, 0, 8, 117, 0, 8, 53, 0, 9, 203, 81, 7, 13, 0, 8, 101, 0, 8, 37, 0, 9, 171, 0, 8, 5, 0, 8, 133, 0, 8, 69, 0, 9, 235, 80, 7, 8, 0, 8, 93, 0, 8, 29, 0, 9, 155, 84, 7, 83, 0, 8, 125, 0, 8, 61, 0, 9, 219, 82, 7, 23, 0, 8, 109, 0, 8, 45, 0, 9, 187, 0, 8, 13, 0, 8, 141, 0, 8, 77, 0, 9, 251, 80, 7, 3, 0, 8, 83, 0, 8, 19, 85, 8, 195, 83, 7, 35, 0, 8, 115, 0, 8, 51, 0, 9, 199, 81, 7, 11, 0, 8, 99, 0, 8, 35, 0, 9, 167, 0, 8, 3, 0, 8, 131, 0, 8, 67, 0, 9, 231, 80, 7, 7, 0, 8, 91, 0, 8, 27, 0, 9, 151, 84, 7, 67, 0, 8, 123, 0, 8, 59, 0, 9, 215, 82, 7, 19, 0, 8, 107, 0, 8, 43, 0, 9, 183, 0, 8, 11, 0, 8, 139, 0, 8, 75, 0, 9, 247, 80, 7, 5, 0, 8, 87, 0, 8, 23, 192, 8, 0, 83, 7, 51, 0, 8, 119, 0, 8, 55, 0, 9, 207, 81, 7, 15, 0, 8, 103, 0, 8, 39, 0, 9, 175, 0, 8, 7, 0, 8, 135, 0, 8, 71, 0, 9, 239, 80, 7, 9, 0, 8, 95, 0, 8, 31, 0, 9, 159, 84, 7, 99, 0, 8, 127, 0, 8, 63, 0, 9, 223, 82, 7, 27, 0, 8, 111, 0, 8, 47, 0, 9, 191, 0, 8, 15, 0, 8, 143, 0, 8, 79, 0, 9, 255];
  var fixed_td = [80, 5, 1, 87, 5, 257, 83, 5, 17, 91, 5, 4097, 81, 5, 5, 89, 5, 1025, 85, 5, 65, 93, 5, 16385, 80, 5, 3, 88, 5, 513, 84, 5, 33, 92, 5, 8193, 82, 5, 9, 90, 5, 2049, 86, 5, 129, 192, 5, 24577, 80, 5, 2, 87, 5, 385, 83, 5, 25, 91, 5, 6145, 81, 5, 7, 89, 5, 1537, 85, 5, 97, 93, 5, 24577, 80, 5, 4, 88, 5, 769, 84, 5, 49, 92, 5, 12289, 82, 5, 13, 90, 5, 3073, 86, 5, 193, 192, 5, 24577];
  var cplens = [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
  var cplext = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 112, 112];
  var cpdist = [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577];
  var cpdext = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
  var BMAX = 15;

  function InfTree() {
    var that = this;
    var hn;
    var v;
    var c;
    var r;
    var u;
    var x;

    function huft_build(b, bindex, n, s, d, e, t, m, hp, hn, v) {
      var a;
      var f;
      var g;
      var h;
      var i;
      var j;
      var k;
      var l;
      var mask;
      var p;
      var q;
      var w;
      var xp;
      var y;
      var z;
      p = 0;
      i = n;

      do {
        c[b[bindex + p]]++;
        p++;
        i--;
      } while (i !== 0);

      if (c[0] == n) {
        t[0] = -1;
        m[0] = 0;
        return Z_OK;
      }

      l = m[0];

      for (j = 1; j <= BMAX; j++) {
        if (c[j] !== 0) break;
      }

      k = j;

      if (l < j) {
        l = j;
      }

      for (i = BMAX; i !== 0; i--) {
        if (c[i] !== 0) break;
      }

      g = i;

      if (l > i) {
        l = i;
      }

      m[0] = l;

      for (y = 1 << j; j < i; j++, y <<= 1) {
        if ((y -= c[j]) < 0) {
          return Z_DATA_ERROR;
        }
      }

      if ((y -= c[i]) < 0) {
        return Z_DATA_ERROR;
      }

      c[i] += y;
      x[1] = j = 0;
      p = 1;
      xp = 2;

      while (--i !== 0) {
        x[xp] = j += c[p];
        xp++;
        p++;
      }

      i = 0;
      p = 0;

      do {
        if ((j = b[bindex + p]) !== 0) {
          v[x[j]++] = i;
        }

        p++;
      } while (++i < n);

      n = x[g];
      x[0] = i = 0;
      p = 0;
      h = -1;
      w = -l;
      u[0] = 0;
      q = 0;
      z = 0;

      for (; k <= g; k++) {
        a = c[k];

        while (a-- !== 0) {
          while (k > w + l) {
            h++;
            w += l;
            z = g - w;
            z = z > l ? l : z;

            if ((f = 1 << (j = k - w)) > a + 1) {
              f -= a + 1;
              xp = k;

              if (j < z) {
                while (++j < z) {
                  if ((f <<= 1) <= c[++xp]) break;
                  f -= c[xp];
                }
              }
            }

            z = 1 << j;

            if (hn[0] + z > MANY) {
              return Z_DATA_ERROR;
            }

            u[h] = q = hn[0];
            hn[0] += z;

            if (h !== 0) {
              x[h] = i;
              r[0] = j;
              r[1] = l;
              j = i >>> w - l;
              r[2] = q - u[h - 1] - j;
              hp.set(r, (u[h - 1] + j) * 3);
            } else {
              t[0] = q;
            }
          }

          r[1] = k - w;

          if (p >= n) {
            r[0] = 128 + 64;
          } else if (v[p] < s) {
            r[0] = v[p] < 256 ? 0 : 32 + 64;
            r[2] = v[p++];
          } else {
            r[0] = e[v[p] - s] + 16 + 64;
            r[2] = d[v[p++] - s];
          }

          f = 1 << k - w;

          for (j = i >>> w; j < z; j += f) {
            hp.set(r, (q + j) * 3);
          }

          for (j = 1 << k - 1; (i & j) !== 0; j >>>= 1) {
            i ^= j;
          }

          i ^= j;
          mask = (1 << w) - 1;

          while ((i & mask) != x[h]) {
            h--;
            w -= l;
            mask = (1 << w) - 1;
          }
        }
      }

      return y !== 0 && g != 1 ? Z_BUF_ERROR : Z_OK;
    }

    function initWorkArea(vsize) {
      var i;

      if (!hn) {
        hn = [];
        v = [];
        c = new Int32Array(BMAX + 1);
        r = [];
        u = new Int32Array(BMAX);
        x = new Int32Array(BMAX + 1);
      }

      if (v.length < vsize) {
        v = [];
      }

      for (i = 0; i < vsize; i++) {
        v[i] = 0;
      }

      for (i = 0; i < BMAX + 1; i++) {
        c[i] = 0;
      }

      for (i = 0; i < 3; i++) {
        r[i] = 0;
      }

      u.set(c.subarray(0, BMAX), 0);
      x.set(c.subarray(0, BMAX + 1), 0);
    }

    that.inflate_trees_bits = function (c, bb, tb, hp, z) {
      var result;
      initWorkArea(19);
      hn[0] = 0;
      result = huft_build(c, 0, 19, 19, null, null, tb, bb, hp, hn, v);

      if (result == Z_DATA_ERROR) {
        z.msg = "oversubscribed dynamic bit lengths tree";
      } else if (result == Z_BUF_ERROR || bb[0] === 0) {
        z.msg = "incomplete dynamic bit lengths tree";
        result = Z_DATA_ERROR;
      }

      return result;
    };

    that.inflate_trees_dynamic = function (nl, nd, c, bl, bd, tl, td, hp, z) {
      var result;
      initWorkArea(288);
      hn[0] = 0;
      result = huft_build(c, 0, nl, 257, cplens, cplext, tl, bl, hp, hn, v);

      if (result != Z_OK || bl[0] === 0) {
        if (result == Z_DATA_ERROR) {
          z.msg = "oversubscribed literal/length tree";
        } else if (result != Z_MEM_ERROR) {
          z.msg = "incomplete literal/length tree";
          result = Z_DATA_ERROR;
        }

        return result;
      }

      initWorkArea(288);
      result = huft_build(c, nl, nd, 0, cpdist, cpdext, td, bd, hp, hn, v);

      if (result != Z_OK || bd[0] === 0 && nl > 257) {
        if (result == Z_DATA_ERROR) {
          z.msg = "oversubscribed distance tree";
        } else if (result == Z_BUF_ERROR) {
          z.msg = "incomplete distance tree";
          result = Z_DATA_ERROR;
        } else if (result != Z_MEM_ERROR) {
          z.msg = "empty distance tree with lengths";
          result = Z_DATA_ERROR;
        }

        return result;
      }

      return Z_OK;
    };
  }

  InfTree.inflate_trees_fixed = function (bl, bd, tl, td) {
    bl[0] = fixed_bl;
    bd[0] = fixed_bd;
    tl[0] = fixed_tl;
    td[0] = fixed_td;
    return Z_OK;
  };

  var START = 0;
  var LEN = 1;
  var LENEXT = 2;
  var DIST = 3;
  var DISTEXT = 4;
  var COPY = 5;
  var LIT = 6;
  var WASH = 7;
  var END = 8;
  var BADCODE = 9;

  function InfCodes() {
    var that = this;
    var mode;
    var len = 0;
    var tree;
    var tree_index = 0;
    var need = 0;
    var lit = 0;
    var get = 0;
    var dist = 0;
    var lbits = 0;
    var dbits = 0;
    var ltree;
    var ltree_index = 0;
    var dtree;
    var dtree_index = 0;

    function inflate_fast(bl, bd, tl, tl_index, td, td_index, s, z) {
      var t;
      var tp;
      var tp_index;
      var e;
      var b;
      var k;
      var p;
      var n;
      var q;
      var m;
      var ml;
      var md;
      var c;
      var d;
      var r;
      var tp_index_t_3;
      p = z.next_in_index;
      n = z.avail_in;
      b = s.bitb;
      k = s.bitk;
      q = s.write;
      m = q < s.read ? s.read - q - 1 : s.end - q;
      ml = inflate_mask[bl];
      md = inflate_mask[bd];

      do {
        while (k < 20) {
          n--;
          b |= (z.read_byte(p++) & 0xff) << k;
          k += 8;
        }

        t = b & ml;
        tp = tl;
        tp_index = tl_index;
        tp_index_t_3 = (tp_index + t) * 3;

        if ((e = tp[tp_index_t_3]) === 0) {
          b >>= tp[tp_index_t_3 + 1];
          k -= tp[tp_index_t_3 + 1];
          s.window[q++] = tp[tp_index_t_3 + 2];
          m--;
          continue;
        }

        do {
          b >>= tp[tp_index_t_3 + 1];
          k -= tp[tp_index_t_3 + 1];

          if ((e & 16) !== 0) {
            e &= 15;
            c = tp[tp_index_t_3 + 2] + (b & inflate_mask[e]);
            b >>= e;
            k -= e;

            while (k < 15) {
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            t = b & md;
            tp = td;
            tp_index = td_index;
            tp_index_t_3 = (tp_index + t) * 3;
            e = tp[tp_index_t_3];

            do {
              b >>= tp[tp_index_t_3 + 1];
              k -= tp[tp_index_t_3 + 1];

              if ((e & 16) !== 0) {
                e &= 15;

                while (k < e) {
                  n--;
                  b |= (z.read_byte(p++) & 0xff) << k;
                  k += 8;
                }

                d = tp[tp_index_t_3 + 2] + (b & inflate_mask[e]);
                b >>= e;
                k -= e;
                m -= c;

                if (q >= d) {
                  r = q - d;

                  if (q - r > 0 && 2 > q - r) {
                    s.window[q++] = s.window[r++];
                    s.window[q++] = s.window[r++];
                    c -= 2;
                  } else {
                    s.window.set(s.window.subarray(r, r + 2), q);
                    q += 2;
                    r += 2;
                    c -= 2;
                  }
                } else {
                  r = q - d;

                  do {
                    r += s.end;
                  } while (r < 0);

                  e = s.end - r;

                  if (c > e) {
                    c -= e;

                    if (q - r > 0 && e > q - r) {
                      do {
                        s.window[q++] = s.window[r++];
                      } while (--e !== 0);
                    } else {
                      s.window.set(s.window.subarray(r, r + e), q);
                      q += e;
                      r += e;
                      e = 0;
                    }

                    r = 0;
                  }
                }

                if (q - r > 0 && c > q - r) {
                  do {
                    s.window[q++] = s.window[r++];
                  } while (--c !== 0);
                } else {
                  s.window.set(s.window.subarray(r, r + c), q);
                  q += c;
                  r += c;
                  c = 0;
                }

                break;
              } else if ((e & 64) === 0) {
                t += tp[tp_index_t_3 + 2];
                t += b & inflate_mask[e];
                tp_index_t_3 = (tp_index + t) * 3;
                e = tp[tp_index_t_3];
              } else {
                z.msg = "invalid distance code";
                c = z.avail_in - n;
                c = k >> 3 < c ? k >> 3 : c;
                n += c;
                p -= c;
                k -= c << 3;
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return Z_DATA_ERROR;
              }
            } while (true);

            break;
          }

          if ((e & 64) === 0) {
            t += tp[tp_index_t_3 + 2];
            t += b & inflate_mask[e];
            tp_index_t_3 = (tp_index + t) * 3;

            if ((e = tp[tp_index_t_3]) === 0) {
              b >>= tp[tp_index_t_3 + 1];
              k -= tp[tp_index_t_3 + 1];
              s.window[q++] = tp[tp_index_t_3 + 2];
              m--;
              break;
            }
          } else if ((e & 32) !== 0) {
            c = z.avail_in - n;
            c = k >> 3 < c ? k >> 3 : c;
            n += c;
            p -= c;
            k -= c << 3;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return Z_STREAM_END;
          } else {
            z.msg = "invalid literal/length code";
            c = z.avail_in - n;
            c = k >> 3 < c ? k >> 3 : c;
            n += c;
            p -= c;
            k -= c << 3;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return Z_DATA_ERROR;
          }
        } while (true);
      } while (m >= 258 && n >= 10);

      c = z.avail_in - n;
      c = k >> 3 < c ? k >> 3 : c;
      n += c;
      p -= c;
      k -= c << 3;
      s.bitb = b;
      s.bitk = k;
      z.avail_in = n;
      z.total_in += p - z.next_in_index;
      z.next_in_index = p;
      s.write = q;
      return Z_OK;
    }

    that.init = function (bl, bd, tl, tl_index, td, td_index) {
      mode = START;
      lbits = bl;
      dbits = bd;
      ltree = tl;
      ltree_index = tl_index;
      dtree = td;
      dtree_index = td_index;
      tree = null;
    };

    that.proc = function (s, z, r) {
      var j;
      var tindex;
      var e;
      var b = 0;
      var k = 0;
      var p = 0;
      var n;
      var q;
      var m;
      var f;
      p = z.next_in_index;
      n = z.avail_in;
      b = s.bitb;
      k = s.bitk;
      q = s.write;
      m = q < s.read ? s.read - q - 1 : s.end - q;

      while (true) {
        switch (mode) {
          case START:
            if (m >= 258 && n >= 10) {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              r = inflate_fast(lbits, dbits, ltree, ltree_index, dtree, dtree_index, s, z);
              p = z.next_in_index;
              n = z.avail_in;
              b = s.bitb;
              k = s.bitk;
              q = s.write;
              m = q < s.read ? s.read - q - 1 : s.end - q;

              if (r != Z_OK) {
                mode = r == Z_STREAM_END ? WASH : BADCODE;
                break;
              }
            }

            need = lbits;
            tree = ltree;
            tree_index = ltree_index;
            mode = LEN;

          case LEN:
            j = need;

            while (k < j) {
              if (n !== 0) r = Z_OK;else {
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            tindex = (tree_index + (b & inflate_mask[j])) * 3;
            b >>>= tree[tindex + 1];
            k -= tree[tindex + 1];
            e = tree[tindex];

            if (e === 0) {
              lit = tree[tindex + 2];
              mode = LIT;
              break;
            }

            if ((e & 16) !== 0) {
              get = e & 15;
              len = tree[tindex + 2];
              mode = LENEXT;
              break;
            }

            if ((e & 64) === 0) {
              need = e;
              tree_index = tindex / 3 + tree[tindex + 2];
              break;
            }

            if ((e & 32) !== 0) {
              mode = WASH;
              break;
            }

            mode = BADCODE;
            z.msg = "invalid literal/length code";
            r = Z_DATA_ERROR;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);

          case LENEXT:
            j = get;

            while (k < j) {
              if (n !== 0) r = Z_OK;else {
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            len += b & inflate_mask[j];
            b >>= j;
            k -= j;
            need = dbits;
            tree = dtree;
            tree_index = dtree_index;
            mode = DIST;

          case DIST:
            j = need;

            while (k < j) {
              if (n !== 0) r = Z_OK;else {
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            tindex = (tree_index + (b & inflate_mask[j])) * 3;
            b >>= tree[tindex + 1];
            k -= tree[tindex + 1];
            e = tree[tindex];

            if ((e & 16) !== 0) {
              get = e & 15;
              dist = tree[tindex + 2];
              mode = DISTEXT;
              break;
            }

            if ((e & 64) === 0) {
              need = e;
              tree_index = tindex / 3 + tree[tindex + 2];
              break;
            }

            mode = BADCODE;
            z.msg = "invalid distance code";
            r = Z_DATA_ERROR;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);

          case DISTEXT:
            j = get;

            while (k < j) {
              if (n !== 0) r = Z_OK;else {
                s.bitb = b;
                s.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                s.write = q;
                return s.inflate_flush(z, r);
              }
              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            dist += b & inflate_mask[j];
            b >>= j;
            k -= j;
            mode = COPY;

          case COPY:
            f = q - dist;

            while (f < 0) {
              f += s.end;
            }

            while (len !== 0) {
              if (m === 0) {
                if (q == s.end && s.read !== 0) {
                  q = 0;
                  m = q < s.read ? s.read - q - 1 : s.end - q;
                }

                if (m === 0) {
                  s.write = q;
                  r = s.inflate_flush(z, r);
                  q = s.write;
                  m = q < s.read ? s.read - q - 1 : s.end - q;

                  if (q == s.end && s.read !== 0) {
                    q = 0;
                    m = q < s.read ? s.read - q - 1 : s.end - q;
                  }

                  if (m === 0) {
                    s.bitb = b;
                    s.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    s.write = q;
                    return s.inflate_flush(z, r);
                  }
                }
              }

              s.window[q++] = s.window[f++];
              m--;
              if (f == s.end) f = 0;
              len--;
            }

            mode = START;
            break;

          case LIT:
            if (m === 0) {
              if (q == s.end && s.read !== 0) {
                q = 0;
                m = q < s.read ? s.read - q - 1 : s.end - q;
              }

              if (m === 0) {
                s.write = q;
                r = s.inflate_flush(z, r);
                q = s.write;
                m = q < s.read ? s.read - q - 1 : s.end - q;

                if (q == s.end && s.read !== 0) {
                  q = 0;
                  m = q < s.read ? s.read - q - 1 : s.end - q;
                }

                if (m === 0) {
                  s.bitb = b;
                  s.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  s.write = q;
                  return s.inflate_flush(z, r);
                }
              }
            }

            r = Z_OK;
            s.window[q++] = lit;
            m--;
            mode = START;
            break;

          case WASH:
            if (k > 7) {
              k -= 8;
              n++;
              p--;
            }

            s.write = q;
            r = s.inflate_flush(z, r);
            q = s.write;
            m = q < s.read ? s.read - q - 1 : s.end - q;

            if (s.read != s.write) {
              s.bitb = b;
              s.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              s.write = q;
              return s.inflate_flush(z, r);
            }

            mode = END;

          case END:
            r = Z_STREAM_END;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);

          case BADCODE:
            r = Z_DATA_ERROR;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);

          default:
            r = Z_STREAM_ERROR;
            s.bitb = b;
            s.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            s.write = q;
            return s.inflate_flush(z, r);
        }
      }
    };

    that.free = function () {};
  }

  var border = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
  var TYPE = 0;
  var LENS = 1;
  var STORED = 2;
  var TABLE = 3;
  var BTREE = 4;
  var DTREE = 5;
  var CODES = 6;
  var DRY = 7;
  var DONELOCKS = 8;
  var BADBLOCKS = 9;

  function InfBlocks(z, w) {
    var that = this;
    var mode = TYPE;
    var left = 0;
    var table = 0;
    var index = 0;
    var blens;
    var bb = [0];
    var tb = [0];
    var codes = new InfCodes();
    var last = 0;
    var hufts = new Int32Array(MANY * 3);
    var check = 0;
    var inftree = new InfTree();
    that.bitk = 0;
    that.bitb = 0;
    that.window = new Uint8Array(w);
    that.end = w;
    that.read = 0;
    that.write = 0;

    that.reset = function (z, c) {
      if (c) c[0] = check;

      if (mode == CODES) {
        codes.free(z);
      }

      mode = TYPE;
      that.bitk = 0;
      that.bitb = 0;
      that.read = that.write = 0;
    };

    that.reset(z, null);

    that.inflate_flush = function (z, r) {
      var n;
      var p;
      var q;
      p = z.next_out_index;
      q = that.read;
      n = (q <= that.write ? that.write : that.end) - q;
      if (n > z.avail_out) n = z.avail_out;
      if (n !== 0 && r == Z_BUF_ERROR) r = Z_OK;
      z.avail_out -= n;
      z.total_out += n;
      z.next_out.set(that.window.subarray(q, q + n), p);
      p += n;
      q += n;

      if (q == that.end) {
        q = 0;
        if (that.write == that.end) that.write = 0;
        n = that.write - q;
        if (n > z.avail_out) n = z.avail_out;
        if (n !== 0 && r == Z_BUF_ERROR) r = Z_OK;
        z.avail_out -= n;
        z.total_out += n;
        z.next_out.set(that.window.subarray(q, q + n), p);
        p += n;
        q += n;
      }

      z.next_out_index = p;
      that.read = q;
      return r;
    };

    that.proc = function (z, r) {
      var t;
      var b;
      var k;
      var p;
      var n;
      var q;
      var m;
      var i;
      p = z.next_in_index;
      n = z.avail_in;
      b = that.bitb;
      k = that.bitk;
      q = that.write;
      m = q < that.read ? that.read - q - 1 : that.end - q;

      while (true) {
        switch (mode) {
          case TYPE:
            while (k < 3) {
              if (n !== 0) {
                r = Z_OK;
              } else {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }

              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            t = b & 7;
            last = t & 1;

            switch (t >>> 1) {
              case 0:
                b >>>= 3;
                k -= 3;
                t = k & 7;
                b >>>= t;
                k -= t;
                mode = LENS;
                break;

              case 1:
                var bl = [];
                var bd = [];
                var tl = [[]];
                var td = [[]];
                InfTree.inflate_trees_fixed(bl, bd, tl, td);
                codes.init(bl[0], bd[0], tl[0], 0, td[0], 0);
                b >>>= 3;
                k -= 3;
                mode = CODES;
                break;

              case 2:
                b >>>= 3;
                k -= 3;
                mode = TABLE;
                break;

              case 3:
                b >>>= 3;
                k -= 3;
                mode = BADBLOCKS;
                z.msg = "invalid block type";
                r = Z_DATA_ERROR;
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
            }

            break;

          case LENS:
            while (k < 32) {
              if (n !== 0) {
                r = Z_OK;
              } else {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }

              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            if ((~b >>> 16 & 0xffff) != (b & 0xffff)) {
              mode = BADBLOCKS;
              z.msg = "invalid stored block lengths";
              r = Z_DATA_ERROR;
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            left = b & 0xffff;
            b = k = 0;
            mode = left !== 0 ? STORED : last !== 0 ? DRY : TYPE;
            break;

          case STORED:
            if (n === 0) {
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            if (m === 0) {
              if (q == that.end && that.read !== 0) {
                q = 0;
                m = q < that.read ? that.read - q - 1 : that.end - q;
              }

              if (m === 0) {
                that.write = q;
                r = that.inflate_flush(z, r);
                q = that.write;
                m = q < that.read ? that.read - q - 1 : that.end - q;

                if (q == that.end && that.read !== 0) {
                  q = 0;
                  m = q < that.read ? that.read - q - 1 : that.end - q;
                }

                if (m === 0) {
                  that.bitb = b;
                  that.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  that.write = q;
                  return that.inflate_flush(z, r);
                }
              }
            }

            r = Z_OK;
            t = left;
            if (t > n) t = n;
            if (t > m) t = m;
            that.window.set(z.read_buf(p, t), q);
            p += t;
            n -= t;
            q += t;
            m -= t;
            if ((left -= t) !== 0) break;
            mode = last !== 0 ? DRY : TYPE;
            break;

          case TABLE:
            while (k < 14) {
              if (n !== 0) {
                r = Z_OK;
              } else {
                that.bitb = b;
                that.bitk = k;
                z.avail_in = n;
                z.total_in += p - z.next_in_index;
                z.next_in_index = p;
                that.write = q;
                return that.inflate_flush(z, r);
              }

              n--;
              b |= (z.read_byte(p++) & 0xff) << k;
              k += 8;
            }

            table = t = b & 0x3fff;

            if ((t & 0x1f) > 29 || (t >> 5 & 0x1f) > 29) {
              mode = BADBLOCKS;
              z.msg = "too many length or distance symbols";
              r = Z_DATA_ERROR;
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            t = 258 + (t & 0x1f) + (t >> 5 & 0x1f);

            if (!blens || blens.length < t) {
              blens = [];
            } else {
              for (i = 0; i < t; i++) {
                blens[i] = 0;
              }
            }

            b >>>= 14;
            k -= 14;
            index = 0;
            mode = BTREE;

          case BTREE:
            while (index < 4 + (table >>> 10)) {
              while (k < 3) {
                if (n !== 0) {
                  r = Z_OK;
                } else {
                  that.bitb = b;
                  that.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  that.write = q;
                  return that.inflate_flush(z, r);
                }

                n--;
                b |= (z.read_byte(p++) & 0xff) << k;
                k += 8;
              }

              blens[border[index++]] = b & 7;
              b >>>= 3;
              k -= 3;
            }

            while (index < 19) {
              blens[border[index++]] = 0;
            }

            bb[0] = 7;
            t = inftree.inflate_trees_bits(blens, bb, tb, hufts, z);

            if (t != Z_OK) {
              r = t;

              if (r == Z_DATA_ERROR) {
                blens = null;
                mode = BADBLOCKS;
              }

              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            index = 0;
            mode = DTREE;

          case DTREE:
            while (true) {
              t = table;

              if (index >= 258 + (t & 0x1f) + (t >> 5 & 0x1f)) {
                break;
              }

              var j, c;
              t = bb[0];

              while (k < t) {
                if (n !== 0) {
                  r = Z_OK;
                } else {
                  that.bitb = b;
                  that.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  that.write = q;
                  return that.inflate_flush(z, r);
                }

                n--;
                b |= (z.read_byte(p++) & 0xff) << k;
                k += 8;
              }

              t = hufts[(tb[0] + (b & inflate_mask[t])) * 3 + 1];
              c = hufts[(tb[0] + (b & inflate_mask[t])) * 3 + 2];

              if (c < 16) {
                b >>>= t;
                k -= t;
                blens[index++] = c;
              } else {
                i = c == 18 ? 7 : c - 14;
                j = c == 18 ? 11 : 3;

                while (k < t + i) {
                  if (n !== 0) {
                    r = Z_OK;
                  } else {
                    that.bitb = b;
                    that.bitk = k;
                    z.avail_in = n;
                    z.total_in += p - z.next_in_index;
                    z.next_in_index = p;
                    that.write = q;
                    return that.inflate_flush(z, r);
                  }

                  n--;
                  b |= (z.read_byte(p++) & 0xff) << k;
                  k += 8;
                }

                b >>>= t;
                k -= t;
                j += b & inflate_mask[i];
                b >>>= i;
                k -= i;
                i = index;
                t = table;

                if (i + j > 258 + (t & 0x1f) + (t >> 5 & 0x1f) || c == 16 && i < 1) {
                  blens = null;
                  mode = BADBLOCKS;
                  z.msg = "invalid bit length repeat";
                  r = Z_DATA_ERROR;
                  that.bitb = b;
                  that.bitk = k;
                  z.avail_in = n;
                  z.total_in += p - z.next_in_index;
                  z.next_in_index = p;
                  that.write = q;
                  return that.inflate_flush(z, r);
                }

                c = c == 16 ? blens[i - 1] : 0;

                do {
                  blens[i++] = c;
                } while (--j !== 0);

                index = i;
              }
            }

            tb[0] = -1;
            var bl_ = [];
            var bd_ = [];
            var tl_ = [];
            var td_ = [];
            bl_[0] = 9;
            bd_[0] = 6;
            t = table;
            t = inftree.inflate_trees_dynamic(257 + (t & 0x1f), 1 + (t >> 5 & 0x1f), blens, bl_, bd_, tl_, td_, hufts, z);

            if (t != Z_OK) {
              if (t == Z_DATA_ERROR) {
                blens = null;
                mode = BADBLOCKS;
              }

              r = t;
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            codes.init(bl_[0], bd_[0], hufts, tl_[0], hufts, td_[0]);
            mode = CODES;

          case CODES:
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;

            if ((r = codes.proc(that, z, r)) != Z_STREAM_END) {
              return that.inflate_flush(z, r);
            }

            r = Z_OK;
            codes.free(z);
            p = z.next_in_index;
            n = z.avail_in;
            b = that.bitb;
            k = that.bitk;
            q = that.write;
            m = q < that.read ? that.read - q - 1 : that.end - q;

            if (last === 0) {
              mode = TYPE;
              break;
            }

            mode = DRY;

          case DRY:
            that.write = q;
            r = that.inflate_flush(z, r);
            q = that.write;
            m = q < that.read ? that.read - q - 1 : that.end - q;

            if (that.read != that.write) {
              that.bitb = b;
              that.bitk = k;
              z.avail_in = n;
              z.total_in += p - z.next_in_index;
              z.next_in_index = p;
              that.write = q;
              return that.inflate_flush(z, r);
            }

            mode = DONELOCKS;

          case DONELOCKS:
            r = Z_STREAM_END;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);

          case BADBLOCKS:
            r = Z_DATA_ERROR;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);

          default:
            r = Z_STREAM_ERROR;
            that.bitb = b;
            that.bitk = k;
            z.avail_in = n;
            z.total_in += p - z.next_in_index;
            z.next_in_index = p;
            that.write = q;
            return that.inflate_flush(z, r);
        }
      }
    };

    that.free = function (z) {
      that.reset(z, null);
      that.window = null;
      hufts = null;
    };

    that.set_dictionary = function (d, start, n) {
      that.window.set(d.subarray(start, start + n), 0);
      that.read = that.write = n;
    };

    that.sync_point = function () {
      return mode == LENS ? 1 : 0;
    };
  }

  var PRESET_DICT = 0x20;
  var Z_DEFLATED = 8;
  var METHOD = 0;
  var FLAG = 1;
  var DICT4 = 2;
  var DICT3 = 3;
  var DICT2 = 4;
  var DICT1 = 5;
  var DICT0 = 6;
  var BLOCKS = 7;
  var DONE = 12;
  var BAD = 13;
  var mark = [0, 0, 0xff, 0xff];

  function Inflate() {
    var that = this;
    that.mode = 0;
    that.method = 0;
    that.was = [0];
    that.need = 0;
    that.marker = 0;
    that.wbits = 0;

    function inflateReset(z) {
      if (!z || !z.istate) return Z_STREAM_ERROR;
      z.total_in = z.total_out = 0;
      z.msg = null;
      z.istate.mode = BLOCKS;
      z.istate.blocks.reset(z, null);
      return Z_OK;
    }

    that.inflateEnd = function (z) {
      if (that.blocks) that.blocks.free(z);
      that.blocks = null;
      return Z_OK;
    };

    that.inflateInit = function (z, w) {
      z.msg = null;
      that.blocks = null;

      if (w < 8 || w > 15) {
        that.inflateEnd(z);
        return Z_STREAM_ERROR;
      }

      that.wbits = w;
      z.istate.blocks = new InfBlocks(z, 1 << w);
      inflateReset(z);
      return Z_OK;
    };

    that.inflate = function (z, f) {
      var r;
      var b;
      if (!z || !z.istate || !z.next_in) return Z_STREAM_ERROR;
      f = f == Z_FINISH ? Z_BUF_ERROR : Z_OK;
      r = Z_BUF_ERROR;

      while (true) {
        switch (z.istate.mode) {
          case METHOD:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;

            if (((z.istate.method = z.read_byte(z.next_in_index++)) & 0xf) != Z_DEFLATED) {
              z.istate.mode = BAD;
              z.msg = "unknown compression method";
              z.istate.marker = 5;
              break;
            }

            if ((z.istate.method >> 4) + 8 > z.istate.wbits) {
              z.istate.mode = BAD;
              z.msg = "invalid window size";
              z.istate.marker = 5;
              break;
            }

            z.istate.mode = FLAG;

          case FLAG:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;
            b = z.read_byte(z.next_in_index++) & 0xff;

            if (((z.istate.method << 8) + b) % 31 !== 0) {
              z.istate.mode = BAD;
              z.msg = "incorrect header check";
              z.istate.marker = 5;
              break;
            }

            if ((b & PRESET_DICT) === 0) {
              z.istate.mode = BLOCKS;
              break;
            }

            z.istate.mode = DICT4;

          case DICT4:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;
            z.istate.need = (z.read_byte(z.next_in_index++) & 0xff) << 24 & 0xff000000;
            z.istate.mode = DICT3;

          case DICT3:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;
            z.istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 16 & 0xff0000;
            z.istate.mode = DICT2;

          case DICT2:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;
            z.istate.need += (z.read_byte(z.next_in_index++) & 0xff) << 8 & 0xff00;
            z.istate.mode = DICT1;

          case DICT1:
            if (z.avail_in === 0) return r;
            r = f;
            z.avail_in--;
            z.total_in++;
            z.istate.need += z.read_byte(z.next_in_index++) & 0xff;
            z.istate.mode = DICT0;
            return Z_NEED_DICT;

          case DICT0:
            z.istate.mode = BAD;
            z.msg = "need dictionary";
            z.istate.marker = 0;
            return Z_STREAM_ERROR;

          case BLOCKS:
            r = z.istate.blocks.proc(z, r);

            if (r == Z_DATA_ERROR) {
              z.istate.mode = BAD;
              z.istate.marker = 0;
              break;
            }

            if (r == Z_OK) {
              r = f;
            }

            if (r != Z_STREAM_END) {
              return r;
            }

            r = f;
            z.istate.blocks.reset(z, z.istate.was);
            z.istate.mode = DONE;

          case DONE:
            return Z_STREAM_END;

          case BAD:
            return Z_DATA_ERROR;

          default:
            return Z_STREAM_ERROR;
        }
      }
    };

    that.inflateSetDictionary = function (z, dictionary, dictLength) {
      var index = 0;
      var length = dictLength;
      if (!z || !z.istate || z.istate.mode != DICT0) return Z_STREAM_ERROR;

      if (length >= 1 << z.istate.wbits) {
        length = (1 << z.istate.wbits) - 1;
        index = dictLength - length;
      }

      z.istate.blocks.set_dictionary(dictionary, index, length);
      z.istate.mode = BLOCKS;
      return Z_OK;
    };

    that.inflateSync = function (z) {
      var n;
      var p;
      var m;
      var r, w;
      if (!z || !z.istate) return Z_STREAM_ERROR;

      if (z.istate.mode != BAD) {
        z.istate.mode = BAD;
        z.istate.marker = 0;
      }

      if ((n = z.avail_in) === 0) return Z_BUF_ERROR;
      p = z.next_in_index;
      m = z.istate.marker;

      while (n !== 0 && m < 4) {
        if (z.read_byte(p) == mark[m]) {
          m++;
        } else if (z.read_byte(p) !== 0) {
          m = 0;
        } else {
          m = 4 - m;
        }

        p++;
        n--;
      }

      z.total_in += p - z.next_in_index;
      z.next_in_index = p;
      z.avail_in = n;
      z.istate.marker = m;

      if (m != 4) {
        return Z_DATA_ERROR;
      }

      r = z.total_in;
      w = z.total_out;
      inflateReset(z);
      z.total_in = r;
      z.total_out = w;
      z.istate.mode = BLOCKS;
      return Z_OK;
    };

    that.inflateSyncPoint = function (z) {
      if (!z || !z.istate || !z.istate.blocks) return Z_STREAM_ERROR;
      return z.istate.blocks.sync_point();
    };
  }

  function ZStream() {}

  ZStream.prototype = {
    inflateInit: function inflateInit(bits) {
      var that = this;
      that.istate = new Inflate();
      if (!bits) bits = MAX_BITS;
      return that.istate.inflateInit(that, bits);
    },
    inflate: function inflate(f) {
      var that = this;
      if (!that.istate) return Z_STREAM_ERROR;
      return that.istate.inflate(that, f);
    },
    inflateEnd: function inflateEnd() {
      var that = this;
      if (!that.istate) return Z_STREAM_ERROR;
      var ret = that.istate.inflateEnd(that);
      that.istate = null;
      return ret;
    },
    inflateSync: function inflateSync() {
      var that = this;
      if (!that.istate) return Z_STREAM_ERROR;
      return that.istate.inflateSync(that);
    },
    inflateSetDictionary: function inflateSetDictionary(dictionary, dictLength) {
      var that = this;
      if (!that.istate) return Z_STREAM_ERROR;
      return that.istate.inflateSetDictionary(that, dictionary, dictLength);
    },
    read_byte: function read_byte(start) {
      var that = this;
      return that.next_in.subarray(start, start + 1)[0];
    },
    read_buf: function read_buf(start, size) {
      var that = this;
      return that.next_in.subarray(start, start + size);
    }
  };

  function Inflater() {
    var that = this;
    var z = new ZStream();
    var bufsize = 512;
    var flush = Z_NO_FLUSH;
    var buf = new Uint8Array(bufsize);
    var nomoreinput = false;
    z.inflateInit();
    z.next_out = buf;

    that.append = function (data, onprogress) {
      var err,
          buffers = [],
          lastIndex = 0,
          bufferIndex = 0,
          bufferSize = 0,
          array;
      if (data.length === 0) return;
      z.next_in_index = 0;
      z.next_in = data;
      z.avail_in = data.length;

      do {
        z.next_out_index = 0;
        z.avail_out = bufsize;

        if (z.avail_in === 0 && !nomoreinput) {
          z.next_in_index = 0;
          nomoreinput = true;
        }

        err = z.inflate(flush);

        if (nomoreinput && err === Z_BUF_ERROR) {
          if (z.avail_in !== 0) throw new Error("inflating: bad input");
        } else if (err !== Z_OK && err !== Z_STREAM_END) throw new Error("inflating: " + z.msg);

        if ((nomoreinput || err === Z_STREAM_END) && z.avail_in === data.length) throw new Error("inflating: bad input");
        if (z.next_out_index) if (z.next_out_index === bufsize) buffers.push(new Uint8Array(buf));else buffers.push(new Uint8Array(buf.subarray(0, z.next_out_index)));
        bufferSize += z.next_out_index;

        if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
          onprogress(z.next_in_index);
          lastIndex = z.next_in_index;
        }
      } while (z.avail_in > 0 || z.avail_out === 0);

      array = new Uint8Array(bufferSize);
      buffers.forEach(function (chunk) {
        array.set(chunk, bufferIndex);
        bufferIndex += chunk.length;
      });
      return array;
    };

    that.flush = function () {
      z.inflateEnd();
    };
  }

  var env = global.zip || global;
  env.Inflater = env._jzlib_Inflater = Inflater;
})(zipExport);

(function (global) {

  var MAX_BITS = 15;
  var D_CODES = 30;
  var BL_CODES = 19;
  var LENGTH_CODES = 29;
  var LITERALS = 256;
  var L_CODES = LITERALS + 1 + LENGTH_CODES;
  var HEAP_SIZE = 2 * L_CODES + 1;
  var END_BLOCK = 256;
  var MAX_BL_BITS = 7;
  var REP_3_6 = 16;
  var REPZ_3_10 = 17;
  var REPZ_11_138 = 18;
  var Buf_size = 8 * 2;
  var Z_DEFAULT_COMPRESSION = -1;
  var Z_FILTERED = 1;
  var Z_HUFFMAN_ONLY = 2;
  var Z_DEFAULT_STRATEGY = 0;
  var Z_NO_FLUSH = 0;
  var Z_PARTIAL_FLUSH = 1;
  var Z_FULL_FLUSH = 3;
  var Z_FINISH = 4;
  var Z_OK = 0;
  var Z_STREAM_END = 1;
  var Z_NEED_DICT = 2;
  var Z_STREAM_ERROR = -2;
  var Z_DATA_ERROR = -3;
  var Z_BUF_ERROR = -5;
  var _dist_code = [0, 1, 2, 3, 4, 4, 5, 5, 6, 6, 6, 6, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9, 9, 9, 9, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 13, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 14, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 0, 0, 16, 17, 18, 18, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29, 29];

  function Tree() {
    var that = this;

    function gen_bitlen(s) {
      var tree = that.dyn_tree;
      var stree = that.stat_desc.static_tree;
      var extra = that.stat_desc.extra_bits;
      var base = that.stat_desc.extra_base;
      var max_length = that.stat_desc.max_length;
      var h;
      var n, m;
      var bits;
      var xbits;
      var f;
      var overflow = 0;

      for (bits = 0; bits <= MAX_BITS; bits++) {
        s.bl_count[bits] = 0;
      }

      tree[s.heap[s.heap_max] * 2 + 1] = 0;

      for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;

        if (bits > max_length) {
          bits = max_length;
          overflow++;
        }

        tree[n * 2 + 1] = bits;
        if (n > that.max_code) continue;
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2];
        s.opt_len += f * (bits + xbits);
        if (stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
      }

      if (overflow === 0) return;

      do {
        bits = max_length - 1;

        while (s.bl_count[bits] === 0) {
          bits--;
        }

        s.bl_count[bits]--;
        s.bl_count[bits + 1] += 2;
        s.bl_count[max_length]--;
        overflow -= 2;
      } while (overflow > 0);

      for (bits = max_length; bits !== 0; bits--) {
        n = s.bl_count[bits];

        while (n !== 0) {
          m = s.heap[--h];
          if (m > that.max_code) continue;

          if (tree[m * 2 + 1] != bits) {
            s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2];
            tree[m * 2 + 1] = bits;
          }

          n--;
        }
      }
    }

    function bi_reverse(code, len) {
      var res = 0;

      do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
      } while (--len > 0);

      return res >>> 1;
    }

    function gen_codes(tree, max_code, bl_count) {
      var next_code = [];
      var code = 0;
      var bits;
      var n;
      var len;

      for (bits = 1; bits <= MAX_BITS; bits++) {
        next_code[bits] = code = code + bl_count[bits - 1] << 1;
      }

      for (n = 0; n <= max_code; n++) {
        len = tree[n * 2 + 1];
        if (len === 0) continue;
        tree[n * 2] = bi_reverse(next_code[len]++, len);
      }
    }

    that.build_tree = function (s) {
      var tree = that.dyn_tree;
      var stree = that.stat_desc.static_tree;
      var elems = that.stat_desc.elems;
      var n, m;
      var max_code = -1;
      var node;
      s.heap_len = 0;
      s.heap_max = HEAP_SIZE;

      for (n = 0; n < elems; n++) {
        if (tree[n * 2] !== 0) {
          s.heap[++s.heap_len] = max_code = n;
          s.depth[n] = 0;
        } else {
          tree[n * 2 + 1] = 0;
        }
      }

      while (s.heap_len < 2) {
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (stree) s.static_len -= stree[node * 2 + 1];
      }

      that.max_code = max_code;

      for (n = Math.floor(s.heap_len / 2); n >= 1; n--) {
        s.pqdownheap(tree, n);
      }

      node = elems;

      do {
        n = s.heap[1];
        s.heap[1] = s.heap[s.heap_len--];
        s.pqdownheap(tree, 1);
        m = s.heap[1];
        s.heap[--s.heap_max] = n;
        s.heap[--s.heap_max] = m;
        tree[node * 2] = tree[n * 2] + tree[m * 2];
        s.depth[node] = Math.max(s.depth[n], s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        s.heap[1] = node++;
        s.pqdownheap(tree, 1);
      } while (s.heap_len >= 2);

      s.heap[--s.heap_max] = s.heap[1];
      gen_bitlen(s);
      gen_codes(tree, that.max_code, s.bl_count);
    };
  }

  Tree._length_code = [0, 1, 2, 3, 4, 5, 6, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 12, 12, 13, 13, 13, 13, 14, 14, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 26, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 27, 28];
  Tree.base_length = [0, 1, 2, 3, 4, 5, 6, 7, 8, 10, 12, 14, 16, 20, 24, 28, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 0];
  Tree.base_dist = [0, 1, 2, 3, 4, 6, 8, 12, 16, 24, 32, 48, 64, 96, 128, 192, 256, 384, 512, 768, 1024, 1536, 2048, 3072, 4096, 6144, 8192, 12288, 16384, 24576];

  Tree.d_code = function (dist) {
    return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
  };

  Tree.extra_lbits = [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
  Tree.extra_dbits = [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
  Tree.extra_blbits = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
  Tree.bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];

  function StaticTree(static_tree, extra_bits, extra_base, elems, max_length) {
    var that = this;
    that.static_tree = static_tree;
    that.extra_bits = extra_bits;
    that.extra_base = extra_base;
    that.elems = elems;
    that.max_length = max_length;
  }

  StaticTree.static_ltree = [12, 8, 140, 8, 76, 8, 204, 8, 44, 8, 172, 8, 108, 8, 236, 8, 28, 8, 156, 8, 92, 8, 220, 8, 60, 8, 188, 8, 124, 8, 252, 8, 2, 8, 130, 8, 66, 8, 194, 8, 34, 8, 162, 8, 98, 8, 226, 8, 18, 8, 146, 8, 82, 8, 210, 8, 50, 8, 178, 8, 114, 8, 242, 8, 10, 8, 138, 8, 74, 8, 202, 8, 42, 8, 170, 8, 106, 8, 234, 8, 26, 8, 154, 8, 90, 8, 218, 8, 58, 8, 186, 8, 122, 8, 250, 8, 6, 8, 134, 8, 70, 8, 198, 8, 38, 8, 166, 8, 102, 8, 230, 8, 22, 8, 150, 8, 86, 8, 214, 8, 54, 8, 182, 8, 118, 8, 246, 8, 14, 8, 142, 8, 78, 8, 206, 8, 46, 8, 174, 8, 110, 8, 238, 8, 30, 8, 158, 8, 94, 8, 222, 8, 62, 8, 190, 8, 126, 8, 254, 8, 1, 8, 129, 8, 65, 8, 193, 8, 33, 8, 161, 8, 97, 8, 225, 8, 17, 8, 145, 8, 81, 8, 209, 8, 49, 8, 177, 8, 113, 8, 241, 8, 9, 8, 137, 8, 73, 8, 201, 8, 41, 8, 169, 8, 105, 8, 233, 8, 25, 8, 153, 8, 89, 8, 217, 8, 57, 8, 185, 8, 121, 8, 249, 8, 5, 8, 133, 8, 69, 8, 197, 8, 37, 8, 165, 8, 101, 8, 229, 8, 21, 8, 149, 8, 85, 8, 213, 8, 53, 8, 181, 8, 117, 8, 245, 8, 13, 8, 141, 8, 77, 8, 205, 8, 45, 8, 173, 8, 109, 8, 237, 8, 29, 8, 157, 8, 93, 8, 221, 8, 61, 8, 189, 8, 125, 8, 253, 8, 19, 9, 275, 9, 147, 9, 403, 9, 83, 9, 339, 9, 211, 9, 467, 9, 51, 9, 307, 9, 179, 9, 435, 9, 115, 9, 371, 9, 243, 9, 499, 9, 11, 9, 267, 9, 139, 9, 395, 9, 75, 9, 331, 9, 203, 9, 459, 9, 43, 9, 299, 9, 171, 9, 427, 9, 107, 9, 363, 9, 235, 9, 491, 9, 27, 9, 283, 9, 155, 9, 411, 9, 91, 9, 347, 9, 219, 9, 475, 9, 59, 9, 315, 9, 187, 9, 443, 9, 123, 9, 379, 9, 251, 9, 507, 9, 7, 9, 263, 9, 135, 9, 391, 9, 71, 9, 327, 9, 199, 9, 455, 9, 39, 9, 295, 9, 167, 9, 423, 9, 103, 9, 359, 9, 231, 9, 487, 9, 23, 9, 279, 9, 151, 9, 407, 9, 87, 9, 343, 9, 215, 9, 471, 9, 55, 9, 311, 9, 183, 9, 439, 9, 119, 9, 375, 9, 247, 9, 503, 9, 15, 9, 271, 9, 143, 9, 399, 9, 79, 9, 335, 9, 207, 9, 463, 9, 47, 9, 303, 9, 175, 9, 431, 9, 111, 9, 367, 9, 239, 9, 495, 9, 31, 9, 287, 9, 159, 9, 415, 9, 95, 9, 351, 9, 223, 9, 479, 9, 63, 9, 319, 9, 191, 9, 447, 9, 127, 9, 383, 9, 255, 9, 511, 9, 0, 7, 64, 7, 32, 7, 96, 7, 16, 7, 80, 7, 48, 7, 112, 7, 8, 7, 72, 7, 40, 7, 104, 7, 24, 7, 88, 7, 56, 7, 120, 7, 4, 7, 68, 7, 36, 7, 100, 7, 20, 7, 84, 7, 52, 7, 116, 7, 3, 8, 131, 8, 67, 8, 195, 8, 35, 8, 163, 8, 99, 8, 227, 8];
  StaticTree.static_dtree = [0, 5, 16, 5, 8, 5, 24, 5, 4, 5, 20, 5, 12, 5, 28, 5, 2, 5, 18, 5, 10, 5, 26, 5, 6, 5, 22, 5, 14, 5, 30, 5, 1, 5, 17, 5, 9, 5, 25, 5, 5, 5, 21, 5, 13, 5, 29, 5, 3, 5, 19, 5, 11, 5, 27, 5, 7, 5, 23, 5];
  StaticTree.static_l_desc = new StaticTree(StaticTree.static_ltree, Tree.extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  StaticTree.static_d_desc = new StaticTree(StaticTree.static_dtree, Tree.extra_dbits, 0, D_CODES, MAX_BITS);
  StaticTree.static_bl_desc = new StaticTree(null, Tree.extra_blbits, 0, BL_CODES, MAX_BL_BITS);
  var MAX_MEM_LEVEL = 9;
  var DEF_MEM_LEVEL = 8;

  function Config(good_length, max_lazy, nice_length, max_chain, func) {
    var that = this;
    that.good_length = good_length;
    that.max_lazy = max_lazy;
    that.nice_length = nice_length;
    that.max_chain = max_chain;
    that.func = func;
  }

  var STORED = 0;
  var FAST = 1;
  var SLOW = 2;
  var config_table = [new Config(0, 0, 0, 0, STORED), new Config(4, 4, 8, 4, FAST), new Config(4, 5, 16, 8, FAST), new Config(4, 6, 32, 32, FAST), new Config(4, 4, 16, 16, SLOW), new Config(8, 16, 32, 32, SLOW), new Config(8, 16, 128, 128, SLOW), new Config(8, 32, 128, 256, SLOW), new Config(32, 128, 258, 1024, SLOW), new Config(32, 258, 258, 4096, SLOW)];
  var z_errmsg = ["need dictionary", "stream end", "", "", "stream error", "data error", "", "buffer error", "", ""];
  var NeedMore = 0;
  var BlockDone = 1;
  var FinishStarted = 2;
  var FinishDone = 3;
  var PRESET_DICT = 0x20;
  var INIT_STATE = 42;
  var BUSY_STATE = 113;
  var FINISH_STATE = 666;
  var Z_DEFLATED = 8;
  var STORED_BLOCK = 0;
  var STATIC_TREES = 1;
  var DYN_TREES = 2;
  var MIN_MATCH = 3;
  var MAX_MATCH = 258;
  var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;

  function smaller(tree, n, m, depth) {
    var tn2 = tree[n * 2];
    var tm2 = tree[m * 2];
    return tn2 < tm2 || tn2 == tm2 && depth[n] <= depth[m];
  }

  function Deflate() {
    var that = this;
    var strm;
    var status;
    var pending_buf_size;
    var last_flush;
    var w_size;
    var w_bits;
    var w_mask;
    var window;
    var window_size;
    var prev;
    var head;
    var ins_h;
    var hash_size;
    var hash_bits;
    var hash_mask;
    var hash_shift;
    var block_start;
    var match_length;
    var prev_match;
    var match_available;
    var strstart;
    var match_start;
    var lookahead;
    var prev_length;
    var max_chain_length;
    var max_lazy_match;
    var level;
    var strategy;
    var good_match;
    var nice_match;
    var dyn_ltree;
    var dyn_dtree;
    var bl_tree;
    var l_desc = new Tree();
    var d_desc = new Tree();
    var bl_desc = new Tree();
    that.depth = [];
    var l_buf;
    var lit_bufsize;
    var last_lit;
    var d_buf;
    var matches;
    var last_eob_len;
    var bi_buf;
    var bi_valid;
    that.bl_count = [];
    that.heap = [];
    dyn_ltree = [];
    dyn_dtree = [];
    bl_tree = [];

    function lm_init() {
      var i;
      window_size = 2 * w_size;
      head[hash_size - 1] = 0;

      for (i = 0; i < hash_size - 1; i++) {
        head[i] = 0;
      }

      max_lazy_match = config_table[level].max_lazy;
      good_match = config_table[level].good_length;
      nice_match = config_table[level].nice_length;
      max_chain_length = config_table[level].max_chain;
      strstart = 0;
      block_start = 0;
      lookahead = 0;
      match_length = prev_length = MIN_MATCH - 1;
      match_available = 0;
      ins_h = 0;
    }

    function init_block() {
      var i;

      for (i = 0; i < L_CODES; i++) {
        dyn_ltree[i * 2] = 0;
      }

      for (i = 0; i < D_CODES; i++) {
        dyn_dtree[i * 2] = 0;
      }

      for (i = 0; i < BL_CODES; i++) {
        bl_tree[i * 2] = 0;
      }

      dyn_ltree[END_BLOCK * 2] = 1;
      that.opt_len = that.static_len = 0;
      last_lit = matches = 0;
    }

    function tr_init() {
      l_desc.dyn_tree = dyn_ltree;
      l_desc.stat_desc = StaticTree.static_l_desc;
      d_desc.dyn_tree = dyn_dtree;
      d_desc.stat_desc = StaticTree.static_d_desc;
      bl_desc.dyn_tree = bl_tree;
      bl_desc.stat_desc = StaticTree.static_bl_desc;
      bi_buf = 0;
      bi_valid = 0;
      last_eob_len = 8;
      init_block();
    }

    that.pqdownheap = function (tree, k) {
      var heap = that.heap;
      var v = heap[k];
      var j = k << 1;

      while (j <= that.heap_len) {
        if (j < that.heap_len && smaller(tree, heap[j + 1], heap[j], that.depth)) {
          j++;
        }

        if (smaller(tree, v, heap[j], that.depth)) break;
        heap[k] = heap[j];
        k = j;
        j <<= 1;
      }

      heap[k] = v;
    };

    function scan_tree(tree, max_code) {
      var n;
      var prevlen = -1;
      var curlen;
      var nextlen = tree[0 * 2 + 1];
      var count = 0;
      var max_count = 7;
      var min_count = 4;

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }

      tree[(max_code + 1) * 2 + 1] = 0xffff;

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1];

        if (++count < max_count && curlen == nextlen) {
          continue;
        } else if (count < min_count) {
          bl_tree[curlen * 2] += count;
        } else if (curlen !== 0) {
          if (curlen != prevlen) bl_tree[curlen * 2]++;
          bl_tree[REP_3_6 * 2]++;
        } else if (count <= 10) {
          bl_tree[REPZ_3_10 * 2]++;
        } else {
          bl_tree[REPZ_11_138 * 2]++;
        }

        count = 0;
        prevlen = curlen;

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen == nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    }

    function build_bl_tree() {
      var max_blindex;
      scan_tree(dyn_ltree, l_desc.max_code);
      scan_tree(dyn_dtree, d_desc.max_code);
      bl_desc.build_tree(that);

      for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
        if (bl_tree[Tree.bl_order[max_blindex] * 2 + 1] !== 0) break;
      }

      that.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
      return max_blindex;
    }

    function put_byte(p) {
      that.pending_buf[that.pending++] = p;
    }

    function put_short(w) {
      put_byte(w & 0xff);
      put_byte(w >>> 8 & 0xff);
    }

    function putShortMSB(b) {
      put_byte(b >> 8 & 0xff);
      put_byte(b & 0xff & 0xff);
    }

    function send_bits(value, length) {
      var val,
          len = length;

      if (bi_valid > Buf_size - len) {
        val = value;
        bi_buf |= val << bi_valid & 0xffff;
        put_short(bi_buf);
        bi_buf = val >>> Buf_size - bi_valid;
        bi_valid += len - Buf_size;
      } else {
        bi_buf |= value << bi_valid & 0xffff;
        bi_valid += len;
      }
    }

    function send_code(c, tree) {
      var c2 = c * 2;
      send_bits(tree[c2] & 0xffff, tree[c2 + 1] & 0xffff);
    }

    function send_tree(tree, max_code) {
      var n;
      var prevlen = -1;
      var curlen;
      var nextlen = tree[0 * 2 + 1];
      var count = 0;
      var max_count = 7;
      var min_count = 4;

      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }

      for (n = 0; n <= max_code; n++) {
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1];

        if (++count < max_count && curlen == nextlen) {
          continue;
        } else if (count < min_count) {
          do {
            send_code(curlen, bl_tree);
          } while (--count !== 0);
        } else if (curlen !== 0) {
          if (curlen != prevlen) {
            send_code(curlen, bl_tree);
            count--;
          }

          send_code(REP_3_6, bl_tree);
          send_bits(count - 3, 2);
        } else if (count <= 10) {
          send_code(REPZ_3_10, bl_tree);
          send_bits(count - 3, 3);
        } else {
          send_code(REPZ_11_138, bl_tree);
          send_bits(count - 11, 7);
        }

        count = 0;
        prevlen = curlen;

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen == nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    }

    function send_all_trees(lcodes, dcodes, blcodes) {
      var rank;
      send_bits(lcodes - 257, 5);
      send_bits(dcodes - 1, 5);
      send_bits(blcodes - 4, 4);

      for (rank = 0; rank < blcodes; rank++) {
        send_bits(bl_tree[Tree.bl_order[rank] * 2 + 1], 3);
      }

      send_tree(dyn_ltree, lcodes - 1);
      send_tree(dyn_dtree, dcodes - 1);
    }

    function bi_flush() {
      if (bi_valid == 16) {
        put_short(bi_buf);
        bi_buf = 0;
        bi_valid = 0;
      } else if (bi_valid >= 8) {
        put_byte(bi_buf & 0xff);
        bi_buf >>>= 8;
        bi_valid -= 8;
      }
    }

    function _tr_align() {
      send_bits(STATIC_TREES << 1, 3);
      send_code(END_BLOCK, StaticTree.static_ltree);
      bi_flush();

      if (1 + last_eob_len + 10 - bi_valid < 9) {
        send_bits(STATIC_TREES << 1, 3);
        send_code(END_BLOCK, StaticTree.static_ltree);
        bi_flush();
      }

      last_eob_len = 7;
    }

    function _tr_tally(dist, lc) {
      var out_length, in_length, dcode;
      that.pending_buf[d_buf + last_lit * 2] = dist >>> 8 & 0xff;
      that.pending_buf[d_buf + last_lit * 2 + 1] = dist & 0xff;
      that.pending_buf[l_buf + last_lit] = lc & 0xff;
      last_lit++;

      if (dist === 0) {
        dyn_ltree[lc * 2]++;
      } else {
        matches++;
        dist--;
        dyn_ltree[(Tree._length_code[lc] + LITERALS + 1) * 2]++;
        dyn_dtree[Tree.d_code(dist) * 2]++;
      }

      if ((last_lit & 0x1fff) === 0 && level > 2) {
        out_length = last_lit * 8;
        in_length = strstart - block_start;

        for (dcode = 0; dcode < D_CODES; dcode++) {
          out_length += dyn_dtree[dcode * 2] * (5 + Tree.extra_dbits[dcode]);
        }

        out_length >>>= 3;
        if (matches < Math.floor(last_lit / 2) && out_length < Math.floor(in_length / 2)) return true;
      }

      return last_lit == lit_bufsize - 1;
    }

    function compress_block(ltree, dtree) {
      var dist;
      var lc;
      var lx = 0;
      var code;
      var extra;

      if (last_lit !== 0) {
        do {
          dist = that.pending_buf[d_buf + lx * 2] << 8 & 0xff00 | that.pending_buf[d_buf + lx * 2 + 1] & 0xff;
          lc = that.pending_buf[l_buf + lx] & 0xff;
          lx++;

          if (dist === 0) {
            send_code(lc, ltree);
          } else {
            code = Tree._length_code[lc];
            send_code(code + LITERALS + 1, ltree);
            extra = Tree.extra_lbits[code];

            if (extra !== 0) {
              lc -= Tree.base_length[code];
              send_bits(lc, extra);
            }

            dist--;
            code = Tree.d_code(dist);
            send_code(code, dtree);
            extra = Tree.extra_dbits[code];

            if (extra !== 0) {
              dist -= Tree.base_dist[code];
              send_bits(dist, extra);
            }
          }
        } while (lx < last_lit);
      }

      send_code(END_BLOCK, ltree);
      last_eob_len = ltree[END_BLOCK * 2 + 1];
    }

    function bi_windup() {
      if (bi_valid > 8) {
        put_short(bi_buf);
      } else if (bi_valid > 0) {
        put_byte(bi_buf & 0xff);
      }

      bi_buf = 0;
      bi_valid = 0;
    }

    function copy_block(buf, len, header) {
      bi_windup();
      last_eob_len = 8;

      if (header) {
        put_short(len);
        put_short(~len);
      }

      that.pending_buf.set(window.subarray(buf, buf + len), that.pending);
      that.pending += len;
    }

    function _tr_stored_block(buf, stored_len, eof) {
      send_bits((STORED_BLOCK << 1) + (eof ? 1 : 0), 3);
      copy_block(buf, stored_len, true);
    }

    function _tr_flush_block(buf, stored_len, eof) {
      var opt_lenb, static_lenb;
      var max_blindex = 0;

      if (level > 0) {
        l_desc.build_tree(that);
        d_desc.build_tree(that);
        max_blindex = build_bl_tree();
        opt_lenb = that.opt_len + 3 + 7 >>> 3;
        static_lenb = that.static_len + 3 + 7 >>> 3;
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
      } else {
        opt_lenb = static_lenb = stored_len + 5;
      }

      if (stored_len + 4 <= opt_lenb && buf != -1) {
        _tr_stored_block(buf, stored_len, eof);
      } else if (static_lenb == opt_lenb) {
        send_bits((STATIC_TREES << 1) + (eof ? 1 : 0), 3);
        compress_block(StaticTree.static_ltree, StaticTree.static_dtree);
      } else {
        send_bits((DYN_TREES << 1) + (eof ? 1 : 0), 3);
        send_all_trees(l_desc.max_code + 1, d_desc.max_code + 1, max_blindex + 1);
        compress_block(dyn_ltree, dyn_dtree);
      }

      init_block();

      if (eof) {
        bi_windup();
      }
    }

    function flush_block_only(eof) {
      _tr_flush_block(block_start >= 0 ? block_start : -1, strstart - block_start, eof);

      block_start = strstart;
      strm.flush_pending();
    }

    function fill_window() {
      var n, m;
      var p;
      var more;

      do {
        more = window_size - lookahead - strstart;

        if (more === 0 && strstart === 0 && lookahead === 0) {
          more = w_size;
        } else if (more == -1) {
          more--;
        } else if (strstart >= w_size + w_size - MIN_LOOKAHEAD) {
          window.set(window.subarray(w_size, w_size + w_size), 0);
          match_start -= w_size;
          strstart -= w_size;
          block_start -= w_size;
          n = hash_size;
          p = n;

          do {
            m = head[--p] & 0xffff;
            head[p] = m >= w_size ? m - w_size : 0;
          } while (--n !== 0);

          n = w_size;
          p = n;

          do {
            m = prev[--p] & 0xffff;
            prev[p] = m >= w_size ? m - w_size : 0;
          } while (--n !== 0);

          more += w_size;
        }

        if (strm.avail_in === 0) return;
        n = strm.read_buf(window, strstart + lookahead, more);
        lookahead += n;

        if (lookahead >= MIN_MATCH) {
          ins_h = window[strstart] & 0xff;
          ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask;
        }
      } while (lookahead < MIN_LOOKAHEAD && strm.avail_in !== 0);
    }

    function deflate_stored(flush) {
      var max_block_size = 0xffff;
      var max_start;

      if (max_block_size > pending_buf_size - 5) {
        max_block_size = pending_buf_size - 5;
      }

      while (true) {
        if (lookahead <= 1) {
          fill_window();
          if (lookahead === 0 && flush == Z_NO_FLUSH) return NeedMore;
          if (lookahead === 0) break;
        }

        strstart += lookahead;
        lookahead = 0;
        max_start = block_start + max_block_size;

        if (strstart === 0 || strstart >= max_start) {
          lookahead = strstart - max_start;
          strstart = max_start;
          flush_block_only(false);
          if (strm.avail_out === 0) return NeedMore;
        }

        if (strstart - block_start >= w_size - MIN_LOOKAHEAD) {
          flush_block_only(false);
          if (strm.avail_out === 0) return NeedMore;
        }
      }

      flush_block_only(flush == Z_FINISH);
      if (strm.avail_out === 0) return flush == Z_FINISH ? FinishStarted : NeedMore;
      return flush == Z_FINISH ? FinishDone : BlockDone;
    }

    function longest_match(cur_match) {
      var chain_length = max_chain_length;
      var scan = strstart;
      var match;
      var len;
      var best_len = prev_length;
      var limit = strstart > w_size - MIN_LOOKAHEAD ? strstart - (w_size - MIN_LOOKAHEAD) : 0;
      var _nice_match = nice_match;
      var wmask = w_mask;
      var strend = strstart + MAX_MATCH;
      var scan_end1 = window[scan + best_len - 1];
      var scan_end = window[scan + best_len];

      if (prev_length >= good_match) {
        chain_length >>= 2;
      }

      if (_nice_match > lookahead) _nice_match = lookahead;

      do {
        match = cur_match;
        if (window[match + best_len] != scan_end || window[match + best_len - 1] != scan_end1 || window[match] != window[scan] || window[++match] != window[scan + 1]) continue;
        scan += 2;
        match++;

        do {} while (window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && window[++scan] == window[++match] && scan < strend);

        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;

        if (len > best_len) {
          match_start = cur_match;
          best_len = len;
          if (len >= _nice_match) break;
          scan_end1 = window[scan + best_len - 1];
          scan_end = window[scan + best_len];
        }
      } while ((cur_match = prev[cur_match & wmask] & 0xffff) > limit && --chain_length !== 0);

      if (best_len <= lookahead) return best_len;
      return lookahead;
    }

    function deflate_fast(flush) {
      var hash_head = 0;
      var bflush;

      while (true) {
        if (lookahead < MIN_LOOKAHEAD) {
          fill_window();

          if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH) {
            return NeedMore;
          }

          if (lookahead === 0) break;
        }

        if (lookahead >= MIN_MATCH) {
          ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
          hash_head = head[ins_h] & 0xffff;
          prev[strstart & w_mask] = head[ins_h];
          head[ins_h] = strstart;
        }

        if (hash_head !== 0 && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD) {
          if (strategy != Z_HUFFMAN_ONLY) {
            match_length = longest_match(hash_head);
          }
        }

        if (match_length >= MIN_MATCH) {
          bflush = _tr_tally(strstart - match_start, match_length - MIN_MATCH);
          lookahead -= match_length;

          if (match_length <= max_lazy_match && lookahead >= MIN_MATCH) {
            match_length--;

            do {
              strstart++;
              ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
              hash_head = head[ins_h] & 0xffff;
              prev[strstart & w_mask] = head[ins_h];
              head[ins_h] = strstart;
            } while (--match_length !== 0);

            strstart++;
          } else {
            strstart += match_length;
            match_length = 0;
            ins_h = window[strstart] & 0xff;
            ins_h = (ins_h << hash_shift ^ window[strstart + 1] & 0xff) & hash_mask;
          }
        } else {
          bflush = _tr_tally(0, window[strstart] & 0xff);
          lookahead--;
          strstart++;
        }

        if (bflush) {
          flush_block_only(false);
          if (strm.avail_out === 0) return NeedMore;
        }
      }

      flush_block_only(flush == Z_FINISH);

      if (strm.avail_out === 0) {
        if (flush == Z_FINISH) return FinishStarted;else return NeedMore;
      }

      return flush == Z_FINISH ? FinishDone : BlockDone;
    }

    function deflate_slow(flush) {
      var hash_head = 0;
      var bflush;
      var max_insert;

      while (true) {
        if (lookahead < MIN_LOOKAHEAD) {
          fill_window();

          if (lookahead < MIN_LOOKAHEAD && flush == Z_NO_FLUSH) {
            return NeedMore;
          }

          if (lookahead === 0) break;
        }

        if (lookahead >= MIN_MATCH) {
          ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
          hash_head = head[ins_h] & 0xffff;
          prev[strstart & w_mask] = head[ins_h];
          head[ins_h] = strstart;
        }

        prev_length = match_length;
        prev_match = match_start;
        match_length = MIN_MATCH - 1;

        if (hash_head !== 0 && prev_length < max_lazy_match && (strstart - hash_head & 0xffff) <= w_size - MIN_LOOKAHEAD) {
          if (strategy != Z_HUFFMAN_ONLY) {
            match_length = longest_match(hash_head);
          }

          if (match_length <= 5 && (strategy == Z_FILTERED || match_length == MIN_MATCH && strstart - match_start > 4096)) {
            match_length = MIN_MATCH - 1;
          }
        }

        if (prev_length >= MIN_MATCH && match_length <= prev_length) {
          max_insert = strstart + lookahead - MIN_MATCH;
          bflush = _tr_tally(strstart - 1 - prev_match, prev_length - MIN_MATCH);
          lookahead -= prev_length - 1;
          prev_length -= 2;

          do {
            if (++strstart <= max_insert) {
              ins_h = (ins_h << hash_shift ^ window[strstart + (MIN_MATCH - 1)] & 0xff) & hash_mask;
              hash_head = head[ins_h] & 0xffff;
              prev[strstart & w_mask] = head[ins_h];
              head[ins_h] = strstart;
            }
          } while (--prev_length !== 0);

          match_available = 0;
          match_length = MIN_MATCH - 1;
          strstart++;

          if (bflush) {
            flush_block_only(false);
            if (strm.avail_out === 0) return NeedMore;
          }
        } else if (match_available !== 0) {
          bflush = _tr_tally(0, window[strstart - 1] & 0xff);

          if (bflush) {
            flush_block_only(false);
          }

          strstart++;
          lookahead--;
          if (strm.avail_out === 0) return NeedMore;
        } else {
          match_available = 1;
          strstart++;
          lookahead--;
        }
      }

      if (match_available !== 0) {
        bflush = _tr_tally(0, window[strstart - 1] & 0xff);
        match_available = 0;
      }

      flush_block_only(flush == Z_FINISH);

      if (strm.avail_out === 0) {
        if (flush == Z_FINISH) return FinishStarted;else return NeedMore;
      }

      return flush == Z_FINISH ? FinishDone : BlockDone;
    }

    function deflateReset(strm) {
      strm.total_in = strm.total_out = 0;
      strm.msg = null;
      that.pending = 0;
      that.pending_out = 0;
      status = BUSY_STATE;
      last_flush = Z_NO_FLUSH;
      tr_init();
      lm_init();
      return Z_OK;
    }

    that.deflateInit = function (strm, _level, bits, _method, memLevel, _strategy) {
      if (!_method) _method = Z_DEFLATED;
      if (!memLevel) memLevel = DEF_MEM_LEVEL;
      if (!_strategy) _strategy = Z_DEFAULT_STRATEGY;
      strm.msg = null;
      if (_level == Z_DEFAULT_COMPRESSION) _level = 6;

      if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || _method != Z_DEFLATED || bits < 9 || bits > 15 || _level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY) {
        return Z_STREAM_ERROR;
      }

      strm.dstate = that;
      w_bits = bits;
      w_size = 1 << w_bits;
      w_mask = w_size - 1;
      hash_bits = memLevel + 7;
      hash_size = 1 << hash_bits;
      hash_mask = hash_size - 1;
      hash_shift = Math.floor((hash_bits + MIN_MATCH - 1) / MIN_MATCH);
      window = new Uint8Array(w_size * 2);
      prev = [];
      head = [];
      lit_bufsize = 1 << memLevel + 6;
      that.pending_buf = new Uint8Array(lit_bufsize * 4);
      pending_buf_size = lit_bufsize * 4;
      d_buf = Math.floor(lit_bufsize / 2);
      l_buf = (1 + 2) * lit_bufsize;
      level = _level;
      strategy = _strategy;
      return deflateReset(strm);
    };

    that.deflateEnd = function () {
      if (status != INIT_STATE && status != BUSY_STATE && status != FINISH_STATE) {
        return Z_STREAM_ERROR;
      }

      that.pending_buf = null;
      head = null;
      prev = null;
      window = null;
      that.dstate = null;
      return status == BUSY_STATE ? Z_DATA_ERROR : Z_OK;
    };

    that.deflateParams = function (strm, _level, _strategy) {
      var err = Z_OK;

      if (_level == Z_DEFAULT_COMPRESSION) {
        _level = 6;
      }

      if (_level < 0 || _level > 9 || _strategy < 0 || _strategy > Z_HUFFMAN_ONLY) {
        return Z_STREAM_ERROR;
      }

      if (config_table[level].func != config_table[_level].func && strm.total_in !== 0) {
        err = strm.deflate(Z_PARTIAL_FLUSH);
      }

      if (level != _level) {
        level = _level;
        max_lazy_match = config_table[level].max_lazy;
        good_match = config_table[level].good_length;
        nice_match = config_table[level].nice_length;
        max_chain_length = config_table[level].max_chain;
      }

      strategy = _strategy;
      return err;
    };

    that.deflateSetDictionary = function (strm, dictionary, dictLength) {
      var length = dictLength;
      var n,
          index = 0;
      if (!dictionary || status != INIT_STATE) return Z_STREAM_ERROR;
      if (length < MIN_MATCH) return Z_OK;

      if (length > w_size - MIN_LOOKAHEAD) {
        length = w_size - MIN_LOOKAHEAD;
        index = dictLength - length;
      }

      window.set(dictionary.subarray(index, index + length), 0);
      strstart = length;
      block_start = length;
      ins_h = window[0] & 0xff;
      ins_h = (ins_h << hash_shift ^ window[1] & 0xff) & hash_mask;

      for (n = 0; n <= length - MIN_MATCH; n++) {
        ins_h = (ins_h << hash_shift ^ window[n + (MIN_MATCH - 1)] & 0xff) & hash_mask;
        prev[n & w_mask] = head[ins_h];
        head[ins_h] = n;
      }

      return Z_OK;
    };

    that.deflate = function (_strm, flush) {
      var i, header, level_flags, old_flush, bstate;

      if (flush > Z_FINISH || flush < 0) {
        return Z_STREAM_ERROR;
      }

      if (!_strm.next_out || !_strm.next_in && _strm.avail_in !== 0 || status == FINISH_STATE && flush != Z_FINISH) {
        _strm.msg = z_errmsg[Z_NEED_DICT - Z_STREAM_ERROR];
        return Z_STREAM_ERROR;
      }

      if (_strm.avail_out === 0) {
        _strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];
        return Z_BUF_ERROR;
      }

      strm = _strm;
      old_flush = last_flush;
      last_flush = flush;

      if (status == INIT_STATE) {
        header = Z_DEFLATED + (w_bits - 8 << 4) << 8;
        level_flags = (level - 1 & 0xff) >> 1;
        if (level_flags > 3) level_flags = 3;
        header |= level_flags << 6;
        if (strstart !== 0) header |= PRESET_DICT;
        header += 31 - header % 31;
        status = BUSY_STATE;
        putShortMSB(header);
      }

      if (that.pending !== 0) {
        strm.flush_pending();

        if (strm.avail_out === 0) {
          last_flush = -1;
          return Z_OK;
        }
      } else if (strm.avail_in === 0 && flush <= old_flush && flush != Z_FINISH) {
        strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];
        return Z_BUF_ERROR;
      }

      if (status == FINISH_STATE && strm.avail_in !== 0) {
        _strm.msg = z_errmsg[Z_NEED_DICT - Z_BUF_ERROR];
        return Z_BUF_ERROR;
      }

      if (strm.avail_in !== 0 || lookahead !== 0 || flush != Z_NO_FLUSH && status != FINISH_STATE) {
        bstate = -1;

        switch (config_table[level].func) {
          case STORED:
            bstate = deflate_stored(flush);
            break;

          case FAST:
            bstate = deflate_fast(flush);
            break;

          case SLOW:
            bstate = deflate_slow(flush);
            break;
        }

        if (bstate == FinishStarted || bstate == FinishDone) {
          status = FINISH_STATE;
        }

        if (bstate == NeedMore || bstate == FinishStarted) {
          if (strm.avail_out === 0) {
            last_flush = -1;
          }

          return Z_OK;
        }

        if (bstate == BlockDone) {
          if (flush == Z_PARTIAL_FLUSH) {
            _tr_align();
          } else {
            _tr_stored_block(0, 0, false);

            if (flush == Z_FULL_FLUSH) {
              for (i = 0; i < hash_size; i++) {
                head[i] = 0;
              }
            }
          }

          strm.flush_pending();

          if (strm.avail_out === 0) {
            last_flush = -1;
            return Z_OK;
          }
        }
      }

      if (flush != Z_FINISH) return Z_OK;
      return Z_STREAM_END;
    };
  }

  function ZStream() {
    var that = this;
    that.next_in_index = 0;
    that.next_out_index = 0;
    that.avail_in = 0;
    that.total_in = 0;
    that.avail_out = 0;
    that.total_out = 0;
  }

  ZStream.prototype = {
    deflateInit: function deflateInit(level, bits) {
      var that = this;
      that.dstate = new Deflate();
      if (!bits) bits = MAX_BITS;
      return that.dstate.deflateInit(that, level, bits);
    },
    deflate: function deflate(flush) {
      var that = this;

      if (!that.dstate) {
        return Z_STREAM_ERROR;
      }

      return that.dstate.deflate(that, flush);
    },
    deflateEnd: function deflateEnd() {
      var that = this;
      if (!that.dstate) return Z_STREAM_ERROR;
      var ret = that.dstate.deflateEnd();
      that.dstate = null;
      return ret;
    },
    deflateParams: function deflateParams(level, strategy) {
      var that = this;
      if (!that.dstate) return Z_STREAM_ERROR;
      return that.dstate.deflateParams(that, level, strategy);
    },
    deflateSetDictionary: function deflateSetDictionary(dictionary, dictLength) {
      var that = this;
      if (!that.dstate) return Z_STREAM_ERROR;
      return that.dstate.deflateSetDictionary(that, dictionary, dictLength);
    },
    read_buf: function read_buf(buf, start, size) {
      var that = this;
      var len = that.avail_in;
      if (len > size) len = size;
      if (len === 0) return 0;
      that.avail_in -= len;
      buf.set(that.next_in.subarray(that.next_in_index, that.next_in_index + len), start);
      that.next_in_index += len;
      that.total_in += len;
      return len;
    },
    flush_pending: function flush_pending() {
      var that = this;
      var len = that.dstate.pending;
      if (len > that.avail_out) len = that.avail_out;
      if (len === 0) return;
      that.next_out.set(that.dstate.pending_buf.subarray(that.dstate.pending_out, that.dstate.pending_out + len), that.next_out_index);
      that.next_out_index += len;
      that.dstate.pending_out += len;
      that.total_out += len;
      that.avail_out -= len;
      that.dstate.pending -= len;

      if (that.dstate.pending === 0) {
        that.dstate.pending_out = 0;
      }
    }
  };

  function Deflater(options) {
    var that = this;
    var z = new ZStream();
    var bufsize = 512;
    var flush = Z_NO_FLUSH;
    var buf = new Uint8Array(bufsize);
    var level = options ? options.level : Z_DEFAULT_COMPRESSION;
    if (typeof level == "undefined") level = Z_DEFAULT_COMPRESSION;
    z.deflateInit(level);
    z.next_out = buf;

    that.append = function (data, onprogress) {
      var err,
          buffers = [],
          lastIndex = 0,
          bufferIndex = 0,
          bufferSize = 0,
          array;
      if (!data.length) return;
      z.next_in_index = 0;
      z.next_in = data;
      z.avail_in = data.length;

      do {
        z.next_out_index = 0;
        z.avail_out = bufsize;
        err = z.deflate(flush);
        if (err != Z_OK) throw new Error("deflating: " + z.msg);
        if (z.next_out_index) if (z.next_out_index == bufsize) buffers.push(new Uint8Array(buf));else buffers.push(new Uint8Array(buf.subarray(0, z.next_out_index)));
        bufferSize += z.next_out_index;

        if (onprogress && z.next_in_index > 0 && z.next_in_index != lastIndex) {
          onprogress(z.next_in_index);
          lastIndex = z.next_in_index;
        }
      } while (z.avail_in > 0 || z.avail_out === 0);

      array = new Uint8Array(bufferSize);
      buffers.forEach(function (chunk) {
        array.set(chunk, bufferIndex);
        bufferIndex += chunk.length;
      });
      return array;
    };

    that.flush = function () {
      var err,
          buffers = [],
          bufferIndex = 0,
          bufferSize = 0,
          array;

      do {
        z.next_out_index = 0;
        z.avail_out = bufsize;
        err = z.deflate(Z_FINISH);
        if (err != Z_STREAM_END && err != Z_OK) throw new Error("deflating: " + z.msg);
        if (bufsize - z.avail_out > 0) buffers.push(new Uint8Array(buf.subarray(0, z.next_out_index)));
        bufferSize += z.next_out_index;
      } while (z.avail_in > 0 || z.avail_out === 0);

      z.deflateEnd();
      array = new Uint8Array(bufferSize);
      buffers.forEach(function (chunk) {
        array.set(chunk, bufferIndex);
        bufferIndex += chunk.length;
      });
      return array;
    };
  }

  var env = global.zip || global;
  env.Deflater = env._jzlib_Deflater = Deflater;
})(zipExport);

var zip = zipExport.zip;

var Unzip = /*#__PURE__*/function () {
  function Unzip() {
    this.name = null;
    this.debug = false;
    this.entriesCb = null;
    this.failIfNotFound = true;
  }

  var _proto = Unzip.prototype;

  _proto.setDebug = function setDebug(debug) {
    this.debug = debug;
    return this;
  };

  _proto.setEntriesCallback = function setEntriesCallback(cb) {
    this.entriesCb = cb;
    return this;
  };

  _proto.setFailIfNotFound = function setFailIfNotFound(v) {
    this.failIfNotFound = v;
    return this;
  };

  _proto.getName = function getName() {
    return this.name;
  };

  _proto.unzipFiles = function unzipFiles(blob) {
    zip.useWebWorkers = false;
    return new Promise(function (success, failure) {
      var files = [];

      var entryProcessor = function entryProcessor(entries) {
        var count = entries.length;

        var doIt = function doIt(index) {
          if (index < count) {
            var entry = entries[index];
            entry.getData(new zip.BlobWriter(), function (blob) {
              files.push({
                name: entry.filename,
                content: blob
              });
              doIt(index + 1);
            });
          } else {
            success(files);
          }
        };

        doIt(0);
      };

      var blobReader = function blobReader(zipReader) {
        zipReader.getEntries(entryProcessor, failure);
      };

      zip.createReader(new zip.BlobReader(blob), blobReader, failure);
    });
  };

  _proto.extractEntry = function extractEntry(entry) {
    return new Promise(function (success, failure) {
      var writer = new zip.BlobWriter();
      entry.getData(writer, success);
    });
  };

  _proto.unzip = function unzip(file, exts, prefExts, scorer) {
    var _this = this;

    zip.useWebWorkers = false;
    var that = this;
    return new Promise(function (success, failure) {
      var entryProcessor = function entryProcessor(entries) {
        if (_this.entriesCb) {
          _this.entriesCb(entries);
        }

        var romEntry = null;

        if (entries.length == 1) {
          romEntry = entries[0];
        } else if (entries.length > 0) {
          var scores = {};

          for (var i = 0; i < entries.length; i++) {
            var entry = entries[i];
            var filename = entry.filename.toLowerCase();

            for (var _i = 0; _i < exts.length; _i++) {
              if (filename.endsWith(exts[_i])) {
                scores[entry.filename] = {
                  entry: entry,
                  lower: filename,
                  score: 0
                };

                if (prefExts !== undefined) {
                  for (var _i2 = 0; _i2 < prefExts.length; _i2++) {
                    if (filename.endsWith(prefExts[_i2])) {
                      if (_this.debug) {
                        info('Known ext, +1000: ' + entry.filename);
                      }

                      scores[entry.filename].score += 1000;
                    }
                  }
                }

                break;
              }
            }
          }

          if (scorer) scorer(scores, _this.debug);

          if (_this.debug) {
            info(scores);
          }

          var maxScore = -1;

          for (var fname in scores) {
            var score = scores[fname];

            if (score.score > maxScore) {
              if (_this.debug) {
                info('New max: ' + score.entry.filename);
              }

              romEntry = score.entry;
              maxScore = score.score;
            }
          }
        }

        if (romEntry) {
          that.name = romEntry.filename;
          var writer = new zip.BlobWriter();
          romEntry.getData(writer, success);
        } else {
          if (_this.failIfNotFound) {
            failure("Unable to find valid ROM in zip file");
          } else {
            success(null);
          }
        }
      };

      var blobReader = function blobReader(zipReader) {
        zipReader.getEntries(entryProcessor, failure);
      };

      zip.createReader(new zip.BlobReader(file), blobReader, function (failure) {
        if (_this.debug) {
          info(failure + ", processing as a non-zip");
        }

        success(file);
      });
    });
  };

  return Unzip;
}();
var romNameScorer = function romNameScorer(scores, debug) {
  var codes = {
    "[!]": {
      points: 100,
      isRegion: false
    },
    "(u)": {
      points: 50,
      isRegion: true
    },
    "(usa)": {
      points: 50,
      isRegion: true
    },
    "(ue)": {
      points: 45,
      isRegion: true
    },
    "(eu)": {
      points: 45,
      isRegion: true
    },
    "(uj)": {
      points: 45,
      isRegion: true
    },
    "(ju)": {
      points: 45,
      isRegion: true
    },
    "(e)": {
      points: 40,
      isRegion: true
    },
    "(j)": {
      points: 30,
      isRegion: true
    }
  };
  var regions = {};

  for (var fname in scores) {
    var score = scores[fname];

    for (var cname in codes) {
      var code = codes[cname];

      if (score.lower.indexOf(cname) != -1) {
        if (debug) {
          info('Adding ' + code.points + " to " + score.entry.filename);
        }

        score.score += code.points;

        if (code.isRegion) {
          var fnameList = regions[cname];

          if (!fnameList) {
            fnameList = [];
            regions[cname] = fnameList;
          }

          fnameList.push(score);
        }
      }
    }
  }

  if (debug) {
    info(regions);
  }

  for (var rname in regions) {
    var rscores = regions[rname];
    var minLength = 99999;
    var minScore = null;

    for (var i = 0; i < rscores.length; i++) {
      var _score = rscores[i];

      if (_score.lower.length < minLength) {
        minLength = _score.lower.length;
        minScore = _score;
      }
    }

    if (minScore) {
      minScore.score += 1;
    }
  }
};

var Zip = /*#__PURE__*/function () {
  function Zip() {}

  var _proto = Zip.prototype;

  _proto.zipFiles = function zipFiles(files) {
    zip.useWebWorkers = false;
    return new Promise(function (success, failure) {
      zip.createWriter(new zip.BlobWriter('application/zip'), function (writer) {
        var count = files.length;

        var doIt = function doIt(index) {
          if (index < count) {
            var f = files[index];
            writer.add(f.name, new zip.BlobReader(f.content), function () {
              doIt(index + 1);
            });
          } else {
            writer.close(function (blob) {
              success(blob);
            });
          }
        };

        doIt(0);
      }, failure);
    });
  };

  _proto.zip = function zip$1(blob, fileName) {
    zip.useWebWorkers = false;
    return new Promise(function (success, failure) {
      var blobWriter = function blobWriter(zipWriter) {
        zipWriter.add(fileName, new zip.BlobReader(blob), function () {
          zipWriter.close(function (blob) {
            success(blob);
          });
        });
      };

      zip.createWriter(new zip.BlobWriter('application/zip'), blobWriter, failure);
    });
  };

  return Zip;
}();

var INFO_NAME = "info.txt";
var STATE_NAME = "state";
var STATE_SLOTS = 8;

var SaveManager = /*#__PURE__*/function () {
  function SaveManager(wrapper, errorCallback) {
    this.appWrapper = wrapper;
    this.cloudEnabled = null;
    this.errorCallback = errorCallback;
    this.lastHashes = {};
    this.gameSavesDisabled = false;
  }

  var _proto = SaveManager.prototype;

  _proto._compareHashes = function _compareHashes(a, b) {
    if (Object.keys(a).length !== Object.keys(b).length) {
      return false;
    }

    for (var key in a) {
      var vala = a[key];
      var valb = b[key];

      if (vala !== valb) {
        return false;
      }
    }

    return true;
  };

  _proto.setDisableGameSaveOnStateLoad = function setDisableGameSaveOnStateLoad(val) {};

  _proto.checkFilesChanged = function checkFilesChanged(files) {
    try {
      var _temp3 = function _temp3() {
        if (!_this2._compareHashes(hashes, _this2.lastHashes)) {
          _this2.lastHashes = hashes;
          return true;
        }

        return false;
      };

      var _this2 = this;

      var hashes = {};

      var _temp4 = _forTo(files, function (i) {
        var f = files[i];
        var name = f.name;

        if (name === INFO_NAME) {
          return;
        }

        var blob = f.content;

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob]);
        }

        return Promise.resolve(blobToStr(blob)).then(function (_blobToStr) {
          var hash = md5(_blobToStr);
          hashes[name] = hash;
        });
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.isCloudEnabled = function isCloudEnabled(callback) {
    try {
      var _temp8 = function _temp8() {
        return _this4.cloudEnabled;
      };

      var _this4 = this;

      var _temp9 = function () {
        if (_this4.cloudEnabled === null) {
          _this4.cloudEnabled = false;

          var _temp10 = function () {
            if (settings.isCloudStorageEnabled()) {
              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_CHECKING));
              return Promise.resolve(dropbox.testWrite()).then(function (_dropbox$testWrite) {
                _this4.cloudEnabled = _dropbox$testWrite;

                if (!_this4.cloudEnabled && _this4.errorCallback) {
                  _this4.errorCallback(Resources.getText(TEXT_IDS.CLOUD_SAVES_DISABLED));
                }
              });
            }
          }();

          if (_temp10 && _temp10.then) return _temp10.then(function () {});
        }
      }();

      return Promise.resolve(_temp9 && _temp9.then ? _temp9.then(_temp8) : _temp8(_temp9));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.createZip = function createZip(files) {
    try {
      var _this6 = this;

      var zip = new Zip();
      var zipFiles = [];

      for (var _i = 0; _i < files.length; _i++) {
        var f = files[_i];
        var _b = f.content;

        if (!(_b instanceof Blob)) {
          _b = new Blob([_b]);
        }

        if (f.name !== INFO_NAME) {
          zipFiles.push({
            name: f.name,
            content: _b
          });
        }
      }

      zipFiles.push({
        name: INFO_NAME,
        content: new Blob([JSON.stringify({
          title: _this6.appWrapper.getTitle(),
          time: new Date().getTime()
        })])
      });
      return Promise.resolve(zip.zipFiles(zipFiles));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFiles = function getFiles(blob) {
    try {
      if (!(blob instanceof Blob)) {
        blob = new Blob([b]);
      }

      var unzip = new Unzip();
      return Promise.resolve(unzip.unzipFiles(blob)).then(function (files) {
        var _temp11 = _forTo(files, function (i) {
          var f = files[i];
          return Promise.resolve(f.content.arrayBuffer()).then(function (_f$content$arrayBuffe) {
            f.content = new Uint8Array(_f$content$arrayBuffe);
          });
        });

        return _temp11 && _temp11.then ? _temp11.then(function () {
          return files;
        }) : files;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getZipFileName = function getZipFileName(path) {
    return path.endsWith(".zip") ? path : path + ".zip";
  };

  _proto.load = function load(path, callback) {
    try {
      var _this8 = this;

      if (_this8.gameSavesDisabled) {
        info("Game-based saves are disabled (state was loaded).");
        return Promise.resolve(null);
      }

      return Promise.resolve(_finallyRethrows(function () {
        return Promise.resolve(_this8.isCloudEnabled(callback)).then(function (_this7$isCloudEnabled) {
          var _exit = false;

          if (_this7$isCloudEnabled) {
            var _temp15 = function _temp15(_result2) {
              if (_exit) return _result2;
              info("Did not find save in the cloud, looking locally.");
              return Promise.resolve(_this8.loadLocal(path)).then(function (files) {
                var _exit2 = false;

                var _temp12 = function () {
                  if (files) {
                    info("Found locally.");
                    return Promise.resolve(_this8.save(path, files, callback)).then(function () {
                      _exit2 = true;
                      return files;
                    });
                  }
                }();

                return _temp12 && _temp12.then ? _temp12.then(function (_result3) {
                  return _exit2 ? _result3 : null;
                }) : _exit2 ? _temp12 : null;
              });
            };

            var _temp16 = _catch(function () {
              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_CHECKING));
              return Promise.resolve(_this8.loadCloud(path)).then(function (_await$_this7$loadClo) {
                _exit = true;
                return _await$_this7$loadClo;
              });
            }, function (e) {
              error("Error loading save from cloud: " + e);
            });

            return _temp16 && _temp16.then ? _temp16.then(_temp15) : _temp15(_temp16);
          } else {
            return Promise.resolve(_this8.loadLocal(path));
          }
        });
      }, function (_wasThrown, _result) {
        if (callback) callback(null);
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.save = function save(path, files, callback) {
    try {
      var _this10 = this;

      if (_this10.gameSavesDisabled) {
        info("Game-based saves are disabled (state was loaded).");
        return Promise.resolve();
      }

      return Promise.resolve(_finallyRethrows(function () {
        return Promise.resolve(_this10.isCloudEnabled(callback)).then(function (_this9$isCloudEnabled) {
          if (_this9$isCloudEnabled) {
            var _temp18 = _catch(function () {
              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_SAVE));
              return Promise.resolve(_this10.saveCloud(path, files)).then(function (success) {
                if (success) {
                  if (storage.remove(_this10.getZipFileName(path))) {
                    info("Successfully saved to the cloud, deleting local files.");
                  }
                }
              });
            }, function (e) {
              error("Error persisting save to cloud: " + e);
            });

            return _temp18 && _temp18.then ? _temp18.then(function () {
              return false;
            }) : false;
          } else {
            return Promise.resolve(_this10.saveLocal(path, files));
          }
        });
      }, function (_wasThrown2, _result4) {
        if (callback) callback(null);
        if (_wasThrown2) throw _result4;
        return _result4;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto["delete"] = function _delete(path, callback) {
    try {
      var _this12 = this;

      return Promise.resolve(_finallyRethrows(function () {
        var zipPath = _this12.getZipFileName(path);

        return Promise.resolve(_this12.isCloudEnabled(callback)).then(function (_this11$isCloudEnable) {
          var _exit3 = false;

          if (_this11$isCloudEnable) {
            var _temp20 = _catch(function () {
              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_SAVE));
              return Promise.resolve(dropbox.deleteFile(zipPath)).then(function (_await$dropbox$delete) {
                _exit3 = true;
                return _await$dropbox$delete;
              });
            }, function (e) {
              error("Error deleting save from cloud: " + e);
            });

            return _temp20 && _temp20.then ? _temp20.then(function (_result6) {
              return _exit3 ? _result6 : false;
            }) : _exit3 ? _temp20 : false;
          } else {
            return Promise.resolve(storage.remove(zipPath));
          }
        });
      }, function (_wasThrown3, _result5) {
        if (callback) callback(null);
        if (_wasThrown3) throw _result5;
        return _result5;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getStateSlots = function getStateSlots(pathPrefix, callback) {
    try {
      var _this14 = this;

      var slots = new Array(STATE_SLOTS + 1);
      return Promise.resolve(_finallyRethrows(function () {
        return Promise.resolve(_this14.isCloudEnabled(callback)).then(function (_this13$isCloudEnable) {
          return function () {
            if (_this13$isCloudEnable) {
              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_CHECKING));
              var _i2 = 1;

              var _temp23 = _for(function () {
                return _i2 <= STATE_SLOTS;
              }, function () {
                return _i2++;
              }, function () {
                var path = pathPrefix + "state." + _i2 + ".json";

                var _temp21 = _catch(function () {
                  return Promise.resolve(_this14.loadCloudSingleFile(path)).then(function (json) {
                    return Promise.resolve(json.text()).then(function (_json$text) {
                      slots[_i2] = JSON.parse(_json$text);
                    });
                  });
                }, function (e) {
                  error("Error getting save slot info, " + path + ": " + e);
                });

                if (_temp21 && _temp21.then) return _temp21.then(function () {});
              });

              return _temp23 && _temp23.then ? _temp23.then(function () {
                return slots;
              }) : slots;
            }
          }();
        });
      }, function (_wasThrown4, _result7) {
        if (callback) callback(null);
        if (_wasThrown4) throw _result7;
        return _result7;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveState = function saveState(pathPrefix, slot, state, canvas, callback, shot, imageProps, otherProps) {
    if (otherProps === void 0) {
      otherProps = {};
    }

    try {
      var _this16 = this;

      var _temp27 = _finallyRethrows(function () {
        imageProps = imageProps ? imageProps : {};
        var path = pathPrefix + "state." + slot;
        var pathMeta = path + ".json";
        var files = [{
          name: STATE_NAME,
          content: state
        }];
        return Promise.resolve(_this16.isCloudEnabled(callback)).then(function (_this15$isCloudEnable) {
          var _temp25 = function () {
            if (_this15$isCloudEnable) {
              var _temp28 = _catch(function () {
                if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_SAVE));
                return Promise.resolve(_this16.deleteState(pathPrefix, slot, null)).then(function () {
                  return Promise.resolve(_this16.saveCloud(path, files)).then(function () {
                    return Promise.resolve(_this16.saveCloudSingleFile(pathMeta, JSON.stringify(_extends({
                      time: new Date().getTime(),
                      shot: shot ? shot : canvas ? canvas.toDataURL() : null,
                      imageProps: imageProps
                    }, otherProps)))).then(function () {});
                  });
                });
              }, function (e) {
                error("Error persisting state to cloud: " + e);

                if (_this16.errorCallback) {
                  _this16.errorCallback(Resources.getText(TEXT_IDS.CLOUD_SAVE_STATE_ERROR));
                }
              });

              if (_temp28 && _temp28.then) return _temp28.then(function () {});
            }
          }();

          if (_temp25 && _temp25.then) return _temp25.then(function () {});
        });
      }, function (_wasThrown5, _result9) {
        if (callback) callback(null);
        if (_wasThrown5) throw _result9;
        return _result9;
      });

      return Promise.resolve(_temp27 && _temp27.then ? _temp27.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadState = function loadState(pathPrefix, slot, callback) {
    try {
      var _this18 = this;

      return Promise.resolve(_finallyRethrows(function () {
        var path = pathPrefix + "state." + slot;
        return Promise.resolve(_this18.isCloudEnabled(callback)).then(function (_this17$isCloudEnable) {
          var _exit4 = false;
          return function () {
            if (_this17$isCloudEnable) {
              var _temp30 = _catch(function () {
                if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_LOAD));
                return Promise.resolve(_this18.loadCloud(path)).then(function (files) {
                  for (var i = 0; i < files.length; i++) {
                    var f = files[i];

                    if (f.name == STATE_NAME) {
                      if (!_this18.gameSavesDisabled && settings.isGameSavesDisabledAfterState()) {
                        _this18.gameSavesDisabled = true;
                        info("Save state was loaded, game-based saves are disabled.");
                      }

                      var _f$content2 = f.content;
                      _exit4 = true;
                      return _f$content2;
                    }
                  }
                });
              }, function (e) {
                error("Error loading save state from cloud: " + e);

                if (_this18.errorCallback) {
                  _this18.errorCallback(Resources.getText(TEXT_IDS.CLOUD_LOAD_STATE_ERROR));
                }
              });

              return _temp30 && _temp30.then ? _temp30.then(function (_result11) {
                return _exit4 ? _result11 : null;
              }) : _exit4 ? _temp30 : null;
            }
          }();
        });
      }, function (_wasThrown6, _result10) {
        if (callback) callback(null);
        if (_wasThrown6) throw _result10;
        return _result10;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.deleteState = function deleteState(pathPrefix, slot, callback) {
    try {
      var _this20 = this;

      var _temp36 = _finallyRethrows(function () {
        var path = pathPrefix + "state." + slot;
        var pathMeta = path + ".json";
        return Promise.resolve(_this20.isCloudEnabled(callback)).then(function (_this19$isCloudEnable) {
          var _temp34 = function () {
            if (_this19$isCloudEnable) {
              var _temp37 = function _temp37() {
                var _temp31 = _catch(function () {
                  return Promise.resolve(_this20.deleteCloudSingleFile(pathMeta)).then(function () {});
                }, function () {});

                if (_temp31 && _temp31.then) return _temp31.then(function () {});
              };

              if (callback) callback(Resources.getText(TEXT_IDS.CLOUD_DELETING));

              var _temp38 = _catch(function () {
                return Promise.resolve(_this20["delete"](path, null)).then(function () {});
              }, function () {});

              return _temp38 && _temp38.then ? _temp38.then(_temp37) : _temp37(_temp38);
            }
          }();

          if (_temp34 && _temp34.then) return _temp34.then(function () {});
        });
      }, function (_wasThrown7, _result13) {
        if (callback) callback(null);
        if (_wasThrown7) throw _result13;
        return _result13;
      });

      return Promise.resolve(_temp36 && _temp36.then ? _temp36.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadLocal = function loadLocal(path) {
    try {
      var _this22 = this;

      info("Loading save locally: " + path);

      var zipPath = _this22.getZipFileName(path);

      return Promise.resolve(storage.get(zipPath)).then(function (zip) {
        return zip ? Promise.resolve(_this22.getFiles(zip)) : null;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveLocal = function saveLocal(path, files) {
    try {
      var _this24 = this;

      info("Saving save locally: " + path);
      return Promise.resolve(_this24.createZip(files)).then(function (zip) {
        var zipPath = _this24.getZipFileName(path);

        return Promise.resolve(storage.put(zipPath, zip)).then(function () {});
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadCloud = function loadCloud(path) {
    try {
      var _this26 = this;

      info("Loading save from cloud: " + path);

      var zipPath = _this26.getZipFileName(path);

      return Promise.resolve(dropbox.downloadFile(zipPath)).then(function (zip) {
        return Promise.resolve(_this26.getFiles(zip));
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveCloud = function saveCloud(path, files) {
    try {
      var _this28 = this;

      info("Saving save to cloud: " + path);
      return Promise.resolve(_this28.createZip(files)).then(function (zip) {
        var zipPath = _this28.getZipFileName(path);

        return _catch(function () {
          return Promise.resolve(dropbox.uploadFile(zip, zipPath));
        }, function (e) {
          if (_this28.errorCallback) {
            _this28.errorCallback(Resources.getText(TEXT_IDS.CLOUD_SAVE_ERROR));
          }

          throw e;
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.saveCloudSingleFile = function saveCloudSingleFile(path, content) {
    try {
      var _this30 = this;

      info("Saving to cloud: " + path);
      return Promise.resolve(_catch(function () {
        return Promise.resolve(dropbox.uploadFile(content, path));
      }, function (e) {
        if (_this30.errorCallback) {
          _this30.errorCallback(Resources.getText(TEXT_IDS.CLOUD_SAVE_ERROR));
        }

        throw e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadCloudSingleFile = function loadCloudSingleFile(path) {
    try {
      info("Loading from cloud: " + path);
      return Promise.resolve(dropbox.downloadFile(path));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.deleteCloudSingleFile = function deleteCloudSingleFile(path) {
    try {
      var _this32 = this;

      info("Deleting from cloud: " + path);
      return Promise.resolve(_catch(function () {
        return Promise.resolve(dropbox.deleteFile(path)).then(function () {});
      }, function (e) {
        if (_this32.errorCallback) {
          _this32.errorCallback(Resources.getText(TEXT_IDS.CLOUD_SAVE_ERROR));
        }

        throw e;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return SaveManager;
}();

var SCREEN_CONTROLS = {
  SC_AUTO: "auto",
  SC_ON: "on",
  SC_OFF: "off"
};
var AppPrefs = /*#__PURE__*/function (_BaseSettings) {
  _inheritsLoose(AppPrefs, _BaseSettings);

  function AppPrefs(emu) {
    var _this;

    _this = _BaseSettings.call(this, emu.getStorage()) || this;
    _this.PREFS_PREFIX = 'prefs';
    _this.emu = emu;
    var app = emu.getApp();
    _this.bilinearPath = app.getStoragePath(_this.PREFS_PREFIX + ".forceBilinear");
    _this.screenSizePath = app.getStoragePath(_this.PREFS_PREFIX + ".screenSize");
    _this.screenControlsPath = app.getStoragePath(_this.PREFS_PREFIX + ".screenControls");
    _this.bilinearEnabled = false;
    _this.screenSize = SCREEN_SIZES.SS_DEFAULT;
    _this.screenControls = SCREEN_CONTROLS.SC_AUTO;
    return _this;
  }

  var _proto = AppPrefs.prototype;

  _proto.load = function load() {
    try {
      var _this3 = this;

      return Promise.resolve(_BaseSettings.prototype.loadBool.call(_this3, _this3.bilinearPath, _this3.bilinearEnabled)).then(function (_BaseSettings$prototy) {
        _this3.bilinearEnabled = _BaseSettings$prototy;
        return Promise.resolve(_BaseSettings.prototype.loadValue.call(_this3, _this3.screenSizePath, _this3.screenSize)).then(function (_BaseSettings$prototy2) {
          _this3.screenSize = _BaseSettings$prototy2;
          return Promise.resolve(_BaseSettings.prototype.loadValue.call(_this3, _this3.screenControlsPath, _this3.screenControls)).then(function (_BaseSettings$prototy3) {
            _this3.screenControls = _BaseSettings$prototy3;
          });
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.save = function save() {
    try {
      var _this5 = this;

      return Promise.resolve(_BaseSettings.prototype.saveBool.call(_this5, _this5.bilinearPath, _this5.bilinearEnabled)).then(function () {
        return Promise.resolve(_BaseSettings.prototype.saveValue.call(_this5, _this5.screenSizePath, _this5.screenSize)).then(function () {
          return Promise.resolve(_BaseSettings.prototype.saveValue.call(_this5, _this5.screenControlsPath, _this5.screenControls)).then(function () {});
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.isBilinearEnabled = function isBilinearEnabled() {
    return this.bilinearEnabled;
  };

  _proto.setBilinearEnabled = function setBilinearEnabled(enabled) {
    this.bilinearEnabled = enabled;
  };

  _proto.getScreenSize = function getScreenSize() {
    return this.screenSize;
  };

  _proto.setScreenSize = function setScreenSize(size) {
    this.screenSize = size;
  };

  _proto.getScreenControls = function getScreenControls() {
    return this.screenControls;
  };

  _proto.setScreenControls = function setScreenControls(value) {
    this.screenControls = value;
  };

  return AppPrefs;
}(BaseSettings);

var AppWrapper = /*#__PURE__*/function () {
  function AppWrapper(app, debug) {
    var _this = this;

    if (debug === void 0) {
      debug = false;
    }

    this.DEFAULT_MAX_EXTRACT_SIZE = 2 * 1024 * 1024 * 1024;
    this.SS_NATIVE = SCREEN_SIZES.SS_NATIVE;
    this.SS_DEFAULT = SCREEN_SIZES.SS_DEFAULT;
    this.SS_16_9 = SCREEN_SIZES.SS_16_9;
    this.SS_FILL = SCREEN_SIZES.SS_FILL;
    this.app = app;
    this.started = false;
    this.debug = debug;
    this.paused = false;
    this.canvas = null;
    this.touchListener = null;
    this.displayLoop = null;
    this.showPauseDelay = 0;
    this.showMessageEnabled = false;
    this.message = null;
    this.saveManager = new SaveManager(this, this.getShowMessageCallback());
    this.controllers = this.createControllers();
    this.storage = this.createStorage();
    this.prefs = this.createPrefs();
    this.visibilityMonitor = this.createVisibilityMonitor();
    this.audioProcessor = this.createAudioProcessor();

    if (this.audioProcessor) {
      this.addAudioProcessorCallback(this.audioProcessor);
    }

    this.saveMessageCallback = function (message) {
      _this.setShowPauseDelay(300);

      app.setStatusMessage(message);
    };

    this.loadMessageCallback = function (message) {
      app.setStatusMessage(message);
    };
  }

  var _proto = AppWrapper.prototype;

  _proto.isBilinearFilterEnabled = function isBilinearFilterEnabled() {
    return settings.isBilinearFilterEnabled() || this.prefs.isBilinearEnabled();
  };

  _proto.updateBilinearFilter = function updateBilinearFilter() {
    var enabled = this.isBilinearFilterEnabled();
    this.canvas.style.setProperty("image-rendering", enabled ? 'auto' : 'pixelated', "important");
  };

  _proto.getScreenSize = function getScreenSize() {
    var size = this.prefs.getScreenSize();
    return size === SCREEN_SIZES.SS_DEFAULT ? settings.getScreenSize() : size;
  };

  _proto.isScreenRotated = function isScreenRotated() {
    return false;
  };

  _proto.isScreenFill = function isScreenFill() {
    return false;
  };

  _proto.updateOnScreenControls = function updateOnScreenControls(initial) {
  };

  _proto.updateScreenSize = function updateScreenSize() {
    var fill = this.isScreenFill();
    var ar = this.getDefaultAspectRatio();
    var ss = this.getScreenSize();
    var canvas = this.canvas;
    var rotated = this.isScreenRotated();

    if (ss === SCREEN_SIZES.SS_16_9) {
      ar = 16 / 9;

      if (rotated) {
        ar = 1 / ar;
      }
    }

    if (ss === SCREEN_SIZES.SS_FILL) {
      ar = 1;
      fill = true;
    }

    if (ar !== 0) {
      var zoomLevel = 0;

      if (this.getProps().zoomLevel) {
        zoomLevel = this.getProps().zoomLevel;
      }

      var size = 96 + zoomLevel;

      if (rotated) {
        canvas.style.setProperty('width', size + "vh", 'important');
        canvas.style.setProperty('height', size + "vw", 'important');
      } else {
        canvas.style.setProperty('width', size + "vw", 'important');
        canvas.style.setProperty('height', size + "vh", 'important');
      }

      if (fill) {
        if (rotated) {
          canvas.style.setProperty('max-width', size + "vh", 'important');
          canvas.style.setProperty('max-height', size + "vw", 'important');
        } else {
          canvas.style.setProperty('max-width', size + "vw", 'important');
          canvas.style.setProperty('max-height', size + "vh", 'important');
        }
      } else {
        if (rotated) {
          canvas.style.setProperty('max-width', "calc(" + size + "vw*" + ar + ")", 'important');
          canvas.style.setProperty('max-height', "calc(" + size + "vh*" + 1 / ar + ")", 'important');
        } else {
          canvas.style.setProperty('max-width', "calc(" + size + "vh*" + ar + ")", 'important');
          canvas.style.setProperty('max-height', "calc(" + size + "vw*" + 1 / ar + ")", 'important');
        }
      }
    }
  };

  _proto.createPrefs = function createPrefs() {
    return new AppPrefs(this);
  };

  _proto.getPrefs = function getPrefs() {
    return this.prefs;
  };

  _proto.getDefaultAspectRatio = function getDefaultAspectRatio() {
    return 0;
  };

  _proto.setShowMessageEnabled = function setShowMessageEnabled(b) {
    this.showMessageEnabled = b;
    var message = this.message;
    this.message = null;

    if (message) {
      setTimeout(function () {
        showMessage(message);
      }, 0);
    }
  };

  _proto.showErrorMessage = function showErrorMessage(error) {
    if (this.showMessageEnabled) {
      showMessage(error);
    } else {
      this.message = error;
    }
  };

  _proto.getShowMessageCallback = function getShowMessageCallback() {
    var _this2 = this;

    return function (error) {
      _this2.showErrorMessage(error);
    };
  };

  _proto.getProps = function getProps() {
    return this.app.appProps;
  };

  _proto.getApp = function getApp() {
    return this.app;
  };

  _proto.getTitle = function getTitle() {
    return this.getProps().title;
  };

  _proto.getStorage = function getStorage() {
    return this.storage;
  };

  _proto.getSaveManager = function getSaveManager() {
    return this.saveManager;
  };

  _proto.saveStateToStorage = function saveStateToStorage(path, buffer, info) {
    if (info === void 0) {
      info = true;
    }

    try {
      var _temp4 = function _temp4() {
        var _temp = function () {
          if (info) {
            return Promise.resolve(storage.put(path + "/info", {
              title: _this4.getTitle(),
              time: new Date().getTime()
            })).then(function () {});
          }
        }();

        if (_temp && _temp.then) return _temp.then(function () {});
      };

      var _this4 = this;

      var storage = _this4.storage;

      var _temp5 = function () {
        if (buffer) {
          return Promise.resolve(storage.put(path, buffer)).then(function () {});
        }
      }();

      return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp4) : _temp4(_temp5));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.createControllers = function createControllers() {
    return new Controllers([new Controller(new DefaultKeyCodeToControlMapping()), new Controller()]);
  };

  _proto.createStorage = function createStorage() {
    return new Storage();
  };

  _proto.createTouchListener = function createTouchListener() {
    var _this5 = this;

    var app = this.app;
    return new TouchEndListener(function () {
      if (!app.isShowOverlay() && _this5.pause(true)) {
        setTimeout(function () {
          return _this5.showPauseMenu();
        }, 50);
      }
    });
  };

  _proto.createVisibilityMonitor = function createVisibilityMonitor() {
    var _this6 = this;

    var app = this.app;
    return new VisibilityChangeMonitor(function (p) {
      if (!app.isPauseScreen()) {
        _this6.pause(p);
      }
    });
  };

  _proto.createAudioProcessor = function createAudioProcessor() {
    return new ScriptAudioProcessor().setDebug(this.debug);
  };

  _proto.addAudioProcessorCallback = function addAudioProcessorCallback(processor) {
    if (!processor) return;
    var app = this.app;
    processor.setCallback(function (running) {
      setTimeout(function () {
        return app.setShowOverlay(!running);
      }, 50);
    });
  };

  _proto.onPause = function onPause(p) {};

  _proto.setShowPauseDelay = function setShowPauseDelay(delay) {
    this.showPauseDelay = delay;
  };

  _proto.onShowPauseMenu = function onShowPauseMenu() {
    return Promise.resolve();
  };

  _proto.onStart = function onStart(canvas) {
    return Promise.resolve();
  };

  _proto.showPauseMenu = function showPauseMenu() {
    var _this7 = this;

    var app = this.app,
        controllers = this.controllers;

    if (controllers) {
      controllers.setEnabled(false);
    }

    this.onShowPauseMenu().then(function () {
      setTimeout(function () {
        _this7.showPauseDelay = 0;
        app.pause(function () {
          if (controllers) {
            controllers.setEnabled(true);
          }

          _this7.pause(false, true);
        });
      }, _this7.showPauseDelay);
    })["catch"](function (e) {
      return error(e);
    });
  };

  _proto.pause = function pause(p, isMenu) {
    var audioProcessor = this.audioProcessor,
        displayLoop = this.displayLoop;

    if (p && !this.paused || !p && this.paused) {
      this.paused = p;
      if (displayLoop) displayLoop.pause(p);
      if (audioProcessor) audioProcessor.pause(p);
      this.onPause(p, isMenu === true);
      return true;
    }

    return false;
  };

  _proto.start = function start(canvas) {
    try {
      var _this9 = this;

      if (_this9.started) return Promise.resolve();
      _this9.started = true;
      _this9.canvas = canvas;

      if (canvas) {
        hideInactiveMouse(canvas);
      }

      return Promise.resolve(_this9.prefs.load()).then(function () {
        _this9.updateBilinearFilter();

        _this9.updateScreenSize();

        _this9.updateOnScreenControls(true);

        return Promise.resolve(_this9.onStart(canvas)).then(function () {
          setTimeout(function () {
            _this9.touchListener = _this9.createTouchListener();
          }, 100);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.extractArchive = function extractArchive(FS, contentDir, bytes, maxExtractSize, callback) {
    try {
      var BrowserFS = window.BrowserFS;
      var myZipFs = new BrowserFS.FileSystem.ZipFS(new Buffer(bytes));

      try {
        FS.mkdir(contentDir);
      } catch (e) {
        info("## Error making directory, it may already exist: " + contentDir);
      }

      var size = 0;

      var recurse = function recurse(path, files, cb) {
        for (var i = 0; i < files.length; i++) {
          var f = path + files[i];
          var stats = myZipFs.statSync(f, true);
          var isDir = stats.isDirectory();

          if (isDir) {
            cb(true, f, stats);
            recurse(f + "/", myZipFs.readdirSync(f), cb);
          } else {
            cb(false, f, stats);
          }
        }
      };

      recurse("/", myZipFs.readdirSync("/"), function (isDir, f, stats) {
        if (callback) callback.onArchiveFile(isDir, contentDir + f);

        if (!isDir) {
          size += stats.size;
        }
      });
      if (callback) callback.onArchiveFilesFinished();

      if (size < maxExtractSize) {
        console.log("EXTRACTING FILES.");
        recurse("/", myZipFs.readdirSync("/"), function (isDir, f, stats) {
          var path = contentDir + f;

          if (isDir) {
            try {
              FS.mkdir(path);
            } catch (e) {
              info("## Error making directory, it may already exist: " + path);
            }
          } else {
            var data = myZipFs.readFileSync(f, null, FileFlag.getFileFlag("r"));
            var stream = FS.open(path, 'a');
            console.log("write: " + path);
            FS.write(stream, data, 0, data.length, 0, true);
            FS.close(stream);
            data = null;
          }
        });
      } else {
        console.log("USING ZIP.");
        var MFS = new BrowserFS.FileSystem.MountableFileSystem();
        MFS.mount(contentDir, myZipFs);
        BrowserFS.initialize(MFS);
        var BFS = new BrowserFS.EmscriptenFS();
        FS.mount(BFS, {
          root: contentDir + "/"
        }, contentDir + "/");
      }

      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.wait = function wait(time) {
    return new Promise(function (resolve, reject) {
      setTimeout(function () {
        resolve();
      }, time);
    });
  };

  return AppWrapper;
}();

var GamepadEnum = {
  UP: 'up',
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  LBUMP: 'lbump',
  RBUMP: 'rbump',
  START: 'start',
  A: 'a',
  ESC: 'esc',
  R_UP: 'r_up',
  R_DOWN: 'r_down',
  R_LEFT: 'r_left',
  R_RIGHT: 'r_right',
  R_ANALOG_X: 'r_analog_x',
  R_ANALOG_Y: 'r_analog_y',
  L_ANALOG_X: 'l_analog_x',
  L_ANALOG_Y: 'l_analog_y'
};

var GamepadNotifier = /*#__PURE__*/function () {
  function GamepadNotifier() {
    var _this = this;

    this.FIRST_POLL_DELAY = 100;
    this.NULL_BUTTON = {
      pressed: false
    };

    this.pollGamepads = function () {
      var running = _this.running,
          FIRST_POLL_DELAY = _this.FIRST_POLL_DELAY,
          mapping = _this.mapping,
          buttons = _this.buttons,
          NULL_BUTTON = _this.NULL_BUTTON;
      var gamepads = navigator.getGamepads ? navigator.getGamepads() : navigator.webkitGetGamepads ? navigator.webkitGetGamepads : [];
      var pCount = 0;

      for (var i = 0; i < gamepads.length; i++) {
        if (gamepads[i]) pCount++;
      }

      _this.padCount = pCount;

      if (pCount === 0) {
        gamepads = [{
          buttons: []
        }];
      }

      var firstPoll = false;

      if (_this.firstPollDelayEnd !== 0) {
        if (_this.firstPollDelayEnd === -1) {
          firstPoll = true;
          _this.firstPollDelayEnd = Date.now() + FIRST_POLL_DELAY;
        } else if (Date.now() < _this.firstPollDelayEnd) {
          firstPoll = true;
        } else {
          _this.firstPollDelayEnd = 0;
        }
      }

      var hit = false;

      for (var _i = 0; _i < gamepads.length && !hit; _i++) {
        var gamepadIndex = _i;

        if (gamepads[_i]) {
          var padDown = _this.padDown;
          var pad = gamepads[_i];

          if (pad.buttons) {
            hit = true;

            for (var _i2 = 0; _i2 < buttons.length; _i2++) {
              if (_i2 < pad.buttons.length) {
                buttons[_i2] = pad.buttons[_i2];
              } else {
                buttons[_i2] = NULL_BUTTON;
              }
            }

            if (buttons[mapping.getButtonNum(CIDS.LTRIG)].pressed && (buttons[mapping.getButtonNum(CIDS.START)].pressed || buttons[mapping.getButtonNum(CIDS.SELECT)].pressed || buttons[mapping.getButtonNum(CIDS.RANALOG)].pressed || buttons[mapping.getButtonNum(CIDS.LANALOG)].pressed) || buttons[mapping.getButtonNum(CIDS.SELECT)].pressed && buttons[mapping.getButtonNum(CIDS.X)].pressed) {
              if (!padDown && !firstPoll && _this.escapePressed === false) {
                _this.escapePressed = true;
                _this.escapePressedIndex = gamepadIndex;
              }
            } else if (_this.escapePressed == true && (buttons[mapping.getButtonNum(CIDS.LTRIG)].pressed || buttons[mapping.getButtonNum(CIDS.RANALOG)].pressed || buttons[mapping.getButtonNum(CIDS.LANALOG)].pressed || buttons[mapping.getButtonNum(CIDS.X)].pressed || buttons[mapping.getButtonNum(CIDS.SELECT)].pressed || buttons[mapping.getButtonNum(CIDS.START)].pressed)) ; else if (buttons[mapping.getButtonNum(CIDS.UP)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.UP, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.DOWN)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.DOWN, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.LEFT)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.LEFT, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.RIGHT)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.RIGHT, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.LBUMP)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.LBUMP, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.RBUMP)].pressed) {
              if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.RBUMP, gamepadIndex);
            } else if (buttons[mapping.getButtonNum(CIDS.A)].pressed) {
              if (_this.immediateA) {
                if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.A, gamepadIndex);
              } else {
                if (!padDown && !firstPoll && _this.aPressed === false) {
                  _this.aPressed = true;
                  _this.aPressedIndex = gamepadIndex;
                }
              }
            } else if (buttons[mapping.getButtonNum(CIDS.START)].pressed) {
              if (!padDown && !firstPoll && _this.startPressed === false) {
                _this.startPressed = true;
                _this.startPressedIndex = gamepadIndex;
              }
            } else {
              hit = false;

              if (_this.escapePressed !== false) {
                if (_this.escapePressedIndex === gamepadIndex) {
                  if (_this.escapePressed === true) {
                    _this.fireEvent(GamepadEnum.ESC, _this.escapePressedIndex);
                  }

                  _this.escapePressed = false;
                }
              }

              if (_this.aPressed !== false) {
                if (_this.aPressedIndex === gamepadIndex) {
                  if (_this.aPressed === true) {
                    _this.fireEvent(GamepadEnum.A, _this.aPressedIndex);
                  }

                  _this.aPressed = false;
                }
              }

              if (_this.startPressed !== false) {
                if (_this.startPressedIndex === gamepadIndex) {
                  if (_this.startPressed === true) {
                    _this.fireEvent(GamepadEnum.START, _this.startPressedIndex);
                  }

                  _this.startPressed = false;
                }
              }
            }
          }

          var axes = pad.axes;

          if (axes) {
            var time = Date.now();
            var fireAnalog = time >= _this.nextAnalog;

            if (fireAnalog) {
              _this.nextAnalog += _this.analogStep;

              if (time >= _this.nextAnalog) {
                _this.nextAnalog = time + _this.analogStep;
              }
            }

            if (axes.length >= 2) {
              var valx = axes[0],
                  valy = axes[1];

              if (fireAnalog) {
                _this.fireAnalogEvent(GamepadEnum.L_ANALOG_X, valx);

                _this.fireAnalogEvent(GamepadEnum.L_ANALOG_Y, valy);
              }

              if (!hit) {
                hit = true;

                if (valy < -0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.UP, gamepadIndex);
                } else if (valy > 0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.DOWN, gamepadIndex);
                } else if (valx < -0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.LEFT, gamepadIndex);
                } else if (valx > 0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.RIGHT, gamepadIndex);
                } else {
                  hit = false;
                }
              }
            }

            if (axes.length >= 4) {
              var _valx = axes[2],
                  _valy = axes[3];

              if (fireAnalog) {
                _this.fireAnalogEvent(GamepadEnum.R_ANALOG_X, _valx);

                _this.fireAnalogEvent(GamepadEnum.R_ANALOG_Y, _valy);
              }

              if (!hit) {
                hit = true;

                if (_valy < -0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.R_UP, gamepadIndex);
                } else if (_valy > 0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.R_DOWN, gamepadIndex);
                } else if (_valx < -0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.R_LEFT, gamepadIndex);
                } else if (_valx > 0.5) {
                  if (!padDown && !firstPoll) _this.fireEvent(GamepadEnum.R_RIGHT, gamepadIndex);
                } else {
                  hit = false;
                }
              }
            }
          }
        }
      }

      _this.padDown = hit;

      if (running) {
        requestAnimationFrame(_this.pollGamepads);
      }
    };

    this.isXbox = isXbox();
    this.running = false;
    this.callbacks = [];
    this.analogCallbacks = [];
    this.globalCallbacks = [];
    this.padDown = false;
    this.firstPollDelayEnd = -1;
    this.defaultCallback = null;
    this.escapePressed = null;
    this.escapePressedIndex = 0;
    this.aPressed = null;
    this.aPressedIndex = 0;
    this.startPressed = null;
    this.startPressedIndex = 0;
    this.mapping = new StandardPadMapping();
    this.buttons = new Array(16);
    this.padCount = 0;
    this.nextAnalog = 0;
    this.analogStep = 1000 / 60.0;
    this.immediateA = false;
  }

  var _proto = GamepadNotifier.prototype;

  _proto.setImmediateA = function setImmediateA(val) {
    this.immediateA = val;
  };

  _proto.fireEvent = function fireEvent(type, index) {
    var callbacks = this.callbacks,
        globalCallbacks = this.globalCallbacks,
        defaultCallback = this.defaultCallback;
    var e = {
      "type": type,
      "index": index
    };

    for (var i = 0; i < globalCallbacks.length; i++) {
      globalCallbacks[i](e);
    }

    for (var _i3 = 0; _i3 < callbacks.length; _i3++) {
      if (callbacks[_i3](e)) return;
    }

    if (defaultCallback) defaultCallback(e);
  };

  _proto.fireAnalogEvent = function fireAnalogEvent(type, value) {
    var analogCallbacks = this.analogCallbacks;

    if (value > -.20 && value < .20) {
      return;
    }

    value = (value > 0 ? value - .20 : value + .20) * (1.0 / .80);
    var e = {
      "type": type,
      "value": value
    };

    for (var i = 0; i < analogCallbacks.length; i++) {
      analogCallbacks[i](e);
    }
  };

  _proto.start = function start() {
    if (this.running) return;
    this.running = true;
    requestAnimationFrame(this.pollGamepads);
  };

  _proto.stop = function stop() {
    if (!this.running) return;
    this.running = false;
  };

  _proto.addCallback = function addCallback(cb) {
    this.callbacks.push(cb);
  };

  _proto.removeCallback = function removeCallback(cb) {
    this.callbacks = this.callbacks.filter(function (value) {
      return value !== cb;
    });
  };

  _proto.addGlobalCallback = function addGlobalCallback(cb) {
    this.globalCallbacks.push(cb);
  };

  _proto.removeGlobalCallback = function removeGlobalCallback(cb) {
    this.globalCallbacks = this.globalCallbacks.filter(function (value) {
      return value !== cb;
    });
  };

  _proto.addAnalogCallback = function addAnalogCallback(cb) {
    this.analogCallbacks.push(cb);
  };

  _proto.removeAnalogCallback = function removeAnalogCallback(cb) {
    this.analogCallbacks = this.analogCallbacks.filter(function (value) {
      return value !== cb;
    });
  };

  _proto.setDefaultCallback = function setDefaultCallback(cb) {
    this.defaultCallback = cb;
  };

  return GamepadNotifier;
}();

var FocusGrid = /*#__PURE__*/function () {
  function FocusGrid() {
    this.comps = [];
    this.unhandledCb = null;
  }

  var _proto = FocusGrid.prototype;

  _proto.setUnhandledGamepadInputCallback = function setUnhandledGamepadInputCallback(cb) {
    this.unhandledCb = cb;
  };

  _proto.setComponents = function setComponents(comps) {
    this.comps = comps;
  };

  _proto.getComponents = function getComponents() {
    return this.comps;
  };

  _proto.setDefaultComponent = function setDefaultComponent(comp) {
    this.defaultComp = comp;
  };

  _proto.getComponentLocation = function getComponentLocation(comp) {
    var comps = this.comps;

    for (var y = 0; y < comps.length; y++) {
      var xarr = comps[y];

      for (var x = 0; x < xarr.length; x++) {
        if (comps[y][x] === comp) {
          return [y, x];
        }
      }
    }

    return null;
  };

  _proto.checkComp = function checkComp(c) {
    if (c && c.current && c.current.focus && (c.current.isFocusable === undefined || c.current.isFocusable())) {
      return c;
    }

    return null;
  };

  _proto.moveFocus = function moveFocus(dir, comp) {
    var that = this;
    var comps = this.comps;
    var loc = this.getComponentLocation(comp);

    var checkRowForComp = function checkRowForComp(row) {
      var comp = null;

      for (var x = 0; x < row.length && !comp; x++) {
        comp = that.checkComp(row[x]);
      }

      return comp;
    };

    if (loc) {
      var y = loc[0],
          x = loc[1];
      var row = comps[y];
      var _comp = null;

      switch (dir) {
        case GamepadEnum.LEFT:
          x--;

          while (x >= 0 && !_comp) {
            _comp = this.checkComp(row[x]);
            x--;
          }

          break;

        case GamepadEnum.RIGHT:
          x++;

          while (x < row.length && !_comp) {
            _comp = this.checkComp(row[x]);
            x++;
          }

          break;

        case GamepadEnum.UP:
          y--;

          while (y >= 0 && !_comp) {
            _comp = checkRowForComp(comps[y]);
            y--;
          }

          break;

        case GamepadEnum.DOWN:
          y++;

          while (y < comps.length && !_comp) {
            _comp = checkRowForComp(comps[y]);
            y++;
          }

          break;

        default:
          if (this.unhandledCb) {
            this.unhandledCb(dir);
          }

          break;
      }

      if (_comp) return _comp.current.focus();
    }

    return false;
  };

  _proto.focus = function focus() {
    var comps = this.comps,
        defaultComp = this.defaultComp;

    if (defaultComp && this.checkComp(defaultComp)) {
      return defaultComp.current.focus();
    }

    for (var y = 0; y < comps.length; y++) {
      var xarr = comps[y];

      for (var x = 0; x < xarr.length; x++) {
        var comp = comps[y][x];

        if (this.checkComp(comp)) {
          return comp.current.focus();
        }
      }
    }

    return false;
  };

  return FocusGrid;
}();

var toggleTabIndex = function toggleTabIndex(parent, focusable) {
  var FOCUSABLE_ELEMENTS = ['a[href]', 'area[href]', 'input:not([disabled])', 'select:not([disabled])', 'textarea:not([disabled])', 'button:not([disabled])', 'iframe', 'object', 'embed', '[contenteditable]', '[tabindex]'];

  var getFocusableElements = function getFocusableElements(el) {
    return Array.prototype.slice.call(el.querySelectorAll(FOCUSABLE_ELEMENTS.join(',')));
  };

  var makeTabbable = function makeTabbable(el) {
    if (el.hasAttribute('data-tabindex')) {
      var index = el.getAttribute('data-tabindex');

      if (index == -2) {
        el.removeAttribute('tabindex');
      } else {
        el.setAttribute('tabindex', index);
      }
    }
  };

  var makeUntabbable = function makeUntabbable(el) {
    el.setAttribute('data-tabindex', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : -2);
    el.setAttribute('tabindex', -1);
  };

  var els = getFocusableElements(parent);
  focusable ? els.forEach(makeTabbable) : els.forEach(makeUntabbable);
};

var Swipe = /*#__PURE__*/function () {
  function Swipe(element) {
    var _this = this;

    this.PERCENT = .05;
    this.xDown = null;
    this.yDown = null;
    this.onUp = null;
    this.onDown = null;
    this.onRight = null;
    this.onLeft = null;

    this.startListener = function (evt) {
      _this.xDown = evt.touches[0].clientX;
      _this.yDown = evt.touches[0].clientY;
    };

    this.stopListener = function (evt) {
      _this.handleTouchMove(evt);
    };

    if (element) {
      this.register(element);
    }
  }

  var _proto = Swipe.prototype;

  _proto.register = function register(element) {
    this.element = element;
    this.element.addEventListener('touchstart', this.startListener);
    this.element.addEventListener('touchmove', this.stopListener);
  };

  _proto.unregister = function unregister() {
    this.element.removeEventListener('touchstart', this.startListener);
    this.element.removeEventListener('touchmove', this.stopListener);
  };

  _proto.onLeft = function onLeft(callback) {
    this.onLeft = callback;
    return this;
  };

  _proto.onRight = function onRight(callback) {
    this.onRight = callback;
    return this;
  };

  _proto.onUp = function onUp(callback) {
    this.onUp = callback;
    return this;
  };

  _proto.onDown = function onDown(callback) {
    this.onDown = callback;
    return this;
  };

  _proto.handleTouchMove = function handleTouchMove(evt) {
    if (!this.xDown || !this.yDown) {
      return;
    }

    var xUp = evt.touches[0].clientX;
    var yUp = evt.touches[0].clientY;
    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;

    if (Math.abs(this.xDiff) > Math.abs(this.yDiff)) {
      if (Math.abs(this.xDiff) < window.innerWidth * this.PERCENT) return;

      if (this.xDiff > 0) {
        if (this.onLeft) this.onLeft(this.xDiff);
      } else {
        if (this.onRight) this.onRight(this.xDiff);
      }
    } else {
      if (Math.abs(this.yDiff) < window.innerHeight * this.PERCENT) return;

      if (this.yDiff > 0) {
        if (this.onUp) this.onUp(this.yDiff);
      } else {
        if (this.onDown) this.onDown(this.yDiff);
      }
    }

    this.xDown = null;
    this.yDown = null;
  };

  return Swipe;
}();

var styles$1 = {"debugText":"_1SQ0g"};

var debugDiv = null;

var addDebugDiv = function addDebugDiv() {
  if (debugDiv === null) {
    var el = document.createElement('div');
    el.className = styles$1.debugText;
    document.body.appendChild(el);
    debugDiv = el;
  }

  return debugDiv;
};

var DisplayLoop = /*#__PURE__*/function () {
  function DisplayLoop(freq, vsync, debug, forceNative, noWait) {
    if (freq === void 0) {
      freq = 60;
    }

    if (vsync === void 0) {
      vsync = true;
    }

    if (debug === void 0) {
      debug = false;
    }

    if (forceNative === void 0) {
      forceNative = false;
    }

    if (noWait === void 0) {
      noWait = false;
    }

    this.waitCount = 0;
    this.frequency = freq;
    this.forceAdjustTimestamp = false;
    this.vsync = forceNative ? true : vsync && settings.isVsyncEnabled();
    this.debug = debug;
    this.paused = true;
    this.isNative = false;
    this.isNativeCheckDone = false;
    this.fps = '';
    this.debugDiv = null;
    this.debugCb = null;
    this.isAdjustTimestampEnabled = true;
    this.isNoWait = noWait;

    if (this.debug) {
      this.debugDiv = addDebugDiv();
    }

    if (forceNative) {
      this.isNative = true;
      this.isNativeCheckDone = true;
    } else {
      if (!this.isNoWait) {
        this.checkNativeFps();
      }
    }
  }

  var _proto = DisplayLoop.prototype;

  _proto.setAdjustTimestampEnabled = function setAdjustTimestampEnabled(val) {
    this.isAdjustTimestampEnabled = val;
  };

  _proto.checkNativeFps = function checkNativeFps() {
    var _this = this;

    if (!this.vsync) {
      this.isNativeCheckDone = true;
      return;
    }

    this.TEST_BEGIN = this.frequency * 5;
    this.TEST_COUNT = this.frequency * 5;
    var fc = 0;
    var start = 0;
    var end = start;

    var f = function f() {
      fc++;
      end = Date.now();

      if (start === 0 && fc === _this.TEST_BEGIN) {
        start = Date.now();
        fc = 0;
        info('native fps test beginning.');
        requestAnimationFrame(f);
      } else if (fc === _this.TEST_COUNT) {
        _this.isNativeCheckDone = true;
        var fps = 1000 / ((end - start) / fc);
        var round = Math.round(fps / 10) * 10;
        var diff = Math.abs(round - fps);
        var nFaster = fps > _this.frequency;
        info('Native FPS: ' + fps + ", round: " + round);

        if (round === _this.frequency && diff < 0.5 && _this.vsync) {
          info('Native matches frequency.');
          _this.isNative = true;
          _this.forceAdjustTimestamp = true;
        } else if (round < _this.frequency || !nFaster && diff >= 5) {
          info('Native frequency too slow, vsync disabled.');
          _this.vsync = false;
          _this.forceAdjustTimestamp = true;
        } else {
          info('Native not close enough to frequency: ' + fps + ', vsync: ' + _this.vsync);
        }
      } else {
        requestAnimationFrame(f);
      }
    };

    requestAnimationFrame(f);
  };

  _proto.getFrequency = function getFrequency() {
    return this.frequency;
  };

  _proto.sync = function sync(cb, afterTimeout) {
    if (this.vsync) {
      requestAnimationFrame(cb);
    } else {
      if (!afterTimeout) {
        setTimeout(cb, 0);
      } else {
        cb();
      }
    }
  };

  _proto.pause = function pause(p) {
    if (p == this.paused) return;

    if (!p) {
      this.forceAdjustTimestamp = true;
    }

    this.paused = p;
  };

  _proto.start = function start(cb) {
    var _this2 = this;

    var frequency = this.frequency;
    var frameTicks = 1000.0 / frequency;
    var adjustTolerance = frameTicks * frequency * 2;
    var checkFrequency = frequency * 5;
    info("Frame ticks: " + frameTicks);
    info("Frequency: " + frequency);
    var initialStart = Date.now();
    var start = Date.now();
    var fc = 0;
    var avgWait = 0;
    var checkSync = this.isNoWait || this.isNative ? 2 : 0;
    var vsyncLow = 0;

    var f = function f() {
      if (!_this2.paused) {
        nextTimestamp = nextTimestamp === -1 ? Date.now() + frameTicks : nextTimestamp + frameTicks;
        var freq = cb();

        if (freq) {
          if (_this2.debug) {
            info("Frequency changed! : " + freq);
          }

          frequency = freq;
          frameTicks = 1000.0 / freq;
          adjustTolerance = frameTicks * freq * 2;
          checkFrequency = freq * 5;
        }

        fc++;
        var now = Date.now();

        if (_this2.isAdjustTimestampEnabled) {
          if (nextTimestamp + adjustTolerance < now || _this2.forceAdjustTimestamp) {
            _this2.forceAdjustTimestamp = false;
            nextTimestamp = -1;
            fc = 0;
            start = now;
            avgWait = 0;

            if (_this2.debug) {
              info("adjusted next timestamp.");
            }
          }
        }

        if (_this2.isNoWait) {
          _this2.sync(f, false);
        } else {
          var wait = nextTimestamp == -1 ? 0 : nextTimestamp - now;
          avgWait += wait;

          if (!_this2.isNative && wait > 0) {
            _this2.waitCount++;
            setTimeout(function () {
              return _this2.sync(f, true);
            }, wait);
          } else {
            _this2.sync(f, false);
          }
        }

        if (fc > checkFrequency) {
          var elapsed = Date.now() - start;
          var fpsVal = 1000.0 / (elapsed / fc);

          if (_this2.debug && checkSync === 1) {
            info("Checking VSYNC");
          }

          if (_this2.vsync && checkSync === 1) {
            if (fpsVal < frequency - 0.5) {
              vsyncLow++;

              if (_this2.debug) {
                info("VSYNC low: " + vsyncLow);
              }

              if (vsyncLow === 2) {
                _this2.isNative = false;
                _this2.vsync = false;
                _this2.forceAdjustTimestamp = true;
                checkSync = 2;
                info('Disabling native and vsync, too slow: ' + fpsVal);
              }
            } else {
              vsyncLow = 0;
            }
          }

          if (_this2.debug) {
            var fps = fpsVal.toFixed(2);
            var w = (avgWait / fc * frequency).toFixed(2);
            _this2.fps = "FPS: " + fps + ", Vsync: " + _this2.vsync + ", Wait: " + w + ", Native: " + _this2.isNative + ", Wait count: " + _this2.waitCount;
            _this2.debugDiv.innerHTML = _this2.debugCb ? _this2.debugCb(_this2.fps) : _this2.fps;
            info(_this2.fps);
          }

          if (checkSync === 0 && _this2.isNativeCheckDone) {
            if (_this2.debug) {
              info("Check sync start: " + (Date.now() - initialStart) / 1000.0);
            }

            checkSync = 1;
          } else if (checkSync === 1) {
            if ((Date.now() - initialStart) / 1000.0 > 60.0) {
              if (_this2.debug) {
                info("1 minute has elapsed, disabling vsync check.");
              }

              checkSync = 2;
            }
          }

          start = Date.now();
          fc = 0;
          avgWait = 0;
        }
      } else {
        _this2.sync(f, false);
      }
    };

    var nextTimestamp = -1;
    this.pause(false);
    setTimeout(function () {
      return _this2.sync(f, true);
    }, 0);
  };

  _proto.setDebugCallback = function setDebugCallback(cb) {
    this.debugCb = cb;
  };

  _proto.getFps = function getFps() {
    return this.fps;
  };

  return DisplayLoop;
}();

var getScreenShot = function getScreenShot(canvas, advanceCb, maxTries) {
  try {
    var _exit2 = false;
    var offscreenCanvas = document.createElement("canvas");
    offscreenCanvas.width = canvas.width;
    offscreenCanvas.height = canvas.height;
    var ctx = offscreenCanvas.getContext("2d");
    var i = 0;

    var _temp6 = _finallyRethrows(function () {
      var doIt = function doIt(advance) {
        try {
          var _temp9 = function _temp9() {
            var result = canvas.toDataURL();
            ctx.drawImage(canvas, 0, 0);
            var imageData = ctx.getImageData(0, 0, offscreenCanvas.width, offscreenCanvas.height);
            var found = false;
            var last = -1;
            var current = 0;

            for (var _i = 0; _i < imageData.data.length; _i++) {
              if (_i > 0 && _i % 4 === 0) {
                if (last !== -1) {
                  if (current !== last) {
                    found = true;
                    break;
                  }
                }

                last = current;
                current = 0;
              }

              current += imageData.data[_i];
            }

            return found ? result : null;
          };

          var _temp10 = function () {
            if (advance) {
              return Promise.resolve(advanceCb()).then(function () {});
            }
          }();

          return Promise.resolve(_temp10 && _temp10.then ? _temp10.then(_temp9) : _temp9(_temp10));
        } catch (e) {
          return Promise.reject(e);
        }
      };

      i = 0;
      return _for(function () {
        return !_exit2 && i < maxTries;
      }, function () {
        return i++;
      }, function () {
        function _temp4() {
          function _temp2() {
            if (shot) {
              _exit2 = true;
              return shot;
            }
          }

          if (shot) {
            _exit2 = true;
            return shot;
          }

          var _temp = _catch(function () {
            return Promise.resolve(doIt(true)).then(function (_doIt2) {
              shot = _doIt2;
            });
          }, function () {});

          return _temp && _temp.then ? _temp.then(_temp2) : _temp2(_temp);
        }

        var shot = null;

        var _temp3 = _catch(function () {
          return Promise.resolve(doIt(false)).then(function (_doIt) {
            shot = _doIt;
          });
        }, function () {});

        return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
      });
    }, function (_wasThrown, _result2) {
      console.log("Tries: " + i);
      offscreenCanvas.remove();
      if (_wasThrown) throw _result2;
      return _result2;
    });

    return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function (_result2) {
      return _exit2 ? _result2 : null;
    }) : _exit2 ? _temp6 : null);
  } catch (e) {
    return Promise.reject(e);
  }
};

var FileManifest = /*#__PURE__*/function () {
  function FileManifest(emulator, FS, destination, bytes, url, archiveCallback) {
    this.archiveCallback = archiveCallback;
    this.emulator = emulator;
    this.app = emulator.getApp();
    this.FS = FS;
    this.destination = destination;
    this.bytes = bytes;
    var lastIndex = url.lastIndexOf("/");
    this.url = url.substring(0, lastIndex);
  }

  var _proto = FileManifest.prototype;

  _proto.onArchiveFile = function onArchiveFile(isDir, name, stats) {
    if (this.archiveCallback) {
      this.archiveCallback.onArchiveFile(isDir, name, stats);
    }
  };

  _proto.onArchiveFilesFinished = function onArchiveFilesFinished() {};

  _proto.getUrl = function getUrl(name, url) {
    var path = this.url;
    var slash = 0;
    if (path.endsWith('/')) slash++;

    if (!url || url.trim().length === 0) {
      url = name;
    } else {
      if (url.toLowerCase().startsWith("http")) {
        return url;
      }
    }

    if (path.startsWith('/')) slash++;
    return slash === 0 ? path + "/" + url : slash === 1 ? path + url : path.substring(1) + url;
  };

  _proto.getDestinationFile = function getDestinationFile(name) {
    var path = this.destination;
    var slash = 0;
    if (path.endsWith('/')) slash++;
    if (name.startsWith('/')) slash++;
    return slash === 0 ? path + "/" + name : slash === 1 ? path + name : path.substring(1) + name;
  };

  _proto.walkFiles = function walkFiles() {
    try {
      var _temp4 = function _temp4() {
        if (_this2.archiveCallback) {
          _this2.archiveCallback.onArchiveFilesFinished();
        }

        return size;
      };

      var _this2 = this;

      var manifest = _this2.manifest,
          FS = _this2.FS,
          app = _this2.app;
      var size = 0;
      var method = null;
      var files = [];

      for (var _i = 0; _i < manifest.files.length; _i++) {
        var file = manifest.files[_i];

        if (file.extract) {
          files.push(file);
        }
      }

      for (var _i2 = 0; _i2 < manifest.files.length; _i2++) {
        var _file = manifest.files[_i2];

        if (!_file.extract) {
          files.push(_file);
        }
      }

      var _temp5 = _forTo(files, function (i) {
        var file = files[i];

        var requestUrl = _this2.getUrl(file.name, file.url ? file.url : "");

        var destinationFile = _this2.getDestinationFile(file.name);

        var extract = file.extract;
        var dirs = destinationFile.split("/");
        var path = "";

        for (var _i3 = 0; _i3 < dirs.length - 1; _i3++) {
          var dir = dirs[_i3];

          if (dir === "") {
            continue;
          }

          path += "/" + dir;

          if (!FS.analyzePath(path).exists) {
            FS.mkdir(path);
          }
        }

        if (files.length > 1) {
          app.setState({
            loadingMessage: "Loading " + (i + 1) + " of " + files.length,
            loadingPercent: null
          });
        } else {
          app.setState({
            loadingMessage: "Loading",
            loadingPercent: null
          });
        }

        return Promise.resolve(_this2.emulator.wait(10)).then(function () {
          requestUrl = requestUrl.replaceAll("#", "%23");
          info(requestUrl);
          var fad = new FetchAppData(requestUrl);
          fad.setMethod(method);
          return Promise.resolve(fad.fetch()).then(function (res) {
            return Promise.resolve(app.fetchResponseBuffer(res)).then(function (bytes) {
              method = fad.getSuccessMethod();
              size += bytes.length;
              console.log(destinationFile);
              return Promise.resolve(_this2.emulator.wait(10)).then(function () {
                var _temp = function () {
                  if (extract) {
                    console.log("#### extract");
                    console.log(destinationFile);
                    var lastIndex = destinationFile.lastIndexOf("/");
                    var destinationDir = destinationFile.substring(0, lastIndex);
                    console.log(destinationDir);
                    return Promise.resolve(_this2.emulator.extractArchive(FS, destinationDir, bytes, 10 * 1024 * 1024 * 1024, _this2)).then(function () {});
                  } else {
                    var stream = FS.open(destinationFile, 'a');
                    FS.write(stream, bytes, 0, bytes.length, 0, true);
                    FS.close(stream);

                    if (_this2.archiveCallback) {
                      _this2.archiveCallback.onArchiveFile(false, destinationFile, null);
                    }
                  }
                }();

                if (_temp && _temp.then) return _temp.then(function () {});
              });
            });
          });
        });
      });

      return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(_temp4) : _temp4(_temp5));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.process = function process() {
    try {
      var _exit2 = false;

      var _this4 = this;

      if (!(_this4.bytes.length < 10 * 1024 * 1024)) {
        return Promise.resolve(false);
      }

      var parsed = false;

      var _temp7 = _catch(function () {
        var contents = new TextDecoder().decode(_this4.bytes);
        _this4.manifest = JSON.parse(contents);

        if (!_this4.manifest.files) {
          throw new Error("Unable to find files in manifest.");
        }

        parsed = true;
        return Promise.resolve(_this4.walkFiles()).then(function (size) {
          _exit2 = true;
          return size;
        });
      }, function (e) {
        error(e);
        if (parsed) throw e;
      });

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function (_result) {
        return _exit2 ? _result : null;
      }) : _exit2 ? _temp7 : null);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return FileManifest;
}();

var STATE_FILE_PATH = "/home/web_user/retroarch/userdata/states/game.state";
var RetroAppWrapper = /*#__PURE__*/function (_AppWrapper) {
  _inheritsLoose(RetroAppWrapper, _AppWrapper);

  function RetroAppWrapper(app, debug) {
    var _this;

    if (debug === void 0) {
      debug = false;
    }

    _this = _AppWrapper.call(this, app, debug) || this;
    _this.INP_LEFT = 1;
    _this.INP_RIGHT = 1 << 1;
    _this.INP_UP = 1 << 2;
    _this.INP_DOWN = 1 << 3;
    _this.INP_START = 1 << 4;
    _this.INP_SELECT = 1 << 5;
    _this.INP_A = 1 << 6;
    _this.INP_B = 1 << 7;
    _this.INP_X = 1 << 8;
    _this.INP_Y = 1 << 9;
    _this.INP_LBUMP = 1 << 10;
    _this.INP_LTRIG = 1 << 11;
    _this.INP_LTHUMB = 1 << 12;
    _this.INP_RBUMP = 1 << 13;
    _this.INP_RTRIG = 1 << 14;
    _this.INP_RTHUMB = 1 << 15;
    _this.CONTROLLER_COUNT = 4;
    _this.OPT1 = 1;
    _this.OPT2 = 1 << 1;
    _this.OPT3 = 1 << 2;
    _this.OPT4 = 1 << 3;
    _this.OPT5 = 1 << 4;
    _this.OPT6 = 1 << 5;
    _this.OPT7 = 1 << 6;
    _this.OPT8 = 1 << 7;
    _this.OPT9 = 1 << 8;
    _this.OPT10 = 1 << 9;
    _this.OPT11 = 1 << 10;
    _this.OPT12 = 1 << 11;
    _this.OPT13 = 1 << 12;
    _this.OPT14 = 1 << 13;
    _this.OPT15 = 1 << 14;
    _this.OPT16 = 1 << 15;
    _this.MOUSE_LEFT = 1;
    _this.MOUSE_MIDDLE = 1 << 1;
    _this.MOUSE_RIGHT = 1 << 2;
    _this.MOUSE_WHEEL_UP = 1 << 3;
    _this.MOUSE_WHEEL_DOWN = 1 << 4;
    _this.MOUSE_HORIZ_WHEEL_UP = 1 << 5;
    _this.MOUSE_HORIZ_WHEEL_DOWN = 1 << 6;
    _this.RA_DIR = '/home/web_user/retroarch/';
    _this.RA_SYSTEM_DIR = _this.RA_DIR + 'system/';
    window.emulator = _assertThisInitialized(_this);
    window.readyAudioContext = null;
    _this.discIndex = null;
    _this.romBytes = null;
    _this.biosBuffers = null;
    _this.escapeCount = -1;
    _this.audioPlaying = false;
    _this.saveStatePrefix = null;
    _this.saveStatePath = null;
    _this.exiting = false;
    _this.mainStarted = false;
    _this.disableInput = false;
    return _this;
  }

  var _proto = RetroAppWrapper.prototype;

  _proto.setDiscIndex = function setDiscIndex(index) {
    this.discIndex = index;
  };

  _proto.setExiting = function setExiting(exiting) {
    this.exiting = true;
  };

  _proto.getScriptUrl = function getScriptUrl() {
    throw "getScriptUrl() has not been implemented";
  };

  _proto.isDiscBased = function isDiscBased() {
    return this.app.isDiscBased();
  };

  _proto.isArchiveBased = function isArchiveBased() {
    return this.app.isArchiveBased();
  };

  _proto.isMediaBased = function isMediaBased() {
    return this.app.isMediaBased();
  };

  _proto.getCustomStartHandler = function getCustomStartHandler() {
    return null;
  };

  _proto.getExitOnLoopError = function getExitOnLoopError() {
    return false;
  };

  _proto.setRoms = function setRoms(uid, frontendArray, biosBuffers, romBytes, ext) {
    this.uid = uid;
    this.frontendArray = frontendArray;
    this.biosBuffers = biosBuffers;
    this.romBytes = romBytes;
    this.ext = ext;
    this.archiveUrl = null;
    this.media = null;
    this.saveDisks = 0;
    this.game = this.isDiscBased() ? this.RA_DIR + 'game.' + (ext != null && ext === 'pbp' ? 'pbp' : 'chd') : this.RA_DIR + "game.bin";
  };

  _proto.setArchiveUrl = function setArchiveUrl(url) {
    this.archiveUrl = url;
  };

  _proto.setMedia = function setMedia(media) {
    this.media = media;
  };

  _proto.setSaveDisks = function setSaveDisks(count) {
    this.saveDisks = count;
  };

  _proto.createControllers = function createControllers() {
    return new Controllers([new Controller(new DefaultKeyCodeToControlMapping()), new Controller(), new Controller(), new Controller()]);
  };

  _proto.createAudioProcessor = function createAudioProcessor() {
    return null;
  };

  _proto.onShowPauseMenu = function onShowPauseMenu() {
    try {
      var _this3 = this;

      return Promise.resolve(_this3.saveState()).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getControllerIndex = function getControllerIndex(index) {
    return index;
  };

  _proto.onArchiveFile = function onArchiveFile(isDir, name, stats) {};

  _proto.onArchiveFilesFinished = function onArchiveFilesFinished() {};

  _proto.getArchiveBinaryFileName = function getArchiveBinaryFileName() {
    return "";
  };

  _proto.isEscapeHackEnabled = function isEscapeHackEnabled() {
    return true;
  };

  _proto.pollControls = function pollControls() {
    var _this4 = this;

    var analogMode = this.analogMode,
        CONTROLLER_COUNT = this.CONTROLLER_COUNT,
        controllers = this.controllers;
    controllers.poll();
    var isAnalog = analogMode;

    if (controllers.isControlDown(0, CIDS.RTRIG) || controllers.isControlDown(0, CIDS.LTRIG) || controllers.isControlDown(0, CIDS.LANALOG) || controllers.isControlDown(0, CIDS.RANALOG)) {
      this.escapeCount = this.escapeCount === -1 ? 0 : this.escapeCount + 1;
    } else {
      this.escapeCount = -1;
    }

    for (var i = 0; i < CONTROLLER_COUNT; i++) {
      var input = 0;
      var escapeOk = !this.isEscapeHackEnabled() || this.escapeCount === -1 || this.escapeCount < 60;

      if (controllers.isControlDown(0, CIDS.ESCAPE) && escapeOk) {
        if (this.pause(true)) {
          controllers.waitUntilControlReleased(0, CIDS.ESCAPE).then(function () {
            return _this4.showPauseMenu();
          });
          return;
        }
      }

      if (controllers.isControlDown(i, CIDS.UP, !isAnalog)) {
        input |= this.INP_UP;
      } else if (controllers.isControlDown(i, CIDS.DOWN, !isAnalog)) {
        input |= this.INP_DOWN;
      }

      if (controllers.isControlDown(i, CIDS.RIGHT, !isAnalog)) {
        input |= this.INP_RIGHT;
      } else if (controllers.isControlDown(i, CIDS.LEFT, !isAnalog)) {
        input |= this.INP_LEFT;
      }

      if (controllers.isControlDown(i, CIDS.START) && escapeOk) {
        input |= this.INP_START;
      }

      if (controllers.isControlDown(i, CIDS.SELECT) && escapeOk) {
        input |= this.INP_SELECT;
      }

      if (controllers.isControlDown(i, CIDS.A)) {
        input |= this.INP_A;
      }

      if (controllers.isControlDown(i, CIDS.B)) {
        input |= this.INP_B;
      }

      if (controllers.isControlDown(i, CIDS.X)) {
        input |= this.INP_X;
      }

      if (controllers.isControlDown(i, CIDS.Y)) {
        input |= this.INP_Y;
      }

      if (controllers.isControlDown(i, CIDS.LBUMP)) {
        input |= this.INP_LBUMP;
      }

      if (controllers.isControlDown(i, CIDS.RBUMP)) {
        input |= this.INP_RBUMP;
      }

      if (controllers.isControlDown(i, CIDS.LTRIG)) {
        input |= this.INP_LTRIG;
      }

      if (controllers.isControlDown(i, CIDS.RTRIG)) {
        input |= this.INP_RTRIG;
      }

      if (controllers.isControlDown(i, CIDS.LANALOG)) {
        input |= this.INP_LTHUMB;
      }

      if (controllers.isControlDown(i, CIDS.RANALOG)) {
        input |= this.INP_RTHUMB;
      }

      var analog0x = controllers.getAxisValue(i, 0, true);
      var analog0y = controllers.getAxisValue(i, 0, false);
      var analog1x = controllers.getAxisValue(i, 1, true);
      var analog1y = controllers.getAxisValue(i, 1, false);
      var controller = this.getControllerIndex(i);
      this.sendInput(controller, input, analog0x, analog0y, analog1x, analog1y);
    }
  };

  _proto.sendInput = function sendInput(controller, input, analog0x, analog0y, analog1x, analog1y) {
    if (!this.disableInput) {
      window.Module._wrc_set_input(controller, input, analog0x, analog0y, analog1x, analog1y);
    }
  };

  _proto.updateSaveStateForSlotProps = function updateSaveStateForSlotProps(slot, props) {};

  _proto.loadEmscriptenModule = function loadEmscriptenModule(canvas) {
    var _this5 = this;

    var app = this.app;
    var scriptUrl = this.getScriptUrl();
    return new Promise(function (resolve, reject) {
      window.Module = {
        canvas: canvas,
        noInitialRun: true,
        onAbort: function onAbort(msg) {
          return app.exit(msg);
        },
        onExit: function onExit() {
          return app.exit();
        },
        onRuntimeInitialized: function onRuntimeInitialized() {
          var f = function f() {
            _this5.setShowMessageEnabled(true);

            if (window.readyAudioContext) {
              if (window.readyAudioContext.state !== 'running') {
                app.setShowOverlay(true);
                registerAudioResume(window.readyAudioContext, function (running) {
                  if (running) {
                    window.Module._rwebaudio_enable();

                    window.Module._cmd_audio_reinit();

                    _this5.audioPlaying = true;
                  }

                  setTimeout(function () {
                    return app.setShowOverlay(!running);
                  }, 50);
                }, 500);
              } else {
                window.Module._rwebaudio_enable();

                window.Module._cmd_audio_reinit();

                _this5.audioPlaying = true;
              }
            } else {
              setTimeout(f, 1000);
            }
          };

          setTimeout(f, 1000);
          resolve();
        },
        preInit: function preInit() {
          var FS = window.FS;
          FS.mkdir('/home/web_user/retroarch');
          FS.mkdir('/home/web_user/retroarch/system');
          FS.mkdir('/home/web_user/retroarch/userdata');
          FS.mkdir('/home/web_user/retroarch/userdata/system');
          FS.mkdir('/home/web_user/retroarch/userdata/system/neocd');
          FS.mkdir('/home/web_user/retroarch/userdata/system/vice');
          FS.mkdir('/home/web_user/retroarch/userdata/saves');
          FS.mkdir('/home/web_user/retroarch/userdata/saves/opera');
          FS.mkdir('/home/web_user/retroarch/userdata/saves/opera/per_game');
          FS.mkdir('/home/web_user/retroarch/userdata/states');
        }
      };
      var script = document.createElement('script');
      document.body.appendChild(script);
      script.src = scriptUrl;
    });
  };

  _proto.getStateSlots = function getStateSlots(showStatus) {
    if (showStatus === void 0) {
      showStatus = true;
    }

    try {
      var _this7 = this;

      return Promise.resolve(_this7.getSaveManager().getStateSlots(_this7.saveStatePrefix, showStatus ? _this7.saveMessageCallback : null));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getShotAspectRatio = function getShotAspectRatio() {
    return null;
  };

  _proto.getShotRotation = function getShotRotation() {
    return null;
  };

  _proto.saveStateForSlot = function saveStateForSlot(slot) {
    try {
      var _this9 = this;

      var _window = window,
          Module = _window.Module;
      return Promise.resolve(getScreenShot(_this9.canvas, function () {
        Module._cmd_audio_stop();

        Module._emscripten_mainloop();

        Module._cmd_audio_start();
      }, 10)).then(function (shot) {
        Module._cmd_save_state();

        var s = null;

        var _temp2 = _catch(function () {
          var FS = window.FS;

          try {
            s = FS.readFile(STATE_FILE_PATH);
          } catch (e) {}

          var _temp = function () {
            if (s) {
              var props = {};

              var ar = _this9.getShotAspectRatio();

              if (ar) {
                props.aspectRatio = "" + ar;
              }

              var rot = _this9.getShotRotation();

              if (rot) {
                props.transform = "rotate(" + rot + "deg)";
              }

              var otherProps = {};

              _this9.updateSaveStateForSlotProps(slot, otherProps);

              return Promise.resolve(_this9.getSaveManager().saveState(_this9.saveStatePrefix, slot, s, shot ? null : _this9.canvas, _this9.saveMessageCallback, shot, props, otherProps)).then(function () {});
            }
          }();

          if (_temp && _temp.then) return _temp.then(function () {});
        }, function (e) {
          error('Error saving state: ' + e);
        });

        return _temp2 && _temp2.then ? _temp2.then(function () {
          return true;
        }) : true;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.loadStateForSlot = function loadStateForSlot(slot) {
    try {
      var _this11 = this;

      var _window2 = window,
          Module = _window2.Module;

      var _temp4 = _catch(function () {
        return Promise.resolve(_this11.getSaveManager().loadState(_this11.saveStatePrefix, slot, _this11.saveMessageCallback)).then(function (state) {
          if (state) {
            var FS = window.FS;
            FS.writeFile(STATE_FILE_PATH, state);

            Module._cmd_load_state();
          }
        });
      }, function (e) {
        error('Error loading state: ' + e);
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {
        return true;
      }) : true);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.deleteStateForSlot = function deleteStateForSlot(slot, showStatus) {
    if (showStatus === void 0) {
      showStatus = true;
    }

    try {
      var _this13 = this;

      var _temp6 = _catch(function () {
        return Promise.resolve(_this13.getSaveManager().deleteState(_this13.saveStatePrefix, slot, showStatus ? _this13.saveMessageCallback : null)).then(function () {});
      }, function (e) {
        error('Error deleting state: ' + e);
      });

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
        return true;
      }) : true);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.onPause = function onPause(p) {
    if (!p) {
      if (window.readyAudioContext) {
        window.readyAudioContext.resume();
        console.log(window.readyAudioContext);

        window.Module._rwebaudio_enable();

        window.Module._cmd_audio_reinit();
      }
    }
  };

  _proto.applyGameSettings = function applyGameSettings() {};

  _proto.updateBilinearFilter = function updateBilinearFilter() {
    if (!this.mainStarted) return;
    var enabled = this.isBilinearFilterEnabled();

    window.Module._wrc_enable_bilinear_filter(enabled ? 1 : 0);
  };

  _proto.isForceAspectRatio = function isForceAspectRatio() {
    return this.getScreenSize() === this.SS_NATIVE;
  };

  _proto.updateScreenSize = function updateScreenSize() {
    if (!this.mainStarted) return;

    try {
      var enabled = this.isForceAspectRatio();

      window.Module._wrc_force_aspect_ratio(enabled ? 1 : 0);
    } catch (e) {
      info("Unable to invoke _wrc_force_aspect_ratio.");
    }

    _AppWrapper.prototype.updateScreenSize.call(this);
  };

  _proto.resizeScreen = function resizeScreen(canvas) {
    throw "resizeScreen() has not been implemented.";
  };

  _proto.createDisplayLoop = function createDisplayLoop(debug) {
    var loop = new DisplayLoop(60, true, debug, true, false);
    loop.setAdjustTimestampEnabled(false);
    return loop;
  };

  _proto.onFrame = function onFrame() {};

  _proto.onWriteAdditionalFiles = function onWriteAdditionalFiles() {
    return Promise.resolve();
  };

  _proto.setStateFilePath = function setStateFilePath(path) {
    STATE_FILE_PATH = path;
  };

  _proto.onStoreMedia = function onStoreMedia() {
    return Promise.resolve();
  };

  _proto.onStart = function onStart(canvas) {
    try {
      var _this15 = this;

      var app = _this15.app,
          debug = _this15.debug,
          game = _this15.game;
      var _window3 = window,
          FS = _window3.FS,
          Module = _window3.Module;
      return Promise.resolve(_catch(function () {
        _this15.canvas = canvas;

        if (_this15.isDiscBased()) {
          setTimeout(function () {
            app.setState({
              loadingMessage: null,
              loadingPercent: null
            });
            setTimeout(function () {
              app.setState({
                loadingMessage: 'Starting'
              });
            }, 2000);
          }, 2000);
        } else {
          app.setState({
            loadingMessage: null,
            loadingPercent: null
          });
        }

        if (_this15.romBytes && _this15.romBytes.byteLength === 0) {
          throw new Error('The size is invalid (0 bytes).');
        }

        return Promise.resolve(_this15.onWriteAdditionalFiles()).then(function () {
          var _exit = false;

          function _temp18(_result2) {
            if (_exit) return _result2;

            function _temp16() {
              _this15.saveStatePrefix = app.getStoragePath(_this15.uid + "/");
              _this15.saveStatePath = "" + _this15.saveStatePrefix + _this15.SAVE_NAME;
              return Promise.resolve(_this15.loadState()).then(function () {
                function _temp14() {
                  var customStart = _this15.getCustomStartHandler();

                  var _temp12 = function () {
                    if (customStart) {
                      return Promise.resolve(customStart(_this15)).then(function () {});
                    } else {
                      var _temp19 = function _temp19() {
                        if (_this15.isDiscBased()) {
                          setTimeout(function () {
                            app.setState({
                              loadingMessage: null
                            });
                          }, 50);
                        }

                        _this15.displayLoop = _this15.createDisplayLoop(debug);
                        setTimeout(function () {
                          _this15.resizeScreen(canvas);

                          Module.setCanvasSize(canvas.offsetWidth, canvas.offsetHeight);
                          setTimeout(function () {
                            _this15.resizeScreen(canvas);
                          }, 1);
                        }, 50);

                        window.onresize = function () {
                          Module.setCanvasSize(canvas.offsetWidth, canvas.offsetHeight);
                          setTimeout(function () {
                            _this15.resizeScreen(canvas);
                          }, 1);
                        };

                        var exit = false;
                        var s = false;

                        _this15.displayLoop.start(function () {
                          try {
                            if (!exit) {
                              _this15.pollControls();

                              Module._emscripten_mainloop();

                              _this15.onFrame();
                            }
                          } catch (e) {
                            if (e.status === 1971) {
                              if (!_this15.exiting) {
                                app.exit(Resources.getText(TEXT_IDS.ERROR_UNKNOWN));
                              } else {
                                app.exit();
                              }

                              exit = true;
                            } else {
                              if (_this15.getExitOnLoopError()) {
                                app.exit(Resources.getText(TEXT_IDS.ERROR_UNKNOWN));
                                exit = true;
                              }

                              error(e);
                            }
                          }

                          if (!s) {
                            s = true;
                            app.setState({
                              loadingMessage: null,
                              loadingPercent: null
                            });
                          }
                        });
                      };

                      window.readyAudioContext = new window.AudioContext();
                      window.readyAudioContext.resume();
                      console.log(window.readyAudioContext);

                      try {
                        var name = _this15.isArchiveBased() ? _this15.getArchiveBinaryFileName() : _this15.game;
                        Module.callMain(['-v', name]);
                      } catch (e) {
                        error(e);
                      }

                      _this15.mainStarted = true;

                      var _temp20 = function () {
                        if (_this15.isBilinearFilterEnabled()) {
                          return Promise.resolve(_this15.wait(1000)).then(function () {
                            Module._wrc_enable_bilinear_filter(1);
                          });
                        }
                      }();

                      return _temp20 && _temp20.then ? _temp20.then(_temp19) : _temp19(_temp20);
                    }
                  }();

                  if (_temp12 && _temp12.then) return _temp12.then(function () {});
                }

                var _temp13 = function () {
                  if (_this15.isDiscBased()) {
                    return Promise.resolve(_this15.wait(10000)).then(function () {});
                  }
                }();

                return _temp13 && _temp13.then ? _temp13.then(_temp14) : _temp14(_temp13);
              });
            }

            _this15.romBytes = null;

            var _temp15 = function () {
              if (_this15.isDiscBased()) {
                return Promise.resolve(_this15.wait(2000)).then(function () {});
              }
            }();

            return _temp15 && _temp15.then ? _temp15.then(_temp16) : _temp16(_temp15);
          }

          _this15.applyGameSettings();

          for (var bios in _this15.biosBuffers) {
            var bytes = _this15.biosBuffers[bios];
            var path = '/home/web_user/retroarch/userdata/system/' + bios;
            FS.writeFile(path, bytes);
          }

          var _temp17 = function () {
            if (_this15.isArchiveBased()) {
              return _catch(function () {
                function _temp8() {
                  return Promise.resolve(_this15.extractArchive(window.FS, "/content", _this15.romBytes, _this15.DEFAULT_MAX_EXTRACT_SIZE, _this15)).then(function () {
                    app.setState({
                      loadingMessage: null
                    });
                    return Promise.resolve(_this15.wait(10)).then(function () {});
                  });
                }

                var _temp7 = function () {
                  if (_this15.romBytes.length > 10 * 1024 * 1024) {
                    app.setState({
                      loadingMessage: 'Preparing files'
                    });
                    return Promise.resolve(_this15.wait(10)).then(function () {});
                  }
                }();

                return _temp7 && _temp7.then ? _temp7.then(_temp8) : _temp8(_temp7);
              }, function (e) {
                info("Not a zip file, checking for a manifest.");
                FS.mkdir("/content");
                var manifest = new FileManifest(_this15, FS, "/content", _this15.romBytes, _this15.archiveUrl, _this15);
                return Promise.resolve(manifest.process()).then(function (totalSize) {
                  if (!totalSize) throw e;
                });
              });
            } else {
              var _temp21 = function () {
                if (_this15.isMediaBased()) {
                  return Promise.resolve(_this15.onStoreMedia()).then(function () {});
                } else {
                  var stream = FS.open(game, 'a');
                  FS.write(stream, _this15.romBytes, 0, _this15.romBytes.length, 0, true);
                  FS.close(stream);
                }
              }();

              if (_temp21 && _temp21.then) return _temp21.then(function () {});
            }
          }();

          return _temp17 && _temp17.then ? _temp17.then(_temp18) : _temp18(_temp17);
        });
      }, function (e) {
        window.readyAudioContext = null;
        app.setState({
          loadingMessage: null,
          loadingPercent: null
        });
        error(e);
        app.exit(e);
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return RetroAppWrapper;
}(AppWrapper);

var RetroPrefs = /*#__PURE__*/function (_BaseSettings) {
  _inheritsLoose(RetroPrefs, _BaseSettings);

  function RetroPrefs(emu) {
    var _this;

    _this = _BaseSettings.call(this, emu.getStorage()) || this;
    _this.PREFS_PREFIX = 'prefs';
    _this.emu = emu;
    var app = emu.getApp();
    _this.bilinearPath = app.getStoragePath(_this.PREFS_PREFIX + ".forceBilinear");
    _this.bilinearEnabled = false;
    return _this;
  }

  var _proto = RetroPrefs.prototype;

  _proto.load = function load() {
    try {
      var _this3 = this;

      return Promise.resolve(_BaseSettings.prototype.loadBool.call(_this3, _this3.bilinearPath, _this3.bilinearEnabled)).then(function (_BaseSettings$prototy) {
        _this3.bilinearEnabled = _BaseSettings$prototy;
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.save = function save() {
    try {
      var _this5 = this;

      return Promise.resolve(_BaseSettings.prototype.saveBool.call(_this5, _this5.bilinearPath, _this5.bilinearEnabled)).then(function () {});
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.isBilinearEnabled = function isBilinearEnabled() {
    return this.bilinearEnabled;
  };

  _proto.setBilinearEnabled = function setBilinearEnabled(enabled) {
    this.bilinearEnabled = enabled;
  };

  return RetroPrefs;
}(BaseSettings);

var FeedBase = /*#__PURE__*/function () {
  function FeedBase(minLength) {
    this.TITLE_SORT = function (a, b) {
      return a.title.localeCompare(b.title);
    };

    this.minLength = minLength;
  }

  var _proto = FeedBase.prototype;

  _proto._logInvalidObject = function _logInvalidObject(msg, object) {
    info(msg + " : " + JSON.stringify(object));
  };

  _proto._expandItems = function _expandItems(items) {
    var minLength = this.minLength;
    if (items.length === 0 || minLength === 0) return items;
    var itemsOut = [];

    while (itemsOut.length < minLength) {
      items.forEach(function (i) {
        var item = _extends({}, i);

        item.id = uuidv4();
        itemsOut.push(item);

        if (itemsOut.length > items.length) {
          item.duplicate = true;
        }
      });
    }

    return itemsOut;
  };

  return FeedBase;
}();

var Feed = /*#__PURE__*/function (_FeedBase) {
  _inheritsLoose(Feed, _FeedBase);

  function Feed(feed, minLength, filterCategories) {
    var _this;

    if (filterCategories === void 0) {
      filterCategories = true;
    }

    _this = _FeedBase.call(this, minLength) || this;
    feed = cloneObject(feed);
    _this.filterCategories = filterCategories;

    _this._parseFeed(feed);

    _this.originalFeed = feed;
    return _this;
  }

  var _proto = Feed.prototype;

  _proto._parseFeed = function _parseFeed(feed) {
    var _this2 = this;

    var reg = AppRegistry.instance;
    var title = feed.title;

    if (title === undefined) {
      throw new Error("Missing title");
    }

    if (feed.background) feed.background = remapUrl(feed.background);
    if (feed.thumbnail) feed.thumbnail = remapUrl(feed.thumbnail);
    if (!feed.props) feed.props = {};
    var categories = feed.categories;

    if (categories === undefined) {
      throw new Error("Missing categories");
    }

    categories = categories.filter(function (c) {
      if (c.title === undefined) {
        _this2._logInvalidObject('Category missing title', c);

        return false;
      } else if (c.items === undefined || c.items.length === 0) {
        if (!_this2.filterCategories) {
          c.items = [];
        } else {
          _this2._logInvalidObject('Category missing items', c);

          return false;
        }
      }

      if (c.background) c.background = remapUrl(c.background);
      if (c.thumbnail) c.thumbnail = remapUrl(c.thumbnail);
      return true;
    });
    categories.forEach(function (category) {
      category.items = _this2._expandItems(category.items.filter(function (a) {
        try {
          reg.validate(a);
          if (a.background) a.background = remapUrl(a.background);
          if (a.thumbnail) a.thumbnail = remapUrl(a.thumbnail);
        } catch (e) {
          _this2._logInvalidObject('Item is invalid: ' + e, a);

          return false;
        }

        return true;
      }).sort(_this2.TITLE_SORT));
    });
    this.uniqueCategoryCount = categories.length;
    categories = this._expandItems(categories.filter(function (c) {
      return c.items.length > 0 || !_this2.filterCategories;
    }));

    if (categories.length === 0 && this.filterCategories) {
      throw new Error("No valid categories found.");
    }

    this.categories = categories;
  };

  _proto.getTitle = function getTitle() {
    return this.originalFeed.title;
  };

  _proto.getProps = function getProps() {
    return this.originalFeed.props ? this.originalFeed.props : {};
  };

  _proto.getCategories = function getCategories() {
    return this.categories;
  };

  _proto.getUniqueCategoryCount = function getUniqueCategoryCount() {
    return this.uniqueCategoryCount;
  };

  _proto.getApps = function getApps(categoryId) {
    var category = this.categories.filter(function (c) {
      return c.id === categoryId;
    });

    if (category.length > 0) {
      return category[0].items;
    }

    throw new Error("Unable to find category with id: " + categoryId);
  };

  _proto.findCategoryByTitle = function findCategoryByTitle(title) {
    if (!title) return null;

    for (var i = 0; i < this.categories.length; i++) {
      var cat = this.categories[i];

      if (cat.title === title) {
        return cat;
      }
    }

    return null;
  };

  _proto.getClonedFeed = function getClonedFeed() {
    var feed = cloneObject(this.originalFeed);
    feed.categories = this.categories ? cloneObject(this.categories) : [];
    return feed;
  };

  return Feed;
}(FeedBase);

var FEEDS_PROP = "feeds";
var LOCAL_FEEDS_PREFIX = "localFeeds.";

var Feeds = /*#__PURE__*/function (_FeedBase) {
  _inheritsLoose(Feeds, _FeedBase);

  function Feeds(feeds, minLength) {
    var _this;

    _this = _FeedBase.call(this, minLength) || this;

    _this._storeFeeds = function () {
      try {
        var outFeeds = [];

        _this.getDistinctFeeds().forEach(function (e) {
          var f = _extends({}, e);

          outFeeds.push(f);
        });

        var _temp2 = _catch(function () {
          return Promise.resolve(storage.put(FEEDS_PROP, outFeeds)).then(function () {});
        }, function (e) {
          error("Error storing feeds: " + e);
        });

        return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.parsedFeeds = [];
    _this.feeds = [];
    feeds.forEach(function (f) {
      return _this._addFeed(f);
    });

    _this._expand();

    return _this;
  }

  Feeds.isDeleteEnabled = function isDeleteEnabled(feed) {
    return feed.feedId !== Feeds.DEFAULT_ID && feed.feedId !== Feeds.ADD_ID;
  };

  Feeds.getUrl = function getUrl(feed) {
    return feed.url ? feed.url === Feeds.NONE_URL ? null : feed.url : null;
  };

  var _proto = Feeds.prototype;

  _proto.isExistingLocalFeed = function isExistingLocalFeed(title) {
    return this._getFeedIndexForTitle(title, true) !== -1;
  };

  _proto.addLocalFeed = function addLocalFeed(feed) {
    try {
      var _temp6 = function _temp6() {
        var _exit = false;
        var newFeed = {
          feedId: oldFeedId ? oldFeedId : uuidv4(),
          localId: oldLocalId ? oldLocalId : uuidv4(),
          title: feed.title
        };
        if (feed.longTitle) newFeed.longTitle = feed.longTitle;
        if (feed.description) newFeed.description = feed.description;
        if (feed.thumbnail) newFeed.thumbnail = feed.thumbnail;
        if (feed.background) newFeed.background = feed.background;

        var addedFeed = _this3._addFeed(newFeed);

        var _temp3 = function () {
          if (addedFeed) {
            return Promise.resolve(storage.put(LOCAL_FEEDS_PREFIX + addedFeed.localId, feed)).then(function () {
              return Promise.resolve(_this3._storeFeeds()).then(function () {
                _this3._expand();

                _exit = true;
                return addedFeed;
              });
            });
          }
        }();

        return _temp3 && _temp3.then ? _temp3.then(function (_result) {
          return _exit ? _result : null;
        }) : _exit ? _temp3 : null;
      };

      var _this3 = this;

      if (!feed.title) {
        return Promise.resolve();
      }

      var index = _this3._getFeedIndexForTitle(feed.title);

      var oldFeedId = null;
      var oldLocalId = null;

      var _temp7 = function () {
        if (index >= 0) {
          var oldFeed = _this3.feeds[index];
          oldFeedId = oldFeed.feedId;
          oldLocalId = oldFeed.localId;
          return Promise.resolve(_this3.removeFeed(oldFeedId)).then(function () {});
        }
      }();

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(_temp6) : _temp6(_temp7));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getLocalFeed = function getLocalFeed(localId) {
    try {
      return Promise.resolve(storage.get(LOCAL_FEEDS_PREFIX + localId));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.addRemoteFeed = function addRemoteFeed(url, inFeed) {
    try {
      var _exit3 = false;

      var _this5 = this;

      var index = _this5._getFeedIndexForUrl(url);

      var exists = index >= 0;
      var feed = exists ? _this5.feeds[index] : _this5._addFeed({
        title: "New feed",
        url: url
      });

      var _temp11 = function () {
        if (feed) {
          var _temp12 = function _temp12() {
            _this5._expand();

            _exit3 = true;
            return feed;
          };

          var updated = _this5._updateFeed(url, inFeed);

          var _temp13 = function () {
            if (!exists || updated) {
              return Promise.resolve(_this5._storeFeeds()).then(function () {});
            }
          }();

          return _temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13);
        }
      }();

      return Promise.resolve(_temp11 && _temp11.then ? _temp11.then(function (_result2) {
        return _exit3 ? _result2 : null;
      }) : _exit3 ? _temp11 : null);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.removeFeed = function removeFeed(feedId) {
    try {
      var _this7 = this;

      var index = _this7.feeds.findIndex(function (f) {
        return f.feedId === feedId;
      });

      var _temp17 = function () {
        if (index >= 0) {
          var _temp18 = function _temp18() {
            _this7.feeds.splice(index, 1);

            return Promise.resolve(_this7._storeFeeds()).then(function () {
              _this7._expand();
            });
          };

          var feed = _this7.feeds[index];

          var _temp19 = function () {
            if (feed.localId) {
              return Promise.resolve(storage.remove(LOCAL_FEEDS_PREFIX + feed.localId)).then(function () {});
            }
          }();

          return _temp19 && _temp19.then ? _temp19.then(_temp18) : _temp18(_temp19);
        }
      }();

      return Promise.resolve(_temp17 && _temp17.then ? _temp17.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getFeedForUrl = function getFeedForUrl(url) {
    var index = this._getFeedIndexForUrl(url);

    return index !== -1 ? this.feeds[index] : null;
  };

  _proto.getFeedWithId = function getFeedWithId(id) {
    for (var i = 0; i < this.feeds.length; i++) {
      var feed = this.feeds[i];

      if (feed.feedId === id) {
        return feed;
      }
    }

    return null;
  };

  _proto.remapUrls = function remapUrls(feeds) {
    for (var i = 0; i < feeds.length; i++) {
      var feed = feeds[i];
      if (feed.background) feed.background = remapUrl(feed.background);
      if (feed.thumbnail) feed.thumbnail = remapUrl(feed.thumbnail);
    }

    return feeds;
  };

  _proto.getDistinctFeeds = function getDistinctFeeds() {
    return this.remapUrls(this.feeds);
  };

  _proto.getFeeds = function getFeeds() {
    return this.remapUrls(this.expandedFeeds);
  };

  _proto._validate = function _validate(f) {
    if (isEmptyString(f.title)) {
      this._logInvalidObject('Feed missing title', f);

      return false;
    } else if (isEmptyString(f.url) && isEmptyString(f.localId)) {
      this._logInvalidObject('Feed missing url or local identifier', f);

      return false;
    }

    return true;
  };

  _proto._updateFeed = function _updateFeed(url, feed) {
    var index = this._getFeedIndexForUrl(url);

    var changed = false;

    if (index >= 0) {
      var f = this.feeds[index];
      var props = ['title', 'longTitle', 'description', 'thumbnail', 'background'];
      props.forEach(function (p) {
        if (f[p] !== feed[p]) {
          changed = true;

          if (feed[p]) {
            f[p] = feed[p];
          } else {
            delete f[p];
          }
        }
      });
    }

    if (changed) {
      this._expand();
    }

    return changed;
  };

  _proto._addFeed = function _addFeed(f) {
    var feed = _extends({}, f);

    if (this._validate(feed)) {
      if (!feed.feedId) {
        feed.feedId = uuidv4();
      }

      this.feeds.push(feed);
      return feed;
    }

    return null;
  };

  _proto._getFeedIndexForUrl = function _getFeedIndexForUrl(url) {
    var index = this.feeds.findIndex(function (feed) {
      return feed.url && feed.url.toUpperCase() === url.toUpperCase();
    });
    return index;
  };

  _proto._getFeedIndexForTitle = function _getFeedIndexForTitle(title, isLocal) {
    if (isLocal === void 0) {
      isLocal = true;
    }

    var index = this.feeds.findIndex(function (feed) {
      return feed.title === title && (!isLocal || feed.localId);
    });
    return index;
  };

  _proto._expand = function _expand() {
    var expandedFeeds = [].concat(this.feeds);
    expandedFeeds.sort(this.TITLE_SORT);

    if (!config.isEmptyDefaultFeed()) {
      expandedFeeds.unshift({
        feedId: Feeds.DEFAULT_ID,
        title: "Default",
        longTitle: "Default Feed",
        description: "The default feed contains a collection of high-quality publicly available games and demos across the various applications (emulators, engines, etc.) that are supported by webЯcade.",
        url: Feeds.NONE_URL,
        thumbnail: "default-feed/images/default-thumb.png",
        background: "default-feed/images/default-background.png"
      });
    }

    expandedFeeds.unshift({
      feedId: Feeds.ADD_ID,
      title: "Add Feed",
      longTitle: "Add Feed",
      description: "Register a new feed with webЯcade by selecting one of the buttons below. Use the \"URL\" button to register a cloud-based feed or the \"FILE\" button for a locally stored feed file.",
      url: Feeds.NONE_URL,
      thumbnail: "images/add-thumb.png",
      background: "images/add-background.png"
    });
    expandedFeeds = this._expandItems(expandedFeeds);
    this.expandedFeeds = expandedFeeds;
  };

  return Feeds;
}(FeedBase);

Feeds.DEFAULT_ID = -1;
Feeds.ADD_ID = -2;
Feeds.NONE_URL = "none";

var loadFeeds = function loadFeeds(minSlidesLength) {
  try {
    return Promise.resolve(_catch(function () {
      return Promise.resolve(storage.get(FEEDS_PROP)).then(function (feedsProp) {
        return new Feeds(feedsProp ? feedsProp : [], minSlidesLength);
      });
    }, function (e) {
      error("Error reading feeds: " + e);
      return new Feeds([], minSlidesLength);
    }));
  } catch (e) {
    return Promise.reject(e);
  }
};

var blobToJson = function blobToJson(blob) {
  return new Promise(function (resolve, reject) {
    var fr = new FileReader();

    fr.onload = function (e) {
      try {
        try {
          var contents = e.target.result;
          resolve(JSON.parse(contents));
        } catch (e) {
          reject(e);
        }

        return Promise.resolve();
      } catch (e) {
        return Promise.reject(e);
      }
    };

    fr.onerror = function (e) {
      reject(e);
    };

    fr.readAsText(blob);
  });
};

var getFeedAsJson = function getFeedAsJson(blob) {
  try {
    var uz = new Unzip().setDebug(true);
    return Promise.resolve(uz.unzip(blob, [], [])).then(function (_uz$unzip) {
      blob = _uz$unzip;
      var fileReader = new Promise(function (resolve, reject) {
        var fr = new FileReader();

        fr.onload = function (e) {
          try {
            var _temp5 = _catch(function () {
              function _temp3() {
                function _temp(_blobToJson) {
                  resolve(_blobToJson);
                }

                var _b = b;
                return _b ? Promise.resolve(blobToJson(b)).then(_temp) : _temp(JSON.parse(contents));
              }

              var contents = e.target.result;
              var b = null;

              var _temp2 = function () {
                if (Base64.isBase64(contents)) {
                  return Promise.resolve(fetch("data:application/octet-stream;base64," + contents)).then(function (b64) {
                    return Promise.resolve(b64.blob()).then(function (_b64$blob) {
                      b = _b64$blob;
                      return Promise.resolve(uz.unzip(b, [], [])).then(function (_uz$unzip2) {
                        b = _uz$unzip2;
                      });
                    });
                  });
                }
              }();

              return _temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2);
            }, function (e) {
              reject('Error reading feed: ' + e);
            });

            return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
          } catch (e) {
            return Promise.reject(e);
          }
        };

        fr.onerror = function (e) {
          reject('Error reading feed: ' + e);
        };

        fr.readAsText(blob);
      });
      return Promise.resolve(fileReader);
    });
  } catch (e) {
    return Promise.reject(e);
  }
};

var WebrcadeContext = React.createContext({});

var styles$2 = {"image-button":"_6miOA"};

var ImageButton = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ImageButton, _Component);

  function ImageButton() {
    var _this;

    _this = _Component.call(this) || this;

    _this.gamepadCallback = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onPad = _this$props.onPad,
          onPadClick = _this$props.onPadClick;
      var focused = _this.state.focused;
      if (!focused) return false;

      if (disabled) {
        _this.setState({
          focused: false
        });

        return false;
      }

      switch (e.type) {
        case GamepadEnum.A:
          if (onPadClick) onPadClick(e);

          _this.onClick(e);

          break;

        case GamepadEnum.DOWN:
        case GamepadEnum.UP:
        case GamepadEnum.LEFT:
        case GamepadEnum.RIGHT:
        case GamepadEnum.LBUMP:
        case GamepadEnum.RBUMP:
          if (onPad) onPad(e);
          break;
      }

      return true;
    };

    _this.onClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e);
    };

    _this.onFocus = function (e) {
      _this.setState({
        focused: true
      });

      var onFocus = _this.props.onFocus;
      if (onFocus) onFocus(e);
    };

    _this.onMouseEnter = function () {
      var onMouseEnter = _this.props.onMouseEnter;
      if (onMouseEnter) onMouseEnter();
    };

    _this.onMouseLeave = function () {
      var onMouseLeave = _this.props.onMouseLeave;
      if (onMouseLeave) onMouseLeave();
    };

    _this.onBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.state = {
      focused: false
    };
    return _this;
  }

  var _proto = ImageButton.prototype;

  _proto.getButton = function getButton() {
    return this.button;
  };

  _proto.componentDidMount = function componentDidMount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.addCallback(this.gamepadCallback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.removeCallback(this.gamepadCallback);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var disabled = this.props.disabled;
    var focused = this.state.focused;

    if (disabled && focused) {
      this.setState({
        focused: false
      });
    }
  };

  _proto.isFocusable = function isFocusable() {
    var button = this.button;
    var disabled = this.props.disabled;

    if (disabled) {
      return false;
    }

    return button.offsetWidth > 0 && button.offsetHeight;
  };

  _proto.focus = function focus() {
    var disabled = this.props.disabled;
    var focused = this.state.focused;
    var button = this.button;
    var disabledBtn = disabled ? true : false;

    if (!focused && !disabledBtn && button) {
      button.focus();
      return true;
    }

    return false;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        hoverImgSrc = _this$props2.hoverImgSrc,
        imgSrc = _this$props2.imgSrc,
        label = _this$props2.label,
        labelClassName = _this$props2.labelClassName,
        onTouchStart = _this$props2.onTouchStart,
        onTouchEnd = _this$props2.onTouchEnd,
        onMouseDown = _this$props2.onMouseDown;
    var focused = this.state.focused;
    var disabledBtn = disabled ? true : false;
    return /*#__PURE__*/React.createElement("button", {
      disabled: disabledBtn,
      className: className === undefined ? styles$2['image-button'] : className,
      ref: function ref(button) {
        _this2.button = button;
      },
      onTouchStart: onTouchStart,
      onTouchEnd: onTouchEnd,
      onClick: this.onClick,
      onFocus: this.onFocus,
      onMouseDown: onMouseDown,
      onMouseEnter: this.onMouseEnter,
      onMouseLeave: this.onMouseLeave,
      onBlur: this.onBlur
    }, " ", imgSrc ? /*#__PURE__*/React.createElement("img", {
      alt: label,
      src: focused && hoverImgSrc ? hoverImgSrc : imgSrc
    }) : null, labelClassName ? /*#__PURE__*/React.createElement("div", {
      className: labelClassName
    }, label) : /*#__PURE__*/React.createElement("div", null, label));
  };

  return ImageButton;
}(Component);
ImageButton.contextType = WebrcadeContext;

var styles$3 = {"screen":"_24S2R","fadein":"_3VZYe","screen-transparency":"_JuOW5","fadeinpause":"_lL_Wr"};

var Screen = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Screen, _Component);

  function Screen() {
    var _this;

    _this = _Component.call(this) || this;
    _this.focusGrid = new FocusGrid();
    _this.gamepadNotifier = new GamepadNotifier();
    _this.screenContext = {
      gamepadNotifier: _this.gamepadNotifier,
      focusGrid: _this.focusGrid
    };
    _this.screenStyles = styles$3;

    _this.globalGamepadCallback = function (e) {
      if (e.type === GamepadEnum.ESC) {
        _this.close();
      }
    };

    _this.handleKeyUpEvent = function (e) {
      if (isEscapeKeySequence(e) || e.code === KCODES.ESCAPE) {
        _this.close();
      }
    };

    _this.defaultGamepadCallback = function (e) {
      _this.focus();

      return true;
    };

    _this.focusGrid.setUnhandledGamepadInputCallback(function (input) {
      _this.onUnhandledGamepadInput(input);
    });

    return _this;
  }

  var _proto = Screen.prototype;

  _proto.onUnhandledGamepadInput = function onUnhandledGamepadInput(input) {};

  _proto.focus = function focus() {
    var focusGrid = this.focusGrid;
    focusGrid.focus();
  };

  _proto.close = function close() {
    var closeCallback = this.props.closeCallback;
    if (closeCallback) closeCallback();
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var gamepadNotifier = this.gamepadNotifier;
    gamepadNotifier.start();
    gamepadNotifier.setDefaultCallback(this.defaultGamepadCallback);
    gamepadNotifier.addGlobalCallback(this.globalGamepadCallback);
    var docElement = document.documentElement;
    docElement.addEventListener("keyup", this.handleKeyUpEvent);
    setTimeout(function () {
      _this2.focus();
    }, 50);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.gamepadNotifier;
    gamepadNotifier.stop();
    gamepadNotifier.setDefaultCallback(null);
    gamepadNotifier.removeGlobalCallback(this.globalGamepadCallback);
    var docElement = document.documentElement;
    docElement.removeEventListener("keyup", this.handleKeyUpEvent);
  };

  return Screen;
}(Component);

var styles$4 = {"alert-screen":"_3vLjH","alert-screen-inner":"_3SNG1","alert-screen-message":"_1uezp","alert-screen-buttons":"_2_lRq"};

var AlertScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(AlertScreen, _Screen);

  function AlertScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.okButtonRef = React.createRef();

    _this.focusGrid.setComponents([[_this.okButtonRef]]);

    return _this;
  }

  var _proto = AlertScreen.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var okButtonRef = this.okButtonRef,
        screenContext = this.screenContext,
        screenStyles = this.screenStyles;
    var _this$props = this.props,
        message = _this$props.message,
        showButtons = _this$props.showButtons;
    var buttonStyle = !showButtons ? {
      display: 'none'
    } : null;
    return /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4['alert-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4['alert-screen-inner'] + " " + screenStyles.screen
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$4['alert-screen-message']
    }, message), /*#__PURE__*/React.createElement("div", {
      className: styles$4['error-screen-buttons'],
      style: buttonStyle
    }, /*#__PURE__*/React.createElement(ImageButton, {
      ref: okButtonRef,
      label: Resources.getText(TEXT_IDS.OK),
      onClick: function onClick() {
        return _this2.close();
      }
    })))));
  };

  return AlertScreen;
}(Screen);

var styles$5 = {"error-screen":"_2hN9h","error-screen-inner":"_1qZf2","error-screen-heading":"__1qPk","error-screen-message":"_lDZev","error-screen-buttons":"_1Pc-x"};

var ErrorScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(ErrorScreen, _Screen);

  function ErrorScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.okButtonRef = React.createRef();

    _this.focusGrid.setComponents([[_this.okButtonRef]]);

    return _this;
  }

  var _proto = ErrorScreen.prototype;

  _proto.formatMessage = function formatMessage(message) {
    return message.split("\n").map(function (item) {
      return item + "<br/>";
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var okButtonRef = this.okButtonRef,
        screenContext = this.screenContext,
        screenStyles = this.screenStyles;
    var message = this.props.message;

    if (message.message) {
      message = message.message;
    }

    if (!message) {
      message = Resources.getText(TEXT_IDS.ERROR_UNKNOWN);
    }

    var msg = message + "\n" + Resources.getText(TEXT_IDS.SEE_CONSOLE_LOG);
    return /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5['error-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5['error-screen-inner'] + " " + screenStyles.screen
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$5['error-screen-heading']
    }, Resources.getText(TEXT_IDS.SOMETHING_WENT_WRONG)), /*#__PURE__*/React.createElement("div", {
      className: styles$5['error-screen-message']
    }, msg.split('\n').map(function (item, key) {
      return key < 5 ? /*#__PURE__*/React.createElement("div", {
        key: key
      }, item) : null;
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$5['error-screen-buttons']
    }, /*#__PURE__*/React.createElement(ImageButton, {
      ref: okButtonRef,
      label: Resources.getText(TEXT_IDS.OK),
      onClick: function onClick() {
        return _this2.close();
      }
    })))));
  };

  return ErrorScreen;
}(Screen);

var styles$6 = {"overlay-screen":"_1EdfC","overlay-screen-inner":"_2fzXq","overlay-screen-inner-unmute":"_3kAeI","overlay-screen-inner-unmute-button":"_3_mWk","overlay-screen-inner-unmute-button-img":"_bXm8E","overlay-screen-inner-unmute-button-label":"_1s7E8","overlay-screen-inner-unmute-button-label-inner":"_3UVe4","overlay-screen-inner-unmute-button-label--hide":"_1rLRd"};

var OverlayScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(OverlayScreen, _Screen);

  function OverlayScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.unmuteTextTimeoutId = null;
    _this.state = {
      hideUnmuteText: false
    };
    return _this;
  }

  var _proto = OverlayScreen.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.unmuteTextTimeoutId = setTimeout(function () {
      _this2.unmuteTextTimeoutId = null;

      _this2.setState({
        hideUnmuteText: true
      });
    }, 5000);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var unmuteTextTimeoutId = this.unmuteTextTimeoutId;

    if (unmuteTextTimeoutId) {
      clearTimeout(unmuteTextTimeoutId);
    }
  };

  _proto.render = function render() {
    var screenContext = this.screenContext,
        screenStyles = this.screenStyles;
    var hideUnmuteText = this.state.hideUnmuteText;
    var buttonPrefix = "overlay-screen-inner-unmute-button";
    var tapText = Resources.getText(isTouchSupported() ? TEXT_IDS.TAP_TO_UNMUTE : TEXT_IDS.CLICK_TO_UNMUTE);
    return /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6['overlay-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6['overlay-screen-inner'] + " " + screenStyles.screen
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6['overlay-screen-inner-unmute']
    }, /*#__PURE__*/React.createElement("button", {
      tabIndex: "-1",
      className: styles$6[buttonPrefix]
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$6[buttonPrefix + '-img'],
      alt: tapText,
      src: VolumeOffBlackImage
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$6[buttonPrefix + '-label'] + " " + (hideUnmuteText ? styles$6[buttonPrefix + '-label--hide'] : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$6[buttonPrefix + '-label-inner']
    }, tapText)))))));
  };

  return OverlayScreen;
}(Screen);

var styles$7 = {"editor-screen":"_23LJF","editor-screen-inner":"_QxYEW","editor-screen-heading":"_1OdS7","editor-screen-heading-group":"_2k8Sx","editor-screen-heading-group-right-text":"_R64Gp","editor-screen-heading-group-image":"_AqRKW","editor-screen-heading-group-button":"_17LMl","editor-screen-content":"_3aKyj","editor-screen-content-container":"_1ytqs","editor-screen-buttons":"_E4PtH","editor-screen-content-fade-in":"_1KfgM","editor-screen-button-hide":"_3LSfo","editor-screen-fadeinpause":"_1ebv0"};

var EditorScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(EditorScreen, _Screen);

  function EditorScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.analogCallback = null;
    _this.okButtonRef = React.createRef();
    _this.cancelButtonRef = React.createRef();
    _this.tabLeftRef = React.createRef();
    _this.tabRightRef = React.createRef();
    _this.state = {
      tabIndex: 0
    };
    return _this;
  }

  var _proto = EditorScreen.prototype;

  _proto.focus = function focus() {
    var okButtonRef = this.okButtonRef;

    if (this.gamepadNotifier.padCount > 0) {
      if (okButtonRef && okButtonRef.current) {
        okButtonRef.current.focus();
      }
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var gamepadNotifier = this.gamepadNotifier;
    var tabIndex = this.state.tabIndex;

    _Screen.prototype.componentDidMount.call(this);

    if (!this.analogCallback) {
      this.analogCallback = function (e) {
        if (e.type === 'r_analog_y') {
          if (_this2.contentRef) {
            var el = _this2.contentRef;
            var height = el.scrollHeight - el.clientHeight;
            var adjust = el.scrollTop + e.value * 10;

            if (adjust < 0) {
              adjust = 0;
            } else if (adjust > height) {
              adjust = height;
            }

            el.scrollTop = adjust;
          }
        }
      };

      gamepadNotifier.addAnalogCallback(this.analogCallback);
    }

    this.setFocusGridComponents(null);
    this.onTabChange(undefined, tabIndex);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.gamepadNotifier;

    _Screen.prototype.componentWillUnmount.call(this);

    if (this.analogCallback) {
      gamepadNotifier.removeAnalogCallback(this.analogCallback);
    }
  };

  _proto.onTabChange = function onTabChange(prevTabIndex, newTabIndex) {
    var onTabChange = this.props.onTabChange;
    if (onTabChange) onTabChange(prevTabIndex, newTabIndex);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var tabIndex = this.state.tabIndex;
    var focusGridComps = this.props.focusGridComps;
    var prevTabIndex = prevState.tabIndex;

    if (prevTabIndex !== tabIndex) {
      this.onTabChange(prevTabIndex, tabIndex);
    }

    var prevFocusGridComps = prevProps.focusGridComps;

    if (focusGridComps !== prevFocusGridComps) {
      this.setFocusGridComponents(focusGridComps);
    }
  };

  _proto.setFocusGridComponents = function setFocusGridComponents(gridComps) {
    var focusGrid = this.focusGrid;
    var showCancel = this.props.showCancel;
    var comps = [];
    comps.push([this.tabLeftRef, this.tabRightRef]);

    if (gridComps) {
      for (var i in gridComps) {
        comps.push(gridComps[i]);
      }
    }

    if (showCancel) {
      comps.push([this.okButtonRef, this.cancelButtonRef]);
    } else {
      comps.push([this.okButtonRef]);
    }

    focusGrid.setComponents(comps);
  };

  _proto.onUnhandledGamepadInput = function onUnhandledGamepadInput(input) {
    if (input === GamepadEnum.LBUMP) {
      this.switchTab(true, false);
    } else if (input === GamepadEnum.RBUMP) {
      this.switchTab(false, false);
    }
  };

  _proto.renderTabButton = function renderTabButton(isPrev) {
    var _this3 = this;

    var tabLeftRef = this.tabLeftRef,
        tabRightRef = this.tabRightRef,
        focusGrid = this.focusGrid;
    var tabs = this.props.tabs;
    var tabIndex = this.state.tabIndex;
    var MIN_TAB = 0;
    var MAX_TAB = tabs.length - 1;
    var disabled = isPrev && tabIndex === MIN_TAB || !isPrev && tabIndex === MAX_TAB;
    return /*#__PURE__*/React.createElement(ImageButton, {
      className: styles$7['editor-screen-heading-group-button'] + (disabled ? ' ' + styles$7['editor-screen-button-hide'] : ''),
      disabled: disabled,
      ref: isPrev ? tabLeftRef : tabRightRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, isPrev ? tabLeftRef : tabRightRef);
      },
      imgSrc: isPrev ? ChevronLeftWhiteImage : ChevronRightWhiteImage,
      onClick: function onClick() {
        _this3.switchTab(isPrev);
      }
    });
  };

  _proto.switchTab = function switchTab(isPrev, focus) {
    var _this4 = this;

    if (focus === void 0) {
      focus = true;
    }

    var tabLeftRef = this.tabLeftRef,
        tabRightRef = this.tabRightRef;
    var tabs = this.props.tabs;
    var tabIndex = this.state.tabIndex;
    var MIN_TAB = 0;
    var MAX_TAB = tabs.length - 1;
    var disabled = isPrev && tabIndex === MIN_TAB || !isPrev && tabIndex === MAX_TAB;

    var fadeOut = function fadeOut() {
      _this4.headingRef.classList.remove(styles$7['editor-screen-content-fade-in']);

      _this4.contentRef.classList.remove(styles$7['editor-screen-content-fade-in']);

      _this4.contentRef.scrollTop = 0;
    };

    if (!disabled) {
      fadeOut();
      var newIndex = isPrev ? tabIndex - 1 : tabIndex + 1;

      if (focus) {
        if (isPrev && newIndex === MIN_TAB || !isPrev && newIndex === MAX_TAB) {
          setTimeout(function () {
            if (isPrev) {
              tabRightRef.current.focus();
            } else {
              tabLeftRef.current.focus();
            }
          }, 50);
        }
      }

      this.setState({
        tabIndex: newIndex
      });
    }
  };

  _proto.renderTabImage = function renderTabImage(tabIndex) {
    var tabs = this.props.tabs;
    return /*#__PURE__*/React.createElement("img", {
      className: styles$7['editor-screen-heading-group-image'],
      src: tabs[tabIndex].image,
      alt: ""
    });
  };

  _proto.renderTabLabel = function renderTabLabel(tabIndex) {
    var tabs = this.props.tabs;
    return /*#__PURE__*/React.createElement("span", {
      className: styles$7['editor-screen-heading-group-right-text']
    }, tabs[tabIndex].label);
  };

  _proto.renderContent = function renderContent(tabIndex) {
    var tabs = this.props.tabs;
    return tabs[tabIndex].content;
  };

  _proto.render = function render() {
    var _this5 = this;

    var okButtonRef = this.okButtonRef,
        cancelButtonRef = this.cancelButtonRef,
        screenContext = this.screenContext,
        screenStyles = this.screenStyles,
        focusGrid = this.focusGrid;
    var _this$props = this.props,
        hidden = _this$props.hidden,
        okLabel = _this$props.okLabel,
        onOk = _this$props.onOk,
        onClose = _this$props.onClose,
        showCancel = _this$props.showCancel;
    var tabIndex = this.state.tabIndex;
    setTimeout(function () {
      if (_this5.headingRef) {
        _this5.headingRef.classList.add(styles$7['editor-screen-content-fade-in']);
      }

      if (_this5.contentRef) {
        _this5.contentRef.classList.add(styles$7['editor-screen-content-fade-in']);
      }
    }, 50);
    var divStyles = {};

    if (hidden) {
      divStyles.display = 'none';
    }

    return /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, /*#__PURE__*/React.createElement("div", {
      className: screenStyles['screen-transparency'],
      style: _extends({}, {
        'animation': 'none'
      }, divStyles)
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen'],
      style: divStyles
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen-inner']
    }, /*#__PURE__*/React.createElement("div", {
      ref: function ref(heading) {
        _this5.headingRef = heading;
      },
      className: styles$7['editor-screen-heading']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen-heading-group']
    }, this.renderTabButton(true), this.renderTabImage(tabIndex), this.renderTabLabel(tabIndex), this.renderTabButton(false))), /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen-content'],
      ref: function ref(content) {
        _this5.contentRef = content;
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen-content-container'],
      key: "tab" + tabIndex
    }, this.renderContent(tabIndex))), /*#__PURE__*/React.createElement("div", {
      className: styles$7['editor-screen-buttons']
    }, /*#__PURE__*/React.createElement(ImageButton, {
      ref: okButtonRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, okButtonRef);
      },
      label: okLabel ? okLabel : Resources.getText(TEXT_IDS.OK),
      onClick: function onClick() {
        if (onOk) {
          onOk();
        } else {
          onClose();
        }
      }
    }), showCancel ? /*#__PURE__*/React.createElement(ImageButton, {
      ref: cancelButtonRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, cancelButtonRef);
      },
      label: Resources.getText(TEXT_IDS.CANCEL),
      onClick: function onClick() {
        return onClose();
      }
    }) : null))));
  };

  return EditorScreen;
}(Screen);
var EditorTab = /*#__PURE__*/function (_Component) {
  _inheritsLoose(EditorTab, _Component);

  function EditorTab() {
    return _Component.apply(this, arguments) || this;
  }

  return EditorTab;
}(Component);

var styles$8 = {"controls-screen-row":"_36jkv","controls-screen-column":"_1YZKt","controls-gamepad-button":"_2Sb1H"};

var ControlsTab = /*#__PURE__*/function (_EditorTab) {
  _inheritsLoose(ControlsTab, _EditorTab);

  function ControlsTab() {
    return _EditorTab.apply(this, arguments) || this;
  }

  var _proto = ControlsTab.prototype;

  _proto.getGamepadImage = function getGamepadImage(control) {
    switch (control) {
      case "start":
        return XboxOneMenuButton;

      case "select":
        return XboxOneWindowsButton;

      case "dpad":
        return XboxOneDpad;

      case "lanalog":
        return XboxOneLeftStick;

      case "ranalog":
        return XboxOneRightStick;

      case "a":
        return XboxOneAButton;

      case "b":
        return XboxOneBButton;

      case "x":
        return XboxOneXButton;

      case "y":
        return XboxOneYButton;

      case "lbump":
        return XboxOneLeftBumper;

      case "rbump":
        return XboxOneRightBumper;

      case "ltrig":
        return XboxOneLeftTrigger;

      case "rtrig":
        return XboxOneRightTrigger;
    }
  };

  _proto.getKeyImage = function getKeyImage(key) {
    switch (key) {
      case 'Escape':
        return EscapeKey;

      case 'Enter':
        return EnterKey;

      case 'ControlLeft':
        return ControlKey;

      case 'ShiftRight':
        return ShiftKey;

      case 'ShiftLeft':
        return ShiftKey;

      case 'Space':
        return SpaceKey;

      case 'ArrowRight':
        return ArrowRightKey;

      case 'ArrowLeft':
        return ArrowLeftKey;

      case 'ArrowUp':
        return ArrowUpKey;

      case 'ArrowDown':
        return ArrowDownKey;

      case 'KeyZ':
        return ZKey;

      case 'KeyX':
        return XKey;

      case 'KeyC':
        return CKey;

      case 'KeyV':
        return VKey;

      case 'KeyA':
        return AKey;

      case 'KeyS':
        return SKey;

      case 'KeyD':
        return DKey;

      case 'KeyQ':
        return QKey;

      case 'KeyW':
        return WKey;

      case 'KeyI':
        return IKey;

      case 'KeyJ':
        return JKey;

      case 'KeyK':
        return KKey;

      case 'KeyL':
        return LKey;

      case 'KeyT':
        return TKey;

      case 'KeyR':
        return RKey;

      case 'KeyE':
        return EKey;

      case 'KeyPeriod':
        return PeriodKey;

      case 'Digit0':
        return ZeroKey;

      case 'Digit1':
        return OneKey;

      case 'Digit2':
        return TwoKey;

      case 'Digit3':
        return ThreeKey;

      case 'Digit4':
        return FourKey;

      case 'Digit5':
        return FiveKey;

      case 'Digit6':
        return SixKey;

      case 'Digit7':
        return SevenKey;

      case 'Digit8':
        return EightKey;

      case 'Digit9':
        return NineKey;

      case 'Minus':
        return MinusKey;

      case 'Equal':
        return EqualsKey;

      case 'KeyF5':
        return F5Key;

      case 'KeyF7':
        return F7Key;

      default:
        return "";
    }
  };

  _proto.renderKey = function renderKey(key, description) {
    return /*#__PURE__*/React.createElement("div", {
      key: key,
      className: styles$8['controls-screen-row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$8['controls-gamepad-button'],
      src: this.getKeyImage(key),
      alt: ""
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, description));
  };

  _proto.renderKeys = function renderKeys(keyList, description) {
    var keys = [];

    for (var i = 0; i < keyList.length; i++) {
      var key = keyList[i];

      if (i > 0) {
        keys.push( /*#__PURE__*/React.createElement("div", {
          style: {
            whiteSpace: 'nowrap'
          }
        }, "\xA0+\xA0"));
      }

      keys.push( /*#__PURE__*/React.createElement("img", {
        className: styles$8['controls-gamepad-button'],
        src: this.getKeyImage(key),
        alt: ""
      }));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, keys)), /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, description));
  };

  _proto.renderControl = function renderControl(control, description) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$8['controls-gamepad-button'],
      src: this.getGamepadImage(control),
      alt: ""
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, description));
  };

  _proto.renderControlWithText = function renderControlWithText(control, text, description) {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-row']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$8['controls-gamepad-button'],
      src: this.getGamepadImage(control),
      alt: ""
    }), text), /*#__PURE__*/React.createElement("div", {
      className: styles$8['controls-screen-column']
    }, description));
  };

  return ControlsTab;
}(EditorTab);

var styles$9 = {"fields-screen-row":"_3e512","fields-screen-label":"_2J1_d","fields-screen-control":"_1FOsd","fields-screen-span":"_VwhaF"};

var FieldRow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FieldRow, _Component);

  function FieldRow() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = FieldRow.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9['fields-screen-row']
    }, children);
  };

  return FieldRow;
}(Component);
var FieldLabel = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(FieldLabel, _Component2);

  function FieldLabel() {
    return _Component2.apply(this, arguments) || this;
  }

  var _proto2 = FieldLabel.prototype;

  _proto2.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9['fields-screen-label']
    }, children);
  };

  return FieldLabel;
}(Component);
var FieldControl = /*#__PURE__*/function (_Component3) {
  _inheritsLoose(FieldControl, _Component3);

  function FieldControl() {
    return _Component3.apply(this, arguments) || this;
  }

  var _proto3 = FieldControl.prototype;

  _proto3.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9['fields-screen-control']
    }, children);
  };

  return FieldControl;
}(Component);
var FieldSpan = /*#__PURE__*/function (_Component4) {
  _inheritsLoose(FieldSpan, _Component4);

  function FieldSpan() {
    return _Component4.apply(this, arguments) || this;
  }

  var _proto4 = FieldSpan.prototype;

  _proto4.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9['fields-screen-span']
    }, children);
  };

  return FieldSpan;
}(Component);
var FieldsTab = /*#__PURE__*/function (_EditorTab) {
  _inheritsLoose(FieldsTab, _EditorTab);

  function FieldsTab() {
    return _EditorTab.apply(this, arguments) || this;
  }

  return FieldsTab;
}(EditorTab);

var styles$a = {"slottab":"_R6EUa","slottab-content":"_2GYsl","slottab-content-right":"_3Zqbn","slottab-content-right-title":"_22k12","slottab-content-right-subtitle":"_3cjPJ","slottab-content-right-buttons":"_GblnM","slottab-content-left":"_2N0V_"};

var DATE_FORMAT = {
  month: '2-digit',
  day: '2-digit',
  year: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};
var SaveStatesEditor = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SaveStatesEditor, _Component);

  function SaveStatesEditor() {
    var _this;

    _this = _Component.call(this) || this;
    _this.busy = false;
    _this.state = {
      tabIndex: null,
      focusGridComps: null,
      slots: new Array(STATE_SLOTS),
      loaded: false
    };
    return _this;
  }

  var _proto = SaveStatesEditor.prototype;

  _proto.updateStates = function updateStates(showStatus) {
    if (showStatus === void 0) {
      showStatus = true;
    }

    try {
      var _this3 = this;

      var emulator = _this3.props.emulator;
      return Promise.resolve(emulator.getStateSlots(showStatus)).then(function (slots) {
        _this3.setState({
          loaded: true,
          slots: slots ? slots : _this3.state.slots
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    var loaded = this.state.loaded;

    if (!loaded) {
      this.updateStates();
    }
  };

  _proto.render = function render() {
    var _this5 = this;

    var _this4 = this;

    var _this$props = this.props,
        emptyImageSrc = _this$props.emptyImageSrc,
        emulator = _this$props.emulator,
        onClose = _this$props.onClose,
        showStatusCallback = _this$props.showStatusCallback;
    var _this$state = this.state,
        loaded = _this$state.loaded,
        slots = _this$state.slots,
        tabIndex = _this$state.tabIndex,
        focusGridComps = _this$state.focusGridComps;
    if (!loaded) return null;

    var setFocusGridComps = function setFocusGridComps(comps) {
      _this4.setState({
        focusGridComps: comps
      });
    };

    var tabs = [];

    for (var i = 0; i < STATE_SLOTS; i++) {
      var slot = i + 1;
      tabs.push({
        image: SaveWhiteImage,
        label: "Save Slot " + slot,
        content: /*#__PURE__*/React.createElement(SlotTab, {
          editor: this,
          emptyImageSrc: emptyImageSrc,
          updateStates: function updateStates(showStatus) {
            try {
              return Promise.resolve(_this5.updateStates(showStatus)).then(function () {});
            } catch (e) {
              return Promise.reject(e);
            }
          },
          onClose: onClose,
          slot: slot,
          slots: slots,
          emulator: emulator,
          isActive: tabIndex === i,
          setFocusGridComps: setFocusGridComps,
          showStatusCallback: showStatusCallback
        })
      });
    }

    return /*#__PURE__*/React.createElement(EditorScreen, {
      showCancel: false,
      onOk: function onOk() {
        onClose();
      },
      onClose: onClose,
      focusGridComps: focusGridComps,
      onTabChange: function onTabChange(oldTab, newTab) {
        return _this4.setState({
          tabIndex: newTab
        });
      },
      tabs: tabs
    });
  };

  return SaveStatesEditor;
}(Component);

var SlotTab = /*#__PURE__*/function (_EditorTab) {
  _inheritsLoose(SlotTab, _EditorTab);

  function SlotTab() {
    var _this6;

    _this6 = _EditorTab.call(this) || this;
    _this6.loadRef = React.createRef();
    _this6.saveRef = React.createRef();
    _this6.deleteRef = React.createRef();
    _this6.gridComps = [[_this6.loadRef, _this6.saveRef, _this6.deleteRef]];
    return _this6;
  }

  var _proto2 = SlotTab.prototype;

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var gridComps = this.gridComps;
    var setFocusGridComps = this.props.setFocusGridComps;
    var isActive = this.props.isActive;

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(gridComps);
    }
  };

  _proto2.render = function render() {
    var _this7 = this;

    var loadRef = this.loadRef,
        saveRef = this.saveRef,
        deleteRef = this.deleteRef;
    var focusGrid = this.context.focusGrid;
    var _this$props2 = this.props,
        editor = _this$props2.editor,
        emptyImageSrc = _this$props2.emptyImageSrc,
        emulator = _this$props2.emulator,
        onClose = _this$props2.onClose,
        slot = _this$props2.slot,
        slots = _this$props2.slots,
        updateStates = _this$props2.updateStates,
        showStatusCallback = _this$props2.showStatusCallback;
    var currentSlot = slots[slot];
    var imageStyle = currentSlot && currentSlot.imageProps ? currentSlot.imageProps : {};
    return /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content-left']
    }, /*#__PURE__*/React.createElement("img", {
      key: "image" + slot,
      style: imageStyle,
      alt: "screenshot",
      src: currentSlot ? currentSlot.shot : emptyImageSrc
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content-right']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content-right-title']
    }, Resources.getText(TEXT_IDS.SAVE_TIME)), /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content-right-subtitle']
    }, currentSlot ? new Date(currentSlot.time).toLocaleString([], DATE_FORMAT) : Resources.getText(TEXT_IDS.SAVE_DOES_NOT_EXIST)), /*#__PURE__*/React.createElement("div", {
      className: styles$a['slottab-content-right-buttons']
    }, currentSlot && /*#__PURE__*/React.createElement(ImageButton, {
      ref: loadRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, loadRef);
      },
      label: Resources.getText(TEXT_IDS.LOAD),
      imgSrc: CloudDownloadBlackImage,
      hoverImgSrc: CloudDownloadWhiteImage,
      onClick: function onClick() {
        try {
          if (editor.busy) return Promise.resolve();

          var _temp2 = _finallyRethrows(function () {
            editor.busy = true;
            return Promise.resolve(emulator.loadStateForSlot(slot, currentSlot)).then(function () {
              onClose();
            });
          }, function (_wasThrown, _result) {
            editor.busy = false;
            if (_wasThrown) throw _result;
            return _result;
          });

          return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }), /*#__PURE__*/React.createElement(ImageButton, {
      ref: saveRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, saveRef);
      },
      label: Resources.getText(TEXT_IDS.SAVE),
      imgSrc: CloudUploadBlackImage,
      hoverImgSrc: CloudUploadWhiteImage,
      onClick: function onClick() {
        try {
          if (editor.busy) return Promise.resolve();

          var _temp4 = _finallyRethrows(function () {
            editor.busy = true;
            return Promise.resolve(emulator.saveStateForSlot(slot)).then(function () {
              onClose();
            });
          }, function (_wasThrown2, _result2) {
            editor.busy = false;
            if (_wasThrown2) throw _result2;
            return _result2;
          });

          return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }), currentSlot && /*#__PURE__*/React.createElement(ImageButton, {
      ref: deleteRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, deleteRef);
      },
      label: Resources.getText(TEXT_IDS.DELETE),
      imgSrc: DeleteForeverBlackImage,
      hoverImgSrc: DeleteForeverWhiteImage,
      onClick: function onClick() {
        try {
          if (editor.busy) return Promise.resolve();

          var _temp6 = _finallyRethrows(function () {
            editor.busy = true;
            showStatusCallback(Resources.getText(TEXT_IDS.CLOUD_DELETING));
            return Promise.resolve(emulator.deleteStateForSlot(slot, false)).then(function () {
              return Promise.resolve(updateStates(false)).then(function () {});
            });
          }, function (_wasThrown3, _result3) {
            _this7.saveRef.current.focus();

            showStatusCallback(null);
            editor.busy = false;
            if (_wasThrown3) throw _result3;
            return _result3;
          });

          return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      }
    })))));
  };

  return SlotTab;
}(EditorTab);

SlotTab.contextType = WebrcadeContext;

var styles$b = {"select":"_3ZQyJ","select-group":"_1YiUm","select-group-text":"_1vPCj","select-group-text-inner":"_2QB_S","select-group-text-inner-option":"_OTorM","select-group-button":"_2G8jD","select-group-button-img":"__K-of","select-group-button-img__disabled":"_3TP2v","select-group-button__focused":"_3fh0J","select-group-button__disabled":"_1AkxZ"};

var Arrow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Arrow, _Component);

  function Arrow() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Arrow.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        imgSrc = _this$props.imgSrc,
        _onClick = _this$props.onClick,
        focused = _this$props.focused,
        disabled = _this$props.disabled;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$b['select-group-button'] + (focused ? " " + styles$b['select-group-button__focused'] : "") + (disabled ? " " + styles$b['select-group-button__disabled'] : ""),
      onClick: function onClick() {
        _onClick();
      }
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$b['select-group-button-img'] + " " + (disabled ? styles$b['select-group-button-img__disabled'] : ""),
      src: imgSrc
    }));
  };

  return Arrow;
}(Component);

var Select = /*#__PURE__*/function (_Component2) {
  _inheritsLoose(Select, _Component2);

  function Select() {
    var _this;

    _this = _Component2.call(this) || this;

    _this.gamepadCallback = function (e) {
      var _this$props2 = _this.props,
          onPad = _this$props2.onPad,
          value = _this$props2.value,
          options = _this$props2.options,
          onChange = _this$props2.onChange;
      var focused = _this.state.focused;
      if (!focused) return false;

      switch (e.type) {
        case GamepadEnum.LEFT:
          _this.onPrevious(value, options, onChange);

          break;

        case GamepadEnum.RIGHT:
          _this.onNext(value, options, onChange);

          break;

        case GamepadEnum.A:
          if (!_this.onNext(value, options, onChange)) {
            onChange(options[0].value);
          }

          break;

        case GamepadEnum.DOWN:
        case GamepadEnum.UP:
        case GamepadEnum.LBUMP:
        case GamepadEnum.RBUMP:
          if (onPad) onPad(e);
          break;
      }

      return true;
    };

    _this.keyDownListener = function (e) {
      _this.keyDown = true;
    };

    _this.keyUpListener = function (e) {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          options = _this$props3.options,
          onChange = _this$props3.onChange;
      if (!_this.keyDown) return;
      _this.keyDown = false;

      switch (e.code) {
        case 'ArrowRight':
          _this.onNext(value, options, onChange);

          break;

        case 'ArrowLeft':
          _this.onPrevious(value, options, onChange);

          break;

        case 'Enter':
          if (!_this.onNext(value, options, onChange)) {
            onChange(options[0].value);
          }

          break;
      }
    };

    _this.onFocus = function () {
      _this.keyDown = false;

      _this.setState({
        focused: true
      });

      document.addEventListener("keyup", _this.keyUpListener);
      document.addEventListener("keydown", _this.keyDownListener);
    };

    _this.onBlur = function () {
      _this.keyDown = false;

      _this.setState({
        focused: false
      });

      document.removeEventListener("keyup", _this.keyUpListener);
      document.removeEventListener("keydown", _this.keyDownListener);
    };

    _this.keyDown = false;
    _this.state = {
      focused: false
    };
    return _this;
  }

  var _proto2 = Select.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.addCallback(this.gamepadCallback);
    }
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.removeCallback(this.gamepadCallback);
    }
  };

  _proto2.focus = function focus() {
    var focused = this.state.focused;
    var container = this.container;

    if (!focused && container) {
      container.focus();
      return true;
    }

    return false;
  };

  _proto2.getIndex = function getIndex(value, options) {
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === value) {
        return i;
      }
    }

    return -1;
  };

  _proto2.onPrevious = function onPrevious(value, options, onChange) {
    var idx = this.getIndex(value, options);

    if (idx !== -1 && idx > 0) {
      onChange(options[idx - 1].value);
      return true;
    }

    return false;
  };

  _proto2.onNext = function onNext(value, options, onChange) {
    var idx = this.getIndex(value, options);

    if (idx !== -1 && idx < options.length - 1) {
      onChange(options[idx + 1].value);
      return true;
    }

    return false;
  };

  _proto2.render = function render() {
    var _this2 = this;

    var focused = this.state.focused;
    var _this$props4 = this.props,
        value = _this$props4.value,
        options = _this$props4.options,
        onChange = _this$props4.onChange,
        width = _this$props4.width;
    var idx = this.getIndex(value, options);
    var finalWidth = width ? width : "7.5rem";
    var opts = [];

    for (var i = 0; i < options.length; i++) {
      opts.push( /*#__PURE__*/React.createElement("div", {
        className: styles$b['select-group-text-inner-option'],
        style: {
          width: finalWidth,
          maxWidth: finalWidth,
          minWidth: finalWidth
        }
      }, options[i].label));
    }

    return /*#__PURE__*/React.createElement("div", {
      className: styles$b['select'],
      tabIndex: "0",
      ref: function ref(container) {
        _this2.container = container;
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$b['select-group']
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Arrow, {
      focused: focused,
      imgSrc: ChevronLeftWhiteImage,
      onClick: function onClick() {
        _this2.onPrevious(value, options, onChange);
      },
      disabled: idx === 0
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$b['select-group-text'] + (focused ? " " + styles$b['select-group-text__focused'] : ""),
      style: {
        width: finalWidth,
        maxWidth: finalWidth,
        minWidth: finalWidth
      },
      onClick: function onClick() {
        if (!_this2.onNext(value, options, onChange)) {
          onChange(options[0].value);
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$b['select-group-text-inner'],
      style: {
        transform: 'translateX(-' + idx * 100 + '%)'
      }
    }, opts)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Arrow, {
      focused: focused,
      imgSrc: ChevronRightWhiteImage,
      onClick: function onClick() {
        _this2.onNext(value, options, onChange);
      },
      disabled: idx === options.length - 1
    }))));
  };

  return Select;
}(Component);
Select.contextType = WebrcadeContext;

function ScreenSizeSelect(props) {
  var addDefault = props.addDefault,
      _onPad = props.onPad,
      value = props.value,
      _onChange = props.onChange,
      selectRef = props.selectRef;
  var opts = [];

  if (addDefault) {
    opts.push({
      value: SCREEN_SIZES.SS_DEFAULT,
      label: Resources.getText(TEXT_IDS.SS_DEFAULT)
    });
  }

  opts.push({
    value: SCREEN_SIZES.SS_NATIVE,
    label: Resources.getText(TEXT_IDS.SS_NATIVE)
  });
  opts.push({
    value: SCREEN_SIZES.SS_16_9,
    label: Resources.getText(TEXT_IDS.SS_16_9)
  });
  opts.push({
    value: SCREEN_SIZES.SS_FILL,
    label: Resources.getText(TEXT_IDS.SS_FILL)
  });
  return /*#__PURE__*/React.createElement(Select, {
    ref: selectRef,
    options: opts,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    value: value,
    onPad: function onPad(e) {
      return _onPad(e);
    }
  });
}

var styles$c = {"dialog-switch":"_35dTO","dialog-switch-slider":"_fAfxL"};

var Switch = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Switch, _Component);

  function Switch() {
    var _this;

    _this = _Component.call(this) || this;

    _this.gamepadCallback = function (e) {
      var onPad = _this.props.onPad;
      var focused = _this.state.focused;
      if (!focused) return false;

      switch (e.type) {
        case GamepadEnum.A:
          _this.field.click();

          break;

        case GamepadEnum.DOWN:
        case GamepadEnum.UP:
        case GamepadEnum.LEFT:
        case GamepadEnum.RIGHT:
        case GamepadEnum.LBUMP:
        case GamepadEnum.RBUMP:
          if (onPad) onPad(e);
          break;
      }

      return true;
    };

    _this.onFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.state = {
      focused: false
    };
    return _this;
  }

  var _proto = Switch.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.addCallback(this.gamepadCallback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.removeCallback(this.gamepadCallback);
    }
  };

  _proto.focus = function focus() {
    var focused = this.state.focused;
    var field = this.field;

    if (!focused && field) {
      field.focus();
      return true;
    }

    return false;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        checked = _this$props.checked,
        onChange = _this$props.onChange;
    return /*#__PURE__*/React.createElement("label", {
      className: styles$c['dialog-switch']
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      ref: function ref(field) {
        _this2.field = field;
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onChange: onChange,
      checked: checked
    }), /*#__PURE__*/React.createElement("span", {
      className: styles$c["dialog-switch-slider"]
    }));
  };

  return Switch;
}(Component);
Switch.contextType = WebrcadeContext;

var SettingsEditor = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SettingsEditor, _Component);

  function SettingsEditor() {
    var _this;

    _this = _Component.call(this) || this;
    var values = {
      expApps: settings.isExpAppsEnabled(),
      vsync: settings.isVsyncEnabled(),
      bilinear: settings.isBilinearFilterEnabled(),
      cloudStorage: settings.isCloudStorageEnabled(),
      hideTitleBar: settings.getHideTitleBar(),
      screenSize: settings.getScreenSize(),
      dbLinked: settings.getDbToken() !== null,
      disableInGame: settings.isGameSavesDisabledAfterState()
    };
    _this.state = {
      tabIndex: null,
      focusGridComps: null,
      values: values,
      originalValues: _extends({}, values)
    };
    return _this;
  }

  var _proto = SettingsEditor.prototype;

  _proto.componentDidMount = function componentDidMount() {};

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ctx = _this$props.ctx,
        isStandalone = _this$props.isStandalone,
        onClose = _this$props.onClose;
    var _this$state = this.state,
        originalValues = _this$state.originalValues,
        tabIndex = _this$state.tabIndex,
        values = _this$state.values,
        focusGridComps = _this$state.focusGridComps;

    var setFocusGridComps = function setFocusGridComps(comps) {
      _this2.setState({
        focusGridComps: comps
      });
    };

    var setValues = function setValues(values) {
      _this2.setState({
        values: values
      });
    };

    return /*#__PURE__*/React.createElement(EditorScreen, {
      hidden: ctx && ctx.isAlertScreenOpen(),
      showCancel: true,
      onOk: function onOk() {
        var oldCloudEnabled = settings.isCloudStorageEnabled();
        settings.setExpAppsEnabled(values.expApps);
        settings.setVsyncEnabled(values.vsync);
        settings.setBilinearFilterEnabled(values.bilinear);
        settings.setCloudStorageEnabled(values.cloudStorage);
        settings.setHideTitleBar(values.hideTitleBar);
        settings.setScreenSize(values.screenSize);
        settings.setGameSavesDisabledAfterState(values.disableInGame);

        if (originalValues.expApps !== values.expApps) {
          ctx.showAlertScreen(true, Resources.getText(TEXT_IDS.RELOAD_EXP_APPS), function () {
            settings.save()["finally"](function () {
              window.location.reload();
            });
          }, true, true);
        } else {
          settings.save()["finally"](function () {
            onClose();

            if (isStandalone && oldCloudEnabled != values.cloudStorage) {
              window.parent.location.reload();
            }
          });
        }
      },
      onClose: onClose,
      focusGridComps: focusGridComps,
      onTabChange: function onTabChange(oldTab, newTab) {
        return _this2.setState({
          tabIndex: newTab
        });
      },
      tabs: isStandalone ? [{
        image: CloudWhiteImage,
        label: Resources.getText(TEXT_IDS.CLOUD_STORAGE),
        content: /*#__PURE__*/React.createElement(CloudStorageTab, {
          isActive: tabIndex === 0,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues,
          isStandalone: isStandalone
        })
      }] : [{
        image: TelevisionWhiteImage,
        label: Resources.getText(TEXT_IDS.DISPLAY_SETTINGS),
        content: /*#__PURE__*/React.createElement(DisplaySettingsTab, {
          isActive: tabIndex === 0,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues
        })
      }, {
        image: CloudWhiteImage,
        label: Resources.getText(TEXT_IDS.CLOUD_STORAGE),
        content: /*#__PURE__*/React.createElement(CloudStorageTab, {
          isActive: tabIndex === 1,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues
        })
      }, {
        image: TuneWhiteImage,
        label: Resources.getText(TEXT_IDS.ADVANCED_SETTINGS),
        content: /*#__PURE__*/React.createElement(AdvancedSettingsTab, {
          isActive: tabIndex === 2,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues
        })
      }]
    });
  };

  return SettingsEditor;
}(Component);
SettingsEditor.contextType = WebrcadeContext;

var AdvancedSettingsTab = /*#__PURE__*/function (_FieldsTab2) {
  _inheritsLoose(AdvancedSettingsTab, _FieldsTab2);

  function AdvancedSettingsTab() {
    var _this4;

    _this4 = _FieldsTab2.call(this) || this;
    _this4.showExperimentalAppsRef = React.createRef();
    _this4.hideTitleBarRef = React.createRef();
    _this4.gridComps = [[_this4.showExperimentalAppsRef], [_this4.hideTitleBarRef]];
    return _this4;
  }

  var _proto3 = AdvancedSettingsTab.prototype;

  _proto3.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var gridComps = this.gridComps;
    var setFocusGridComps = this.props.setFocusGridComps;
    var isActive = this.props.isActive;

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(gridComps);
    }
  };

  _proto3.render = function render() {
    var hideTitleBarRef = this.hideTitleBarRef,
        showExperimentalAppsRef = this.showExperimentalAppsRef;
    var focusGrid = this.context.focusGrid;
    var _this$props3 = this.props,
        setValues = _this$props3.setValues,
        values = _this$props3.values;
    return [/*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.EXPERIMENTAL_APPS)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: showExperimentalAppsRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, showExperimentalAppsRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          expApps: e.target.checked
        }));
      },
      checked: values.expApps
    }))), /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.HIDE_TITLE_BAR)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: hideTitleBarRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, hideTitleBarRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          hideTitleBar: e.target.checked
        }));
      },
      checked: values.hideTitleBar
    })))];
  };

  return AdvancedSettingsTab;
}(FieldsTab);

AdvancedSettingsTab.contextType = WebrcadeContext;

var DisplaySettingsTab = /*#__PURE__*/function (_FieldsTab3) {
  _inheritsLoose(DisplaySettingsTab, _FieldsTab3);

  function DisplaySettingsTab() {
    var _this5;

    _this5 = _FieldsTab3.call(this) || this;
    _this5.screenSizeRef = React.createRef();
    _this5.verticalSyncRef = React.createRef();
    _this5.bilinearFilterRef = React.createRef();
    _this5.gridComps = [[_this5.screenSizeRef], [_this5.verticalSyncRef], [_this5.bilinearFilterRef]];
    return _this5;
  }

  var _proto4 = DisplaySettingsTab.prototype;

  _proto4.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var gridComps = this.gridComps;
    var setFocusGridComps = this.props.setFocusGridComps;
    var isActive = this.props.isActive;

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(gridComps);
    }
  };

  _proto4.render = function render() {
    var bilinearFilterRef = this.bilinearFilterRef,
        screenSizeRef = this.screenSizeRef,
        verticalSyncRef = this.verticalSyncRef;
    var focusGrid = this.context.focusGrid;
    var _this$props4 = this.props,
        setValues = _this$props4.setValues,
        values = _this$props4.values;
    return [/*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.SCREEN_SIZE)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(ScreenSizeSelect, {
      selectRef: screenSizeRef,
      onChange: function onChange(value) {
        setValues(_extends({}, values, {
          screenSize: value
        }));
      },
      value: values.screenSize,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, screenSizeRef);
      }
    }))), /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.VERTICAL_SYNC)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: verticalSyncRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, verticalSyncRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          vsync: e.target.checked
        }));
      },
      checked: values.vsync
    }))), /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.BILINEAR_FILTER)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: bilinearFilterRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, bilinearFilterRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          bilinear: e.target.checked
        }));
      },
      checked: values.bilinear
    })))];
  };

  return DisplaySettingsTab;
}(FieldsTab);

DisplaySettingsTab.contextType = WebrcadeContext;

var CloudStorageTab = /*#__PURE__*/function (_FieldsTab4) {
  _inheritsLoose(CloudStorageTab, _FieldsTab4);

  function CloudStorageTab() {
    var _this6;

    _this6 = _FieldsTab4.call(this) || this;
    _this6.cloudStorageRef = React.createRef();
    _this6.dropboxRef = React.createRef();
    _this6.disableSavesRef = React.createRef();
    _this6.gridComps = [[_this6.cloudStorageRef], [_this6.dropboxRef], [_this6.disableSavesRef]];
    return _this6;
  }

  var _proto5 = CloudStorageTab.prototype;

  _proto5.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var gridComps = this.gridComps;
    var setFocusGridComps = this.props.setFocusGridComps;
    var isActive = this.props.isActive;

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(gridComps);
    }
  };

  _proto5.render = function render() {
    var cloudStorageRef = this.cloudStorageRef,
        dropboxRef = this.dropboxRef,
        disableSavesRef = this.disableSavesRef;
    var focusGrid = this.context.focusGrid;
    var _this$props5 = this.props,
        isStandalone = _this$props5.isStandalone,
        setValues = _this$props5.setValues,
        values = _this$props5.values;
    var cloudStorageComps = null;

    if (values.cloudStorage) {
      cloudStorageComps = [/*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.DROPBOX)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageButton, {
        ref: dropboxRef,
        imgSrc: values.dbLinked ? LinkOffBlackImage : LinkBlackImage,
        hoverImgSrc: values.dbLinked ? LinkOffWhiteImage : LinkWhiteImage,
        label: Resources.getText(values.dbLinked ? TEXT_IDS.UNLINK : TEXT_IDS.LINK),
        onPad: function onPad(e) {
          return focusGrid.moveFocus(e.type, dropboxRef);
        },
        onClick: function onClick() {
          if (!values.dbLinked) {
            settings.setCloudStorageEnabled(true);
            settings.save()["finally"](function () {
              if (isStandalone) {
                window.parent._dropbox.link(window.parent.location.href)["catch"](function (e) {
                  return showMessage(e);
                });
              } else {
                dropbox.link()["catch"](function (e) {
                  return showMessage(e);
                });
              }
            });
          } else {
            settings.setDbToken(null);
            settings.save()["finally"](function () {
              setValues(_extends({}, values, {
                dbLinked: false
              }));
            });
          }
        }
      })))), /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.STATUS)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement("div", null, Resources.getText(values.dbLinked ? TEXT_IDS.LINKED : TEXT_IDS.UNLINKED)))), /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, "Disable saves after state load"), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
        ref: disableSavesRef,
        onPad: function onPad(e) {
          return focusGrid.moveFocus(e.type, disableSavesRef);
        },
        onChange: function onChange(e) {
          setValues(_extends({}, values, {
            disableInGame: e.target.checked
          }));
        },
        checked: values.disableInGame
      })))];
    }

    return [/*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.ENABLED)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: cloudStorageRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, cloudStorageRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          cloudStorage: e.target.checked
        }));
      },
      checked: values.cloudStorage
    }))), cloudStorageComps];
  };

  return CloudStorageTab;
}(FieldsTab);

CloudStorageTab.contextType = WebrcadeContext;

var styles$d = {"pause-screen":"_1O0HI","pause-screen-inner":"_2KOe-","pause-screen-inner-info":"_3VdT0","pause-screen-inner-info-title":"_2kozc","pause-screen-inner-info-app":"_xdCUz","pause-screen-inner-buttons":"_zmLiu","pause-screen-inner-buttons-container":"_3c68d","pause-screen-image-button":"_27F_L"};

var _excluded$1 = ["buttonRef", "onHandlePad"];
var PauseScreenButton = /*#__PURE__*/function (_ImageButton) {
  _inheritsLoose(PauseScreenButton, _ImageButton);

  function PauseScreenButton() {
    return _ImageButton.apply(this, arguments) || this;
  }

  var _proto = PauseScreenButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        buttonRef = _this$props.buttonRef,
        onHandlePad = _this$props.onHandlePad,
        other = _objectWithoutPropertiesLoose(_this$props, _excluded$1);

    var focusGrid = this.context.focusGrid;
    return /*#__PURE__*/React.createElement(ImageButton, _extends({
      ref: buttonRef,
      className: styles$d["pause-screen-image-button"],
      onPad: function onPad(e) {
        if (onHandlePad) onHandlePad(focusGrid, e);
      }
    }, other));
  };

  return PauseScreenButton;
}(ImageButton);
var PauseScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(PauseScreen, _Screen);

  function PauseScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.pauseStyles = styles$d;
    _this.exitOrSettingsButtonRef = React.createRef();
    _this.settingsButtonRef = React.createRef();
    _this.resumeButtonRef = React.createRef();

    _this.focusGrid.setComponents(_this.getFocusGridComponents());

    _this.state = {
      showSettingsScreen: false
    };
    return _this;
  }

  var _proto2 = PauseScreen.prototype;

  _proto2.getFocusGridComponents = function getFocusGridComponents() {
    return [[this.exitOrSettingsButtonRef, this.resumeButtonRef]];
  };

  _proto2.focus = function focus() {
    var resumeButtonRef = this.resumeButtonRef;

    if (this.gamepadNotifier.padCount > 0) {
      if (resumeButtonRef && resumeButtonRef.current) {
        resumeButtonRef.current.focus();
      }
    }
  };

  _proto2.getAdditionalButtons = function getAdditionalButtons() {
    return null;
  };

  _proto2.render = function render() {
    var _this2 = this;

    var exitOrSettingsButtonRef = this.exitOrSettingsButtonRef,
        resumeButtonRef = this.resumeButtonRef,
        screenContext = this.screenContext,
        screenStyles = this.screenStyles;
    var _this$props2 = this.props,
        appProps = _this$props2.appProps,
        exitCallback = _this$props2.exitCallback,
        isEditor = _this$props2.isEditor,
        isStandalone = _this$props2.isStandalone;
    var showSettingsScreen = this.state.showSettingsScreen;
    var buttons = [/*#__PURE__*/React.createElement("div", {
      className: screenStyles['screen-transparency']
    }), /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner'] + " " + screenStyles.screen
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner-info']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner-info-title']
    }, appProps.title), /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner-info-app']
    }, appProps.app)), /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner-buttons']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$d['pause-screen-inner-buttons-container']
    }, !isStandalone && /*#__PURE__*/React.createElement(PauseScreenButton, {
      className: styles$d["pause-screen-image-button"],
      imgSrc: ArrowBackWhiteImage,
      buttonRef: exitOrSettingsButtonRef,
      label: Resources.getText(isEditor ? TEXT_IDS.RETURN_TO_EDITOR : TEXT_IDS.RETURN_TO_BROWSE),
      onHandlePad: function onHandlePad(focusGrid, e) {
        return focusGrid.moveFocus(e.type, exitOrSettingsButtonRef);
      },
      onClick: function onClick() {
        if (exitCallback) exitCallback();
      }
    }), isStandalone && isParentSameOrigin() && !window.parent._inIframe && /*#__PURE__*/React.createElement(PauseScreenButton, {
      imgSrc: SettingsWhiteImage,
      buttonRef: exitOrSettingsButtonRef,
      label: Resources.getText(TEXT_IDS.SETTINGS),
      onHandlePad: function onHandlePad(focusGrid, e) {
        return focusGrid.moveFocus(e.type, exitOrSettingsButtonRef);
      },
      onClick: function onClick() {
        _this2.setState({
          showSettingsScreen: true
        });
      }
    }), this.getAdditionalButtons(), /*#__PURE__*/React.createElement(PauseScreenButton, {
      className: styles$d["pause-screen-image-button"],
      imgSrc: PlayArrowWhiteImage,
      buttonRef: this.resumeButtonRef,
      label: Resources.getText(TEXT_IDS.RESUME),
      onHandlePad: function onHandlePad(focusGrid, e) {
        return focusGrid.moveFocus(e.type, resumeButtonRef);
      },
      onClick: function onClick() {
        return _this2.close();
      }
    })))))];
    var settingsEditor = /*#__PURE__*/React.createElement(SettingsEditor, {
      isStandalone: isStandalone,
      onClose: function onClose() {
        return _this2.close();
      }
    });
    return !showSettingsScreen ? /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, buttons) : settingsEditor;
  };

  return PauseScreen;
}(Screen);
var CustomPauseScreen = /*#__PURE__*/function (_PauseScreen) {
  _inheritsLoose(CustomPauseScreen, _PauseScreen);

  function CustomPauseScreen() {
    return _PauseScreen.apply(this, arguments) || this;
  }

  var _proto3 = CustomPauseScreen.prototype;

  _proto3.componentDidMount = function componentDidMount() {
    var additionalButtonRefs = this.props.additionalButtonRefs;
    var focusGrid = this.focusGrid;

    if (additionalButtonRefs) {
      var comps = this.getFocusGridComponents();
      comps[0] = [comps[0][0]].concat(additionalButtonRefs, [comps[0][1]]);
      focusGrid.setComponents(comps);
    }

    _PauseScreen.prototype.componentDidMount.call(this);
  };

  _proto3.getAdditionalButtons = function getAdditionalButtons() {
    var additionalButtons = this.props.additionalButtons;
    return additionalButtons;
  };

  return CustomPauseScreen;
}(PauseScreen);

var styles$e = {"status-screen":"_PRCqq","statusfadein":"_3AE1-","status-screen-content":"_joVTu","status-screen-content-image":"_pMNFn","status-screen-content-text":"_3GuSO"};

var StatusScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(StatusScreen, _Screen);

  function StatusScreen() {
    return _Screen.call(this) || this;
  }

  var _proto = StatusScreen.prototype;

  _proto.componentDidMount = function componentDidMount() {};

  _proto.componentWillUnmount = function componentWillUnmount() {};

  _proto.render = function render() {
    var message = this.props.message;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$e['status-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$e['status-screen-content']
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("object", {
      type: "image/svg+xml",
      className: styles$e['status-screen-content-image'],
      data: LoaderImage
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$e['status-screen-content-text']
    }, message)));
  };

  return StatusScreen;
}(Screen);

var styles$f = {"yesno-screen":"_Hgflf","yesno-screen-inner":"_ZPrBo","yesno-screen-heading":"_2ZPd7","yesno-screen-message":"_32Wda","yesno-screen-prompt":"_JMXJp","yesno-screen-buttons":"_37wua"};

var YesNoScreen = /*#__PURE__*/function (_Screen) {
  _inheritsLoose(YesNoScreen, _Screen);

  function YesNoScreen() {
    var _this;

    _this = _Screen.call(this) || this;
    _this.yesButtonRef = React.createRef();
    _this.noButtonRef = React.createRef();

    _this.focusGrid.setComponents([[_this.yesButtonRef, _this.noButtonRef]]);

    _this.state = {};
    return _this;
  }

  var _proto = YesNoScreen.prototype;

  _proto.focus = function focus() {
    var noButtonRef = this.noButtonRef;

    if (noButtonRef && noButtonRef.current) {
      noButtonRef.current.focus();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var focusGrid = this.focusGrid,
        yesButtonRef = this.yesButtonRef,
        noButtonRef = this.noButtonRef,
        screenContext = this.screenContext,
        screenStyles = this.screenStyles;
    var _this$props$info = this.props.info,
        header = _this$props$info.header,
        message = _this$props$info.message,
        prompt = _this$props$info.prompt,
        onYes = _this$props$info.onYes,
        onNo = _this$props$info.onNo;
    return /*#__PURE__*/React.createElement(WebrcadeContext.Provider, {
      value: screenContext
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen']
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen-inner'] + " " + screenStyles.screen
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen-heading']
    }, header), /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen-message']
    }, message.split('\n').map(function (item, key) {
      var val = item ? /*#__PURE__*/React.createElement("span", null, item) : /*#__PURE__*/React.createElement("span", null, "\xA0");
      return key < 10 ? /*#__PURE__*/React.createElement("div", {
        className: styles$f['yesno-screen-message-line'],
        key: key
      }, val) : null;
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen-prompt']
    }, prompt), /*#__PURE__*/React.createElement("div", {
      className: styles$f['yesno-screen-buttons']
    }, /*#__PURE__*/React.createElement(ImageButton, {
      ref: yesButtonRef,
      label: Resources.getText(TEXT_IDS.YES),
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, yesButtonRef);
      },
      onClick: function onClick() {
        if (onYes) onYes(_this2);
      }
    }), /*#__PURE__*/React.createElement(ImageButton, {
      ref: noButtonRef,
      label: Resources.getText(TEXT_IDS.NO),
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, noButtonRef);
      },
      onClick: function onClick() {
        if (onNo) onNo(_this2);
      }
    })))));
  };

  return YesNoScreen;
}(Screen);

var styles$g = {"loading":"_3o3pD","fadein":"_26Bvn","loading-percent":"_1sp2T"};

var WebrcadeApp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(WebrcadeApp, _Component);

  function WebrcadeApp() {
    var _this;

    _this = _Component.call(this) || this;
    _this.ModeEnum = {
      LOADING: "loading",
      LOADED: "loaded",
      ERROR: "error",
      YESNO: "yesno",
      PAUSE: "pause"
    };

    _this.messageListener = function (e) {
      if (e.data === 'exit') {
        _this.setState({
          mode: null
        });

        _this.exit(null, false)["catch"](function (e) {
          return error(e);
        })["finally"](function () {
          setTimeout(function () {
            e.source.postMessage("exitComplete", "*");
          }, 0);
        });
      }
    };

    preloadImages([VolumeOffBlackImage, ArrowBackWhiteImage, PlayArrowWhiteImage]);
    _this.state = {
      mode: _this.ModeEnum.LOADING,
      loadingMessage: null,
      loadingPercent: null,
      errorMessage: null,
      yesNoInfo: null,
      showOverlay: false,
      showXboxViewMessage: false,
      statusMessage: null,
      refresh: 0
    };
    _this.pauseExit = false;
    _this.exited = false;
    window.app = _assertThisInitialized(_this);
    return _this;
  }

  var _proto = WebrcadeApp.prototype;

  _proto.forceRefresh = function forceRefresh() {
    this.setState({
      refresh: this.state.refresh + 1
    });
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener("message", this.messageListener);

    if (!isDev() && window.parent) {
      window.parent.postMessage("appLoaded", "*");
    }

    addXboxFullscreenCallback(function (show) {
      _this2.setState({
        showXboxViewMessage: show
      });
    });

    if (!isDev()) {
      try {
        window.frameElement.style.display = 'block';
      } catch (e) {
        info('error attempting to make application visible: ' + e);
      }
    }

    var url = window.location.search;
    info(url);
    var propsEncoded = UrlUtil.getParam(url, AppProps.RP_PROPS);

    if (propsEncoded) {
      this.appProps = AppProps.decode(propsEncoded);
      this.type = this.appProps.type;
    } else {
      this.appProps = {};
    }

    var context = UrlUtil.getParam(url, AppProps.RP_CONTEXT);
    this.isEditor = context && context === AppProps.RV_CONTEXT_EDITOR;
    this.isStandalone = context && context === AppProps.RV_CONTEXT_STANDALONE;
    this.debug = UrlUtil.getBoolParam(url, AppProps.RP_DEBUG);
    AppRegistry.instance.enableExpApps(true);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener("message", this.messageListener);
  };

  _proto.isExitFromPause = function isExitFromPause() {
    return this.pauseExit;
  };

  _proto.exitFromPause = function exitFromPause() {
    this.pauseExit = true;
    this.exit();
  };

  _proto.getAppType = function getAppType() {
    return this.type;
  };

  _proto.getAppProps = function getAppProps() {
    return this.appProps;
  };

  _proto.getStoragePath = function getStoragePath(postfix) {
    return "/wrc/" + this.getAppType() + "/" + postfix;
  };

  _proto.getCanvasStyles = function getCanvasStyles() {
    var styles = {};
    return styles;
  };

  _proto.renderLoading = function renderLoading() {
    var _this$state = this.state,
        loadingMessage = _this$state.loadingMessage,
        loadingPercent = _this$state.loadingPercent;
    return /*#__PURE__*/React.createElement("div", {
      key: loadingMessage ? loadingMessage : "loading"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$g.loading
    }, loadingMessage ? loadingMessage : Resources.getText(TEXT_IDS.LOADING), "..."), loadingPercent !== null ? /*#__PURE__*/React.createElement("div", {
      className: styles$g['loading-percent']
    }, loadingPercent, "%") : null);
  };

  _proto.renderErrorScreen = function renderErrorScreen() {
    var _this$state2 = this.state,
        errorCloseCallback = _this$state2.errorCloseCallback,
        errorMessage = _this$state2.errorMessage;
    return /*#__PURE__*/React.createElement(ErrorScreen, {
      message: errorMessage,
      closeCallback: errorCloseCallback
    });
  };

  _proto.renderYesNoScreen = function renderYesNoScreen() {
    var yesNoInfo = this.state.yesNoInfo;
    return /*#__PURE__*/React.createElement(YesNoScreen, {
      info: yesNoInfo
    });
  };

  _proto.renderPauseScreen = function renderPauseScreen() {
    var _this3 = this;

    var appProps = this.appProps;
    return /*#__PURE__*/React.createElement(PauseScreen, {
      appProps: appProps,
      closeCallback: function closeCallback() {
        return _this3.resume();
      },
      exitCallback: function exitCallback() {
        _this3.exitFromPause();
      },
      isEditor: this.isEditor,
      isStandalone: this.isStandalone
    });
  };

  _proto.renderXboxViewScreen = function renderXboxViewScreen() {
    return /*#__PURE__*/React.createElement(AlertScreen, {
      message: getXboxViewMessage(),
      showButtons: false
    });
  };

  _proto.renderOverlayScreen = function renderOverlayScreen() {
    return /*#__PURE__*/React.createElement(OverlayScreen, null);
  };

  _proto.isDebug = function isDebug() {
    return this.debug;
  };

  _proto.render = function render() {
    var ModeEnum = this.ModeEnum;
    var _this$state3 = this.state,
        mode = _this$state3.mode,
        showOverlay = _this$state3.showOverlay,
        showXboxViewMessage = _this$state3.showXboxViewMessage,
        statusMessage = _this$state3.statusMessage;
    var render = null;

    if (showXboxViewMessage) {
      render = this.renderXboxViewScreen();
    } else if (mode === ModeEnum.ERROR) {
      render = this.renderErrorScreen();
    } else if (mode === ModeEnum.YESNO) {
      render = this.renderYesNoScreen();
    } else if (showOverlay) {
      render = this.renderOverlayScreen();
    }

    return [/*#__PURE__*/React.createElement(Message, null), render, statusMessage && /*#__PURE__*/React.createElement(StatusScreen, {
      message: statusMessage
    })];
  };

  _proto.setStatusMessage = function setStatusMessage(message) {
    this.setState({
      statusMessage: message
    });
  };

  _proto.yesNoPrompt = function yesNoPrompt(info) {
    var ModeEnum = this.ModeEnum;
    this.setState({
      mode: ModeEnum.YESNO,
      yesNoInfo: info
    });
  };

  _proto.pause = function pause(resumeCallback) {
    var mode = this.state.mode;
    var ModeEnum = this.ModeEnum;

    if (mode !== ModeEnum.PAUSE) {
      this.setState({
        mode: ModeEnum.PAUSE,
        resumeCallback: resumeCallback
      });
      return true;
    }

    return false;
  };

  _proto.resume = function resume(targetMode) {
    var _this$state4 = this.state,
        mode = _this$state4.mode,
        resumeCallback = _this$state4.resumeCallback;
    var ModeEnum = this.ModeEnum;

    if (mode === ModeEnum.PAUSE || targetMode && mode === targetMode) {
      this.setState({
        mode: ModeEnum.LOADED,
        resumeCallback: null
      }, function () {
        return resumeCallback();
      });
      return true;
    }

    return false;
  };

  _proto.isPauseScreen = function isPauseScreen() {
    var mode = this.state.mode;
    var ModeEnum = this.ModeEnum;
    return mode === ModeEnum.PAUSE;
  };

  _proto.onPreExit = function onPreExit() {
    try {
      info('onPreExit...');
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto._exit = function _exit(navigateBack) {
    try {
      var _temp3 = function _temp3() {
        if (navigateBack) {
          if (!_this5.isStandalone) {
            window.history.back();
          } else {
            window.document.body.innerHTML = '';
          }
        }
      };

      var _this5 = this;

      var _temp4 = _catch(function () {
        return Promise.resolve(_this5.onPreExit()).then(function () {});
      }, function (e) {
        error(e);
      });

      return Promise.resolve(_temp4 && _temp4.then ? _temp4.then(_temp3) : _temp3(_temp4));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.setShowOverlay = function setShowOverlay(show) {
    var showOverlay = this.state.showOverlay;

    if (show != showOverlay) {
      this.setState({
        showOverlay: show
      });
    }
  };

  _proto.isShowOverlay = function isShowOverlay() {
    var showOverlay = this.state.showOverlay;
    return showOverlay;
  };

  _proto.exit = function exit(error$1, navigateBack) {
    if (navigateBack === void 0) {
      navigateBack = true;
    }

    try {
      var _this7 = this;

      var ModeEnum = _this7.ModeEnum;

      if (error$1) {
        error(error$1);
      }

      var _temp7 = function () {
        if (!_this7.exited) {
          _this7.exited = true;
          info("exiting application...");

          var _temp8 = function () {
            if (error$1) {
              _this7.setState({
                mode: ModeEnum.ERROR,
                errorMessage: error$1,
                errorCloseCallback: function () {
                  try {
                    return Promise.resolve(_this7._exit(navigateBack)).then(function () {});
                  } catch (e) {
                    return Promise.reject(e);
                  }
                }
              });
            } else {
              return Promise.resolve(_this7._exit(navigateBack)).then(function () {});
            }
          }();

          if (_temp8 && _temp8.then) return _temp8.then(function () {});
        }
      }();

      return Promise.resolve(_temp7 && _temp7.then ? _temp7.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.fetchResponseBuffer = function fetchResponseBuffer(response) {
    try {
      var _exit3 = false;

      var _this9 = this;

      var length = response.headers.get('Content-Length');
      var type = response.headers.get("Content-Type");
      var isText = type && type.toLowerCase().indexOf("text/") !== -1 || type.toLowerCase().indexOf("application/json") !== -1 || type.toLowerCase().indexOf("application/xml") !== -1;
      return Promise.resolve(function () {
        if (!isText && length) {
          var _temp11 = function _temp11(_result2) {
            if (_exit3) return _result2;

            try {
              return _array;
            } finally {
              _array = null;
            }
          };

          length = parseInt(length);

          var _array = length > 0 ? new Uint8Array(length) : new Uint8Array();

          var _temp12 = function () {
            if (length > 0) {
              var _interrupt2 = false;
              var at = 0;
              var reader = response.body.getReader();
              return _for(function () {
                return !(_interrupt2 || _exit3);
              }, void 0, function () {
                return Promise.resolve(reader.read()).then(function (_ref) {
                  var done = _ref.done,
                      value = _ref.value;

                  if (done) {
                    _interrupt2 = true;
                    return;
                  }

                  if (at + value.length > length) {
                    error("File exceeded reported length! " + (at + value.length) + ", " + length);
                    _exit3 = true;
                    return _array;
                  }

                  _array.set(value, at);

                  at += value.length;
                  var progress = ((at / length).toFixed(2) * 100).toFixed(0);

                  _this9.setState({
                    loadingPercent: progress | 0
                  });
                });
              });
            }
          }();

          return _temp12 && _temp12.then ? _temp12.then(_temp11) : _temp11(_temp12);
        } else {
          return Promise.resolve(response.blob()).then(function (blob) {
            return Promise.resolve(new Response(blob).arrayBuffer()).then(function (_Response$arrayBuffer) {
              return new Uint8Array(_Response$arrayBuffer);
            });
          });
        }
      }());
    } catch (e) {
      return Promise.reject(e);
    }
  };

  return WebrcadeApp;
}(Component);

var DiscSelectionEditor = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DiscSelectionEditor, _Component);

  function DiscSelectionEditor() {
    var _this;

    _this = _Component.call(this) || this;
    _this.state = {
      tabIndex: null,
      focusGridComps: null,
      values: {}
    };
    return _this;
  }

  var _proto = DiscSelectionEditor.prototype;

  _proto.componentDidMount = function componentDidMount() {};

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        app = _this$props.app,
        onClose = _this$props.onClose;
    var _this$state = this.state,
        tabIndex = _this$state.tabIndex,
        values = _this$state.values,
        focusGridComps = _this$state.focusGridComps;

    var setFocusGridComps = function setFocusGridComps(comps) {
      _this2.setState({
        focusGridComps: comps
      });
    };

    var setValues = function setValues(values) {
      _this2.setState({
        values: values
      });
    };

    return /*#__PURE__*/React.createElement(EditorScreen, {
      showCancel: false,
      okLabel: Resources.getText(TEXT_IDS.CANCEL),
      onOk: function onOk() {
        app.exit(0);
      },
      onClose: onClose,
      focusGridComps: focusGridComps,
      onTabChange: function onTabChange(oldTab, newTab) {
        return _this2.setState({
          tabIndex: newTab
        });
      },
      tabs: [{
        image: AlbumWhiteImage,
        label: 'Disc Selection',
        content: /*#__PURE__*/React.createElement(DiscSelectionTab, {
          app: app,
          isActive: tabIndex === 0,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues
        })
      }]
    });
  };

  return DiscSelectionEditor;
}(Component);

var DiscSelectionTab = /*#__PURE__*/function (_FieldsTab) {
  _inheritsLoose(DiscSelectionTab, _FieldsTab);

  function DiscSelectionTab() {
    var _this3;

    _this3 = _FieldsTab.call(this) || this;
    _this3.gridComps = null;
    return _this3;
  }

  var _proto2 = DiscSelectionTab.prototype;

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var setFocusGridComps = this.props.setFocusGridComps;
    var _this$props2 = this.props,
        app = _this$props2.app,
        isActive = _this$props2.isActive;

    if (!this.gridComps) {
      var comps = [];

      for (var i = 0; i < app.discs.length; i++) {
        comps.push([React.createRef()]);
      }

      this.gridComps = comps;
      setTimeout(function () {
        comps[0][0].current.focus();
      });
    }

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(this.gridComps);
    }
  };

  _proto2.render = function render() {
    var gridComps = this.gridComps;
    var focusGrid = this.context.focusGrid;
    var app = this.props.app;
    var fields = [];

    if (gridComps) {
      var _loop = function _loop(i) {
        fields.push( /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, Resources.getText(TEXT_IDS.SELECT_DISC, i + 1)), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImageButton, {
          ref: gridComps[i][0],
          imgSrc: PlayArrowBlackImage,
          hoverImgSrc: PlayArrowWhiteImage,
          label: Resources.getText(TEXT_IDS.LOAD),
          onPad: function onPad(e) {
            return focusGrid.moveFocus(e.type, gridComps[i][0]);
          },
          onClick: function onClick() {
            app.start(i);
          }
        })))));
      };

      for (var i = 0; i < app.discs.length; i++) {
        _loop(i);
      }
    }

    return /*#__PURE__*/React.createElement(Fragment, null, fields);
  };

  return DiscSelectionTab;
}(FieldsTab);

DiscSelectionTab.contextType = WebrcadeContext;

var WebrcadeRetroApp = /*#__PURE__*/function (_WebrcadeApp) {
  _inheritsLoose(WebrcadeRetroApp, _WebrcadeApp);

  function WebrcadeRetroApp() {
    var _this;

    _this = _WebrcadeApp.call(this) || this;
    _this.emulator = null;
    _this.MODE_DISC_SELECT = 'discSelectionMode';
    _this.state.mode = null;
    return _this;
  }

  var _proto = WebrcadeRetroApp.prototype;

  _proto.createEmulator = function createEmulator(app, isDebug) {
    throw "createEmulator is not implemented.";
  };

  _proto.isDiscBased = function isDiscBased() {
    return true;
  };

  _proto.isArchiveBased = function isArchiveBased() {
    return false;
  };

  _proto.isMediaBased = function isMediaBased() {
    return false;
  };

  _proto.isBiosRequired = function isBiosRequired() {
    return true;
  };

  _proto.getBiosMap = function getBiosMap() {
    return null;
  };

  _proto.getAlternateBiosMap = function getAlternateBiosMap() {
    return null;
  };

  _proto.getBiosUrls = function getBiosUrls() {
    return null;
  };

  _proto.fetchMedia = function fetchMedia(media) {
    try {
      var _this3 = this;

      var ret = [];

      var _temp6 = function () {
        if (media) {
          var _temp7 = _forTo(media, function (i) {
            var mediaUrl = media[i];

            if (mediaUrl.trim().length === 0) {
              return;
            }

            var fad = new FetchAppData(mediaUrl);
            return Promise.resolve(fad.fetch()).then(function (res) {
              var _temp3 = function () {
                if (res.ok) {
                  return Promise.resolve(res.blob()).then(function (blob) {
                    var uz = new Unzip().setDebug(_this3.isDebug());
                    var multi = null;
                    return Promise.resolve(uz.unzip(blob, _this3.extsNotUnique, _this3.exts, function (s) {
                      multi = s;
                    })).then(function (_uz$unzip) {
                      blob = _uz$unzip;

                      var _temp2 = function () {
                        if (multi && Object.keys(multi).length > 1) {
                          var _temp8 = _forIn(multi, function (key) {
                            var entry = multi[key];
                            return Promise.resolve(uz.extractEntry(entry.entry)).then(function (blob) {
                              return Promise.resolve(blob.arrayBuffer()).then(function (_blob$arrayBuffer) {
                                var bytes = new Uint8Array(_blob$arrayBuffer);
                                ret.push([bytes, key]);
                              });
                            });
                          });

                          if (_temp8 && _temp8.then) return _temp8.then(function () {});
                        } else {
                          var filename = uz.getName();

                          if (!filename) {
                            filename = fad.getFilename(res);
                          }

                          if (!filename) {
                            filename = UrlUtil.getFileName(mediaUrl);
                          }

                          return Promise.resolve(blob.arrayBuffer()).then(function (_blob$arrayBuffer2) {
                            var bytes = new Uint8Array(_blob$arrayBuffer2);
                            ret.push([bytes, filename]);
                          });
                        }
                      }();

                      if (_temp2 && _temp2.then) return _temp2.then(function () {});
                    });
                  });
                }
              }();

              if (_temp3 && _temp3.then) return _temp3.then(function () {});
            });
          });

          if (_temp7 && _temp7.then) return _temp7.then(function () {});
        }
      }();

      return Promise.resolve(_temp6 && _temp6.then ? _temp6.then(function () {
        return ret;
      }) : ret);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.fetchBios = function fetchBios(bios, biosMap, alternateBiosMap) {
    if (biosMap === void 0) {
      biosMap = null;
    }

    if (alternateBiosMap === void 0) {
      alternateBiosMap = null;
    }

    try {
      var _temp12 = function _temp12() {
        if (Object.keys(BIOS_MAP).length > 0) {
          var haveBuffers = false;

          if (ALT_BIOS_MAP) {
            for (var p in ALT_BIOS_MAP) {
              var f = ALT_BIOS_MAP[p];

              for (var n in biosBuffers) {
                if (f === n) {
                  var buff = biosBuffers[n];
                  biosBuffers = {};
                  biosBuffers[n] = buff;
                  haveBuffers = true;
                  break;
                }
              }
            }
          }

          if (!haveBuffers) {
            for (var _p in BIOS_MAP) {
              var _f = BIOS_MAP[_p];
              var found = false;

              for (var _n in biosBuffers) {
                if (_f === _n) {
                  found = true;
                  break;
                }
              }

              if (!found) throw new Error("Unable to find BIOS file: " + _f);
            }
          }
        }

        console.log(biosBuffers);
        return biosBuffers;
      };

      var _this5 = this;

      var biosBuffers = {};
      var BIOS_MAP = biosMap ? biosMap : _this5.getBiosMap();
      var ALT_BIOS_MAP = alternateBiosMap ? alternateBiosMap : _this5.getAlternateBiosMap();

      var _temp13 = _forTo(bios, function (i) {
        var biosUrl = bios[i];

        if (biosUrl.trim().length === 0) {
          return;
        }

        var fad = new FetchAppData(biosUrl);
        return Promise.resolve(fad.fetch()).then(function (res) {
          return Promise.resolve(res.blob()).then(function (blob) {
            return Promise.resolve(blobToStr(blob)).then(function (blobStr) {
              var md5Hash = md5(blobStr);
              var name = BIOS_MAP[md5Hash];

              if (ALT_BIOS_MAP && !name) {
                name = ALT_BIOS_MAP[md5Hash];
              }

              var _temp9 = function () {
                if (name) {
                  return Promise.resolve(blob.arrayBuffer()).then(function (_blob$arrayBuffer3) {
                    biosBuffers[name] = new Uint8Array(_blob$arrayBuffer3);
                  });
                }
              }();

              if (_temp9 && _temp9.then) return _temp9.then(function () {});
            });
          });
        });
      });

      return Promise.resolve(_temp13 && _temp13.then ? _temp13.then(_temp12) : _temp12(_temp13));
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.getExtension = function getExtension(url, fad, res) {
    var filename = fad.getFilename(res);

    if (!filename) {
      filename = UrlUtil.getFileName(url);
    }

    if (filename) {
      var comps = filename.split('.');

      if (comps.length > 1) {
        return comps[comps.length - 1].toLowerCase();
      }
    }

    return null;
  };

  _proto.start = function start(discIndex) {
    var _this6 = this;

    setMessageAnchorId('canvas');
    var appProps = this.appProps,
        bios = this.bios,
        discs = this.discs,
        emulator = this.emulator,
        ModeEnum = this.ModeEnum;
    this.setState({
      mode: ModeEnum.LOADING
    });

    try {
      var biosBuffers = null;
      var frontend = null;
      var extension = null;
      var fad = null;
      var discUrl = null;
      var exts = null;
      var extsNotUnique = null;
      var type = appProps.type;
      exts = AppRegistry.instance.getExtensions(type, true, false);
      this.exts = exts;
      extsNotUnique = AppRegistry.instance.getExtensions(type, true, true);
      this.extsNotUnique = extsNotUnique;

      if (this.isDiscBased()) {
        discUrl = discs[discIndex];
        fad = new FetchAppData(discUrl);
      } else if (this.isArchiveBased()) {
        fad = new FetchAppData(this.archive);
      } else if (this.isMediaBased()) {
        fad = null;
      } else {
        fad = new FetchAppData(this.rom);
      }

      settings.load().then(function () {
        return emulator.loadEmscriptenModule(_this6.canvas);
      }).then(function () {
        return _this6.isBiosRequired() ? _this6.fetchBios(bios) : null;
      }).then(function (b) {
        biosBuffers = b;
      }).then(function () {
        return fad ? fad.fetch() : null;
      }).then(function (response) {
        if (_this6.isDiscBased()) {
          extension = _this6.getExtension(discUrl, fad, response);
          emulator.setDiscIndex(discIndex);
        }

        return response;
      }).then(function (response) {
        if (_this6.isDiscBased() || _this6.isArchiveBased()) {
          return _this6.fetchResponseBuffer(response);
        } else if (_this6.isMediaBased()) {
          return _this6.fetchMedia(_this6.media);
        } else {
          var romBlob = null;
          var uz = new Unzip().setDebug(_this6.isDebug());
          return response.blob().then(function (blob) {
            return uz.unzip(blob, extsNotUnique, exts, romNameScorer);
          }).then(function (blob) {
            romBlob = blob;
            return blob;
          }).then(function (blob) {
            return AppRegistry.instance.getMd5(blob, type);
          }).then(function (md5) {
            _this6.uid = md5;
          }).then(function () {
            return new Response(romBlob).arrayBuffer();
          }).then(function (buffer) {
            return new Uint8Array(buffer);
          });
        }
      }).then(function (content) {
        emulator.setRoms(_this6.uid, frontend, biosBuffers, _this6.isMediaBased() ? null : content, extension);

        if (_this6.isArchiveBased()) {
          emulator.setArchiveUrl(_this6.archive);
        }

        if (_this6.isMediaBased()) {
          emulator.setMedia(content);
          emulator.setSaveDisks(_this6.saveDisks);
        }

        return content;
      }).then(function () {
        return _this6.setState({
          mode: ModeEnum.LOADED,
          loadingMessage: null
        });
      })["catch"](function (msg) {
        error(msg);

        _this6.exit(msg ? msg : Resources.getText(TEXT_IDS.ERROR_RETRIEVING_GAME));
      });
    } catch (e) {
      this.exit(e);
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    _WebrcadeApp.prototype.componentDidMount.call(this);

    var appProps = this.appProps;

    if (this.emulator === null) {
      try {
        this.emulator = this.createEmulator(this, this.isDebug());

        if (this.isDiscBased() || this.isArchiveBased() || this.isMediaBased()) {
          this.uid = appProps.uid;
          if (!this.uid) throw new Error('A unique identifier was not found for the game.');

          if (this.isDiscBased()) {
            this.discs = appProps.discs;
            if (this.discs) this.discs = removeEmptyArrayItems(this.discs);
            if (!this.discs || this.discs.length === 0) throw new Error('A disc was not specified.');
          } else if (this.isMediaBased()) {
            this.media = appProps.media;
            this.saveDisks = appProps.saveDisks;
            if (this.media) this.media = removeEmptyArrayItems(this.media);
            if ((!this.media || this.media.length === 0) && (!this.saveDisks || this.saveDisks <= 0)) throw new Error('No media was specified.');
          } else {
            this.archive = appProps.archive;
            if (!this.archive) throw new Error('An archive file was not specified.');
          }
        } else {
          var rom = appProps.rom;
          if (!rom) throw new Error('A ROM file was not specified.');
          this.rom = rom;
        }

        this.bios = this.getBiosUrls(appProps);

        if (this.bios && !Array.isArray(this.bios)) {
          this.bios = [this.bios];
        }

        if (this.bios) this.bios = removeEmptyArrayItems(this.bios);

        if (this.isBiosRequired() && Object.keys(this.getBiosMap()).length > 0 && (!this.bios || this.bios.length === 0)) {
          throw new Error('BIOS file(s) were not specified.');
        }

        if (this.isDiscBased() && this.discs.length > 1) {
          this.setState({
            mode: this.MODE_DISC_SELECT
          });
        } else {
          this.start(0);
        }
      } catch (msg) {
        error(msg);
        this.exit(msg ? msg : Resources.getText(TEXT_IDS.ERROR_RETRIEVING_GAME));
      }
    }
  };

  _proto.onPreExit = function onPreExit() {
    try {
      var _this8 = this;

      var _temp16 = _catch(function () {
        return Promise.resolve(_WebrcadeApp.prototype.onPreExit.call(_this8)).then(function () {
          var _temp14 = function () {
            if (!_this8.isExitFromPause()) {
              return Promise.resolve(_this8.emulator.saveState()).then(function () {});
            }
          }();

          if (_temp14 && _temp14.then) return _temp14.then(function () {});
        });
      }, function (e) {
        error(e);
      });

      return Promise.resolve(_temp16 && _temp16.then ? _temp16.then(function () {}) : void 0);
    } catch (e) {
      return Promise.reject(e);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    var mode = this.state.mode;
    var ModeEnum = this.ModeEnum,
        emulator = this.emulator,
        canvas = this.canvas;

    if (mode === ModeEnum.LOADED) {
      window.focus();
      emulator.start(canvas);
    }
  };

  _proto.renderPauseScreen = function renderPauseScreen() {
    throw "renderPauseScreen not implemented";
  };

  _proto.renderCanvas = function renderCanvas() {
    var _this9 = this;

    return /*#__PURE__*/React.createElement("canvas", {
      ref: function ref(canvas) {
        _this9.canvas = canvas;
      },
      id: "canvas"
    });
  };

  _proto.render = function render() {
    var _this$state = this.state,
        errorMessage = _this$state.errorMessage,
        loadingMessage = _this$state.loadingMessage,
        statusMessage = _this$state.statusMessage,
        mode = _this$state.mode;
    var ModeEnum = this.ModeEnum,
        MODE_DISC_SELECT = this.MODE_DISC_SELECT;
    return /*#__PURE__*/React.createElement(Fragment, null, _WebrcadeApp.prototype.render.call(this), mode === MODE_DISC_SELECT && this.discs ? /*#__PURE__*/React.createElement(DiscSelectionEditor, {
      app: this
    }) : null, !statusMessage && (mode === ModeEnum.LOADING || loadingMessage && !errorMessage) ? this.renderLoading() : null, mode === ModeEnum.PAUSE ? this.renderPauseScreen() : null, this.renderCanvas());
  };

  return WebrcadeRetroApp;
}(WebrcadeApp);

var FileButton = /*#__PURE__*/function (_ImageButton) {
  _inheritsLoose(FileButton, _ImageButton);

  function FileButton() {
    var _this;

    _this = _ImageButton.call(this) || this;

    _this.onClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick();

      var _assertThisInitialize = _assertThisInitialized(_this),
          fileInputRef = _assertThisInitialize.fileInputRef;

      fileInputRef.current.click();
    };

    _this.fileInputRef = React.createRef();
    return _this;
  }

  var _proto = FileButton.prototype;

  _proto.render = function render() {
    var fileInputRef = this.fileInputRef;
    var onFileSelect = this.props.onFileSelect;
    return /*#__PURE__*/React.createElement("div", null, _ImageButton.prototype.render.call(this), /*#__PURE__*/React.createElement("input", {
      ref: fileInputRef,
      type: "file",
      style: {
        display: 'none'
      },
      onChange: onFileSelect
    }));
  };

  return FileButton;
}(ImageButton);
FileButton.contextType = WebrcadeContext;

function ScreenControlsSelect(props) {
  var addDefault = props.addDefault,
      _onPad = props.onPad,
      value = props.value,
      _onChange = props.onChange,
      selectRef = props.selectRef;
  var opts = [];

  if (addDefault) {
    opts.push({
      value: SCREEN_CONTROLS.SC_AUTO,
      label: Resources.getText(TEXT_IDS.SC_AUTO)
    });
  }

  opts.push({
    value: SCREEN_CONTROLS.SC_ON,
    label: Resources.getText(TEXT_IDS.SC_ON)
  });
  return /*#__PURE__*/React.createElement(Select, {
    ref: selectRef,
    options: opts,
    onChange: function onChange(value) {
      return _onChange(value);
    },
    value: value,
    onPad: function onPad(e) {
      return _onPad(e);
    }
  });
}

var styles$h = {"text-field":"_24Yg1"};

var TextField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TextField, _Component);

  function TextField() {
    var _this;

    _this = _Component.call(this) || this;

    _this.gamepadCallback = function (e) {
      var onPad = _this.props.onPad;
      var focused = _this.state.focused;
      if (!focused) return false;

      switch (e.type) {
        case GamepadEnum.A:
          break;

        case GamepadEnum.DOWN:
        case GamepadEnum.UP:
        case GamepadEnum.LEFT:
        case GamepadEnum.RIGHT:
        case GamepadEnum.LBUMP:
        case GamepadEnum.RBUMP:
          if (onPad) onPad(e);
          break;
      }

      return true;
    };

    _this.onClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick();
    };

    _this.onFocus = function () {
      _this.setState({
        focused: true
      });
    };

    _this.onBlur = function () {
      _this.setState({
        focused: false
      });
    };

    _this.state = {
      focused: false
    };
    return _this;
  }

  var _proto = TextField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.addCallback(this.gamepadCallback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var gamepadNotifier = this.context.gamepadNotifier;

    if (gamepadNotifier) {
      gamepadNotifier.removeCallback(this.gamepadCallback);
    }
  };

  _proto.focus = function focus() {
    var focused = this.state.focused;
    var field = this.field;

    if (!focused && field) {
      field.focus();
      return true;
    }

    return false;
  };

  _proto.render = function render() {
    var _this2 = this;

    var width = this.props.width;
    var style = {};
    if (width) style.width = width;
    return /*#__PURE__*/React.createElement("input", {
      className: styles$h['text-field'],
      type: "text",
      style: style,
      ref: function ref(field) {
        _this2.field = field;
      },
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
  };

  return TextField;
}(Component);
TextField.contextType = WebrcadeContext;

var AppSettingsEditor = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AppSettingsEditor, _Component);

  function AppSettingsEditor() {
    var _this;

    _this = _Component.call(this) || this;
    _this.state = {
      tabIndex: null,
      focusGridComps: null,
      values: {}
    };
    return _this;
  }

  var _proto = AppSettingsEditor.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var emulator = this.props.emulator;
    this.setState({
      values: {
        origBilinearMode: emulator.getPrefs().isBilinearEnabled(),
        bilinearMode: emulator.getPrefs().isBilinearEnabled(),
        origScreenSize: emulator.getPrefs().getScreenSize(),
        screenSize: emulator.getPrefs().getScreenSize(),
        origScreenControls: emulator.getPrefs().getScreenControls(),
        screenControls: emulator.getPrefs().getScreenControls()
      }
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        emulator = _this$props.emulator,
        onClose = _this$props.onClose,
        hideBilinear = _this$props.hideBilinear,
        showOnScreenControls = _this$props.showOnScreenControls;
    var _this$state = this.state,
        tabIndex = _this$state.tabIndex,
        values = _this$state.values,
        focusGridComps = _this$state.focusGridComps;

    var setFocusGridComps = function setFocusGridComps(comps) {
      _this2.setState({
        focusGridComps: comps
      });
    };

    var setValues = function setValues(values) {
      _this2.setState({
        values: values
      });
    };

    return /*#__PURE__*/React.createElement(EditorScreen, {
      showCancel: true,
      onOk: function onOk() {
        var change = false;

        if (!hideBilinear && values.origBilinearMode !== values.bilinearMode) {
          emulator.getPrefs().setBilinearEnabled(values.bilinearMode);
          emulator.updateBilinearFilter();
          change = true;
        }

        if (values.origScreenSize !== values.screenSize) {
          emulator.getPrefs().setScreenSize(values.screenSize);
          emulator.updateScreenSize();
          change = true;
        }

        if (values.origScreenControls !== values.screenControls) {
          emulator.getPrefs().setScreenControls(values.screenControls);
          emulator.updateOnScreenControls();
          change = true;
        }

        if (change) {
          emulator.getPrefs().save();
        }

        onClose();
      },
      onClose: onClose,
      focusGridComps: focusGridComps,
      onTabChange: function onTabChange(oldTab, newTab) {
        return _this2.setState({
          tabIndex: newTab
        });
      },
      tabs: [{
        image: TelevisionWhiteImage,
        label: 'Display Settings',
        content: /*#__PURE__*/React.createElement(AppDisplaySettingsTab, {
          emulator: emulator,
          hideBilinear: hideBilinear,
          showOnScreenControls: showOnScreenControls,
          isActive: tabIndex === 0,
          setFocusGridComps: setFocusGridComps,
          values: values,
          setValues: setValues
        })
      }]
    });
  };

  return AppSettingsEditor;
}(Component);
var AppDisplaySettingsTab = /*#__PURE__*/function (_FieldsTab) {
  _inheritsLoose(AppDisplaySettingsTab, _FieldsTab);

  function AppDisplaySettingsTab() {
    var _this3;

    _this3 = _FieldsTab.call(this) || this;
    _this3.bilinearRef = React.createRef();
    _this3.screenSizeRef = React.createRef();
    _this3.screenControlsRef = React.createRef();
    _this3.gridComps = [[_this3.screenSizeRef], [_this3.bilinearRef], [_this3.screenControlsRef]];
    return _this3;
  }

  var _proto2 = AppDisplaySettingsTab.prototype;

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var gridComps = this.gridComps;
    var setFocusGridComps = this.props.setFocusGridComps;
    var isActive = this.props.isActive;

    if (isActive && isActive !== prevProps.isActive) {
      setFocusGridComps(gridComps);
    }
  };

  _proto2.render = function render() {
    var bilinearRef = this.bilinearRef,
        screenSizeRef = this.screenSizeRef,
        screenControlsRef = this.screenControlsRef;
    var focusGrid = this.context.focusGrid;
    var _this$props2 = this.props,
        setValues = _this$props2.setValues,
        values = _this$props2.values,
        hideBilinear = _this$props2.hideBilinear,
        showOnScreenControls = _this$props2.showOnScreenControls;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, "Screen size"), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(ScreenSizeSelect, {
      selectRef: screenSizeRef,
      addDefault: true,
      onChange: function onChange(value) {
        setValues(_extends({}, values, {
          screenSize: value
        }));
      },
      value: values.screenSize,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, screenSizeRef);
      }
    }))), !hideBilinear && /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, "Force bilinear filter"), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(Switch, {
      ref: bilinearRef,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, bilinearRef);
      },
      onChange: function onChange(e) {
        setValues(_extends({}, values, {
          bilinearMode: e.target.checked
        }));
      },
      checked: values.bilinearMode
    }))), showOnScreenControls && /*#__PURE__*/React.createElement(FieldRow, null, /*#__PURE__*/React.createElement(FieldLabel, null, "On-screen controls"), /*#__PURE__*/React.createElement(FieldControl, null, /*#__PURE__*/React.createElement(ScreenControlsSelect, {
      selectRef: screenControlsRef,
      addDefault: true,
      onChange: function onChange(value) {
        setValues(_extends({}, values, {
          screenControls: value
        }));
      },
      value: values.screenControls,
      onPad: function onPad(e) {
        return focusGrid.moveFocus(e.type, screenControlsRef);
      }
    }))));
  };

  return AppDisplaySettingsTab;
}(FieldsTab);
AppDisplaySettingsTab.contextType = WebrcadeContext;

var APP_DIV_ID = "webrcade-app";
var APP_FRAME_ID = "webrcade-app-iframe";
var AppScreen = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AppScreen, _Component);

  function AppScreen() {
    var _this;

    _this = _Component.call(this) || this;
    _this.MAX_LOAD_TIME = 10 * 1000;
    _this.STATUS_DIV_ID = "webrcade-app-status-div";

    _this.messageListener = function (e) {
      if (e.data === 'appLoaded') {
        info("app loaded message received.");

        _this.clearRefreshTimout();
      }
    };

    _this.frameRetryId = null;
    return _this;
  }

  var _proto = AppScreen.prototype;

  _proto.clearRefreshTimout = function clearRefreshTimout() {
    var frameRetryId = this.frameRetryId;

    if (frameRetryId != null) {
      clearTimeout(frameRetryId);
      this.frameRetryId = null;
    }
  };

  _proto.getAppDiv = function getAppDiv() {
    return document.getElementById(APP_DIV_ID);
  };

  _proto.getAppIframe = function getAppIframe() {
    return document.getElementById(APP_FRAME_ID);
  };

  _proto.getStatusDiv = function getStatusDiv() {
    return document.getElementById(this.STATUS_DIV_ID);
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var MAX_LOAD_TIME = this.MAX_LOAD_TIME;
    window.addEventListener("message", this.messageListener);
    this.frameRetryId = setTimeout(function () {
      var iframe = _this2.getAppIframe();

      if (iframe && !isDev()) {
        info("attempting to reload frame, exceeded wait timeout: " + MAX_LOAD_TIME);
        iframe.contentDocument.location.reload();
      }
    }, MAX_LOAD_TIME);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$props = this.props,
        app = _this$props.app,
        exitCallback = _this$props.exitCallback;
    var reg = AppRegistry.instance;
    var appDiv = this.getAppDiv();
    var isSlowExit = reg.isSlowExit(app);

    if (!reg.isDelayedExit(app)) {
      if (appDiv) {
        appDiv.parentNode.removeChild(appDiv);

        if (exitCallback) {
          exitCallback();
        }
      }
    } else {
      var statusDiv = this.getStatusDiv();

      if (statusDiv) {
        statusDiv.style.display = 'block';
        setTimeout(function () {
          statusDiv.style.opacity = '1.0';
        }, 100);
      }

      var count = 0;

      var _appDiv = this.getAppDiv();

      if (_appDiv) {
        var iframe = _appDiv.children[0];
        iframe.style.height = '20px';
        iframe.style.opacity = '0';
        var intervalId = setInterval(function () {
          if (count === (isSlowExit ? 100 : 20)) {
            clearInterval(intervalId);

            _appDiv.parentNode.removeChild(_appDiv);

            if (exitCallback) {
              exitCallback();
            }
          }

          iframe.src = "about:blank";
          count++;
        }, 100);
      }
    }

    window.removeEventListener("message", this.messageListener);
    this.clearRefreshTimout();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        app = _this$props2.app,
        context = _this$props2.context,
        feedProps = _this$props2.feedProps;
    var reg = AppRegistry.instance;
    var location = reg.getLocation(app, context, feedProps);

    if (!isDev() && context && context === AppProps.RV_CONTEXT_EDITOR) {
      location = "../../" + location;
    }

    var appDiv = this.getAppDiv();

    if (!appDiv) {
      appDiv = document.createElement("div");
      appDiv.className = APP_DIV_ID;
      appDiv.id = APP_DIV_ID;
      var iframe = document.createElement("iframe");

      if (!isDev()) {
        iframe.style.display = 'none';
      }

      iframe.id = APP_FRAME_ID;
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("frameBorder", "0");
      iframe.setAttribute("src", location);
      iframe.setAttribute("allow", "autoplay; gamepad");
      appDiv.appendChild(iframe);
      var statusDiv = document.createElement("div");
      statusDiv.id = this.STATUS_DIV_ID;
      statusDiv.innerHTML = "Exiting...";
      statusDiv.style.position = "absolute";
      statusDiv.style.left = "50%";
      statusDiv.style.top = "50%";
      statusDiv.style.marginRight = "-50%";
      statusDiv.style.transform = "translate(-50%, -50%)";
      statusDiv.style.fontSize = "2.75vw";
      statusDiv.style.zIndex = "5";
      statusDiv.style.fontFamily = "Quicksand";
      statusDiv.style.transition = "opacity 1s";
      statusDiv.style.display = 'none';
      statusDiv.style.cursor = 'none';
      statusDiv.style.opacity = '0';
      appDiv.appendChild(statusDiv);
      document.body.appendChild(appDiv);
    }

    return /*#__PURE__*/React.createElement("div", null);
  };

  return AppScreen;
}(Component);

export { A5200Background, A5200Controller, AKey, APP_DIV_ID, APP_FRAME_ID, APP_TYPE_KEYS, AddCircleBlackImage, AddCircleWhiteImage, AlbumWhiteImage, AppDisplaySettingsTab, AppPrefs, AppProps, AppRegistry, AppScreen, AppSettingsEditor, AppWrapper, ArcadeBackground, ArrowBackImage, ArrowBackWhiteImage, ArrowDownKey, ArrowDownwardImage, ArrowForwardImage, ArrowLeftKey, ArrowRightKey, ArrowUpKey, ArrowUpwardImage, Atari2600Background, Atari7800Background, Base64, BaseSettings, CIDS, CKey, CapcomBackground, CategoryBackgroundImage, CategoryThumbImage, ChevronLeftWhiteImage, ChevronRightWhiteImage, CloudBlackImage, CloudDownloadBlackImage, CloudDownloadWhiteImage, CloudUploadBlackImage, CloudUploadWhiteImage, CloudWhiteImage, ColecoController, ColecoVisionBackground, Commodore64Background, ControlKey, Controller, Controllers, ControlsTab, CustomPauseScreen, DKey, DefaultKeyCodeToControlMapping, DeleteForeverBlackImage, DeleteForeverWhiteImage, DescriptionBlackImage, DescriptionWhiteImage, DiscSelectionEditor, DisplayLoop, EKey, EditorScreen, EditorTab, EightKey, EnterKey, EqualsKey, EscapeKey, F5Key, F7Key, Feed, FeedBackgroundImage, FeedThumbImage, Feeds, FetchAppData, FieldControl, FieldLabel, FieldRow, FieldSpan, FieldsTab, FileButton, FileManifest, FiveKey, FocusGrid, FourKey, GameGearBackground, GamepadEnum, GamepadNotifier, GamepadWhiteImage, GbBackground, GbaBackground, GbcBackground, GenesisBackground, IKey, ImageButton, JKey, KCODES, KKey, KeyCodeToControlMapping, KeyboardWhiteImage, KonamiBackground, LKey, LOG, LinkBlackImage, LinkOffBlackImage, LinkOffWhiteImage, LinkWhiteImage, ListsWhiteImage, LoaderImage, LynxBackground, MasterSystemBackground, Message, MinusKey, MouseWhiteImage, N64Background, NeoGeoBackground, NeoGeoCdBackground, NesBackground, NgcBackground, NgpBackground, NineKey, OneKey, PadMapping, PauseScreen, PauseScreenButton, PauseWhiteImage, PceBackground, PceCdBackground, PeriodKey, PlayArrowBlackImage, PlayArrowWhiteImage, PsxBackground, QKey, RKey, RP_DEBUG, Resources, RetroAppWrapper, RetroPrefs, SCREEN_CONTROLS, SCREEN_SIZES, SKey, STATE_SLOTS, SaveManager, SaveStatesEditor, SaveWhiteImage, Screen, ScreenControlsSelect, ScreenSizeSelect, ScriptAudioProcessor, ScummVmBackground, SegaCdBackground, Select, Settings, SettingsAppWhiteImage, SettingsEditor, SettingsRedImage, SettingsWhiteImage, SevenKey, Sg1000Background, SgxBackground, ShiftKey, SixKey, SnesBackground, SpaceKey, StandardPadMapping, Storage, SwapVertImage, Swipe, SwipeWhiteImage, Switch, TEXT_IDS, TKey, TelevisionWhiteImage, TextField, ThreeKey, ThreedoBackground, TouchEndListener, TuneWhiteImage, TwoKey, Unzip, UrlUtil, VKey, VbBackground, VideoGameAssetOffWhiteImage, VideoGameAssetWhiteImage, VisibilityChangeMonitor, VolumeOffBlackImage, WKey, WebrcadeApp, WebrcadeContext, WebrcadeLogoDarkImage, WebrcadeLogoLargeImage, WebrcadeRetroApp, WsBackground, WscBackground, XKey, XboxOneAButton, XboxOneBButton, XboxOneDpad, XboxOneLeftBumper, XboxOneLeftStick, XboxOneLeftTrigger, XboxOneMenuButton, XboxOneRightBumper, XboxOneRightStick, XboxOneRightTrigger, XboxOneWindowsButton, XboxOneXButton, XboxOneYButton, ZKey, ZeroKey, Zip, addDebugDiv, addXboxFullscreenCallback, applyIosNavBarHack, blobToStr, cloneObject, config, dropbox, fullScreen, getContentDispositionFilename, getFeedAsJson, getScreenShot, getStandaloneLocation, getXboxViewMessage, hideInactiveMouse, hideMessage, isApp, isDebug, isDev, isEmptyString, isEscapeKeySequence, isIos, isMacOs, isMobileSafari, isParentSameOrigin, isStoragePersisted, isTouchSupported, isValidString, isXbox, limitString, loadFeeds, md5, normalizeFileName, preloadImages, registerAudioResume, remapUrl, removeEmptyArrayItems, removeIosNavBarHack, resolvePath$1 as resolveImagePath, resolvePath, romNameScorer, setMessageAnchorId, settings, showMessage, storage, storagePersist, strReplaceAll, toggleTabIndex, u8ArrayToStr, uuidv4 };
//# sourceMappingURL=index.modern.js.map
